
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("2TEqc", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("elAFM")).CustomersAppLayout);

var $elAFM = parcelRequire("elAFM");

});
parcelRegister("elAFM", function(module, exports) {

$parcel$export(module.exports, "CustomersAppLayout", () => $de3c6acc4ac6feee$export$77fba3c9350934ab);

var $eUqFw = parcelRequire("eUqFw");

var $j7bQJ = parcelRequire("j7bQJ");
var $6tahE = parcelRequire("6tahE");

var $5BRby = parcelRequire("5BRby");

var $kJlBc = parcelRequire("kJlBc");

var $iVSJI = parcelRequire("iVSJI");


var $cEzlf = parcelRequire("cEzlf");

var $frZnw = parcelRequire("frZnw");

var $5tI0b = parcelRequire("5tI0b");

var $2rxYS = parcelRequire("2rxYS");

var $aSEj7 = parcelRequire("aSEj7");

var $kKzsy = parcelRequire("kKzsy");

var $3o0h6 = parcelRequire("3o0h6");
var $2d7Sj = parcelRequire("2d7Sj");
var $dVAlv = parcelRequire("dVAlv");
var $51Ia6 = parcelRequire("51Ia6");

var $fCHTf = parcelRequire("fCHTf");

var $6M8Uw = parcelRequire("6M8Uw");

var $jK1pm = parcelRequire("jK1pm");
const $de3c6acc4ac6feee$var$CustomersTheme = {
    isNestedGrid: true,
    spacing: 'compact',
    columns: 1
};
const $de3c6acc4ac6feee$var$pageId = 'servicedesk-customers';
const $de3c6acc4ac6feee$export$77fba3c9350934ab = ()=>{
    const [{ match: match }] = (0, $kJlBc.useRouter)();
    const [{ data: pageContextData, error: error }] = (0, $51Ia6.usePageContext)();
    const { tenantContext: tenantContext, projectContext: projectContext } = pageContextData || {};
    const { projectName: projectName } = projectContext || {};
    const { baseUrl: baseUrl } = tenantContext || {};
    const { data: serviceProjectFeatureData } = (0, $aSEj7.default)();
    if (serviceProjectFeatureData?.[0, $89d8bb437c2044ff$export$6860c7a26d6d6d35]?.status === (0, $89d8bb437c2044ff$export$e927a5d1b72f0b68)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fCHTf.AsyncContactsAppLayout), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "servicedesk-customers-v2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6M8Uw.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dVAlv.SpaPageWrapper), {
        pageId: $de3c6acc4ac6feee$var$pageId,
        baseUrl: baseUrl,
        currentUrl: match.url,
        // @ts-expect-error - TS2322 - Type '{ projectId: number; projectKey: string; projectName: string; projectType: ProjectType; isAdmin: boolean; isProjectSimplified: boolean; } | undefined' is not assignable to type 'ProjectContext | null | undefined'.
        projectContext: projectContext,
        isLoading: !pageContextData && !error,
        error: error
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2d7Sj.ServiceDeskDocumentTitle), {
        projectName: projectName,
        section: "customers"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5BRby.default), {
        id: $de3c6acc4ac6feee$var$pageId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iVSJI.ServiceDeskAnalyticsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cEzlf.default), {
        appName: (0, $frZnw.APP_NAMES).CUSTOMERS,
        ErrorView: (0, $2rxYS.ErrorView)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3o0h6.PageStyle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j7bQJ.default), {
        layout: "fluid",
        theme: $de3c6acc4ac6feee$var$CustomersTheme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6tahE.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5tI0b.default), null)))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKzsy.JsdGettingStartedPanelShouldRender), null));
};

});
parcelRegister("j7bQJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $21cf405c5617943d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $cuCEk = parcelRequire("cuCEk");

var $gw8fk = parcelRequire("gw8fk");

var $6tahE = parcelRequire("6tahE");

var $02LzD = parcelRequire("02LzD");
/**
 * __Grid__
 *
 * A grid contains one or more `GridColumn` to provide a grid layout.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $21cf405c5617943d$var$GridWrapper = ({ spacing: spacingProp, columns: columnsProp, layout: layout, testId: testId, children: children, theme: theme })=>{
    /**
	 * isRoot is `true` only in the default context (i.e. no ancestor Grid).
	 */ const { isRoot: isRoot } = (0, $eUqFw.useContext)((0, $02LzD.GridContext));
    const { medium: medium } = (0, $eUqFw.useContext)((0, $6tahE.GridColumnContext));
    /**
	 * The colspan of the current containing GridColumn provides
	 * the default amount of columns in a nested grid.
	 */ const defaultColumns = medium > 0 ? medium : (0, $cuCEk.defaultGridColumns);
    /**
	 * This is to account for the eventual removal of the `theme` prop. In theory, this should not be exposed.
	 * However, consumers are still using it - there should be a major rerelease with the complete removal of this prop later.
	 */ const spacing = spacingProp ?? theme?.spacing ?? (0, $cuCEk.defaultSpacing);
    const columns = columnsProp ?? theme?.columns ?? defaultColumns;
    const isNested = theme?.isNestedGrid ?? !isRoot;
    const contextValue = (0, $eUqFw.useMemo)(()=>({
            isRoot: false,
            isNested: isNested,
            spacing: spacing,
            columns: columns
        }), [
        spacing,
        columns,
        isNested
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $02LzD.GridContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gw8fk.Grid), {
        layout: layout,
        testId: testId
    }, children));
};
var $21cf405c5617943d$export$2e2bcd8739ae039 = $21cf405c5617943d$var$GridWrapper;

});
parcelRegister("cuCEk", function(module, exports) {

$parcel$export(module.exports, "defaultGridColumns", () => $63536614c324c20f$export$74797698e12f8baa);
$parcel$export(module.exports, "defaultGridColumnWidth", () => $63536614c324c20f$export$b8241a1616ab1b96);
$parcel$export(module.exports, "spacingMapping", () => $63536614c324c20f$export$2a89a65a43bab52d);
$parcel$export(module.exports, "defaultSpacing", () => $63536614c324c20f$export$8ec7372efd74b753);
$parcel$export(module.exports, "defaultBannerHeight", () => $63536614c324c20f$export$d77f83c3d17a7b8a);
$parcel$export(module.exports, "defaultMedium", () => $63536614c324c20f$export$f8725d21f81f3e01);
$parcel$export(module.exports, "defaultLayout", () => $63536614c324c20f$export$2303d2bd9eeff99a);
$parcel$export(module.exports, "varColumnsNum", () => $63536614c324c20f$export$9ddc3632bbfb8966);
$parcel$export(module.exports, "varColumnSpan", () => $63536614c324c20f$export$8b7e31f391e6e681);
$parcel$export(module.exports, "varGridSpacing", () => $63536614c324c20f$export$936829b4511db3e4);
const $63536614c324c20f$export$3aaf3a78c909ea56 = 8;
const $63536614c324c20f$export$74797698e12f8baa = 12;
const $63536614c324c20f$export$b8241a1616ab1b96 = $63536614c324c20f$export$3aaf3a78c909ea56 * 10;
const $63536614c324c20f$export$2a89a65a43bab52d = {
    comfortable: $63536614c324c20f$export$3aaf3a78c909ea56 * 5,
    cosy: $63536614c324c20f$export$3aaf3a78c909ea56 * 2,
    compact: $63536614c324c20f$export$3aaf3a78c909ea56 * 0.5
};
const $63536614c324c20f$export$8ec7372efd74b753 = 'cosy';
const $63536614c324c20f$export$d77f83c3d17a7b8a = 52;
const $63536614c324c20f$export$f8725d21f81f3e01 = 0;
const $63536614c324c20f$export$2303d2bd9eeff99a = 'fixed';
const $63536614c324c20f$export$9ddc3632bbfb8966 = '--ds-columns-num';
const $63536614c324c20f$export$8b7e31f391e6e681 = '--ds-column-span';
const $63536614c324c20f$export$936829b4511db3e4 = '--ds-grid-spacing';

});

parcelRegister("gw8fk", function(module, exports) {

$parcel$export(module.exports, "Grid", () => $7946ba115b4da3a8$export$ef2184bd89960b14);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $cuCEk = parcelRequire("cuCEk");

var $02LzD = parcelRequire("02LzD");
function $7946ba115b4da3a8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7946ba115b4da3a8$var$gridStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `0 calc(var(${(0, $cuCEk.varGridSpacing)}) / 2)`,
    position: 'relative',
    alignItems: 'flex-start',
    flexWrap: 'wrap'
});
const $7946ba115b4da3a8$var$gridLayoutStyles = {
    fixed: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(var(${(0, $cuCEk.varColumnsNum)}) * ${(0, $cuCEk.defaultGridColumnWidth)}px)`
    }),
    fluid: {
        name: "qhxz92",
        styles: "max-width:100%"
    }
};
const $7946ba115b4da3a8$var$nestedGridStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(-1 * var(${(0, $cuCEk.varGridSpacing)}))`
});
const $7946ba115b4da3a8$export$ef2184bd89960b14 = ({ layout: layout = (0, $cuCEk.defaultLayout), testId: testId, children: children })=>{
    const { isNested: isNested, columns: columns, spacing: spacing } = (0, $eUqFw.useContext)((0, $02LzD.GridContext));
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $7946ba115b4da3a8$var$gridStyles,
            $7946ba115b4da3a8$var$gridLayoutStyles[layout],
            isNested && $7946ba115b4da3a8$var$nestedGridStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $cuCEk.varColumnsNum)]: columns,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $cuCEk.varGridSpacing)]: `${(0, $cuCEk.spacingMapping)[spacing]}px`
        },
        "data-testid": testId
    }, children);
};

});
parcelRegister("02LzD", function(module, exports) {

$parcel$export(module.exports, "GridContext", () => $abe6d6b3e91c4986$export$11cae3e04ab99fae);

var $eUqFw = parcelRequire("eUqFw");

var $cuCEk = parcelRequire("cuCEk");
const $abe6d6b3e91c4986$export$11cae3e04ab99fae = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isRoot: true,
    isNested: false,
    spacing: (0, $cuCEk.defaultSpacing),
    columns: (0, $cuCEk.defaultGridColumns)
});

});


parcelRegister("6tahE", function(module, exports) {

$parcel$export(module.exports, "GridColumnContext", () => $384e4fce86f51330$export$1229ad7112b989f5);
$parcel$export(module.exports, "default", () => $384e4fce86f51330$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $cuCEk = parcelRequire("cuCEk");

var $02LzD = parcelRequire("02LzD");
var $384e4fce86f51330$var$ColumnVariant;
/**
 * Determines the method by which column width is calculated.
 */ (function(ColumnVariant) {
    /**
   * Column occupies available space.
   *
   * Used when `medium` is 0 (the default).
   */ ColumnVariant["Auto"] = "auto";
    /**
   * Column occupies specified space.
   *
   * Used when 0 < `medium` < `columns`.
   */ ColumnVariant["Bounded"] = "bounded";
    /**
   * Column occupies entire row.
   *
   * Used when `medium` >= `columns`.
   *
   * This case is handled separately because of rounding.
   */ ColumnVariant["FullWidth"] = "fullWidth";
})($384e4fce86f51330$var$ColumnVariant || ($384e4fce86f51330$var$ColumnVariant = {}));
const $384e4fce86f51330$var$getVariant = ({ medium: medium, columns: columns })=>{
    if (medium === (0, $cuCEk.defaultMedium)) return "auto";
    else if (medium < columns) return "bounded";
    return "fullWidth";
};
/**
 * IE11 and Edge both have rounding issues for flexbox which is why a width of
 * 99.9999% is used. Using 100% here causes columns to wrap prematurely.
 */ const $384e4fce86f51330$var$availableWidth = '99.9999%';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $384e4fce86f51330$var$singleColumnWidth = `(${$384e4fce86f51330$var$availableWidth} / var(${(0, $cuCEk.varColumnsNum)}))`;
const $384e4fce86f51330$var$gridColumnStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: `calc(${$384e4fce86f51330$var$singleColumnWidth} - var(${(0, $cuCEk.varGridSpacing)}))`,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(var(${(0, $cuCEk.varGridSpacing)}) / 2)`,
    flexGrow: 1,
    flexShrink: 0,
    wordWrap: 'break-word'
});
const $384e4fce86f51330$var$gridColumnWidthStyles = {
    ["auto"]: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $cuCEk.varGridSpacing)}))`,
        flexBasis: `auto`
    }),
    ["bounded"]: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(${$384e4fce86f51330$var$singleColumnWidth} *  var(${(0, $cuCEk.varColumnSpan)}) - var(${(0, $cuCEk.varGridSpacing)}))`,
        flexBasis: `100%`
    }),
    ["fullWidth"]: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $cuCEk.varGridSpacing)}))`,
        flexBasis: `100%`
    })
};
const $384e4fce86f51330$export$1229ad7112b989f5 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    medium: (0, $cuCEk.defaultMedium)
});
/**
 * __Grid column__
 *
 * A grid column can span one or more column positions within a grid.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $384e4fce86f51330$var$GridColumn = ({ medium: medium = (0, $cuCEk.defaultMedium), children: children, testId: testId })=>{
    const { columns: columns } = (0, $eUqFw.useContext)((0, $02LzD.GridContext));
    const contextValue = (0, $eUqFw.useMemo)(()=>({
            medium: medium
        }), [
        medium
    ]);
    /**
   * The real column span,
   * obtained by clamping the passed `medium` value within the allowed range.
   */ const colSpan = Math.max(1, Math.min(medium, columns));
    /**
   * How we should calculate the column width.
   */ const variant = $384e4fce86f51330$var$getVariant({
        medium: medium,
        columns: columns
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)($384e4fce86f51330$export$1229ad7112b989f5.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $384e4fce86f51330$var$gridColumnStyles,
            $384e4fce86f51330$var$gridColumnWidthStyles[variant]
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            /**
       * The 'auto' value here isn't actually consumed anywhere and is
       * just to better reflect what is happening when inspecting CSS.
       */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $cuCEk.varColumnSpan)]: variant === "auto" ? 'auto' : colSpan
        },
        "data-testid": testId
    }, children));
};
var $384e4fce86f51330$export$2e2bcd8739ae039 = $384e4fce86f51330$var$GridColumn;

});


const $89d8bb437c2044ff$export$b45a36df7873757 = 'alerts';
const $89d8bb437c2044ff$export$a7952c5a5c371ddd = 'oncall';
const $89d8bb437c2044ff$export$de0bca182bc46c7f = 'services';
const $89d8bb437c2044ff$export$ed849d1eb34423e5 = 'similarIssues';
const $89d8bb437c2044ff$export$d4a1ed8524773042 = 'sentiment-analysis';
const $89d8bb437c2044ff$export$3d2ce10d3ca55e3c = 'automaticallySetRequestType';
const $89d8bb437c2044ff$export$cae2404f62c0f4d7 = 'change-management';
const $89d8bb437c2044ff$export$31ffe79c2b019cf = 'incident-management';
const $89d8bb437c2044ff$export$3a20074cc38cbf69 = 'problem-management';
const $89d8bb437c2044ff$export$a364d86306d4a6d4 = 'service-request';
const $89d8bb437c2044ff$export$71f1a79e03f525 = 'post-incident-review';
const $89d8bb437c2044ff$export$ff4743f07602eea7 = 'csat';
const $89d8bb437c2044ff$export$51e98af8dd4951f3 = 'email-request';
const $89d8bb437c2044ff$export$6860c7a26d6d6d35 = 'csm-customer-context';
const $89d8bb437c2044ff$export$7c5ee80fcb40e9d3 = 'developer-escalation';
const $89d8bb437c2044ff$export$28fc94ee6c61f632 = 'products-and-entitlements';
const $89d8bb437c2044ff$export$1eb399d8c2d53748 = 'jsm-board';
const $89d8bb437c2044ff$export$abbcecf25bfa1e87 = 'jsm-calendar';
const $89d8bb437c2044ff$export$66ede2c1de447f8f = 'developer-escalation';
const $89d8bb437c2044ff$export$e927a5d1b72f0b68 = 'ENABLED';
const $89d8bb437c2044ff$export$8cd212c10b4124d2 = 'DISABLED';

parcelRegister("cEzlf", function(module, exports) {

$parcel$export(module.exports, "default", () => $65565c9fe9c34504$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $frZnw = parcelRequire("frZnw");
/**
 * @deprecated GasV2 has been cleaned up, and it has not been logging any events since July. Please replace implementation with sending GasV3 analytics: go/gasv3
 */ const $65565c9fe9c34504$var$triggerAnalyticsEvent = (_appName)=>(_eventNameSuffix, _eventData)=>Promise.resolve(undefined);
const $65565c9fe9c34504$var$toErrorOrUndefined = (error)=>{
    if (error instanceof Error) return error;
    if (typeof error === 'string') return new Error(error);
    return undefined;
};
class $65565c9fe9c34504$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
        this.triggerEvent = $65565c9fe9c34504$var$triggerAnalyticsEvent(`${props.appName}`);
    }
    componentDidCatch(error) {
        const { onErrorHandler: onErrorHandler, ErrorView: ErrorView, appName: appName } = this.props;
        const data = error instanceof Error ? {
            message: error.message,
            stack: error.stack
        } : {
            message: error
        };
        this.triggerEvent('error-boundary.error-caught', data);
        (0, $guiFP.default)({
            meta: {
                id: 'unhandled',
                packageName: (0, $frZnw.toPackageName)(appName) || 'jiraServicedeskCommon'
            },
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            event: this.triggerEvent,
            error: $65565c9fe9c34504$var$toErrorOrUndefined(error),
            sendToPrivacyUnsafeSplunk: true
        });
        // If error view is present then allow error view to handle errors.
        if (ErrorView) return;
        // Some of the non spa apps uses this call back function which doesn't have any error view
        if (onErrorHandler) onErrorHandler(error);
        else // Rethrow for error boundary handling by app-base
        throw error;
    }
    render() {
        const { hasError: hasError } = this.state;
        const { ErrorView: ErrorView, children: children } = this.props;
        if (hasError && ErrorView) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ErrorView, null);
        return children;
    }
}

});

parcelRegister("5tI0b", function(module, exports) {

$parcel$export(module.exports, "default", () => $b03cc6e2800b7fd5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $7d1RI = parcelRequire("7d1RI");

var $iJHZm = parcelRequire("iJHZm");

var $gd0Sp = parcelRequire("gd0Sp");

var $6OqHe = parcelRequire("6OqHe");

var $1rtHO = parcelRequire("1rtHO");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b03cc6e2800b7fd5$export$2e2bcd8739ae039 = ({ useCommonPageContext: useCommonPageContext = (0, $7d1RI.useCommonPageContext) })=>{
    const { baseUrl: baseUrl, projectKey: projectKey } = useCommonPageContext();
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "viewCustomers",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        attributes: {
            viewCustomersScreenVersion: 2,
            edition: tenantContext.appEditions.serviceDesk
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OqHe.AppStoreContainer), {
        // @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
        baseUrl: baseUrl,
        // @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
        projectKey: projectKey,
        scope: `CUSTOMERS_SPA_APP_${projectKey}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1rtHO.CustomersApp), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJHZm.SpaStatePageReady), null));
};

});
// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("7d1RI", function(module, exports) {

$parcel$export(module.exports, "useCommonPageContext", () => $7c0a5b8b9305ec46$export$682ebac4d54e1a69);

var $51Ia6 = parcelRequire("51Ia6");

var $6vrw7 = parcelRequire("6vrw7");

const $7c0a5b8b9305ec46$export$682ebac4d54e1a69 = (usePageContext = (0, $51Ia6.usePageContext))=>{
    const [{ data: pageContextData, error: error }] = usePageContext();
    const { tenantContext: tenantContext, projectContext: projectContext } = pageContextData || {};
    const { projectKey: projectKey, projectName: projectName, projectId: projectId, isProjectSimplified: isProjectSimplified } = projectContext || {};
    const { baseUrl: baseUrl, locale: locale } = tenantContext || {};
    return {
        baseUrl: baseUrl !== undefined ? (0, $6vrw7.toBaseUrl)(baseUrl) : baseUrl,
        error: error,
        locale: locale,
        projectKey: projectKey !== undefined ? (0, $6vrw7.toProjectKey)(projectKey) : projectKey,
        projectName: projectName,
        projectId: projectId != null ? (0, $6vrw7.toProjectId)(projectId.toString()) : projectId,
        isProjectSimplified: isProjectSimplified
    };
};

});
parcelRegister("51Ia6", function(module, exports) {

$parcel$export(module.exports, "usePageContext", () => $16ae5fc48efca0d6$export$9c25024bdfe755f7);

var $eUqFw = parcelRequire("eUqFw");

var $iZJHG = parcelRequire("iZJHG");

var $ixwgj = parcelRequire("ixwgj");

var $gd0Sp = parcelRequire("gd0Sp");

var $jyTef = parcelRequire("jyTef");
const $16ae5fc48efca0d6$var$getProjectContextResource = ()=>(0, $ixwgj.projectContextResourceWithCache);
const $16ae5fc48efca0d6$export$9c25024bdfe755f7 = (customContext)=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const { data: projectContext, loading: projectContextLoading, error: projectContextError } = (0, $iZJHG.useResourceWithCustomRouterContext)($16ae5fc48efca0d6$var$getProjectContextResource(), customContext);
    const [{ data: serviceDeskContext, loading: serviceDeskLoading, error: serviceDeskError }] = (0, $jyTef.useServiceDeskContext)(projectContext?.projectKey || undefined, customContext);
    const pageContextData = (0, $eUqFw.useMemo)(()=>({
            data: projectContext && serviceDeskContext ? {
                serviceDeskContext: {
                    portalId: serviceDeskContext.portalId,
                    portalUrl: serviceDeskContext.portalUrl,
                    canSeeNewIssueView: serviceDeskContext.canSeeNewIssueView,
                    userRole: serviceDeskContext.userRole,
                    serviceDeskId: serviceDeskContext.serviceDeskId
                },
                projectContext: {
                    projectId: projectContext.projectId,
                    projectKey: projectContext.projectKey,
                    projectName: projectContext.projectName,
                    projectType: projectContext.projectType,
                    // Refactor this in https://jdog.jira-dev.com/browse/JSK-443 this is a temporary fix to
                    // resolve a regression https://jira.atlassian.com/browse/JSDCLOUD-8751
                    isAdmin: projectContext.isProjectAdmin || tenantContext.isAdmin,
                    isProjectSimplified: projectContext.simplified
                },
                tenantContext: {
                    baseUrl: tenantContext.baseUrl,
                    locale: tenantContext.locale,
                    userFullname: tenantContext.userFullname,
                    cloudId: tenantContext.cloudId,
                    fabricPfDirUrl: tenantContext.fabricPfDirUrl,
                    atlassianAccountId: tenantContext.atlassianAccountId,
                    isJiraAdmin: tenantContext.isAdmin,
                    isSiteAdmin: tenantContext.isSiteAdmin,
                    activationId: tenantContext.activationId
                }
            } : null,
            loading: projectContextLoading || serviceDeskLoading,
            error: serviceDeskError || projectContextError || null
        }), [
        tenantContext,
        projectContext,
        serviceDeskContext,
        projectContextLoading,
        serviceDeskLoading,
        serviceDeskError,
        projectContextError
    ]);
    return [
        pageContextData
    ];
};

});
parcelRegister("jyTef", function(module, exports) {

$parcel$export(module.exports, "useServiceDeskContext", () => $3f940b317a874b53$export$712ead87353ac687);

var $eUqFw = parcelRequire("eUqFw");

var $iZJHG = parcelRequire("iZJHG");

var $ct0sQ = parcelRequire("ct0sQ");

var $9V785 = parcelRequire("9V785");
const $3f940b317a874b53$var$getServiceDeskContextResource = ()=>(0, $ct0sQ.serviceDeskContextResource);
const $3f940b317a874b53$export$712ead87353ac687 = (projectKey, customContext)=>{
    const { data: data, loading: loading, error: error, refresh: refreshCache } = (0, $iZJHG.useResourceWithCustomRouterContext)($3f940b317a874b53$var$getServiceDeskContextResource(), customContext);
    (0, $eUqFw.useEffect)(()=>{
        if (!false) refreshCache();
    }, [
        projectKey,
        refreshCache
    ]);
    return [
        {
            data: data,
            loading: loading,
            error: error
        }
    ];
};

});
parcelRegister("9V785", function(module, exports) {

$parcel$export(module.exports, "USER_JSM_PROJECT_ROLE", () => $3cdacd90d2ecef12$export$a9054e41660c4d00);
// use USER_JSM_PROJECT_ROLE instead
const $3cdacd90d2ecef12$var$AGENT_ROLE = 'agent';
const $3cdacd90d2ecef12$var$AGENT_PROJECT_ADMIN_ROLE = 'agent-project-admin';
const $3cdacd90d2ecef12$var$JIRA_ROLE = 'jira-user';
const $3cdacd90d2ecef12$export$a9054e41660c4d00 = {
    AGENT_ROLE: $3cdacd90d2ecef12$var$AGENT_ROLE,
    AGENT_PROJECT_ADMIN_ROLE: $3cdacd90d2ecef12$var$AGENT_PROJECT_ADMIN_ROLE,
    JIRA_ROLE: $3cdacd90d2ecef12$var$JIRA_ROLE
};

});




parcelRegister("6OqHe", function(module, exports) {

$parcel$export(module.exports, "useAppStore", () => $030892794ea57138$export$35cd30506bcba883);
$parcel$export(module.exports, "AppStoreContainer", () => $030892794ea57138$export$b78f26a8c37a0820);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $1wQbY = parcelRequire("1wQbY");
const $030892794ea57138$export$d4c72bab9d6cc13a = {
    userPermissions: undefined,
    searchString: '',
    page: 1,
    pageData: undefined,
    loading: false,
    error: null
};
const $030892794ea57138$export$6f57813fe9f31bf9 = (0, $a61MH.createStore)({
    name: 'CustomerAndOrganizationStore',
    initialState: $030892794ea57138$export$d4c72bab9d6cc13a,
    actions: $1wQbY.actions
});
const $030892794ea57138$export$35cd30506bcba883 = (0, $ggKAj.createHook)($030892794ea57138$export$6f57813fe9f31bf9);
const $030892794ea57138$export$b78f26a8c37a0820 = (0, $heB5U.createContainer)($030892794ea57138$export$6f57813fe9f31bf9, {
    displayName: 'CustomerAndOrganizationContainer',
    onInit: $1wQbY.onInit
});

});
parcelRegister("1wQbY", function(module, exports) {

$parcel$export(module.exports, "actions", () => $5b63bae5d868f445$export$e324594224ef24da);
$parcel$export(module.exports, "onInit", () => $5b63bae5d868f445$export$13f23e293cec2ec3);

var $aqpMX = parcelRequire("aqpMX");
var $e5Blg = parcelRequire("e5Blg");
var $6VbwK = parcelRequire("6VbwK");

var $05ifK = parcelRequire("05ifK");
const $5b63bae5d868f445$export$e324594224ef24da = {
    fetchAndUpdatePageData: $05ifK.fetchAndUpdatePageData,
    updateOptimisticCustomers: $e5Blg.updateOptimisticCustomers,
    updateSearchString: $6VbwK.updateSearchString,
    updatePageNumber: $6VbwK.updatePageNumber,
    onResetSearchState: $aqpMX.onResetSearchState
};
const $5b63bae5d868f445$export$13f23e293cec2ec3 = ()=>({ dispatch: dispatch })=>{
        dispatch($5b63bae5d868f445$export$e324594224ef24da.fetchAndUpdatePageData());
    };

});
parcelRegister("aqpMX", function(module, exports) {

$parcel$export(module.exports, "onResetSearchState", () => $4161eaef16904ae2$export$216c684cd7d2babe);
const $4161eaef16904ae2$export$216c684cd7d2babe = ()=>({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            searchString: '',
            page: 1
        });
    };

});

parcelRegister("e5Blg", function(module, exports) {

$parcel$export(module.exports, "updateOptimisticCustomers", () => $08e54ec116b32589$export$9c21b8152ba49b03);
const $08e54ec116b32589$export$9c21b8152ba49b03 = (optimisticCustomerList = [])=>async ({ getState: getState, setState: setState })=>{
        const { loading: loading, pageData: pageData, ...rest } = getState();
        if (!pageData) return;
        setState({
            ...rest,
            pageData: pageData,
            loading: true,
            error: null
        });
        const { customers: customers, total: total, rowsPerPage: rowsPerPage } = pageData;
        // The backend doesn't care if the user tries to add a customer that already
        // exists - it just returns the existing data as if it was just created.
        // This means that we can show the same customer twice, once from `optimisticCustomerList`
        // and the other from the existing entry in `customers`. Use a Map to deduplicate
        // the resulting list while maintaining insertion order
        const customerMap = new Map();
        optimisticCustomerList.forEach((c)=>customerMap.set(c.identifier, c));
        customers.forEach((c)=>customerMap.set(c.identifier, c));
        const deduplicatedCustomersArray = Array.from(customerMap.values());
        const prependUsers = deduplicatedCustomersArray.slice(0, rowsPerPage);
        const updatedPageData = {
            ...pageData,
            customers: prependUsers,
            total: total + prependUsers.length - customers.length
        };
        setState({
            ...getState(),
            pageData: updatedPageData,
            loading: false
        });
    };

});

parcelRegister("6VbwK", function(module, exports) {

$parcel$export(module.exports, "updateSearchString", () => $19191fe6327e4c41$export$762bdf38e87c280d);
$parcel$export(module.exports, "updatePageNumber", () => $19191fe6327e4c41$export$80051aaa1c551d75);
const $19191fe6327e4c41$export$762bdf38e87c280d = (searchString)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            searchString: searchString || '',
            page: 1
        });
    };
const $19191fe6327e4c41$export$80051aaa1c551d75 = (page)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            page: page || 1
        });
    };

});

parcelRegister("05ifK", function(module, exports) {

$parcel$export(module.exports, "fetchAndUpdatePageData", () => $5ad6858fec616fad$export$fbc9fdbc42b86571);

var $dxIU5 = parcelRequire("dxIU5");

var $ldoFd = parcelRequire("ldoFd");

var $guiFP = parcelRequire("guiFP");

var $jMP2a = parcelRequire("jMP2a");

var $NDFJi = parcelRequire("NDFJi");

var $kzfAD = parcelRequire("kzfAD");
const $5ad6858fec616fad$var$defaultOptions = Object.freeze({});
const $5ad6858fec616fad$var$fireSearchSuccessEvent = (analyticsEvent, { isSearchStringEmpty: isSearchStringEmpty })=>{
    (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'jsmCustomersPageSearch succeeded', {
        isSearchStringEmpty: isSearchStringEmpty
    });
};
// we debounce the success event firing, to more accurately represent a complete search
// as opposed to a search which is triggered mid-way through a user's search term
const $5ad6858fec616fad$var$searchSuccessDebounceTime = 2000;
const $5ad6858fec616fad$var$debouncedFireSearchSuccessEvent = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))($5ad6858fec616fad$var$fireSearchSuccessEvent, $5ad6858fec616fad$var$searchSuccessDebounceTime, {
    leading: true,
    trailing: false
});
const $5ad6858fec616fad$export$fbc9fdbc42b86571 = ({ createAnalyticsEvent: createAnalyticsEvent } = $5ad6858fec616fad$var$defaultOptions)=>async ({ getState: getState, setState: setState }, { baseUrl: baseUrl, projectKey: projectKey })=>{
        const { loading: loading, ...rest } = getState();
        setState({
            ...rest,
            loading: true,
            error: null
        });
        try {
            const signal = (0, $NDFJi.abortControllerUtils).getAbortSignal();
            const shouldFetchUserPermissions = (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(rest.userPermissions);
            const { userPermissions: userPermissions, pageData: pageData } = await (0, $kzfAD.fetchCustomers)(baseUrl, projectKey, shouldFetchUserPermissions, rest.searchString, rest.page, signal);
            if (userPermissions) setState({
                ...getState(),
                userPermissions: userPermissions,
                pageData: pageData,
                loading: false
            });
            else setState({
                ...getState(),
                pageData: pageData,
                loading: false
            });
            if (createAnalyticsEvent) {
                const analyticsEvent = createAnalyticsEvent({});
                $5ad6858fec616fad$var$debouncedFireSearchSuccessEvent(analyticsEvent, {
                    isSearchStringEmpty: rest.searchString === ''
                });
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            if (err && err.name === 'AbortError') return;
            // Only fire analytics for unexpected errors. In this case the backend really
            // only returns a 403 if the current user doesn't have a valid service desk
            // license or is not an agent in the current project. Such a user shouldn't
            // have access to the customers/orgs page anyway to trigger this fetch action.
            // As such any errors we get here can be considered unexpected, so we log them
            (0, $guiFP.default)({
                meta: {
                    id: 'fetchAndUpdatePageData',
                    packageName: 'jiraServicedeskCustomers',
                    teamName: 'boysenberry'
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
            setState({
                ...getState(),
                error: err,
                loading: false
            });
        }
    };

});
parcelRegister("NDFJi", function(module, exports) {

$parcel$export(module.exports, "splitInputTextBySeparator", () => $b033debb5a3ec513$export$39feb0d4e17bb1a0);
$parcel$export(module.exports, "abortControllerUtils", () => $b033debb5a3ec513$export$aa8a3296fc0fcc0d);
$parcel$export(module.exports, "isHttpClientErrorResponse", () => $b033debb5a3ec513$export$2b62e563f0fadcee);

var $guiFP = parcelRequire("guiFP");
const $b033debb5a3ec513$export$1a5a4674dd906e7e = (statusCode)=>statusCode === 0;
const $b033debb5a3ec513$export$d31fd506ce75fa65 = (statusCode)=>statusCode >= 400 && statusCode < 500;
const $b033debb5a3ec513$export$53ee51427129200c = (statusCode)=>$b033debb5a3ec513$export$1a5a4674dd906e7e(statusCode) || $b033debb5a3ec513$export$d31fd506ce75fa65(statusCode);
const $b033debb5a3ec513$export$58da9968c3170cb1 = (err)=>{
    if ($b033debb5a3ec513$export$53ee51427129200c(Number(err.statusCode))) return;
    (0, $guiFP.default)({
        meta: {
            id: 'helpCenterFetchService',
            packageName: 'jiraServicedeskCustomersOrganizationCommon',
            teamName: 'boysenberry'
        },
        error: err,
        sendToPrivacyUnsafeSplunk: true
    });
};
const $b033debb5a3ec513$export$39feb0d4e17bb1a0 = (input = '')=>{
    const substrings = input.split(/[\s,;]+/g);
    return substrings.filter((value)=>value.trim());
};
const $b033debb5a3ec513$export$aa8a3296fc0fcc0d = (()=>{
    let abortController;
    const getAbortSignal = ()=>{
        if (abortController) abortController.abort();
        // AbortController is only supported from Node.js 15
        // and throws error when run in SSR (Node.js 12)
        try {
            abortController = new AbortController();
            return abortController.signal;
        } catch  {
            return null;
        }
    };
    return {
        getAbortSignal: getAbortSignal
    };
})();
const $b033debb5a3ec513$export$2b62e563f0fadcee = (statusCode)=>statusCode === 0 || statusCode >= 400 && statusCode < 500;

});

parcelRegister("kzfAD", function(module, exports) {

$parcel$export(module.exports, "fetchCustomers", () => $a3e06b4845ffe047$export$9b3e065657c7cd2e);

var $lRmyA = parcelRequire("lRmyA");

var $8qOvS = parcelRequire("8qOvS");
const $a3e06b4845ffe047$export$9b3e065657c7cd2e = async (baseUrl, projectKey, shouldFetchUserPermissions, query, page, signal)=>{
    const response = await (0, $lRmyA.performGetRequest)((0, $8qOvS.getUrl)(baseUrl, projectKey, shouldFetchUserPermissions, query, page), {
        method: 'GET',
        signal: signal
    });
    const result = (0, $8qOvS.transformSearchResults)(response);
    return result;
};

});
parcelRegister("8qOvS", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $1968cf91d442e77a$export$94df0e59ebebf4a7);
$parcel$export(module.exports, "transformSearchResults", () => $1968cf91d442e77a$export$8262399879b151f0);

var $53ciZ = parcelRequire("53ciZ");

var $a4UlN = parcelRequire("a4UlN");
const $1968cf91d442e77a$var$stringifyOptions = {
    skipNull: true,
    skipEmptyString: true,
    sort: false
};
const $1968cf91d442e77a$export$94df0e59ebebf4a7 = (baseUrl, projectKey, shouldFetchUserPermissions, query = '', page)=>{
    const defaultUrl = `${baseUrl}/rest/servicedesk/1/pages/people/customers/pagination/${projectKey}`;
    if (shouldFetchUserPermissions) return defaultUrl;
    // @ts-expect-error - TS2559 - Type '{ readonly skipNull: true; readonly skipEmptyString: true; readonly sort: false; }' has no properties in common with type 'StringifyOptions'.
    return `${defaultUrl}/search?${(0, $53ciZ.stringify)({
        query: query,
        page: page
    }, $1968cf91d442e77a$var$stringifyOptions)}`;
};
const $1968cf91d442e77a$export$8262399879b151f0 = (results)=>{
    // @ts-expect-error - TS2339 - Property 'customerResults' does not exist on type 'SearchResult'.
    if (results.customerResults) {
        const { customerResults: // @ts-expect-error - TS2339 - Property 'customerResults' does not exist on type 'SearchResult'.
        customerResults, // @ts-expect-error - TS2339 - Property 'customerInviteDialogueModel' does not exist on type 'SearchResult'.
        customerInviteDialogueModel: { isInviteEmailEnabled: isInviteEmailEnabled }, ...rest } = results;
        return {
            // @ts-expect-error - TS2322 - Type '{ isInviteEmailEnabled: any; results: Customers; query: string; total: number; pageNumber: number; lastDeterminedPaged: number; totalHasBeenDetermined: boolean; resultsPerPage: number; pageRange: number; } | { ...; }' is not assignable to type 'UserPermissions | null'.
            userPermissions: {
                ...rest,
                isInviteEmailEnabled: isInviteEmailEnabled
            },
            pageData: (0, $a4UlN.transformCustomerSearchResults)(customerResults)
        };
    }
    return {
        userPermissions: null,
        // @ts-expect-error - TS2345 - Argument of type 'SearchResult' is not assignable to parameter of type 'PagedSearchResults'.
        pageData: (0, $a4UlN.transformCustomerSearchResults)(results)
    };
};

});
parcelRegister("a4UlN", function(module, exports) {

$parcel$export(module.exports, "isOrganization", () => $e3280d6e0a8ab86a$export$8226e76296c78f74);
$parcel$export(module.exports, "normalizeToOrgProfile", () => $e3280d6e0a8ab86a$export$ae8b88aa7f3c74ec);
$parcel$export(module.exports, "normalizeToUserProfile", () => $e3280d6e0a8ab86a$export$f8cdd0399a1a6e);
$parcel$export(module.exports, "transformCustomerSearchResults", () => $e3280d6e0a8ab86a$export$d727facaab9dd2d9);

var $e46qA = parcelRequire("e46qA");
const $e3280d6e0a8ab86a$export$2e44165f1da65304 = ({ type: type })=>type === (0, $e46qA.PROFILE_TYPES).user;
const $e3280d6e0a8ab86a$export$8226e76296c78f74 = ({ type: type })=>type === (0, $e46qA.PROFILE_TYPES).organization;
const $e3280d6e0a8ab86a$export$ae8b88aa7f3c74ec = (profile)=>{
    if (profile.type === (0, $e46qA.PROFILE_TYPES).organization) return profile;
    return undefined;
};
const $e3280d6e0a8ab86a$export$f8cdd0399a1a6e = (profile)=>{
    if (profile.type === (0, $e46qA.PROFILE_TYPES).user) return profile;
    return undefined;
};
const $e3280d6e0a8ab86a$export$d727facaab9dd2d9 = (searchResults)=>{
    const { results: results, pageNumber: pageNumber, resultsPerPage: resultsPerPage, ...rest } = searchResults;
    return {
        customers: results,
        page: pageNumber,
        rowsPerPage: resultsPerPage,
        ...rest
    };
};

});
parcelRegister("e46qA", function(module, exports) {

$parcel$export(module.exports, "HAS_LOGGED_IN", () => $844d5bc20fa37e0e$export$e524939ea46db45f);
$parcel$export(module.exports, "PENDING_LOGIN", () => $844d5bc20fa37e0e$export$c3a105a524843459);
$parcel$export(module.exports, "NOT_AVAILABLE", () => $844d5bc20fa37e0e$export$d5f291b4be36f605);
$parcel$export(module.exports, "PROFILE_TYPES", () => $844d5bc20fa37e0e$export$419b0fc33fbd6ae7);
const $844d5bc20fa37e0e$export$e524939ea46db45f = 'HAS_LOGGED_IN';
const $844d5bc20fa37e0e$export$c3a105a524843459 = 'PENDING_LOGIN';
const $844d5bc20fa37e0e$export$d5f291b4be36f605 = 'NOT_AVAILABLE';
const $844d5bc20fa37e0e$export$c0ae0768e117bb0e = 10;
const $844d5bc20fa37e0e$export$9b2c73c824a302e4 = 5;
const $844d5bc20fa37e0e$export$419b0fc33fbd6ae7 = {
    user: 'User',
    organization: 'Organisation'
};

});







parcelRegister("1rtHO", function(module, exports) {

$parcel$export(module.exports, "CustomersApp", () => $f0dec7f889245693$export$8119386408e137b9);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $giAhk = parcelRequire("giAhk");

var $be3PE = parcelRequire("be3PE");

var $7d1RI = parcelRequire("7d1RI");

var $c7ChL = parcelRequire("c7ChL");

var $6OqHe = parcelRequire("6OqHe");

var $74czz = parcelRequire("74czz");

var $90cVE = parcelRequire("90cVE");

var $84MTW = parcelRequire("84MTW");

var $eWZfO = parcelRequire("eWZfO");
const $f0dec7f889245693$var$Customers = ({ useCommonPageContext: useCommonPageContext = (0, $7d1RI.useCommonPageContext), intl: { formatMessage: formatMessage } })=>{
    const { baseUrl: baseUrl, projectKey: projectKey, isProjectSimplified: isProjectSimplified } = useCommonPageContext();
    const [{ userPermissions: userPermissions }, { onResetSearchState: onResetSearchState }] = (0, $6OqHe.useAppStore)();
    (0, $eUqFw.useEffect)(()=>()=>{
            onResetSearchState();
        }, [
        onResetSearchState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f0dec7f889245693$var$PageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c7ChL.Header), {
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $90cVE.HeaderActions), null)
    }, formatMessage((0, $eWZfO.default).customersBreadcrumbTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $74czz.AccessMessage), {
        // @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
        baseUrl: baseUrl,
        // @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
        projectKey: projectKey,
        userPermissions: userPermissions,
        isProjectSimplified: isProjectSimplified
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $84MTW.SearchWithResults), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $be3PE.JsmPageInteractiveEvent), null));
};
const $f0dec7f889245693$export$8119386408e137b9 = (0, $giAhk.injectIntlV2)($f0dec7f889245693$var$Customers); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f0dec7f889245693$var$PageWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _c71lif4r",
            __cmplp.className
        ])
    });
});

});
parcelRegister("be3PE", function(module, exports) {

$parcel$export(module.exports, "JsmPageInteractiveEvent", () => $695cc37a0df2f37c$export$c4ba40c380ee9a11);

var $eUqFw = parcelRequire("eUqFw");

var $7vf5z = parcelRequire("7vf5z");
const $695cc37a0df2f37c$export$c4ba40c380ee9a11 = (args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7vf5z.default), args);
$695cc37a0df2f37c$export$c4ba40c380ee9a11.defaultProps = {
    isExpectedToHaveSsr: false,
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    withMarks: [],
    extra: {}
};
$695cc37a0df2f37c$export$c4ba40c380ee9a11.displayName = 'JsmPageInteractiveEvent';

});
parcelRegister("7vf5z", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $074ba9858fda469d$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $074ba9858fda469d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $074ba9858fda469d$export$9b3029ee6188a41f);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $4nnPJ = parcelRequire("4nnPJ");

var $1QVWH = parcelRequire("1QVWH");

var $j2Yjr = parcelRequire("j2Yjr");

var $gnIbC = parcelRequire("gnIbC");

var $22iQy = parcelRequire("22iQy");

var $brm1D = parcelRequire("brm1D");

var $ifyPR = parcelRequire("ifyPR");

var $aS0xb = parcelRequire("aS0xb");

var $45wsB = parcelRequire("45wsB");
const $074ba9858fda469d$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $074ba9858fda469d$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame, waitForLongTaskIdleTTI: waitForLongTaskIdleTTI } = this.props;
        $074ba9858fda469d$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1ybV0.ff)('uip.ufo') && (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $aS0xb.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $ifyPR.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $45wsB.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1QVWH.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j2Yjr.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brm1D.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $gnIbC.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $22iQy.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame,
            waitForLongTaskIdleTTI: waitForLongTaskIdleTTI
        }));
    }
}
const $074ba9858fda469d$export$9b3029ee6188a41f = $074ba9858fda469d$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("1QVWH", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4fbf7a0879450da$export$2e2bcd8739ae039);
$parcel$export(module.exports, "addUFOCustomData", () => $a4fbf7a0879450da$export$d12f56a472cdbe6c);

var $eUqFw = parcelRequire("eUqFw");

var $5iuyH = parcelRequire("5iuyH");

var $gnIbC = parcelRequire("gnIbC");

var $fVaJL = parcelRequire("fVaJL");
function $a4fbf7a0879450da$export$2e2bcd8739ae039({ data: data }) {
    const interactionContext = (0, $eUqFw.useContext)((0, $5iuyH.default));
    (0, $eUqFw.useMemo)(()=>{
        if (!interactionContext) return;
        interactionContext.addCustomData(data);
    }, [
        data,
        interactionContext
    ]);
    return null;
}
function $a4fbf7a0879450da$export$d12f56a472cdbe6c(data) {
    const interactionId = (0, $gnIbC.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    (0, $fVaJL.addCustomData)(currentInteractionId, [], data);
}

});

parcelRegister("j2Yjr", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $9cfce24b860b88bd$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $9cfce24b860b88bd$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $9cfce24b860b88bd$export$d93d677ef2f33c5c);

var $eUqFw = parcelRequire("eUqFw");

var $5iuyH = parcelRequire("5iuyH");

var $gnIbC = parcelRequire("gnIbC");

var $fVaJL = parcelRequire("fVaJL");
function $9cfce24b860b88bd$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $9cfce24b860b88bd$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $eUqFw.useContext)((0, $5iuyH.default));
    const interactionId = (0, $gnIbC.getInteractionId)().current;
    (0, $eUqFw.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $fVaJL.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $9cfce24b860b88bd$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $9cfce24b860b88bd$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $gnIbC.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $fVaJL.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $9cfce24b860b88bd$export$f02972da195a43bb(marks, timingsConfig);
        (0, $fVaJL.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("22iQy", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $c48b51f586335ad5$export$575e93c0f9905999);

var $eUqFw = parcelRequire("eUqFw");

var $acbV3 = parcelRequire("acbV3");

var $6iz4v = parcelRequire("6iz4v");

var $6xYPC = parcelRequire("6xYPC");

var $1ybV0 = parcelRequire("1ybV0");

var $cNlZD = parcelRequire("cNlZD");

var $cNlZD = parcelRequire("cNlZD");

var $6M8Uw = parcelRequire("6M8Uw");
var $2B87Z = parcelRequire("2B87Z");

var $87isp = parcelRequire("87isp");

var $5iuyH = parcelRequire("5iuyH");

const $c48b51f586335ad5$var$emitMetrics = (metric, customData, stopTime)=>{
    !(0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) {
        if (!(0, $1ybV0.ff)('bm3.wait-for-long-task')) {
            metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
        }
        metric.stop({
            customData: customData,
            stopTime: stopTime
        });
    } else metric.stop({
        customData: customData
    });
    if ((0, $87isp.isAutomaticExposureCollectionEnabled)()) (0, $6xYPC.stopLowPriorityEventDelay)();
};
class $c48b51f586335ad5$export$575e93c0f9905999 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $1ybV0.ff)('bm3.wait-for-long-task') ? (0, $acbV3.browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_END');
        (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (this.props.waitForLongTaskIdleTTI) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            (0, $cNlZD.getTTIValue)().then((tti)=>{
                (0, $cNlZD.resetTTIObserver)();
                (0, $6iz4v.setMark)('BROWSER_METRICS_LONG_TASK_TTI_END', {
                    startTime: tti
                });
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_LONG_TASK_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_LONG_TASK_TTI_END');
                $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
        } else if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) {
                    metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                }
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                    $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
                }, 500);
                else $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            $c48b51f586335ad5$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $5iuyH.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("cNlZD", function(module, exports) {

$parcel$export(module.exports, "resetTTIObserver", () => $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c);
$parcel$export(module.exports, "startTTIObserver", () => $2134fd1f8b4ec9b6$export$d2209a9a3184ff99);
$parcel$export(module.exports, "getTTIValue", () => $2134fd1f8b4ec9b6$export$e67176cf000b0a2e);

var $ba8ih = parcelRequire("ba8ih");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
let $2134fd1f8b4ec9b6$var$resolveTti = (_v)=>{};
let $2134fd1f8b4ec9b6$var$observerStarted = false;
/**
 * Initialize module state and return the promise a consumer can use to wait
 * for the TTI event.
 */ function $2134fd1f8b4ec9b6$var$initTtiPromise() {
    return new Promise((resolve)=>{
        let hasResolved = false;
        const callback = (ttiResult)=>{
            if (hasResolved) return;
            hasResolved = true;
            resolve(ttiResult);
        };
        $2134fd1f8b4ec9b6$var$resolveTti = callback;
    });
}
let $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
function $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c() {
    $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
    $2134fd1f8b4ec9b6$var$observerStarted = false;
}
function $2134fd1f8b4ec9b6$export$d2209a9a3184ff99() {
    $2134fd1f8b4ec9b6$var$observerStarted = true;
    let cleanupObserver = null;
    let lastSeenEventTime = performance.now();
    const callback = ()=>{
        cleanupObserver?.();
        $2134fd1f8b4ec9b6$var$resolveTti(lastSeenEventTime);
    };
    let timeoutId = setTimeout(callback, 5000);
    cleanupObserver = (0, $ba8ih.startLongTaskObserver)(()=>{
        lastSeenEventTime = performance.now();
        clearTimeout(timeoutId);
        timeoutId = setTimeout(callback, 5000);
    });
}
function $2134fd1f8b4ec9b6$export$e67176cf000b0a2e() {
    const promise = $2134fd1f8b4ec9b6$var$ttiPromise ?? $2134fd1f8b4ec9b6$var$initTtiPromise();
    if (!$2134fd1f8b4ec9b6$var$observerStarted) $2134fd1f8b4ec9b6$export$d2209a9a3184ff99();
    return promise;
}

});
parcelRegister("ba8ih", function(module, exports) {

$parcel$export(module.exports, "startLongTaskObserver", () => $c3f66a1c0c2d8c9c$export$af412d3da3bf848a);
/**
 * Starts a long-task observer that will call `cb` on each observation.
 * Returns a disposal function
 */ function $c3f66a1c0c2d8c9c$export$af412d3da3bf848a(cb) {
    const observer = new PerformanceObserver(()=>{
        cb();
    });
    observer.observe({
        type: 'longtask'
    });
    return ()=>{
        observer.disconnect();
    };
}

});


parcelRegister("6M8Uw", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $e57b25b6033962a3$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $e57b25b6033962a3$export$2a999c5f84501025);

var $6iz4v = parcelRequire("6iz4v");
const $e57b25b6033962a3$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $e57b25b6033962a3$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($e57b25b6033962a3$export$8e54fca0a680fdfd);
        (0, $6iz4v.setMark)($e57b25b6033962a3$export$8e54fca0a680fdfd);
    }
    return null;
};

});

const $37f655a4e4d5690e$export$56940a9488e85199 = 'jira.fe.spa-';
const $37f655a4e4d5690e$export$45c4b6bf7935c69a = `${$37f655a4e4d5690e$export$56940a9488e85199}start`;
const $37f655a4e4d5690e$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $37f655a4e4d5690e$export$ff834eccc35b9089 = 'appBundleReady';
const $37f655a4e4d5690e$export$86b05e34d462ead8 = 'prefetchApiReady';
const $37f655a4e4d5690e$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $37f655a4e4d5690e$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $37f655a4e4d5690e$export$3ae43cc1782d058f = 'jswRenderStart';
const $37f655a4e4d5690e$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $37f655a4e4d5690e$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $37f655a4e4d5690e$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $37f655a4e4d5690e$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $37f655a4e4d5690e$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $37f655a4e4d5690e$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $37f655a4e4d5690e$export$99c08ec92759c71c = 'tti-raf-mark';
const $37f655a4e4d5690e$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("brm1D", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $aa08c3eb931d9705$export$d91154f099475c5);

var $eUqFw = parcelRequire("eUqFw");

var $4nnPJ = parcelRequire("4nnPJ");

var $5iuyH = parcelRequire("5iuyH");
class $aa08c3eb931d9705$export$d91154f099475c5 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $4nnPJ.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $5iuyH.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("ifyPR", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $d6714c8d166fb68b$export$bf239ac2bfb04967);

var $gnIbC = parcelRequire("gnIbC");

var $fVaJL = parcelRequire("fVaJL");
function $d6714c8d166fb68b$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $gnIbC.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $fVaJL.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("aS0xb", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $714e33db0dc77e43$export$e63862cd888fe05a);

var $4nnPJ = parcelRequire("4nnPJ");
var $aPkDp = parcelRequire("aPkDp");

var $gnIbC = parcelRequire("gnIbC");

var $fVaJL = parcelRequire("fVaJL");
async function $714e33db0dc77e43$export$e63862cd888fe05a() {
    const interactionId = (0, $gnIbC.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $4nnPJ.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $aPkDp.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $fVaJL.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("45wsB", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $58cb476ec3ec20ed$export$f00f1e874ce869e9);

var $aWbzA = parcelRequire("aWbzA");

var $gnIbC = parcelRequire("gnIbC");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $58cb476ec3ec20ed$export$7b4abba432e57989 = (value)=>$58cb476ec3ec20ed$var$isString(value) && $58cb476ec3ec20ed$var$startsAsObject(value) || $58cb476ec3ec20ed$var$isObject(value);
const $58cb476ec3ec20ed$export$fcc03ee4c944962f = (featureFlagValue)=>$58cb476ec3ec20ed$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $58cb476ec3ec20ed$export$d2818866b4acbea4 = new Map();
const $58cb476ec3ec20ed$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $gnIbC.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $aWbzA.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $58cb476ec3ec20ed$export$fcc03ee4c944962f(value);
            $58cb476ec3ec20ed$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});



parcelRegister("c7ChL", function(module, exports) {

$parcel$export(module.exports, "Header", () => $267d5e78dd573566$export$8b251419efc915eb);

var $eUqFw = parcelRequire("eUqFw");

var $3a8wJ = parcelRequire("3a8wJ");

var $7d1RI = parcelRequire("7d1RI");

var $gBok5 = parcelRequire("gBok5");
const $267d5e78dd573566$export$8b251419efc915eb = ({ actions: actions, children: children, crumbText: crumbText })=>{
    const { baseUrl: baseUrl, projectKey: projectKey, projectName: projectName } = (0, $7d1RI.useCommonPageContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3a8wJ.default), {
        actions: actions,
        breadcrumbs: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gBok5.CustomBreadcrumbs), {
            /* @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Argument of type 'string | undefined' is not assignable to parameter of type 'string' */ baseUrl: baseUrl,
            /* @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Argument of type 'string | undefined' is not assignable to parameter of type 'string' */ projectKey: projectKey,
            /* @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Argument of type 'string | undefined' is not assignable to parameter of type 'string' */ projectName: projectName,
            crumbText: crumbText || ''
        }),
        truncateTitle: true
    }, children);
};
$267d5e78dd573566$export$8b251419efc915eb.displayName = 'HeaderWithBreadcrumb';

});
parcelRegister("gBok5", function(module, exports) {

$parcel$export(module.exports, "CustomBreadcrumbs", () => $ba6c515e926f43b1$export$686f1edf1ae6303e);

var $eUqFw = parcelRequire("eUqFw");

var $kKe2o = parcelRequire("kKe2o");
var $7ehAr = parcelRequire("7ehAr");
var $c76ap = parcelRequire("c76ap");
var $dpXKE = parcelRequire("dpXKE");
const $ba6c515e926f43b1$export$686f1edf1ae6303e = ({ baseUrl: baseUrl, projectKey: projectKey, projectName: projectName, crumbText: crumbText })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ehAr.BreadcrumbManager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c76ap.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dpXKE.default), {
        baseUrl: baseUrl,
        projectKey: projectKey,
        projectName: projectName
    }, crumbText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKe2o.default), {
        breadcrumb: {
            text: crumbText,
            href: `${baseUrl}/jira/servicedesk/projects/${projectKey}/customers`,
            type: 'servicedeskCustomersBreadcrumb'
        }
    }) : null));

});


parcelRegister("74czz", function(module, exports) {

$parcel$export(module.exports, "AccessMessage", () => $ab24d9e9d158795d$export$8ee72bd493afce87);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1H7E7 = parcelRequire("1H7E7");

var $5cljw = parcelRequire("5cljw");
const $ab24d9e9d158795d$export$8ee72bd493afce87 = ({ baseUrl: baseUrl, projectKey: projectKey, isProjectSimplified: isProjectSimplified, userPermissions: // @ts-expect-error - TS2740 - Type '{}' is missing the following properties from type 'UserPermissions': customerRoleMisconfigured, canAdminister, canAdministerJIRA, outgoingMailConfigured, and 7 more.
userPermissions = {} })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { canAdminister: canAdminister } = userPermissions;
    if (!canAdminister) return null;
    const customerPermissionUrl = isProjectSimplified ? `${baseUrl}/jira/servicedesk/projects/${projectKey}/settings/channels/customer-permissions` : `${baseUrl}/jira/servicedesk/projects/${projectKey}/settings/customer-permissions`;
    const message = (0, $1ybV0.ff)('jsm-csm-a11y-fixes_ho588') ? (0, $5cljw.getMessageBasedOnUserPermissionsNew)(userPermissions) : (0, $5cljw.getMessageBasedOnUserPermissions)(userPermissions);
    return (0, $1ybV0.ff)('jsm-csm-a11y-fixes_ho588') ? formatMessage(message, {
        a: (children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                appearance: "link",
                href: customerPermissionUrl,
                spacing: "none"
            }, children)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1H7E7.default), {
        ...message,
        values: {
            tagStart: `<a href=${customerPermissionUrl} />`,
            tagEnd: '</a>'
        }
    });
};

});
parcelRegister("1H7E7", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b24d6ddddc3bd62$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $giAhk = parcelRequire("giAhk");
/**
 * Helper class to safely add HTML to translation strings.
 *
 * All HTML MUST be injected via 'values' and not be included directly in the defaultMessages.
 *
 * Also note that in order to mitigate mistranslations this component will not replace any placeholders unless all placeholders
 * can be replaced.
 */ // eslint-disable-next-line jira/react/no-class-components
class $1b24d6ddddc3bd62$var$HtmlFormattedMessage extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            values: {}
        };
    }
    componentDidUpdate() {
        this.renderTranslatedMessage(this.ref);
    }
    renderTranslatedMessage(ref) {
        if (ref) {
            const { values: values } = this.props;
            const { innerHTML: innerHTML } = ref;
            const containAllKeys = Object.keys(values).every((key)=>innerHTML.indexOf(key) !== -1);
            if (containAllKeys) {
                let newHtmlContent = innerHTML;
                Object.keys(values).forEach((key)=>{
                    newHtmlContent = newHtmlContent.replace(`{${key}}`, values[key]);
                });
                // eslint-disable-next-line no-param-reassign
                ref.innerHTML = newHtmlContent;
            }
        }
    }
    render() {
        const { intl: intl, id: id, defaultMessage: defaultMessage, values: values } = this.props;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const messageTags = Object.keys(values).reduce((tags, key)=>{
            // eslint-disable-next-line no-param-reassign
            tags[key] = `{${key}}`;
            return tags;
        }, {});
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            ref: this.onRef,
            key: JSON.stringify(values)
        }, intl.formatMessage({
            id: id,
            defaultMessage: defaultMessage
        }, messageTags));
    }
    constructor(...args){
        super(...args);
        this.onRef = (ref)=>{
            this.ref = ref;
            this.renderTranslatedMessage(ref);
        };
    }
}
var $1b24d6ddddc3bd62$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($1b24d6ddddc3bd62$var$HtmlFormattedMessage);

});

parcelRegister("5cljw", function(module, exports) {

$parcel$export(module.exports, "getMessageBasedOnUserPermissions", () => $c64c63af43b1b8a3$export$c022198e62b2f564);
$parcel$export(module.exports, "getMessageBasedOnUserPermissionsNew", () => $c64c63af43b1b8a3$export$e578f2f6d15240f8);

var $1bU2R = parcelRequire("1bU2R");
const $c64c63af43b1b8a3$export$c022198e62b2f564 = (userPermissions)=>{
    const { serviceDeskPublicSignUp: serviceDeskPublicSignUp, serviceDeskOpenAccess: serviceDeskOpenAccess } = userPermissions;
    // Open: Anyone can raise a request in this service desk. Link to customer permissions page.
    if (serviceDeskPublicSignUp) return (0, $1bU2R.default).publicSignUpAccessMessageJsm;
    // Any Existing User: Everyone with an account on this Jira instance is a customer. Link to customer permissions page.
    if (serviceDeskOpenAccess) return (0, $1bU2R.default).openAccessMessage;
    // Closed: This service desk is open to customers who are added to the project. Link to customer permissions page.
    return (0, $1bU2R.default).adminAccessMessageJsm;
};
const $c64c63af43b1b8a3$export$e578f2f6d15240f8 = (userPermissions)=>{
    const { serviceDeskPublicSignUp: serviceDeskPublicSignUp, serviceDeskOpenAccess: serviceDeskOpenAccess } = userPermissions;
    // Open: Anyone can raise a request in this service desk. Link to customer permissions page.
    if (serviceDeskPublicSignUp) return (0, $1bU2R.default).publicSignUpAccessMessageJsmNew;
    // Any Existing User: Everyone with an account on this Jira instance is a customer. Link to customer permissions page.
    if (serviceDeskOpenAccess) return (0, $1bU2R.default).openAccessMessageNew;
    // Closed: This service desk is open to customers who are added to the project. Link to customer permissions page.
    return (0, $1bU2R.default).adminAccessMessageJsmNew;
};

});
parcelRegister("1bU2R", function(module, exports) {

$parcel$export(module.exports, "default", () => $90b4a76aeec8baf0$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $90b4a76aeec8baf0$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    publicSignUpAccessMessageJsm: {
        "id": "servicedesk-customers.access-message.public-sign-up-access-message-jsm",
        "defaultMessage": "Anyone can raise a request in this service project. {tagStart} Change permissions. {tagEnd}"
    },
    openAccessMessage: {
        "id": "servicedesk-customers.access-message.open-access-message",
        "defaultMessage": "Everyone with an account on this Jira instance is a customer. {tagStart} Change permissions. {tagEnd}"
    },
    adminAccessMessageJsm: {
        "id": "servicedesk-customers.access-message.admin-access-message-jsm",
        "defaultMessage": "This service project is open to customers who are added to the project. {tagStart} Change permissions. {tagEnd}"
    },
    publicSignUpAccessMessageJsmNew: {
        "id": "servicedesk-customers.access-message.public-sign-up-access-message-jsm-new",
        "defaultMessage": "Anyone can raise a request in this service project. <a>Change permissions.</a>"
    },
    openAccessMessageNew: {
        "id": "servicedesk-customers.access-message.open-access-message-new",
        "defaultMessage": "Everyone with an account on this Jira instance is a customer. <a>Change permissions.</a>"
    },
    adminAccessMessageJsmNew: {
        "id": "servicedesk-customers.access-message.admin-access-message-jsm-new",
        "defaultMessage": "This service project is open to customers who are added to the project. <a>Change permissions.</a>"
    }
});

});



parcelRegister("90cVE", function(module, exports) {

$parcel$export(module.exports, "HeaderActions", () => $1bd37f871fdada62$export$223875819fd7cf93);

var $eUqFw = parcelRequire("eUqFw");

var $bLFgh = parcelRequire("bLFgh");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $7d1RI = parcelRequire("7d1RI");

var $ZuvYz = parcelRequire("ZuvYz");

var $f7BqA = parcelRequire("f7BqA");

var $ggHET = parcelRequire("ggHET");

var $3a3cg = parcelRequire("3a3cg");

var $6OqHe = parcelRequire("6OqHe");

var $bwDmb = parcelRequire("bwDmb");
const $1bd37f871fdada62$export$223875819fd7cf93 = ()=>{
    const { baseUrl: baseUrl, projectKey: projectKey } = (0, $7d1RI.useCommonPageContext)();
    const [{ userPermissions: userPermissions }, { fetchAndUpdatePageData: fetchAndUpdatePageData, updateOptimisticCustomers: updateOptimisticCustomers }] = (0, $6OqHe.useAppStore)();
    const { canAdminister: canAdminister, canManageOrganizations: canManageOrganizations, canInvite: canInvite } = userPermissions || {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $1bd37f871fdada62$var$buttonGroupWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f7BqA.CanManageOrganization), {
        canAdminister: canAdminister,
        canManageOrganizations: canManageOrganizations
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bwDmb.AddOrganizationsInlineDialogButton), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ZuvYz.CanInviteCustomers), {
        canInvite: canInvite
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ggHET.AddCustomersDialogContextProvider), {
        // @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
        baseUrl: baseUrl,
        // @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
        projectKey: projectKey,
        userPermissions: userPermissions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3a3cg.AddCustomersInlineDialogButton), {
        onUpdateAppState: fetchAndUpdatePageData,
        onPrependOptimisticCustomers: updateOptimisticCustomers
    })))));
};
const $1bd37f871fdada62$var$buttonGroupWrapperStyles = (0, $1ZAYh.xcss)({
    paddingRight: 'space.500'
});

});
parcelRegister("ZuvYz", function(module, exports) {

$parcel$export(module.exports, "CanInviteCustomers", () => $5f59473c92d44567$export$1b5263a66e3e70c0);

var $eUqFw = parcelRequire("eUqFw");
const $5f59473c92d44567$export$1b5263a66e3e70c0 = ({ children: children, canInvite: canInvite })=>{
    if (canInvite === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    return null;
};

});

parcelRegister("f7BqA", function(module, exports) {

$parcel$export(module.exports, "CanManageOrganization", () => $1a674b93f9da8755$export$ee7e83ff27686f81);

var $eUqFw = parcelRequire("eUqFw");
const $1a674b93f9da8755$export$ee7e83ff27686f81 = ({ canAdminister: canAdminister, canManageOrganizations: canManageOrganizations, children: children })=>{
    if (canAdminister === true || canManageOrganizations === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    return null;
};

});

parcelRegister("ggHET", function(module, exports) {

$parcel$export(module.exports, "AddCustomersDialogContext", () => $75bfc1059541599f$export$9ed8929522ab3e7d);
$parcel$export(module.exports, "AddCustomersDialogContextProvider", () => $75bfc1059541599f$export$4cba165b9c3121cb);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $NqqMP = parcelRequire("NqqMP");

var $bdu6l = parcelRequire("bdu6l");

var $7Mksm = parcelRequire("7Mksm");
const $75bfc1059541599f$export$9ed8929522ab3e7d = /*#__PURE__*/ (0, $eUqFw.createContext)([
    {
        isOpen: false,
        customers: [],
        isValidating: false,
        organization: undefined,
        helpCenter: undefined,
        defaultOrganization: undefined,
        customerEmailsInputFieldValue: '',
        userPermissions: undefined,
        emailValidationErrors: null,
        serviceErrors: null,
        emailPresetValue: ''
    },
    {
        togglePopup: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        setCustomers: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        setOrganization: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        setHelpCenter: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        setCustomerEmailsInputFieldValue: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        // @ts-expect-error - TS2322 - Type '(...args: any[]) => void' is not assignable to type '(emails: string[]) => Promise<undefined> | undefined'.
        onValidateCustomerEmails: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        resetForm: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        resetAndCloseForm: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        setEmailPresetValue: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    }
]);
const $75bfc1059541599f$export$4cba165b9c3121cb = ({ children: children, baseUrl: baseUrl, projectKey: projectKey, userPermissions: userPermissions, useValidateCustomerEmailsService: useValidateCustomerEmailsService, defaultOrganization: defaultOrganization })=>{
    const [customerEmailsInputFieldValue, setCustomerEmailsInputFieldValue] = (0, $eUqFw.useState)('');
    const [customers, setCustomers] = (0, $eUqFw.useState)([]);
    const [organization, setOrganization] = (0, $eUqFw.useState)();
    const [helpCenter, setHelpCenter] = (0, $eUqFw.useState)();
    const [isOpen, togglePopup, closePopup] = (0, $NqqMP.usePopupController)();
    const [emailPresetValue, setEmailPresetValue] = (0, $eUqFw.useState)('');
    const { loading: isValidating, data: validatedEmails, fetch: onValidateCustomerEmailsAsync, emailValidationErrors: emailValidationErrors, resetEmailValidation: resetEmailValidation, error: serviceErrors, resetError: resetError } = useValidateCustomerEmailsService({
        baseUrl: baseUrl,
        projectKey: projectKey
    });
    (0, $eUqFw.useEffect)(()=>{
        if (!isOpen) resetEmailValidation();
    }, [
        isOpen,
        resetEmailValidation
    ]);
    const onValidateCustomerEmails = (0, $eUqFw.useCallback)((emails)=>{
        // @ts-expect-error - TS2571 - Object is of type 'unknown'. | TS7031 - Binding element 'emailAddress' implicitly has an 'any' type.
        const existingValidatedEmails = customers.map(({ emailAddress: emailAddress })=>emailAddress);
        onValidateCustomerEmailsAsync([
            ...emails,
            ...existingValidatedEmails
        ]);
    }, [
        customers,
        onValidateCustomerEmailsAsync
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isOpen) resetError();
    }, [
        isOpen,
        resetError
    ]);
    const resetForm = (0, $eUqFw.useCallback)(()=>{
        setCustomerEmailsInputFieldValue('');
        setEmailPresetValue('');
        setCustomers([]);
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
        setOrganization();
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
        setHelpCenter();
    }, []);
    const resetAndCloseForm = (0, $eUqFw.useCallback)(()=>{
        resetForm();
        closePopup();
    }, [
        closePopup,
        resetForm
    ]);
    const state = {
        isOpen: isOpen,
        isValidating: isValidating,
        customers: customers,
        organization: organization,
        helpCenter: helpCenter,
        defaultOrganization: defaultOrganization,
        userPermissions: userPermissions,
        customerEmailsInputFieldValue: customerEmailsInputFieldValue,
        emailValidationErrors: emailValidationErrors,
        serviceErrors: serviceErrors,
        emailPresetValue: emailPresetValue
    };
    const actions = {
        togglePopup: togglePopup,
        setCustomers: setCustomers,
        setOrganization: setOrganization,
        setHelpCenter: setHelpCenter,
        setCustomerEmailsInputFieldValue: setCustomerEmailsInputFieldValue,
        onValidateCustomerEmails: onValidateCustomerEmails,
        resetForm: resetForm,
        resetAndCloseForm: resetAndCloseForm,
        setEmailPresetValue: setEmailPresetValue
    };
    (0, $eUqFw.useEffect)(()=>{
        if (validatedEmails) {
            // We only want validated emails to be prefilled as a list.
            // If we have one invalid email in the valid email list, we will
            // show this in a text area, controlled by emailPreset value
            const invalidCustomers = validatedEmails.filter((customer)=>customer.type === (0, $bdu6l.CustomerTypes).invalidCustomer);
            if (invalidCustomers.length === 0) setCustomers(validatedEmails.filter((customer)=>customer.type === (0, $bdu6l.CustomerTypes).validCustomer));
            // clear email-text-field value upon validation
            setCustomerEmailsInputFieldValue('');
        }
    }, [
        validatedEmails
    ]);
    return(// @ts-expect-error - TS2322 - Type '{ isOpen: boolean; isValidating: boolean; customers: unknown; organization: unknown; defaultOrganization: Organization | undefined; userPermissions: UserPermissions | undefined; customerEmailsInputFieldValue: string; emailValidationErrors: EmailValidationErrorType; serviceErrors: ServiceError; emailPresetValue: stri...' is not assignable to type 'AddCustomersDialogState'. | TS2322 - Type '{ togglePopup: () => void; setCustomers: React.Dispatch<unknown>; setOrganization: React.Dispatch<unknown>; setCustomerEmailsInputFieldValue: React.Dispatch<React.SetStateAction<string>>; onValidateCustomerEmails: (emails: string[]) => void; resetForm: () => void; resetAndCloseForm: () => void; setEmailPresetValue: ...' is not assignable to type 'AddCustomersDialogActions'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($75bfc1059541599f$export$9ed8929522ab3e7d.Provider, {
        value: [
            state,
            actions
        ]
    }, children));
};
$75bfc1059541599f$export$4cba165b9c3121cb.defaultProps = {
    useValidateCustomerEmailsService: (0, $7Mksm.useValidateCustomerEmailsService)
};
$75bfc1059541599f$export$4cba165b9c3121cb.displayName = 'AddCustomersDialogContext';

});
parcelRegister("NqqMP", function(module, exports) {

$parcel$export(module.exports, "usePopupController", () => $fa19abd3eff42ee5$export$55fb67b4e2c495d8);

var $eUqFw = parcelRequire("eUqFw");
const $fa19abd3eff42ee5$export$55fb67b4e2c495d8 = (defaultState = false)=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(defaultState);
    const togglePopup = ()=>{
        setIsOpen((prev)=>!prev);
    };
    const closePopup = (0, $eUqFw.useCallback)(()=>setIsOpen(false), []);
    return [
        isOpen,
        togglePopup,
        closePopup
    ];
};

});

parcelRegister("bdu6l", function(module, exports) {

$parcel$export(module.exports, "CustomerTypes", () => $1f460ac7a65baf36$export$21437b03a44b5609);
const $1f460ac7a65baf36$export$21437b03a44b5609 = {
    invalidCustomer: 'invalid-customer',
    validCustomer: 'valid-customer'
};

});

parcelRegister("7Mksm", function(module, exports) {

$parcel$export(module.exports, "useValidateCustomerEmailsService", () => $a61a6928c125b599$export$3c8f9b12e7ccf671);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $fV97Z = parcelRequire("fV97Z");

var $aCE4U = parcelRequire("aCE4U");
const $a61a6928c125b599$export$3c8f9b12e7ccf671 = ({ baseUrl: baseUrl, projectKey: projectKey })=>{
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const [data, setData] = (0, $eUqFw.useState)(null);
    const [error, setError] = (0, $eUqFw.useState)(null);
    const [emailValidationErrors, setEmailValidationErrors] = (0, $eUqFw.useState)(null);
    const abortController = (0, $eUqFw.useRef)(new AbortController());
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const resetEmailValidation = ()=>{
        setEmailValidationErrors(null);
    };
    const resetError = ()=>{
        setError(null);
    };
    const fetch = (0, $eUqFw.useCallback)(async (emails)=>{
        setLoading(true);
        setError(null);
        resetEmailValidation();
        if (abortController.current && abortController.current.abort) abortController.current.abort();
        try {
            abortController.current = new AbortController();
            const { signal: signal } = abortController.current;
            const response = await (0, $fV97Z.performPostRequest)((0, $aCE4U.getUrl)(baseUrl, projectKey), {
                body: JSON.stringify({
                    emails: emails
                }),
                signal: signal
            });
            const transformedResponse = (0, $aCE4U.transformData)(response);
            setData(transformedResponse);
            setEmailValidationErrors((0, $aCE4U.transformForView)(response));
            setLoading(false);
            const analyticsEvent = createAnalyticsEvent({});
            (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, `customer ${response.failed.length ? 'addValidationFailed' : 'addValidationSucceeded'}`);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            const { reasonKey: reasonKey, response: response, statusCode: statusCode } = err;
            // Only fire analytics for unexpected errors. ValidationErrors are used when
            // the backend returns a 400. Expected 400 errors from the backend include:
            // - the email address is invalid (eg `bad@email@example.com`)
            // A 403 is also returned if the user doesn't have permission to invite, but
            // we only show the invite button after a permission check -
            // it's an unexpected error if we see it here
            const shouldFireErrorAnalytics = err.statusCode !== 400;
            if (shouldFireErrorAnalytics) (0, $guiFP.default)({
                error: err,
                meta: {
                    id: 'useValidateCustomerEmailsService',
                    packageName: 'jiraServicedeskCustomersOrganizationCommon',
                    teamName: 'boysenberry'
                },
                sendToPrivacyUnsafeSplunk: true,
                attributes: {
                    reasonKey: reasonKey
                }
            });
            if (response?.failed) setEmailValidationErrors((0, $aCE4U.transformForView)(response));
            if (response?.failed) setData((0, $aCE4U.transformData)(response));
            else setError((0, $aCE4U.transformError)(statusCode) ?? err);
            setLoading(false);
        }
    }, [
        baseUrl,
        createAnalyticsEvent,
        projectKey
    ]);
    return {
        loading: loading,
        error: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'ServiceError'.
        error,
        data: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'ServiceData<Data>'.
        data,
        fetch: // @ts-expect-error - TS2322 - Type '(emails: string[]) => Promise<void>' is not assignable to type '(() => Promise<void>) & ((ValidateCustomerEmailsRequest: string[]) => Promise<void>)'.
        fetch,
        emailValidationErrors: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'EmailValidationErrorType'.
        emailValidationErrors,
        resetEmailValidation: resetEmailValidation,
        resetError: resetError
    };
};

});
parcelRegister("fV97Z", function(module, exports) {

$parcel$export(module.exports, "JsdFetchError", () => $c9869c00ba1fbd5b$export$fee0012ae6cb3438);
$parcel$export(module.exports, "performGetRequest", () => $c9869c00ba1fbd5b$export$4a53ae1be8ec80c7);
$parcel$export(module.exports, "performPutRequest", () => $c9869c00ba1fbd5b$export$9ead1f9103e6de6b);
$parcel$export(module.exports, "performPostRequest", () => $c9869c00ba1fbd5b$export$692a4d9808143175);
$parcel$export(module.exports, "performDeleteRequest", () => $c9869c00ba1fbd5b$export$8ef51cba9d28f819);

var $8blac = parcelRequire("8blac");

var $kkgbD = parcelRequire("kkgbD");

var $fVqUX = parcelRequire("fVqUX");


var $7EhAs = parcelRequire("7EhAs");

var $88Osm = parcelRequire("88Osm");

var $lRmyA = parcelRequire("lRmyA");
const $c9869c00ba1fbd5b$var$VALIDATION_ERROR_KEY = 'validation.error';
class $c9869c00ba1fbd5b$export$fee0012ae6cb3438 extends (0, $7EhAs.default) {
    constructor(statusCode, message, reasonKey, response){
        super(statusCode, (0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(message) ? `Fetch call failed with status code: ${statusCode}` : message);
        this.name = 'JsdFetchError';
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($kkgbD)))(reasonKey)) this.reasonKey = reasonKey;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($kkgbD)))(response)) this.response = response;
    }
}
const $c9869c00ba1fbd5b$var$transformMessageErrorsFromServer = (errors = [])=>errors.reduce((messages, { errorMessage: errorMessage })=>{
        messages.push(errorMessage);
        return messages;
    }, []).join(' ');
const $c9869c00ba1fbd5b$var$putOptions = {
    ...(0, $fVqUX.default),
    method: 'PUT'
};
const $c9869c00ba1fbd5b$var$postOptions = {
    ...(0, $fVqUX.default),
    method: 'POST'
};
const $c9869c00ba1fbd5b$var$deleteOptions = {
    ...(0, $fVqUX.default),
    method: 'DELETE'
};
const $c9869c00ba1fbd5b$var$patchOptions = {
    ...(0, $fVqUX.default),
    method: 'PATCH'
};
const $c9869c00ba1fbd5b$var$processResponse = async (response)=>{
    if ((0, $1c3fbb431a173cc6$export$9de493bcd9b1d977) === response.status) {
        const jsonResponse = await response.json();
        const { errors: errors, reasonKey: reasonKey } = jsonResponse;
        if (reasonKey === $c9869c00ba1fbd5b$var$VALIDATION_ERROR_KEY) throw (0, $lRmyA.transformValidationErrorFromServer)(jsonResponse);
        const message = $c9869c00ba1fbd5b$var$transformMessageErrorsFromServer(errors);
        throw new $c9869c00ba1fbd5b$export$fee0012ae6cb3438(response.status, message, reasonKey, jsonResponse);
    }
    if (!response.ok) {
        const traceId = response.headers.get((0, $88Osm.TRACE_ID_HEADER));
        if (traceId != null && traceId !== '') throw new (0, $7EhAs.default)(response.status, `Error server response: ${response.status}`, traceId);
        else throw new (0, $7EhAs.default)(response.status, `Error server response: ${response.status}`);
    }
    if (response.status === (0, $1c3fbb431a173cc6$export$3288b14b6745c572)) return Promise.resolve(null);
    return response.text().then((text)=>text ? JSON.parse(text) : null);
};
const $c9869c00ba1fbd5b$export$4a53ae1be8ec80c7 = (url, options = {})=>fetch(url, {
        ...(0, $fVqUX.default),
        ...options
    }).then($c9869c00ba1fbd5b$var$processResponse);
const $c9869c00ba1fbd5b$export$9ead1f9103e6de6b = (url, options = {})=>fetch(url, {
        ...$c9869c00ba1fbd5b$var$putOptions,
        ...options
    }).then($c9869c00ba1fbd5b$var$processResponse);
const $c9869c00ba1fbd5b$export$692a4d9808143175 = (url, options = {})=>fetch(url, {
        ...$c9869c00ba1fbd5b$var$postOptions,
        ...options
    }).then($c9869c00ba1fbd5b$var$processResponse);
const $c9869c00ba1fbd5b$export$8ef51cba9d28f819 = (url, options = {})=>fetch(url, {
        ...$c9869c00ba1fbd5b$var$deleteOptions,
        ...options
    }).then($c9869c00ba1fbd5b$var$processResponse);
const $c9869c00ba1fbd5b$export$52be6ab13d7e758d = (url, options = {})=>fetch(url, {
        ...$c9869c00ba1fbd5b$var$patchOptions,
        ...options
    }).then($c9869c00ba1fbd5b$var$processResponse);

});
const $1c3fbb431a173cc6$export$ff39ebd4bb12b718 = 201;
const $1c3fbb431a173cc6$export$3288b14b6745c572 = 204;
const $1c3fbb431a173cc6$export$9de493bcd9b1d977 = 400;
const $1c3fbb431a173cc6$export$67d19e9a991baa07 = 401;
const $1c3fbb431a173cc6$export$a3269a3914b007e3 = 403;
const $1c3fbb431a173cc6$export$8bca792d963eb0ef = 404;
const $1c3fbb431a173cc6$export$4a3cb39801694eee = 407;
const $1c3fbb431a173cc6$export$fa405bbf47d510e2 = 408;
const $1c3fbb431a173cc6$export$c09e7ea0fc79f34f = 409;
const $1c3fbb431a173cc6$export$5244030134e99 = 412;
const $1c3fbb431a173cc6$export$f90ac1df0b60853d = 413;
const $1c3fbb431a173cc6$export$a447d0a965e16776 = 422;
const $1c3fbb431a173cc6$export$3b48aba8957000cd = 426;
const $1c3fbb431a173cc6$export$6763168a631449a2 = 429;
const $1c3fbb431a173cc6$export$e813cd7045fcc98d = 500;
const $1c3fbb431a173cc6$export$2ce38d41a306034e = 502;
const $1c3fbb431a173cc6$export$974c37534b0191b1 = 503;
const $1c3fbb431a173cc6$export$5400e8dddac3fcf3 = 504;


parcelRegister("aCE4U", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $0ebfa32a9aa0108b$export$94df0e59ebebf4a7);
$parcel$export(module.exports, "transformData", () => $0ebfa32a9aa0108b$export$3ceb62baab058c6b);
$parcel$export(module.exports, "transformForView", () => $0ebfa32a9aa0108b$export$1b944b7015956dad);
$parcel$export(module.exports, "transformError", () => $0ebfa32a9aa0108b$export$78c6267359db7e73);

var $bdu6l = parcelRequire("bdu6l");
const $0ebfa32a9aa0108b$export$94df0e59ebebf4a7 = (baseUrl, projectKey)=>`${baseUrl}/rest/servicedesk/1/pages/people/customers/pagination/${projectKey}/invite/validate`;
const $0ebfa32a9aa0108b$export$3ceb62baab058c6b = ({ failed: failedCustomerEmails = [], success: successCustomerEmails = [] })=>[
        ...failedCustomerEmails.map((failedCustomerEmail)=>({
                ...failedCustomerEmail,
                type: (0, $bdu6l.CustomerTypes).invalidCustomer
            })),
        ...successCustomerEmails.map((successCustomerEmail)=>({
                ...successCustomerEmail,
                type: (0, $bdu6l.CustomerTypes).validCustomer
            }))
    ];
const $0ebfa32a9aa0108b$export$1b944b7015956dad = (props)=>{
    const { failed: failed, success: success } = props;
    return {
        failed: failed.map((f)=>f && f.emailAddress),
        passed: success.map((f)=>f && f.emailAddress),
        added: [],
        sent: [],
        failedWithErrors: failed.map((f)=>f && {
                email: f.emailAddress,
                error: f.error
            })
    };
};
const $0ebfa32a9aa0108b$export$78c6267359db7e73 = (statusCode)=>{
    switch(statusCode){
        case 401:
            return {
                reasonKey: 'Unauthorised.',
                reasonCode: '401',
                errors: []
            };
        case 500:
            return {
                reasonKey: 'Internal server error.',
                reasonCode: '500',
                errors: []
            };
        default:
            return null;
    }
};

});



parcelRegister("3a3cg", function(module, exports) {

$parcel$export(module.exports, "AddCustomersInlineDialogButton", () => $185b4baf8876671a$export$4777b350d0f3ed6);

var $eUqFw = parcelRequire("eUqFw");

var $8WuJm = parcelRequire("8WuJm");

var $6ZQ3I = parcelRequire("6ZQ3I");
const $185b4baf8876671a$export$4777b350d0f3ed6 = (props)=>{
    const sourceName = props.isOrganizationDefaulted === true ? 'addCustomersToOrganization' : 'addCustomers';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: sourceName,
        sourceType: (0, $41ea3621645e2acc$export$cae2783c9279926),
        attributes: {
            isSpa: true,
            version: 2
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ZQ3I.AddCustomersInlineDialogButton), props));
};

});
parcelRegister("6ZQ3I", function(module, exports) {

$parcel$export(module.exports, "AddCustomersInlineDialogButton", () => $e707675b1653de3d$export$4777b350d0f3ed6);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $7u4fN = parcelRequire("7u4fN");

var $29yDk = parcelRequire("29yDk");

var $3MV1G = parcelRequire("3MV1G");

var $cPGDt = parcelRequire("cPGDt");

var $1ybV0 = parcelRequire("1ybV0");

var $c8KxL = parcelRequire("c8KxL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $d6f6c = parcelRequire("d6f6c");

var $eAdw7 = parcelRequire("eAdw7");

var $NqqMP = parcelRequire("NqqMP");

var $7DTLe = parcelRequire("7DTLe");

var $4rWQe = parcelRequire("4rWQe");
var $dWLk9 = parcelRequire("dWLk9");


var $lDc85 = parcelRequire("lDc85");
var $adPlo = parcelRequire("adPlo");

var $dgUkL = parcelRequire("dgUkL");

var $5G38t = parcelRequire("5G38t");

var $4PQRQ = parcelRequire("4PQRQ");

var $1OmMe = parcelRequire("1OmMe");
const $e707675b1653de3d$export$836d27ce4dd57d44 = ({ isOrganizationDefaulted: isOrganizationDefaulted, onPrependOptimisticCustomers: onPrependOptimisticCustomers, onUpdateAppState: onUpdateAppState })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [showSuccess, setShowSuccess] = (0, $eUqFw.useState)(false);
    const [showError, setShowError] = (0, $eUqFw.useState)(false);
    const [failedEmails, setFailedEmails] = (0, $eUqFw.useState)([]);
    const [successCount, setSuccessCount] = (0, $eUqFw.useState)(0);
    const isMultiHcAndInviteRoutingEnabled = (0, $1ybV0.ff)('multi_help_center_kosh_integration') && (0, $1ybV0.ff)('enable_invitation_routing_with_channel_44900');
    const cloudId = (0, $dWLk9.useCloudId)();
    const activationId = (0, $4rWQe.useActivationId)();
    const workSpaceARI = String((0, $cPGDt.JiraWorkspaceAri).create({
        siteId: cloudId,
        activationId: activationId
    }));
    const [queryReference, loadQuery, disposeQuery] = (0, $iWLL0.useQueryLoader)((0, $eAdw7.default));
    const [// @ts-expect-error - TS2525 - Initializer provides no value for this binding element and the binding element has no default value.
    { isOpen: isOpen, userPermissions: { isInviteEmailEnabled: isInviteEmailEnabled } = {} }, { resetAndCloseForm: resetAndCloseForm, togglePopup: togglePopup }] = (0, $dgUkL.useAddCustomersDialogContext)();
    const [isConfirmationModalOpen, toggleConfirmationModal, closeConfirmationModal] = (0, $NqqMP.usePopupController)();
    const { invitedCustomers: invitedCustomers, error: error, formSubmissionStatus: formSubmissionStatus, isSubmitting: isSubmitting, onFormSubmit: onFormSubmit } = (0, $1OmMe.useFormSubmissionUtils)();
    const setSuccessFlag = (0, $eUqFw.useCallback)(()=>{
        setShowSuccess(true);
        if (invitedCustomers) {
            const success = invitedCustomers?.success || [];
            setSuccessCount(success.length);
        }
    }, [
        invitedCustomers
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (isMultiHcAndInviteRoutingEnabled) loadQuery({
            cloudId: cloudId,
            workSpaceARI: workSpaceARI
        }, {
            fetchPolicy: 'store-or-network'
        });
        return disposeQuery; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cloudId,
        workSpaceARI
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (formSubmissionStatus === (0, $f03a99a9199936f4$export$523ddafd4d035371)) {
            resetAndCloseForm();
            setSuccessFlag();
        }
    }, [
        formSubmissionStatus,
        resetAndCloseForm,
        setSuccessFlag
    ]);
    const setErrorFlag = (0, $eUqFw.useCallback)(()=>{
        setShowError(true);
        if (invitedCustomers) {
            const failed = invitedCustomers?.failed || [];
            setFailedEmails(failed.map((failedResponse)=>({
                    email: failedResponse.emailAddress,
                    errorMessage: failedResponse.error
                })));
        }
    }, [
        invitedCustomers
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (formSubmissionStatus === (0, $f03a99a9199936f4$export$8a5cac0f50542e41)) setErrorFlag();
    }, [
        formSubmissionStatus,
        setErrorFlag
    ]);
    const closePopups = ()=>{
        setShowSuccess(false);
        setShowError(false);
    };
    const renderDialog = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $29yDk.default), {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5G38t.AddCustomersForm), {
                isConfirmationModalOpen: isConfirmationModalOpen,
                onCloseConfirmationModal: closeConfirmationModal,
                onToggleConfirmationModal: toggleConfirmationModal,
                onUpdateAppState: onUpdateAppState,
                onPrependOptimisticCustomers: onPrependOptimisticCustomers,
                isOrganizationDefaulted: isOrganizationDefaulted,
                invitedCustomers: invitedCustomers,
                error: error,
                isSubmitting: isSubmitting,
                onFormSubmit: onFormSubmit,
                formSubmissionStatus: formSubmissionStatus,
                queryRef: queryReference
            }),
            isOpen: isOpen,
            onClose: ({ event: event })=>{
                // don't allow in-line dialog to close if close event is triggered from AkSelect.
                // don't allow in-line dialog to close if confirmation modal is opened on top of dialog
                // @ts-expect-error - TS2345 - Argument of type 'Event' is not assignable to parameter of type 'MouseEvent'.
                if ((0, $lDc85.isEventFromOrganizationSelectDropList)(event) || isConfirmationModalOpen) return;
                togglePopup();
            },
            placement: isOrganizationDefaulted === true ? 'bottom-start' : 'bottom-end'
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            testId: "servicedesk-customers-organization-common.ui.add-customers-dialog.button",
            onClick: togglePopup,
            appearance: "primary"
        }, formatMessage((0, $4PQRQ.default).addCustomers)));
    const Trigger = (0, $eUqFw.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            ...triggerProps,
            testId: "servicedesk-customers-organization-common.ui.add-customers-dialog.button",
            onClick: togglePopup,
            appearance: "primary"
        }, formatMessage((0, $4PQRQ.default).addCustomers)), [
        formatMessage,
        togglePopup
    ]);
    const renderPopup = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
            content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e707675b1653de3d$var$ContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5G38t.AddCustomersForm), {
                    isConfirmationModalOpen: isConfirmationModalOpen,
                    onCloseConfirmationModal: closeConfirmationModal,
                    onToggleConfirmationModal: toggleConfirmationModal,
                    onUpdateAppState: onUpdateAppState,
                    onPrependOptimisticCustomers: onPrependOptimisticCustomers,
                    isOrganizationDefaulted: isOrganizationDefaulted,
                    invitedCustomers: invitedCustomers,
                    error: error,
                    isSubmitting: isSubmitting,
                    onFormSubmit: onFormSubmit,
                    formSubmissionStatus: formSubmissionStatus,
                    queryRef: queryReference
                })),
            isOpen: isOpen,
            onClose: togglePopup,
            placement: isOrganizationDefaulted === true ? 'bottom-start' : 'bottom-end',
            trigger: Trigger
        });
    const generalSuccessDescription = formatMessage((0, $4PQRQ.default).addedCustomersDescriptionNew);
    const inviteDisabled = formatMessage((0, $4PQRQ.default).addedCustomersWhenEmailDisabled);
    const successDescription = isInviteEmailEnabled ? generalSuccessDescription : inviteDisabled;
    const flagTitle = isMultiHcAndInviteRoutingEnabled ? formatMessage((0, $4PQRQ.default).addedCustomersNewMultipleHelpCenters, {
        count: successCount
    }) : formatMessage((0, $4PQRQ.default).addedCustomersNew, {
        count: successCount
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, isMultiHcAndInviteRoutingEnabled ? renderPopup() : renderDialog(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c8KxL.default), {
        onDismissed: closePopups
    }, showSuccess && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $adPlo.SuccessFlag), {
        title: flagTitle,
        description: successDescription,
        onDismissed: closePopups,
        key: successCount
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireTrackAnalytics), {
        actionSubject: "customer",
        action: "inviteSuccess"
    }))), showError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7DTLe.AsyncInviteFailed), {
        failedEmails: failedEmails,
        onClosed: closePopups
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireTrackAnalytics), {
        actionSubject: "customer",
        action: "inviteFailed"
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $e707675b1653de3d$var$ContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt44ar7 _c71ldgin",
            __cmplp.className
        ])
    });
});
const $e707675b1653de3d$export$4777b350d0f3ed6 = $e707675b1653de3d$export$836d27ce4dd57d44;

});
parcelRegister("29yDk", function(module, exports) {

$parcel$export(module.exports, "default", () => $99fb58582e83d080$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $74BVL = parcelRequire("74BVL");

var $lbDTY = parcelRequire("lbDTY");

var $hM7RE = parcelRequire("hM7RE");
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $5Q9wj = parcelRequire("5Q9wj");

var $etCs9 = parcelRequire("etCs9");
var $eN43R = parcelRequire("eN43R");

var $XHGTv = parcelRequire("XHGTv");

var $8nlzU = parcelRequire("8nlzU");
var $i6BC8 = parcelRequire("i6BC8");
var $6frYP = parcelRequire("6frYP");

var $1GZRB = parcelRequire("1GZRB");
const $99fb58582e83d080$var$packageName = "platform-pkg";
const $99fb58582e83d080$var$packageVersion = "0.0.0-use.local";
const $99fb58582e83d080$var$checkIsChildOfPortal = (node)=>{
    if (!node) return false;
    return node.classList && node.classList.contains('atlaskit-portal-container') || $99fb58582e83d080$var$checkIsChildOfPortal(node.parentElement);
};
// escape close manager for layering
const $99fb58582e83d080$var$EscapeCloseManager = ({ handleClose: handleClose })=>{
    (0, $eN43R.useCloseOnEscapePress)({
        onClose: handleClose
    });
    // only create a dummy component for using ths hook in class component
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", null);
};
const $99fb58582e83d080$export$513033cc22e3bc20 = /*#__PURE__*/ (0, $eUqFw.memo)(function InlineDialog({ isOpen: isOpen = false, onContentBlur: onContentBlur = (0, $5Q9wj.default), onContentClick: onContentClick = (0, $5Q9wj.default), onContentFocus: onContentFocus = (0, $5Q9wj.default), onClose: onClose = (0, $5Q9wj.default), placement: placement = 'bottom-start', strategy: strategy = 'fixed', testId: testId, content: content, children: children }) {
    const containerRef = (0, $eUqFw.useRef)(null);
    const triggerRef = (0, $eUqFw.useRef)(null);
    // we put this into a ref to avoid handleCloseRequest having this as a dependency
    const onCloseRef = (0, $eUqFw.useRef)(onClose);
    const isLayeringEnabled = (0, $XHGTv.fg)('platform.design-system-team.inline-message-layering_wfp1p') && isOpen;
    (0, $eUqFw.useEffect)(()=>{
        onCloseRef.current = onClose;
    });
    const handleCloseRequest = (0, $eUqFw.useCallback)((event)=>{
        const { target: target } = event;
        // checks for when target is not HTMLElement
        if (!(target instanceof HTMLElement)) return;
        // TODO: This is to handle the case where the target is no longer in the DOM.
        // This happens with react-select in datetime picker. There might be other
        // edge cases for this.
        if (!document.body.contains(target)) return;
        if (isLayeringEnabled) {
            onCloseRef.current?.({
                isOpen: false,
                event: event
            });
            return;
        }
        // handles the case where inline dialog opens portalled elements such as modal
        if ($99fb58582e83d080$var$checkIsChildOfPortal(target)) return;
        // call onClose if the click originated from outside the dialog
        if (containerRef.current && !containerRef.current.contains(target)) onCloseRef.current?.({
            isOpen: false,
            event: event
        });
    }, [
        isLayeringEnabled
    ]);
    const handleClick = (0, $eUqFw.useCallback)((event)=>{
        // exit if we click outside but on the trigger — it can handle the clicks itself
        if (triggerRef.current && triggerRef.current.contains(event.target)) return;
        // if feature flag is enabled we won't file the close event when clicking inside dialog
        if (isLayeringEnabled && containerRef.current?.contains(event.target)) return;
        handleCloseRequest(event);
    }, [
        handleCloseRequest,
        isLayeringEnabled
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isOpen) return;
        return (0, $74BVL.bind)(window, {
            type: 'click',
            listener: handleClick,
            options: {
                capture: true
            }
        });
    }, [
        isOpen,
        handleClick
    ]);
    const handleKeyDown = (0, $eUqFw.useCallback)((event)=>{
        if (event.key === 'Escape') handleCloseRequest(event);
    }, [
        handleCloseRequest
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // if layering is enabled, we will use useCloseOnEscapePress hook instead
        if (!isOpen || isLayeringEnabled) return;
        const unbind = (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: handleKeyDown,
            options: {
                capture: true
            }
        });
        return unbind;
    }, [
        isOpen,
        handleKeyDown,
        isLayeringEnabled
    ]);
    const popper = isOpen ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $i6BC8.Popper), {
        placement: placement,
        strategy: strategy
    }, ({ ref: ref, style: style })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $1GZRB.Container), {
            onBlur: onContentBlur,
            onFocus: onContentFocus,
            onClick: onContentClick,
            ref: (node)=>{
                if (node) {
                    containerRef.current = node;
                    if (typeof ref === 'function') ref(node);
                    else ref.current = node;
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: style,
            testId: testId
        }, content)) : null;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8nlzU.Manager), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $6frYP.Reference), null, ({ ref: ref })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lbDTY))), {
            innerRef: (node)=>{
                triggerRef.current = node;
                if (typeof ref === 'function') ref(node);
                else ref.current = node;
            }
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children))), isLayeringEnabled ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $etCs9.UNSAFE_LAYERING), {
        isDisabled: false
    }, popper, /*#__PURE__*/ (0, $byn9U.jsx)($99fb58582e83d080$var$EscapeCloseManager, {
        handleClose: handleCloseRequest
    })) : popper);
});
$99fb58582e83d080$export$513033cc22e3bc20.displayName = 'InlineDialog';
const $99fb58582e83d080$var$createAndFireEventOnAtlaskit = (0, $hM7RE.default)('atlaskit');
/**
 * __Inline dialog__
 *
 * _We are planning on deprecating Inline dialog. We recommend using the Popup component instead._
 *
 * An inline dialog is a pop-up container for small amounts of information. It can also contain controls.
 *
 * - [Examples](https://atlassian.design/components/inline-dialog/examples)
 * - [Code](https://atlassian.design/components/inline-dialog/code)
 * - [Usage](https://atlassian.design/components/inline-dialog/usage)
 */ const $99fb58582e83d080$var$InlineDialog = (0, $1ngde.default)({
    componentName: 'inlineDialog',
    packageName: $99fb58582e83d080$var$packageName,
    packageVersion: $99fb58582e83d080$var$packageVersion
})((0, $2jDha.default)({
    onClose: $99fb58582e83d080$var$createAndFireEventOnAtlaskit({
        action: 'closed',
        actionSubject: 'inlineDialog',
        attributes: {
            componentName: 'inlineDialog',
            packageName: $99fb58582e83d080$var$packageName,
            packageVersion: $99fb58582e83d080$var$packageVersion
        }
    })
})($99fb58582e83d080$export$513033cc22e3bc20));
var $99fb58582e83d080$export$2e2bcd8739ae039 = $99fb58582e83d080$var$InlineDialog;

});
parcelRegister("1GZRB", function(module, exports) {

$parcel$export(module.exports, "Container", () => $9db71f94672a5c3a$export$42a852a2b6b56249);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");

var $lcnyw = parcelRequire("lcnyw");
const $9db71f94672a5c3a$var$CSS_THEME_BACKGROUND = '--theme-background';
const $9db71f94672a5c3a$var$CSS_THEME_COLOR = '--theme-color';
const $9db71f94672a5c3a$var$CSS_THEME_BOX_SHADOW = '--theme-box-shadow';
const $9db71f94672a5c3a$var$containerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    boxSizing: 'content-box',
    maxWidth: `${448}px`,
    maxHeight: `${448}px`,
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-300, 24px)"}`,
    zIndex: (0, $lcnyw.layers).dialog(),
    background: `var(${$9db71f94672a5c3a$var$CSS_THEME_BACKGROUND})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: `var(${$9db71f94672a5c3a$var$CSS_THEME_BOX_SHADOW})`,
    color: `var(${$9db71f94672a5c3a$var$CSS_THEME_COLOR})`,
    '&:focus': {
        outline: 'none'
    }
});
const $9db71f94672a5c3a$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, onBlur: onBlur, onClick: onClick, onFocus: onFocus, style: style, testId: testId }, ref)=>{
    return(// Unfortunately, these are used for products to pass through. Inline Dialog is being deprecated anyway
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $9db71f94672a5c3a$var$containerStyles,
        "data-testid": testId,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            [$9db71f94672a5c3a$var$CSS_THEME_BACKGROUND]: `var(--ds-surface-overlay, ${(0, $PdmhA.N0)})`,
            [$9db71f94672a5c3a$var$CSS_THEME_COLOR]: `var(--ds-text, ${(0, $PdmhA.N900)})`,
            [$9db71f94672a5c3a$var$CSS_THEME_BOX_SHADOW]: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $PdmhA.N50A)}, 0 0 1px ${(0, $PdmhA.N60A)}`})`,
            ...style
        }
    }, children));
});

});


parcelRegister("cPGDt", function(module, exports) {

$parcel$export(module.exports, "JiraWorkspaceAri", () => $95f709ad54a54828$export$d4d0794234e3fd53);

var $5pMX4 = parcelRequire("5pMX4");

var $v8cEo = parcelRequire("v8cEo");

var $hkoEN = parcelRequire("hkoEN");
// src/jira/workspace/manifest.ts
var $95f709ad54a54828$var$jiraWorkspaceAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9-]+$"),
    resourceOwner: (0, $5pMX4.JiraWorkspaceAriResourceOwner),
    resourceType: (0, $5pMX4.JiraWorkspaceAriResourceType),
    resourceIdSlug: "{activationId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/
    }
};
// src/jira/workspace/index.ts
var $95f709ad54a54828$export$d4d0794234e3fd53 = class _JiraWorkspaceAri extends (0, $v8cEo.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $95f709ad54a54828$var$jiraWorkspaceAriStaticOpts.qualifier,
            platformQualifier: $95f709ad54a54828$var$jiraWorkspaceAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $95f709ad54a54828$var$jiraWorkspaceAriStaticOpts.resourceOwner,
            resourceType: $95f709ad54a54828$var$jiraWorkspaceAriStaticOpts.resourceType,
            resourceId: `${opts.activationId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId
            }
        }, ariOpts = (0, $hkoEN.AriParser).fromOpts(derivedOpts, $95f709ad54a54828$var$jiraWorkspaceAriStaticOpts);
        return new _JiraWorkspaceAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $hkoEN.AriParser).fromString(maybeAri, $95f709ad54a54828$var$jiraWorkspaceAriStaticOpts);
        return new _JiraWorkspaceAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId
        };
    }
};

});
parcelRegister("5pMX4", function(module, exports) {

$parcel$export(module.exports, "JiraWorkspaceAriResourceOwner", () => $cffaa0f78943566d$export$e52ccdf6abac8896);
$parcel$export(module.exports, "JiraWorkspaceAriResourceType", () => $cffaa0f78943566d$export$669cd5f7b3746bb);
// src/jira/workspace/types.ts
var $cffaa0f78943566d$export$e52ccdf6abac8896 = "jira", $cffaa0f78943566d$export$669cd5f7b3746bb = "workspace";

});


parcelRegister("c8KxL", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b9f08ed55ceefb4$export$2e2bcd8739ae039);

var $kQ0RL = parcelRequire("kQ0RL");
var $4b9f08ed55ceefb4$export$2e2bcd8739ae039 = (0, $kQ0RL.FlagGroup);

});
parcelRegister("kQ0RL", function(module, exports) {

$parcel$export(module.exports, "CommonFlag", () => $2ffdc518941fd08c$export$13d73238a031436b);
$parcel$export(module.exports, "ErrorFlag", () => $2ffdc518941fd08c$export$518ba8e0e60f145f);
$parcel$export(module.exports, "ErrorAutoDismissFlag", () => $2ffdc518941fd08c$export$3f75672bb90a4431);
$parcel$export(module.exports, "InfoFlag", () => $2ffdc518941fd08c$export$6a55b52e74c1e48e);
$parcel$export(module.exports, "SuccessAutoDismissFlag", () => $2ffdc518941fd08c$export$74a3c0748aa31355);
$parcel$export(module.exports, "SuccessFlag", () => $2ffdc518941fd08c$export$93bd4963a1d00fd5);
$parcel$export(module.exports, "WarningFlag", () => $2ffdc518941fd08c$export$23695d8281998f27);
$parcel$export(module.exports, "FlagGroup", () => $2ffdc518941fd08c$export$a2c3479950310d7d);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $1ybV0 = parcelRequire("1ybV0");

var $5L0Jp = parcelRequire("5L0Jp");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintCommonFlag = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("aiVXY")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintCommonFlag = (0, $7rh0R.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("aiVXY")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintJiraCommonFlag = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("aiVXY")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintJiraCommonFlag = (0, $7rh0R.lazyAfterPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("aiVXY")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$CommonFlagImpl = (props)=>{
    if ((0, $1ybV0.ff)('post-office_enable_jira_choreographer')) return __SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintJiraCommonFlag, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintJiraCommonFlag, props);
    return __SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintCommonFlag, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintCommonFlag, props);
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintFlagGroup = (0, $7rh0R.lazyForPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("Tabui")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintFlagGroup = (0, $7rh0R.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("Tabui")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$FlagGroupImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintFlagGroup, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintFlagGroup, props);
const $2ffdc518941fd08c$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, props));
const $2ffdc518941fd08c$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        ...props
    }));
const $2ffdc518941fd08c$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "info",
        ...props
    }));
const $2ffdc518941fd08c$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        ...props
    }));
const $2ffdc518941fd08c$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "warning",
        ...props
    }));
const $2ffdc518941fd08c$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$FlagGroupImpl, props));

});
parcelRegister("aiVXY", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('cCYJs')
        ]);
        const value = parcelRequire('kbpOk');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("cCYJs")
    ]).then(()=>parcelRequire('kbpOk'));
}

});

parcelRegister("Tabui", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hkLGi');
        const value = parcelRequire('jkRT2');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hkLGi").then(()=>parcelRequire('jkRT2'));
}

});



parcelRegister("eAdw7", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a6a0280e2069639$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ba2e3b5ca8459f4d7f7dc8bb79612586>>
 * @relayHash d17b7d02c56efacfe603b2d440c2fd0a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c26ce19a32f11e4aa97daae63596d4acca03a0b1e74f76dbaa843ef1ba26c337
const $7a6a0280e2069639$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "workSpaceARI"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "workspaceAri",
            "variableName": "workSpaceARI"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEnabled"
            }
        ],
        "type": "HelpCentersConfig"
    }, v5 = {
        "kind": "ScalarField",
        "name": "identifier"
    }, v6 = {
        "kind": "ScalarField",
        "name": "message"
    }, v7 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v8 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "extendedFormContentMultiHcEntitlementQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCentersConfig",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "extendedFormContentMultiHcEntitlementQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCentersConfig",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c26ce19a32f11e4aa97daae63596d4acca03a0b1e74f76dbaa843ef1ba26c337",
            "metadata": {},
            "name": "extendedFormContentMultiHcEntitlementQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$7a6a0280e2069639$var$node.hash = "8f923ba417e51d30e9f4d5e3995b1ad1";
var $7a6a0280e2069639$export$2e2bcd8739ae039 = $7a6a0280e2069639$var$node;

});

parcelRegister("7DTLe", function(module, exports) {

$parcel$export(module.exports, "AsyncInviteFailed", () => $10956b0a67996013$export$792469666d9a4f5e);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $6U1dF = parcelRequire("6U1dF");

var $iVSJI = parcelRequire("iVSJI");

var $7hBTQ = parcelRequire("7hBTQ");
const $10956b0a67996013$export$792469666d9a4f5e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6U1dF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "jsm-customers-common-invite-failed",
        packageName: "jira-servicedesk-customers-common-invite-failed",
        fallback: "unmount",
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iVSJI.ServiceDeskAnalyticsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7hBTQ.AsyncLazyInviteFailed), props))));

});
parcelRegister("7hBTQ", function(module, exports) {

$parcel$export(module.exports, "AsyncLazyInviteFailed", () => $1c24d37527b9eba8$export$f7f954a76e72fe86);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

const $1c24d37527b9eba8$var$AsyncInviteFailed = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("e16W7")), {
    moduleId: "./src/packages/servicedesk/customers-common-invite-failed/src/ui/invite-failed/index.tsx"
});
const $1c24d37527b9eba8$export$f7f954a76e72fe86 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "customers-invite-failed-dialog",
        packageName: "jira-servicedesk-customers-organization-common"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "servicedesk-customers-invite-failed",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1c24d37527b9eba8$var$AsyncInviteFailed, props)));

});
parcelRegister("e16W7", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('6Djid');
        const value = parcelRequire('8NXWO');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("6Djid").then(()=>parcelRequire('8NXWO'));
}

});



const $f03a99a9199936f4$export$f5940ec982f5760a = 'PendingSubmission';
const $f03a99a9199936f4$export$523ddafd4d035371 = 'Successful';
const $f03a99a9199936f4$export$8a5cac0f50542e41 = 'Unsuccessful';

parcelRegister("lDc85", function(module, exports) {

$parcel$export(module.exports, "mapOrganizationsToLabelOptions", () => $13ecb90490836ed5$export$f2e5b457ef82caef);
$parcel$export(module.exports, "isSelectedOptionValid", () => $13ecb90490836ed5$export$970d68ac829ec175);
$parcel$export(module.exports, "isEventFromOrganizationSelectDropList", () => $13ecb90490836ed5$export$8a1d1ca8a66dea73);

var $ldoFd = parcelRequire("ldoFd");

var $gUsKc = parcelRequire("gUsKc");

const $13ecb90490836ed5$export$f2e5b457ef82caef = (organizations, formatMessage)=>organizations.map(({ id: id, name: name, numberOfOtherProjects: numberOfOtherProjects })=>({
            label: name,
            name: name,
            status: `${numberOfOtherProjects > 0 ? formatMessage((0, $gUsKc.default).inOtherProjects, {
                numberOfOtherProjects: numberOfOtherProjects
            }) : ''}`,
            value: id,
            numberOfOtherProjects: numberOfOtherProjects
        }));
const $13ecb90490836ed5$export$970d68ac829ec175 = (options, selectedOption)=>{
    if (!selectedOption) return true;
    const optionExistInList = options.some(({ name: name })=>name.toLowerCase() === selectedOption.name.toLowerCase());
    return !optionExistInList;
};
const $13ecb90490836ed5$export$8a1d1ca8a66dea73 = (event)=>{
    if (event && !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(event.target)) {
        // @ts-expect-error - TS2339 - Property 'classList' does not exist on type 'EventTarget'.
        const { classList: classList } = event.target;
        return classList.contains(`${(0, $7f387e8fcff8ab0c$export$60fb28d4aee3606e)}__option`);
    }
    return false;
};

});
parcelRegister("gUsKc", function(module, exports) {

$parcel$export(module.exports, "default", () => $285c0975e1339e61$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $285c0975e1339e61$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    inOtherProjects: {
        "id": "servicedesk-customers-organization-common.common.organizations-select-field.in-other-projects",
        "defaultMessage": "in {numberOfOtherProjects, plural, one {# project} other { # other projects}}"
    },
    somethingWentWrong: {
        "id": "servicedesk-customers-organization-common.common.organizations-select-field.something-went-wrong",
        "defaultMessage": "Something went wrong. Check your connection, then give it another try."
    }
});

});

const $7f387e8fcff8ab0c$export$60fb28d4aee3606e = 'serviceDeskOrganizationSelect';


parcelRegister("adPlo", function(module, exports) {

$parcel$export(module.exports, "SuccessFlag", () => $5c2158f1e655e014$export$93bd4963a1d00fd5);

var $eUqFw = parcelRequire("eUqFw");

var $aWvIp = parcelRequire("aWvIp");

var $PdmhA = parcelRequire("PdmhA");

var $95RcH = parcelRequire("95RcH");
const $5c2158f1e655e014$export$93bd4963a1d00fd5 = ({ title: title, description: description, onDismissed: onDismissed })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $95RcH.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aWvIp))), {
            primaryColor: `var(--ds-icon-success, ${(0, $PdmhA.G300)})`,
            label: "Success"
        }),
        title: title,
        description: description,
        id: Math.random(),
        onDismissed: onDismissed,
        testId: "servicedesk-customers-organization-common.common.ui.success-flag.success-flag"
    });

});
parcelRegister("95RcH", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eca080011a53a1f$export$2e2bcd8739ae039);

var $kQ0RL = parcelRequire("kQ0RL");
var $6eca080011a53a1f$export$2e2bcd8739ae039 = (0, $kQ0RL.SuccessAutoDismissFlag);

});


parcelRegister("dgUkL", function(module, exports) {

$parcel$export(module.exports, "useAddCustomersDialogContext", () => $0ec63de8f06f5f2e$export$8303be3e6da4917b);

var $eUqFw = parcelRequire("eUqFw");

var $ggHET = parcelRequire("ggHET");
const $0ec63de8f06f5f2e$export$8303be3e6da4917b = ()=>(0, $eUqFw.useContext)((0, $ggHET.AddCustomersDialogContext));

});

parcelRegister("5G38t", function(module, exports) {

$parcel$export(module.exports, "AddCustomersForm", () => $27a358956a88b77d$export$6cf1c0f31a72e7e3);

var $eUqFw = parcelRequire("eUqFw");

var $lzLxZ = parcelRequire("lzLxZ");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $gGtKh = parcelRequire("gGtKh");

var $d6f6c = parcelRequire("d6f6c");

var $8Iss3 = parcelRequire("8Iss3");

var $dgUkL = parcelRequire("dgUkL");

var $7qcF4 = parcelRequire("7qcF4");

var $jLIyH = parcelRequire("jLIyH");

var $bKnoT = parcelRequire("bKnoT");
const $27a358956a88b77d$export$6cf1c0f31a72e7e3 = ({ isConfirmationModalOpen: isConfirmationModalOpen, isOrganizationDefaulted: isOrganizationDefaulted, onToggleConfirmationModal: onToggleConfirmationModal, onPrependOptimisticCustomers: onPrependOptimisticCustomers, onCloseConfirmationModal: onCloseConfirmationModal, onUpdateAppState: onUpdateAppState, formSubmissionStatus: formSubmissionStatus, invitedCustomers: invitedCustomers, error: error, isSubmitting: isSubmitting, onFormSubmit: onFormSubmit, queryRef: queryRef })=>{
    const [{ organization: organization, defaultOrganization: defaultOrganization }] = (0, $dgUkL.useAddCustomersDialogContext)();
    const onSubmit = (0, $eUqFw.useCallback)(()=>{
        const selectedOrganization = organization || defaultOrganization;
        if (selectedOrganization && selectedOrganization.numberOfOtherProjects > 0) onToggleConfirmationModal();
        else onFormSubmit();
    }, [
        defaultOrganization,
        onFormSubmit,
        onToggleConfirmationModal,
        organization
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!invitedCustomers) return;
        const { optimisticCustomerListUpdateResults: optimisticCustomerListUpdateResults, failed: failed } = invitedCustomers;
        // prepend customers only if there is no selected organization
        // or if there are no failed invited customers
        const shouldPrependOptimisticCustomers = (isOrganizationDefaulted === true || !organization) && !failed.length;
        if (shouldPrependOptimisticCustomers) onPrependOptimisticCustomers(optimisticCustomerListUpdateResults);
        else onUpdateAppState();
    }, [
        invitedCustomers,
        isOrganizationDefaulted,
        onPrependOptimisticCustomers,
        onUpdateAppState,
        organization
    ]);
    const formContentProps = {
        error: error,
        invitedCustomers: invitedCustomers,
        formSubmissionStatus: formSubmissionStatus,
        isSubmitting: isSubmitting,
        isOrganizationDefaulted: isOrganizationDefaulted
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Iss3.DialogWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lzLxZ.default), {
        onSubmit: onSubmit
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("form", {
            ...formProps,
            name: "add-customers-form",
            "data-testId": "servicedesk-organization-details.common.ui.add-customers-dialog.form.form"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "add-customers-popup",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                xcss: $27a358956a88b77d$var$spinnerWrapStyle
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
                size: "medium"
            }))
        }, queryRef ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jLIyH.ExtendedFormContent), {
            queryRef: queryRef,
            render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bKnoT.FormContent), {
                    ...formContentProps,
                    ...props
                })
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bKnoT.FormContent), {
            ...formContentProps,
            hasMultiHcAndInviteRouting: false
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7qcF4.ConfirmationModal), {
            isOpen: isConfirmationModalOpen,
            onConfirm: onFormSubmit,
            onClose: onCloseConfirmationModal
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null));
};
$27a358956a88b77d$export$6cf1c0f31a72e7e3.displayName = 'AddCustomersDialogContent';
const $27a358956a88b77d$var$spinnerWrapStyle = (0, $1ZAYh.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '348px'
});

});
parcelRegister("lzLxZ", function(module, exports) {

$parcel$export(module.exports, "FormContext", () => $35270e9129320e50$export$c24727297075ec6a);
$parcel$export(module.exports, "IsDisabledContext", () => $35270e9129320e50$export$c17cf6b332a82dbc);
$parcel$export(module.exports, "default", () => $35270e9129320e50$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3DX5R = parcelRequire("3DX5R");

var $519wV = parcelRequire("519wV");

var $a0i0f = parcelRequire("a0i0f");
const $35270e9129320e50$export$c24727297075ec6a = /*#__PURE__*/ (0, $eUqFw.createContext)({
    registerField: function() {
        return ()=>{};
    },
    getCurrentValue: ()=>undefined,
    subscribe: function() {
        return ()=>{};
    }
});
const $35270e9129320e50$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $eUqFw.createContext)(false);
function $35270e9129320e50$export$2e2bcd8739ae039(props) {
    const formRef = (0, $eUqFw.useRef)(null);
    const onSubmitRef = (0, $eUqFw.useRef)(props.onSubmit);
    onSubmitRef.current = props.onSubmit;
    const [form] = (0, $eUqFw.useState)(()=>{
        // Types here would break the existing API
        const finalForm = (0, $3DX5R.createForm)({
            onSubmit: (...args)=>onSubmitRef.current(...args),
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: ([name, defaultValue], state)=>{
                    if (state.formState.initialValues) {
                        const initialValues = state.formState.initialValues;
                        const values = state.formState.values;
                        const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        /* eslint-disable no-param-reassign */ (0, (/*@__PURE__*/$parcel$interopDefault($a0i0f)))(initialValues, name, value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($a0i0f)))(values, name, value);
                    /* eslint-enable */ }
                }
            }
        });
        (0, $519wV.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [])(finalForm);
        return finalForm;
    });
    const [state, setState] = (0, $eUqFw.useState)({
        dirty: false,
        submitting: false
    });
    (0, $eUqFw.useEffect)(()=>{
        const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    const registerField = (0, $eUqFw.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
        form.pauseValidation();
        const unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        form.submit();
    };
    const handleReset = (initialValues)=>{
        form.reset(initialValues);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    const { isDisabled: isDisabled = false, children: children } = props;
    const { dirty: dirty, submitting: submitting } = state;
    /**
	 * This method is needed in FormContext to use it on the field level
	 * to check the current value of the field in case of the component re-mounting.
	 */ const getCurrentValue = (0, $eUqFw.useCallback)((name)=>{
        const formState = form.getState();
        return formState?.values[name] || undefined;
    }, [
        form
    ]);
    const FormContextValue = (0, $eUqFw.useMemo)(()=>{
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35270e9129320e50$export$c24727297075ec6a.Provider, {
        value: FormContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35270e9129320e50$export$c17cf6b332a82dbc.Provider, {
        value: isDisabled
    }, children({
        formProps: {
            onSubmit: handleSubmit,
            ref: formRef,
            onKeyDown: handleKeyDown
        },
        dirty: dirty,
        reset: handleReset,
        submitting: submitting,
        disabled: isDisabled,
        getState: ()=>form.getState(),
        getValues: ()=>form.getState().values,
        setFieldValue: form.change
    })));
}

});
parcelRegister("3DX5R", function(module, exports) {

$parcel$export(module.exports, "getIn", () => $2a72da5b7ec16659$export$c52e5867d5879e24);
$parcel$export(module.exports, "FORM_ERROR", () => $2a72da5b7ec16659$export$97cd7fc25dd32915);
$parcel$export(module.exports, "fieldSubscriptionItems", () => $2a72da5b7ec16659$export$41e855cb628c1b55);
$parcel$export(module.exports, "formSubscriptionItems", () => $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3);
$parcel$export(module.exports, "version", () => $2a72da5b7ec16659$export$83d89fbfd8236492);
$parcel$export(module.exports, "createForm", () => $2a72da5b7ec16659$export$f681a8129d2e9d28);

var $kU09D = parcelRequire("kU09D");

var $6XgOP = parcelRequire("6XgOP");
//      
var $2a72da5b7ec16659$var$charCodeOfDot = ".".charCodeAt(0);
var $2a72da5b7ec16659$var$reEscapeChar = /\\(\\)?/g;
var $2a72da5b7ec16659$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $2a72da5b7ec16659$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $2a72da5b7ec16659$var$charCodeOfDot) result.push("");
    string.replace($2a72da5b7ec16659$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($2a72da5b7ec16659$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $2a72da5b7ec16659$var$keysCache = {};
var $2a72da5b7ec16659$var$keysRegex = /[.[\]]+/;
var $2a72da5b7ec16659$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($2a72da5b7ec16659$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $2a72da5b7ec16659$var$keysCache[key] = key.split($2a72da5b7ec16659$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $2a72da5b7ec16659$var$keysCache[key] = $2a72da5b7ec16659$var$stringToPath(key);
    }
    return $2a72da5b7ec16659$var$keysCache[key];
};
//      
var $2a72da5b7ec16659$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $2a72da5b7ec16659$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $2a72da5b7ec16659$var$_toPropertyKey(arg) {
    var key = $2a72da5b7ec16659$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $2a72da5b7ec16659$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $2a72da5b7ec16659$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $6XgOP.default)(current, [
                key
            ].map($2a72da5b7ec16659$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $kU09D.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $2a72da5b7ec16659$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $2a72da5b7ec16659$var$setInRecursor(state, 0, $2a72da5b7ec16659$var$toPath(key), value1, destroyArrays);
};
var $2a72da5b7ec16659$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $2a72da5b7ec16659$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $2a72da5b7ec16659$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $2a72da5b7ec16659$export$c52e5867d5879e24(values, name);
    var error = $2a72da5b7ec16659$export$c52e5867d5879e24(errors, name);
    if (error && error[$2a72da5b7ec16659$export$735bebc8ffabf28a]) error = error[$2a72da5b7ec16659$export$735bebc8ffabf28a];
    var submitError = submitErrors && $2a72da5b7ec16659$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $2a72da5b7ec16659$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $2a72da5b7ec16659$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $2a72da5b7ec16659$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $2a72da5b7ec16659$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$2a72da5b7ec16659$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $2a72da5b7ec16659$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $2a72da5b7ec16659$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $2a72da5b7ec16659$var$subscriptionFilter(result, state, previousState, subscription, $2a72da5b7ec16659$export$41e855cb628c1b55, $2a72da5b7ec16659$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $2a72da5b7ec16659$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $2a72da5b7ec16659$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $2a72da5b7ec16659$var$subscriptionFilter(result, state, previousState, subscription, $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3, $2a72da5b7ec16659$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $2a72da5b7ec16659$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$2a72da5b7ec16659$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $2a72da5b7ec16659$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $2a72da5b7ec16659$export$83d89fbfd8236492 = "4.20.10";
var $2a72da5b7ec16659$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $2a72da5b7ec16659$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $2a72da5b7ec16659$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $2a72da5b7ec16659$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $2a72da5b7ec16659$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $2a72da5b7ec16659$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $2a72da5b7ec16659$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $2a72da5b7ec16659$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($2a72da5b7ec16659$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $2a72da5b7ec16659$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $kU09D.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $kU09D.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $kU09D.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $kU09D.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $kU09D.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $2a72da5b7ec16659$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $2a72da5b7ec16659$export$e6bdf135a54e021b,
                    shallowEqual: $2a72da5b7ec16659$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $kU09D.default)({}, state.formState.values)); // clone to avoid writing
            if ($2a72da5b7ec16659$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $2a72da5b7ec16659$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $2a72da5b7ec16659$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $kU09D.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $2a72da5b7ec16659$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $2a72da5b7ec16659$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $2a72da5b7ec16659$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$2a72da5b7ec16659$export$735bebc8ffabf28a]) {
                    var existing = $2a72da5b7ec16659$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$2a72da5b7ec16659$export$735bebc8ffabf28a] = error[$2a72da5b7ec16659$export$735bebc8ffabf28a];
                    merged = $2a72da5b7ec16659$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$2a72da5b7ec16659$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$2a72da5b7ec16659$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $2a72da5b7ec16659$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $2a72da5b7ec16659$var$notify(fieldSubscriber, fieldState, lastFieldState, $2a72da5b7ec16659$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $2a72da5b7ec16659$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$2a72da5b7ec16659$var$hasAnyError(formState.errors) && !(formState.submitErrors && $2a72da5b7ec16659$var$hasAnyError(formState.submitErrors));
        var nextFormState = $2a72da5b7ec16659$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $2a72da5b7ec16659$var$notify(state.subscribers, nextFormState, lastFormState, $2a72da5b7ec16659$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $kU09D.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $kU09D.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $kU09D.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $2a72da5b7ec16659$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $2a72da5b7ec16659$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name) === $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $kU09D.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $kU09D.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $kU09D.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $2a72da5b7ec16659$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$2a72da5b7ec16659$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $kU09D.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $2a72da5b7ec16659$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $2a72da5b7ec16659$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $2a72da5b7ec16659$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $2a72da5b7ec16659$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("519wV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a747034649a7960$export$2e2bcd8739ae039);

var $3DX5R = parcelRequire("3DX5R");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $3a747034649a7960$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $3a747034649a7960$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($3a747034649a7960$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $3a747034649a7960$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $3DX5R.getIn)(errors, input.name);
    });
};
//      
var $3a747034649a7960$var$noop = function noop() {};
var $3a747034649a7960$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $3a747034649a7960$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $3a747034649a7960$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $3a747034649a7960$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $3a747034649a7960$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($3a747034649a7960$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$3a747034649a7960$export$2e2bcd8739ae039 = $3a747034649a7960$var$createDecorator;

});

parcelRegister("a0i0f", function(module, exports) {

var $buvff = parcelRequire("buvff");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $7487de7aebcafd99$var$set(object, path, value) {
    return object == null ? object : $buvff(object, path, value);
}
module.exports = $7487de7aebcafd99$var$set;

});


parcelRegister("8Iss3", function(module, exports) {

$parcel$export(module.exports, "DialogWrapper", () => $e758a69eac2a83f0$export$2c5463a7353cb944);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $aOiov = parcelRequire("aOiov");

var $ietBz = parcelRequire("ietBz");

var $kzvQD = parcelRequire("kzvQD");
const $e758a69eac2a83f0$export$2c5463a7353cb944 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbnklw _o5724jg8 _c71l1kw7 _p12f1kw7 _1reo1wug _18m91wug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aOiov", function(module, exports) {

$parcel$export(module.exports, "FormErrors", () => $7b87ef8dd09ea654$export$db5ae436ef8b64fb);

var $eUqFw = parcelRequire("eUqFw");

var $1c8hB = parcelRequire("1c8hB");

var $7jPhn = parcelRequire("7jPhn");

var $giAhk = parcelRequire("giAhk");

var $f8dtc = parcelRequire("f8dtc");
const $7b87ef8dd09ea654$export$abc143e4c598f328 = ({ intl: { formatMessage: formatMessage }, isError: isError, formErrors: formErrors, serviceError: serviceError })=>{
    if (formErrors || isError) {
        if (formErrors && formErrors.errors && (0, (/*@__PURE__*/$parcel$interopDefault($1c8hB)))(formErrors.errors)) {
            const { errors: errors } = formErrors;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, errors.map(({ error: { errorMessage: errorMessage } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), {
                    key: errorMessage
                }, errorMessage)));
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, formatMessage((0, $f8dtc.default).genericErrorText));
    }
    if (serviceError) {
        // @ts-expect-error - TS2339 - Property 'reasonCode' does not exist on type 'Error | ValidationErrors | { statusCode: number; message?: string | undefined; }'.
        if (serviceError.reasonCode === '401') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, formatMessage((0, $f8dtc.default).loggedOut));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, formatMessage((0, $f8dtc.default).genericErrorText));
    }
    return null;
};
$7b87ef8dd09ea654$export$abc143e4c598f328.defaultProps = {
    isError: false,
    formErrors: null
};
const $7b87ef8dd09ea654$export$db5ae436ef8b64fb = (0, $giAhk.injectIntlV2)($7b87ef8dd09ea654$export$abc143e4c598f328);

});
parcelRegister("7jPhn", function(module, exports) {

$parcel$export(module.exports, "HelperMessage", () => $8d7fd15aabd72279$export$8fbe3c7d0ed2c683);
$parcel$export(module.exports, "ErrorMessage", () => $8d7fd15aabd72279$export$915e9e7bd4f0f96d);
$parcel$export(module.exports, "ValidMessage", () => $8d7fd15aabd72279$export$5505afb209a532c8);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $lD2Nx = parcelRequire("lD2Nx");

var $96IgR = parcelRequire("96IgR");

var $PdmhA = parcelRequire("PdmhA");

var $gaA9C = parcelRequire("gaA9C");
function $8d7fd15aabd72279$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8d7fd15aabd72279$var$messageStyles = {
    name: "ywqxo4",
    styles: "display:flex;justify-content:baseline;gap:var(--ds-space-050, 4px);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-start:var(--ds-space-050, 4px)"
};
const $8d7fd15aabd72279$var$messageAppearanceStyles = {
    default: /*#__PURE__*/ (0, $byn9U.css)({
        color: `var(--ds-text-subtlest, ${(0, $PdmhA.N200)})`
    }),
    error: {
        name: "g75jq6",
        styles: "color:var(--ds-text-danger, #AE2A19)"
    },
    valid: {
        name: "118r6eb",
        styles: "color:var(--ds-text-success, #216E4E)"
    }
};
const $8d7fd15aabd72279$var$iconWrapperStyles = {
    name: "zjik7",
    styles: "display:flex"
};
const $8d7fd15aabd72279$var$IconWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $8d7fd15aabd72279$var$iconWrapperStyles
    }, children);
};
const $8d7fd15aabd72279$var$messageIcons = {
    error: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
        size: "small",
        label: "error"
    }),
    valid: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lD2Nx))), {
        size: "small",
        label: "success"
    })
};
const $8d7fd15aabd72279$var$Message = ({ children: children, appearance: appearance = 'default', fieldId: fieldId, testId: testId })=>{
    const icon = $8d7fd15aabd72279$var$messageIcons[appearance];
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ const content = typeof children === 'string' ? children : /*#__PURE__*/ (0, $byn9U.jsx)("span", null, children);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $8d7fd15aabd72279$var$messageStyles,
            $8d7fd15aabd72279$var$messageAppearanceStyles[appearance]
        ],
        "data-testid": testId,
        id: fieldId,
        "aria-live": "polite"
    }, icon && /*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$IconWrapper, null, icon), content);
};
const $8d7fd15aabd72279$export$8fbe3c7d0ed2c683 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$Message, {
            fieldId: fieldId ? `${fieldId}-helper` : undefined,
            testId: testId
        }, children));
const $8d7fd15aabd72279$export$915e9e7bd4f0f96d = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$Message, {
            appearance: "error",
            fieldId: fieldId ? `${fieldId}-error` : undefined,
            testId: testId
        }, children));
const $8d7fd15aabd72279$export$5505afb209a532c8 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$Message, {
            appearance: "valid",
            fieldId: fieldId ? `${fieldId}-valid` : undefined,
            testId: testId
        }, children));

});
parcelRegister("lD2Nx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fbef6921e18df378$var$_react = $fbef6921e18df378$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $fbef6921e18df378$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $fbef6921e18df378$var$EditorSuccessIcon = (props)=>/*#__PURE__*/ $fbef6921e18df378$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12 20a8 8 0 110-16 8 8 0 010 16zm1.364-10.964l-2.152 4.11-1.543-1.39a1 1 0 10-1.338 1.487l2.5 2.25a1 1 0 001.555-.279l2.75-5.25a1 1 0 00-1.772-.928z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$fbef6921e18df378$var$EditorSuccessIcon.displayName = 'EditorSuccessIcon';
var $fbef6921e18df378$var$_default = $fbef6921e18df378$var$EditorSuccessIcon;
module.exports.default = $fbef6921e18df378$var$_default;

});

parcelRegister("gaA9C", function(module, exports) {

$parcel$export(module.exports, "FieldId", () => $d60d84c188ee2cc0$export$3c4232819458a302);

var $eUqFw = parcelRequire("eUqFw");
const $d60d84c188ee2cc0$export$3c4232819458a302 = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);

});


parcelRegister("f8dtc", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c7de1f515db9442$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7c7de1f515db9442$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    genericErrorText: {
        "id": "servicedesk-customers-organization-common.common.inline-dialog.form-errors.generic-error-text",
        "defaultMessage": "We're having trouble. Check your connection and try again."
    },
    loggedOut: {
        "id": "servicedesk-customers-organization-common.common.inline-dialog.form-errors.logged-out",
        "defaultMessage": "You are not currently logged in. Please log in to perform this action."
    }
});

});


parcelRegister("ietBz", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $7c94340cbddaeae7$export$a06f1c675e846f6f);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $bLFgh = parcelRequire("bLFgh");

var $7opLA = parcelRequire("7opLA");

var $7u4fN = parcelRequire("7u4fN");

var $7CD1S = parcelRequire("7CD1S");

var $giAhk = parcelRequire("giAhk");

var $6Q766 = parcelRequire("6Q766");
const $7c94340cbddaeae7$export$af41f29dfb7e37b8 = ({ intl: { formatMessage: formatMessage }, isFormValid: isFormValid = false, isLoading: isLoading = false, onSubmit: onSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onCancel: onCancel = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))) })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7CD1S.default), {
        align: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
        appearance: "primary",
        type: "submit",
        isLoading: isLoading,
        isDisabled: !isFormValid,
        testId: "servicedesk-customers-organization-common.common.ui.inline-dialog.footer.submit-button",
        onClick: onSubmit
    }, formatMessage((0, $6Q766.default).add)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "link",
        onClick: onCancel,
        testId: "servicedesk-customers-organization-common.common.ui.inline-dialog.footer.cancel-button"
    }, formatMessage((0, $6Q766.default).cancel))));
const $7c94340cbddaeae7$export$a06f1c675e846f6f = (0, $giAhk.injectIntlV2)($7c94340cbddaeae7$export$af41f29dfb7e37b8);

});
parcelRegister("7CD1S", function(module, exports) {

$parcel$export(module.exports, "default", () => $564306fc9833a41c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");
function $564306fc9833a41c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $564306fc9833a41c$var$formFooterWrapperStyles = {
    name: "1rruhyk",
    styles: "display:flex;justify-content:flex-end;margin-block-start:var(--ds-space-300, 24px)"
};
const $564306fc9833a41c$var$justifyContentStyles = {
    name: "11g6mpt",
    styles: "justify-content:flex-start"
};
function $564306fc9833a41c$export$2e2bcd8739ae039({ align: align = 'end', children: children }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("footer", {
        css: [
            $564306fc9833a41c$var$formFooterWrapperStyles,
            align === 'start' && $564306fc9833a41c$var$justifyContentStyles
        ]
    }, children);
}

});

parcelRegister("6Q766", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f516dbc128154fe$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5f516dbc128154fe$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    add: {
        "id": "servicedesk-customers-organization-common.common.inline-dialog.footer.add",
        "defaultMessage": "Add"
    },
    cancel: {
        "id": "servicedesk-customers-organization-common.common.inline-dialog.footer.cancel",
        "defaultMessage": "Cancel"
    }
});

});


parcelRegister("kzvQD", function(module, exports) {

$parcel$export(module.exports, "FooterControls", () => $ad5d95daf31bd989$export$377702b113c526d0);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $bLFgh = parcelRequire("bLFgh");

var $7opLA = parcelRequire("7opLA");

var $7u4fN = parcelRequire("7u4fN");

var $7CD1S = parcelRequire("7CD1S");

var $giAhk = parcelRequire("giAhk");

var $fACdP = parcelRequire("fACdP");
const $ad5d95daf31bd989$export$9b45ee8853d84503 = ({ intl: { formatMessage: formatMessage }, isFormValid: isFormValid = false, isLoading: isLoading = false, onSubmit: onSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onCancel: onCancel = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))) })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7CD1S.default), {
        align: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "link",
        onClick: onCancel,
        testId: "servicedesk-customers-organization-common.common.ui.inline-dialog.footer-controls.cancel-button"
    }, formatMessage((0, $fACdP.default).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
        appearance: "primary",
        type: "submit",
        isLoading: isLoading,
        isDisabled: !isFormValid,
        testId: "servicedesk-customers-organization-common.common.ui.inline-dialog.footer-controls.submit-button",
        onClick: onSubmit
    }, formatMessage((0, $fACdP.default).save))));
const $ad5d95daf31bd989$export$377702b113c526d0 = (0, $giAhk.injectIntlV2)($ad5d95daf31bd989$export$9b45ee8853d84503);

});
parcelRegister("fACdP", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b3b44e299ed0d11$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4b3b44e299ed0d11$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    save: {
        "id": "servicedesk-customers-organization-common.common.inline-dialog.footer-controls.save",
        "defaultMessage": "Ok"
    },
    cancel: {
        "id": "servicedesk-customers-organization-common.common.inline-dialog.footer-controls.cancel",
        "defaultMessage": "Cancel"
    }
});

});



parcelRegister("7qcF4", function(module, exports) {

$parcel$export(module.exports, "ConfirmationModal", () => $c5c09571faddb453$export$1f33f980da756c46);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");
var $dxopF = parcelRequire("dxopF");

var $kGQen = parcelRequire("kGQen");

var $giAhk = parcelRequire("giAhk");

var $dgUkL = parcelRequire("dgUkL");

var $9r3B9 = parcelRequire("9r3B9");
const $c5c09571faddb453$export$6ebc7d2bd49c7c52 = ({ intl: { formatMessage: formatMessage }, useAddCustomersDialogContext: useAddCustomersDialogContext, isOpen: isOpen, onConfirm: onConfirm, onClose: onClose })=>{
    const [{ organization: organization, defaultOrganization: defaultOrganization }] = useAddCustomersDialogContext();
    const selectedOrganization = organization || defaultOrganization;
    const onConfirmAndClose = ()=>{
        onConfirm();
        onClose();
    };
    const actions = [
        {
            text: formatMessage((0, $9r3B9.default).addCustomers),
            onClick: onConfirmAndClose,
            'data-test-id': 'servicedesk-customers-organization-common.ui.add-customers-dialog.form.confirmation-modal.confirm-add-customers-to-multiple-projects'
        },
        {
            text: formatMessage((0, $9r3B9.default).cancel),
            onClick: onClose,
            'data-test-id': 'servicedesk-customers-organization-common.ui.add-customers-dialog.form.confirmation-modal.cancel-add-customers-to-multiple-projects'
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, formatMessage((0, $9r3B9.default).confirmationTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5c09571faddb453$var$ModalContentWrapper, null, formatMessage((0, $9r3B9.default).multipleProjectOrganization, selectedOrganization))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, actions.map((props, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            key: index,
            ...props,
            autoFocus: index === 0,
            appearance: index === 0 ? 'primary' : 'subtle'
        }, props.text)).reverse()))));
};
$c5c09571faddb453$export$6ebc7d2bd49c7c52.defaultProps = {
    useAddCustomersDialogContext: (0, $dgUkL.useAddCustomersDialogContext)
};
const $c5c09571faddb453$export$1f33f980da756c46 = (0, $giAhk.injectIntlV2)($c5c09571faddb453$export$6ebc7d2bd49c7c52); // eslint-disable-next-line @atlaskit/design-system/no-empty-styled-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c5c09571faddb453$var$ModalContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kGQen", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistryContext", () => $082205e2100625d8$export$ebbb59327adb551a);
$parcel$export(module.exports, "default", () => $082205e2100625d8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fVFUy = parcelRequire("fVFUy");
const $082205e2100625d8$export$ebbb59327adb551a = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $fVFUy.rootRegistry));
const $082205e2100625d8$var$ShortcutScope = ({ children: children = null })=>{
    const registry = (0, $eUqFw.useMemo)(()=>new (0, $fVFUy.ShortcutRegistry)(), []);
    const parentRegistry = (0, $eUqFw.useContext)($082205e2100625d8$export$ebbb59327adb551a) || (0, $fVFUy.rootRegistry);
    (0, $eUqFw.useEffect)(()=>{
        // "This only happens ONCE.  But it happens AFTER the initial render."
        const removeRegistry = parentRegistry.addChildRegistry(registry);
        return removeRegistry;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($082205e2100625d8$export$ebbb59327adb551a.Provider, {
        value: registry
    }, children);
};
var $082205e2100625d8$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : $082205e2100625d8$var$ShortcutScope;

});
parcelRegister("fVFUy", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistry", () => $3843ad0413ec519e$export$ca1c75b575abf5ff);
$parcel$export(module.exports, "rootRegistry", () => $3843ad0413ec519e$export$1dd4c61d1ce1fa15);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ /**
 * A tree-like registry of shortcuts, with a default, root registry.
 */ 
var $fUTZC = parcelRequire("fUTZC");

var $6G5mG = parcelRequire("6G5mG");

var $ldoFd = parcelRequire("ldoFd");

var $bFXjh = parcelRequire("bFXjh");

var $1YqdI = parcelRequire("1YqdI");
const $3843ad0413ec519e$var$validateKeyMaps = (keyMaps)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(keyMaps, (keyMap, keyMapIndex)=>{
        const shortcuts = Object.keys(keyMap);
        (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(shortcuts, (shortcut, shortcutIndex)=>{
            if (!(0, $1YqdI.isValidShortcut)(shortcut)) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
            for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                    if ((0, $1YqdI.isShortcutCollision)(anotherShortcut, shortcut)) // If neither shortcut has a priority we have a conflict.. You should ideally
                    // put a priority on one of these conflicting shortcut configs so you definitively
                    // know which one should be active when there is a conflict.
                    {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(keyMap[shortcut].priority) && (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) // DO NOT LET THIS HAPPEN. ADD A PRIORITY!!!
                        // eslint-disable-next-line no-console
                        console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                    }
                });
            }
            for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, $1YqdI.isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
        });
    });
};
const $3843ad0413ec519e$var$mergeKeyMaps = (keyMapsToMerge)=>// Instead of doing the standard Object.assign({}, ...keyMapsToMerge)
    // we want to have a bit more control over what we can and can't override
    // through the use of the priority
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    keyMapsToMerge.reduce((prev, keyMap)=>({
            ...prev,
            // Add the keys that can be overridden
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1 // Default behaviour is override
                )) return {
                    ...newAccumulator,
                    [newKey]: keyMap[newKey]
                };
                return newAccumulator;
            }, {})
        }), {});
class $3843ad0413ec519e$export$ca1c75b575abf5ff {
    addChildRegistry(child) {
        this.children.push(child);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.children, child);
        };
    }
    addKeyMap(getKeyMap) {
        this.keyMapRetrievers.push(getKeyMap);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.keyMapRetrievers, getKeyMap);
        };
    }
    getActiveKeyMap() {
        const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
        return {
            ...$3843ad0413ec519e$var$mergeKeyMaps(keyMaps)
        };
    }
    getKeyMapInfo() {
        const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
        // @ts-expect-error - TS2769 - No overload matches this call.
        const flattenedInfo = [].concat(...info);
        return flattenedInfo;
    }
    constructor(){
        // go/jfe-eslint
        this.children = [];
        this.keyMapRetrievers = [];
    }
}
const $3843ad0413ec519e$export$1dd4c61d1ce1fa15 = new $3843ad0413ec519e$export$ca1c75b575abf5ff();

});
parcelRegister("bFXjh", function(module, exports) {

var $9eFtX = parcelRequire("9eFtX");

var $49axs = parcelRequire("49axs");
/**
 * Removes all given values from `array` using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
 * to remove elements from an array by predicate.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {...*} [values] The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pull(array, 'a', 'c');
 * console.log(array);
 * // => ['b', 'b']
 */ var $880187c06210b759$var$pull = $9eFtX($49axs);
module.exports = $880187c06210b759$var$pull;

});
parcelRegister("49axs", function(module, exports) {

var $3cvRc = parcelRequire("3cvRc");
/**
 * This method is like `_.pull` except that it accepts an array of values to remove.
 *
 * **Note:** Unlike `_.difference`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pullAll(array, ['a', 'c']);
 * console.log(array);
 * // => ['b', 'b']
 */ function $30502d761f1085cf$var$pullAll(array, values) {
    return array && array.length && values && values.length ? $3cvRc(array, values) : array;
}
module.exports = $30502d761f1085cf$var$pullAll;

});
parcelRegister("3cvRc", function(module, exports) {

var $kJvGp = parcelRequire("kJvGp");

var $jkhuN = parcelRequire("jkhuN");

var $2Rm6I = parcelRequire("2Rm6I");

var $74vSq = parcelRequire("74vSq");

var $b69Sx = parcelRequire("b69Sx");
/** Used for built-in method references. */ var $254b343f3ff82813$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $254b343f3ff82813$var$splice = $254b343f3ff82813$var$arrayProto.splice;
/**
 * The base implementation of `_.pullAllBy` without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 */ function $254b343f3ff82813$var$basePullAll(array, values, iteratee, comparator) {
    var indexOf = comparator ? $2Rm6I : $jkhuN, index = -1, length = values.length, seen = array;
    if (array === values) values = $b69Sx(values);
    if (iteratee) seen = $kJvGp(array, $74vSq(iteratee));
    while(++index < length){
        var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
        while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
            if (seen !== array) $254b343f3ff82813$var$splice.call(seen, fromIndex, 1);
            $254b343f3ff82813$var$splice.call(array, fromIndex, 1);
        }
    }
    return array;
}
module.exports = $254b343f3ff82813$var$basePullAll;

});
parcelRegister("2Rm6I", function(module, exports) {
/**
 * This function is like `baseIndexOf` except that it accepts a comparator.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $2151ae143791d52b$var$baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (comparator(array[index], value)) return index;
    }
    return -1;
}
module.exports = $2151ae143791d52b$var$baseIndexOfWith;

});




parcelRegister("1YqdI", function(module, exports) {

$parcel$export(module.exports, "toKeyWithModifiers", () => $1b99fa3356e664b3$export$8cf0d2c3d060a0c2);
$parcel$export(module.exports, "isValidShortcut", () => $1b99fa3356e664b3$export$8e231506c5580162);
$parcel$export(module.exports, "isShortcutCollision", () => $1b99fa3356e664b3$export$4add9e50cb49d130);
/**
 * Converts a KeyboardEvent to a normalised string representation of
 * modifiers and key.
 *
 * Ordering of modifier keys is taken from Apple's guidelines:
 * https://developer.apple.com/macos/human-interface-guidelines/input-and-output/keyboard/
 *
 * Example representation of ArrowUp key with all modifiers present:
 * ctrl+shift+meta+arrowup
 *
 * Character keys never include the 'shift' modifier,.
 * as it changes the character itself.
 * Examples:
 *  - instead of 'shift+a' the normal form is 'A'
 *  - instead of 'shift+/' the normal form is '?'
 *
 * The 'alt' modifier is NOT supported at all due to inconsistent behaviour
 * across platforms. On Mac, it changes the character input, e.g.
 * 'alt+z' is 'Ω' - which becomes the `event.key`. To properly support
 * this, a reverse-mapping of all these characters needs to be added.
 * Alternatively, `String.fromCharCode(event.which)` can be used, but
 * 1. This is a deprecated property
 * 2. The char code is still for the modified character for some keys on Mac
 *    (e.g. The char code for 'alt+/' is '¿')
 */ // Special keys such as 'Escape', 'ArrowUp' or ' '
const $1b99fa3356e664b3$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
const $1b99fa3356e664b3$var$modifiers = [
    {
        name: 'ctrl',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.ctrlKey
    },
    {
        name: 'shift',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.shiftKey && $1b99fa3356e664b3$var$isNonCharacterKey(e)
    },
    {
        // Command key on MacOS, Windows key on Windows
        name: 'meta',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
    }
];
const $1b99fa3356e664b3$var$toKey = (e)=>{
    if ($1b99fa3356e664b3$var$isNonCharacterKey(e)) return e.key.toLowerCase();
    // Ignore accidental CapsLock
    return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
};
const $1b99fa3356e664b3$export$8cf0d2c3d060a0c2 = (e)=>{
    if (!e || !e.key) // There are still browsers out there that do not support e.key;
    // Just today (Oct 2018) I have observed Chrome 47 in Sentry, but it started supporting e.key since 51.
    // So instead of crashing the page with TypeError let's not detect keyboard shortcuts.
    return {
        sequence: '',
        e: e
    };
    return {
        sequence: $1b99fa3356e664b3$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($1b99fa3356e664b3$var$toKey(e)).join('+'),
        e: e
    };
};
/*
 *  Selected special key values disjunction for regex. All lowercase, ordered alphabethically.
 *  See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values.
 */ const $1b99fa3356e664b3$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
/*
 * This string when used as a regular expression:
 * 1. Allows lowercase only with a single exception (see 3)
 * 2. Allows optional ctrl, shift, meta followed by "+" in that specific order in the beginning
 * 3. Allows any printable character (may be uppercase letter) or a special key value
 * 4. If shift modifier is used it can only be followed by a special char
 * 5. Is based on toKeyWithModifiers, uses orSpecialChars whitelist for shift chars
 * 6. Does not capture redundant groups
 */ const $1b99fa3356e664b3$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$1b99fa3356e664b3$var$orSpecialChars}))))?(meta\\+)?(${$1b99fa3356e664b3$var$orSpecialChars}|[!-~])`;
/*
 * Any number of singleShortcutEntry separated by a single space
 * We are not specifying "g" flag, so it's fine to reuse the same regex object.
 */ const $1b99fa3356e664b3$var$shortcutRegex = RegExp(`^${$1b99fa3356e664b3$var$singleShortcutEntry}( ${$1b99fa3356e664b3$var$singleShortcutEntry})*$`);
const $1b99fa3356e664b3$export$8e231506c5580162 = (shortcut)=>$1b99fa3356e664b3$var$shortcutRegex.test(shortcut);
const $1b99fa3356e664b3$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
    if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
    if (rightShortcut === leftShortcut) return true;
    if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
    if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
    return false;
};

});



parcelRegister("9r3B9", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c47f5d538dd1078$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9c47f5d538dd1078$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    confirmationTitle: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.form.confirmation-modal.confirmation-title",
        "defaultMessage": "Add customer to multiple projects"
    },
    multipleProjectOrganization: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.form.confirmation-modal.multiple-project-organization",
        "defaultMessage": "The organization {name} is used in {numberOfOtherProjects, plural, one {# project} other {# projects}}. Customers you add to it can view requests shared with the organization and raise their own requests in those projects."
    },
    addCustomers: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.form.confirmation-modal.add-customers",
        "defaultMessage": "Add customers"
    },
    cancel: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.form.confirmation-modal.cancel",
        "defaultMessage": "Cancel"
    }
});

});


parcelRegister("jLIyH", function(module, exports) {

$parcel$export(module.exports, "ExtendedFormContent", () => $7b21a21b32f98def$export$427282f4d8726cae);

var $eAdw7 = parcelRequire("eAdw7");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $0cdA8 = parcelRequire("0cdA8");

var $guiFP = parcelRequire("guiFP");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $NDFJi = parcelRequire("NDFJi");
const $7b21a21b32f98def$var$logError = (err)=>{
    (0, $guiFP.default)({
        meta: {
            id: 'entitlementServiceFetch',
            packageName: 'jiraServicedeskCustomersOrganizationCommon',
            teamName: 'boysenberry'
        },
        error: err,
        sendToPrivacyUnsafeSplunk: true
    });
};
const $7b21a21b32f98def$var$ExtendedFormContentContainer = (props)=>{
    const formContentMultihcViewQueryData = (0, $iWLL0.usePreloadedQuery)((0, $eAdw7.default), props.queryRef);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [hasMultiHcAndInviteRouting, setHasMultiHcAndInviteRouting] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (!hasMultiHcAndInviteRouting && formContentMultihcViewQueryData) {
            let updatedMultiHcAndInviteRouting = false;
            const helpCenterConfig = formContentMultihcViewQueryData?.helpCenter?.helpCentersConfig;
            if (!helpCenterConfig) // This could occur when the request did not reach Kosh
            $7b21a21b32f98def$var$logError(new Error(`Missing required fields in entitlement response, possibly an AGG error. ${JSON.stringify(formContentMultihcViewQueryData)}`));
            else if (helpCenterConfig.__typename === 'HelpCentersConfig') {
                const { isEnabled: isEnabled } = helpCenterConfig;
                updatedMultiHcAndInviteRouting = isEnabled;
                const analyticsEvent = createAnalyticsEvent({});
                (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'entitlement APICallSuccess', {
                    source: 'entitlementServiceFetch',
                    hasMultiHcAndInviteRouting: isEnabled
                });
            } else if (helpCenterConfig.__typename === 'QueryError') {
                const { identifier: identifier, message: message, extensions: extensions } = helpCenterConfig;
                const { errorType: errorType, statusCode: statusCode } = extensions?.[0] || {};
                if (!(0, $NDFJi.isHttpClientErrorResponse)(Number(statusCode))) $7b21a21b32f98def$var$logError(new Error(`QueryError: ${JSON.stringify({
                    identifier: identifier,
                    message: message,
                    errorType: errorType,
                    statusCode: statusCode
                })}`));
            }
            if (updatedMultiHcAndInviteRouting !== hasMultiHcAndInviteRouting) setHasMultiHcAndInviteRouting(updatedMultiHcAndInviteRouting);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        formContentMultihcViewQueryData,
        hasMultiHcAndInviteRouting
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.render({
        hasMultiHcAndInviteRouting: hasMultiHcAndInviteRouting
    }));
};
const $7b21a21b32f98def$export$427282f4d8726cae = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "add-customer-entitlement-check",
        fallback: ()=>props.render({
                hasMultiHcAndInviteRouting: false
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7b21a21b32f98def$var$ExtendedFormContentContainer, props));

});

parcelRegister("bKnoT", function(module, exports) {

$parcel$export(module.exports, "FormContent", () => $5ea3d6367f5e3532$export$6ed20265bd6496f6);

var $eUqFw = parcelRequire("eUqFw");

var $aYQ0Q = parcelRequire("aYQ0Q");
var $bKkhQ = parcelRequire("bKkhQ");
var $jeetE = parcelRequire("jeetE");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $giAhk = parcelRequire("giAhk");

var $1McoB = parcelRequire("1McoB");

var $aOiov = parcelRequire("aOiov");

var $f7BqA = parcelRequire("f7BqA");

var $dgUkL = parcelRequire("dgUkL");

var $cZz4A = parcelRequire("cZz4A");
var $erYQo = parcelRequire("erYQo");
var $1wCxQ = parcelRequire("1wCxQ");

var $7voIf = parcelRequire("7voIf");

var $aNlDF = parcelRequire("aNlDF");
const $5ea3d6367f5e3532$export$fc632c513fd5822e = ({ intl: { formatMessage: formatMessage }, isSubmitting: isSubmitting, isOrganizationDefaulted: isOrganizationDefaulted, error: formErrors, hasMultiHcAndInviteRouting: hasMultiHcAndInviteRouting })=>{
    const [{ userPermissions: { canAdminister: // @ts-expect-error - TS2525 - Initializer provides no value for this binding element and the binding element has no default value.
    canAdminister, canManageOrganizations: // @ts-expect-error - TS2525 - Initializer provides no value for this binding element and the binding element has no default value.
    canManageOrganizations, outgoingMailConfigured: // @ts-expect-error - TS2525 - Initializer provides no value for this binding element and the binding element has no default value.
    outgoingMailConfigured, isInviteEmailEnabled: // @ts-expect-error - TS2525 - Initializer provides no value for this binding element and the binding element has no default value.
    isInviteEmailEnabled } = {}, serviceErrors: serviceErrors, helpCenter: helpCenter }, { resetAndCloseForm: resetAndCloseForm, setHelpCenter: setHelpCenter }] = (0, $dgUkL.useAddCustomersDialogContext)();
    const requiredField = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $5ea3d6367f5e3532$var$requiredFieldStyles
    }, formatMessage((0, $aNlDF.default).requiredField), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeetE.default), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aYQ0Q.default), {
        title: formatMessage((0, $aNlDF.default).addCustomers)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cZz4A.CustomerNotificationHelpText), {
        isAdmin: canAdminister,
        isOutgoingMailEnabled: outgoingMailConfigured,
        isInviteEmailEnabled: isInviteEmailEnabled,
        isMultiHcAndInviteRoutingEnabled: hasMultiHcAndInviteRouting
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bKkhQ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $5ea3d6367f5e3532$var$noOverflowX
    }, hasMultiHcAndInviteRouting && requiredField, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $erYQo.DynamicInputField), null), hasMultiHcAndInviteRouting && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1McoB.HelpCenterSelectField), {
        selectedHelpCenter: helpCenter,
        setSelectedHelpCenter: setHelpCenter
    }), isOrganizationDefaulted !== true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f7BqA.CanManageOrganization), {
        canAdminister: canAdminister,
        canManageOrganizations: canManageOrganizations
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1wCxQ.OrganizationsSelectField), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOiov.FormErrors), {
        formErrors: formErrors,
        serviceError: serviceErrors
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7voIf.Footer), {
        isLoading: isSubmitting,
        onCancel: resetAndCloseForm,
        hasMultiHcAndInviteRouting: hasMultiHcAndInviteRouting
    }))));
};
const $5ea3d6367f5e3532$var$requiredFieldStyles = (0, $1ZAYh.xcss)({
    marginBottom: 'space.200'
});
const $5ea3d6367f5e3532$var$noOverflowX = (0, $1ZAYh.xcss)({
    overflowX: 'hidden'
});
const $5ea3d6367f5e3532$export$6ed20265bd6496f6 = (0, $giAhk.injectIntlV2)($5ea3d6367f5e3532$export$fc632c513fd5822e);

});
parcelRegister("aYQ0Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $97ae6dd46b7e11ec$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $hI5oG = parcelRequire("hI5oG");

var $XHGTv = parcelRequire("XHGTv");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4lTFP = parcelRequire("4lTFP");
function $97ae6dd46b7e11ec$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $97ae6dd46b7e11ec$var$formHeaderContentStyles = (0, $1ZAYh.xcss)({
    minWidth: '100%',
    marginBlockStart: 'space.100'
});
const $97ae6dd46b7e11ec$var$formHeaderDescriptionStyles = (0, $1ZAYh.xcss)({
    marginBlockStart: 'space.100'
});
const $97ae6dd46b7e11ec$var$formHeaderTitleStyles = {
    name: "1eccq1n",
    styles: "line-height:var(--ds-font-lineHeight-500, 32px);margin-block-start:0;margin-inline-end:var(--ds-space-400, 32px);overflow:hidden;text-overflow:ellipsis;white-space:nowrap"
};
const $97ae6dd46b7e11ec$var$formHeaderWrapperStyles = {
    name: "xzr008",
    styles: "font-family:var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $97ae6dd46b7e11ec$var$lightH700Styles = /*#__PURE__*/ (0, $byn9U.css)((0, $4lTFP.h700)({
    theme: {
        mode: 'light'
    }
}));
const $97ae6dd46b7e11ec$export$2328f6c3afc53a3c = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $97ae6dd46b7e11ec$var$formHeaderContentStyles
    }, children);
};
const $97ae6dd46b7e11ec$export$fc2f92b09a865fbb = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $97ae6dd46b7e11ec$var$formHeaderDescriptionStyles
    }, children);
};
const $97ae6dd46b7e11ec$export$979afebc6a69047 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("h2", {
        css: [
            $97ae6dd46b7e11ec$var$lightH700Styles,
            $97ae6dd46b7e11ec$var$formHeaderTitleStyles
        ]
    }, children);
};
const $97ae6dd46b7e11ec$var$FormHeaderWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $97ae6dd46b7e11ec$var$formHeaderWrapperStyles
    }, children);
};
/**
 * __Form header__.
 *
 * A form header contains the form component's heading and subheadings. This provides the correct padding
 * and styling for it.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout).
 */ const $97ae6dd46b7e11ec$var$FormHeader = ({ children: children, description: description, title: title })=>{
    return (0, $XHGTv.getBooleanFF)('platform.design-system-team.form-header-typography-updates_4f1g6') ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), null, title && /*#__PURE__*/ (0, $byn9U.jsx)((0, $hI5oG.default), {
        size: "large"
    }, title), description && /*#__PURE__*/ (0, $byn9U.jsx)($97ae6dd46b7e11ec$export$fc2f92b09a865fbb, null, description), children && /*#__PURE__*/ (0, $byn9U.jsx)($97ae6dd46b7e11ec$export$2328f6c3afc53a3c, null, children)) : /*#__PURE__*/ (0, $byn9U.jsx)($97ae6dd46b7e11ec$var$FormHeaderWrapper, null, title && /*#__PURE__*/ (0, $byn9U.jsx)($97ae6dd46b7e11ec$export$979afebc6a69047, null, title), description && /*#__PURE__*/ (0, $byn9U.jsx)($97ae6dd46b7e11ec$export$fc2f92b09a865fbb, null, description), children && /*#__PURE__*/ (0, $byn9U.jsx)($97ae6dd46b7e11ec$export$2328f6c3afc53a3c, null, children));
};
var $97ae6dd46b7e11ec$export$2e2bcd8739ae039 = $97ae6dd46b7e11ec$var$FormHeader;

});

parcelRegister("bKkhQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c95da9811468ff1e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $hI5oG = parcelRequire("hI5oG");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $c95da9811468ff1e$var$formSectionDescriptionStyles = (0, $1ZAYh.xcss)({
    marginBlockStart: 'space.100'
});
const $c95da9811468ff1e$var$formSectionWrapperStyles = (0, $1ZAYh.xcss)({
    marginBlockStart: 'space.300'
});
const $c95da9811468ff1e$var$FormSectionWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $c95da9811468ff1e$var$formSectionWrapperStyles
    }, children);
};
const $c95da9811468ff1e$var$FormSectionDescription = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $c95da9811468ff1e$var$formSectionDescriptionStyles
    }, children);
};
/**
 * __Form section__.
 *
 * A form section is used to define a section of a form layout. This contains a section title, content
 * and a description of the section.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout).
 */ const $c95da9811468ff1e$var$FormSection = ({ children: children, description: description, title: title })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)($c95da9811468ff1e$var$FormSectionWrapper, null, title && /*#__PURE__*/ (0, $byn9U.jsx)((0, $hI5oG.default), {
        size: "medium"
    }, title), description && /*#__PURE__*/ (0, $byn9U.jsx)($c95da9811468ff1e$var$FormSectionDescription, null, description), children);
};
var $c95da9811468ff1e$export$2e2bcd8739ae039 = $c95da9811468ff1e$var$FormSection;

});

parcelRegister("jeetE", function(module, exports) {

$parcel$export(module.exports, "default", () => $d43a5e2537ba41ea$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");
const $d43a5e2537ba41ea$var$requiredIndicatorStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-danger, ${(0, $PdmhA.R400)})`,
    fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    paddingInlineStart: "var(--ds-space-025, 2px)"
});
function $d43a5e2537ba41ea$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $d43a5e2537ba41ea$var$requiredIndicatorStyles,
        "aria-hidden": "true",
        title: "required"
    }, "*");
}

});

parcelRegister("1McoB", function(module, exports) {

$parcel$export(module.exports, "HelpCenterSelectField", () => $78bb285007a4d180$export$53a0ffb611752140);

var $eUqFw = parcelRequire("eUqFw");

var $oEEHR = parcelRequire("oEEHR");

var $7jPhn = parcelRequire("7jPhn");
var $4LhB6 = parcelRequire("4LhB6");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5wCDk = parcelRequire("5wCDk");

var $c9TLT = parcelRequire("c9TLT");

var $5JgJ2 = parcelRequire("5JgJ2");


var $yCziW = parcelRequire("yCziW");
var $12r3d = parcelRequire("12r3d");

var $iJNtC = parcelRequire("iJNtC");

var $1RhQ9 = parcelRequire("1RhQ9");
const $78bb285007a4d180$var$HelpCenterSelectView = ({ selectedHelpCenter: selectedHelpCenter, setSelectedHelpCenter: setSelectedHelpCenter })=>{
    const { fetch: fetch, isLoading: isLoading, error: error, hasNext: hasNext } = (0, $iJNtC.useHelpCenterFetchService)();
    const [options, setOptions] = (0, $eUqFw.useState)([]);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { ref: ref, inView: inView } = (0, $oEEHR.useInView)({
        threshold: 0
    });
    const loadOptions = (0, $eUqFw.useCallback)(async (initial = false)=>{
        const helpCenters = await fetch();
        if (helpCenters?.length > 0 && !error) {
            const helpCenterOptions = helpCenters.map((hc, hcIndex)=>{
                const renderWithref = hcIndex === helpCenters.length - (0, $7e206d83f4cfe846$export$9b2c73c824a302e4);
                const hcNameWithDefaultLozenge = hc.slug ? hc.name : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $yCziW.HelpCenterOptionCustomLabel), {
                    value: hc.name
                });
                const hcLabel = renderWithref ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                    ref: ref
                }, hc.name) : hcNameWithDefaultLozenge;
                const option = {
                    label: hcLabel,
                    value: hc.helpCenterAri,
                    stringLabel: hc.name,
                    slug: hc.slug
                };
                if (!hc.slug && !selectedHelpCenter && initial) setSelectedHelpCenter(option);
                return option;
            });
            if (helpCenterOptions.length > 0) setOptions(helpCenterOptions);
        }
    }, [
        error,
        fetch,
        selectedHelpCenter,
        ref,
        setSelectedHelpCenter
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // Load more options only when there is not an error and there are more options to load
        if (hasNext && inView && !isLoading && !error) loadOptions(false);
    }, [
        hasNext,
        inView,
        loadOptions,
        isLoading,
        error
    ]);
    (0, $eUqFw.useEffect)(()=>{
        loadOptions(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onSelect = (selected)=>{
        // When someone clears the field
        if (selected === null) setSelectedHelpCenter(undefined);
        else setSelectedHelpCenter(selected);
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const menuPortal = (base)=>({
            ...base,
            zIndex: (0, $c9TLT.layers).modal
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $78bb285007a4d180$var$helpCenterSelectWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        name: "add-to-hc-field",
        label: formatMessage((0, $1RhQ9.default).addToHelpCenterUpdated),
        isRequired: true
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $12r3d.HelpMe), {
            helperText: formatMessage((0, $1RhQ9.default).info)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
            cacheOptions: true,
            options: options,
            value: selectedHelpCenter,
            onChange: onSelect,
            openMenuOnClick: true,
            isClearable: true,
            isLoading: isLoading,
            "aria-label": formatMessage((0, $1RhQ9.default).addToHelpCenterUpdated),
            placeholder: formatMessage((0, $1RhQ9.default).placeHolder),
            menuPortalTarget: document.body,
            isSearchable: false,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
            styles: {
                menuPortal: menuPortal
            }
        }), !isLoading && error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, formatMessage((0, $1RhQ9.default).somethingWentWrong))))));
};
const $78bb285007a4d180$var$helpCenterSelectWrapper = (0, $1ZAYh.xcss)({
    marginTop: 'space.100',
    marginBottom: 'space.200'
});
const $78bb285007a4d180$export$53a0ffb611752140 = $78bb285007a4d180$var$HelpCenterSelectView;

});
parcelRegister("oEEHR", function(module, exports) {

$parcel$export(module.exports, "useInView", () => $04a1c75a07b1651f$export$2f62ee6831462844);

var $eUqFw = parcelRequire("eUqFw");
function $04a1c75a07b1651f$var$_extends() {
    $04a1c75a07b1651f$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $04a1c75a07b1651f$var$_extends.apply(this, arguments);
}
function $04a1c75a07b1651f$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $04a1c75a07b1651f$var$_setPrototypeOf(subClass, superClass);
}
function $04a1c75a07b1651f$var$_setPrototypeOf(o, p) {
    $04a1c75a07b1651f$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $04a1c75a07b1651f$var$_setPrototypeOf(o, p);
}
function $04a1c75a07b1651f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $04a1c75a07b1651f$var$observerMap = new Map();
var $04a1c75a07b1651f$var$RootIds = new WeakMap();
var $04a1c75a07b1651f$var$rootId = 0;
var $04a1c75a07b1651f$var$unsupportedValue = undefined;
/**
 * What should be the default behavior if the IntersectionObserver is unsupported?
 * Ideally the polyfill has been loaded, you can have the following happen:
 * - `undefined`: Throw an error
 * - `true` or `false`: Set the `inView` value to this regardless of intersection state
 * **/ function $04a1c75a07b1651f$export$2ef3a60ee1f37bec(inView) {
    $04a1c75a07b1651f$var$unsupportedValue = inView;
}
/**
 * Generate a unique ID for the root element
 * @param root
 */ function $04a1c75a07b1651f$var$getRootId(root) {
    if (!root) return '0';
    if ($04a1c75a07b1651f$var$RootIds.has(root)) return $04a1c75a07b1651f$var$RootIds.get(root);
    $04a1c75a07b1651f$var$rootId += 1;
    $04a1c75a07b1651f$var$RootIds.set(root, $04a1c75a07b1651f$var$rootId.toString());
    return $04a1c75a07b1651f$var$RootIds.get(root);
}
/**
 * Convert the options to a string Id, based on the values.
 * Ensures we can reuse the same observer when observing elements with the same options.
 * @param options
 */ function $04a1c75a07b1651f$var$optionsToId(options) {
    return Object.keys(options).sort().filter(function(key) {
        return options[key] !== undefined;
    }).map(function(key) {
        return key + "_" + (key === 'root' ? $04a1c75a07b1651f$var$getRootId(options.root) : options[key]);
    }).toString();
}
function $04a1c75a07b1651f$var$createObserver(options) {
    // Create a unique ID for this observer instance, based on the root, root margin and threshold.
    var id = $04a1c75a07b1651f$var$optionsToId(options);
    var instance = $04a1c75a07b1651f$var$observerMap.get(id);
    if (!instance) {
        // Create a map of elements this observer is going to observe. Each element has a list of callbacks that should be triggered, once it comes into view.
        var elements = new Map();
        var thresholds;
        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                var _elements$get;
                // While it would be nice if you could just look at isIntersecting to determine if the component is inside the viewport, browsers can't agree on how to use it.
                // -Firefox ignores `threshold` when considering `isIntersecting`, so it will never be false again if `threshold` is > 0
                var inView = entry.isIntersecting && thresholds.some(function(threshold) {
                    return entry.intersectionRatio >= threshold;
                }); // @ts-ignore support IntersectionObserver v2
                if (options.trackVisibility && typeof entry.isVisible === 'undefined') // The browser doesn't support Intersection Observer v2, falling back to v1 behavior.
                // @ts-ignore
                entry.isVisible = inView;
                (_elements$get = elements.get(entry.target)) == null || _elements$get.forEach(function(callback) {
                    callback(inView, entry);
                });
            });
        }, options); // Ensure we have a valid thresholds array. If not, use the threshold from the options
        thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [
            options.threshold || 0
        ]);
        instance = {
            id: id,
            observer: observer,
            elements: elements
        };
        $04a1c75a07b1651f$var$observerMap.set(id, instance);
    }
    return instance;
}
/**
 * @param element - DOM Element to observe
 * @param callback - Callback function to trigger when intersection status changes
 * @param options - Intersection Observer options
 * @param fallbackInView - Fallback inView value.
 * @return Function - Cleanup function that should be triggered to unregister the observer
 */ function $04a1c75a07b1651f$export$d1203567a167490e(element, callback, options, fallbackInView) {
    if (options === void 0) options = {};
    if (fallbackInView === void 0) fallbackInView = $04a1c75a07b1651f$var$unsupportedValue;
    if (typeof window.IntersectionObserver === 'undefined' && fallbackInView !== undefined) {
        var bounds = element.getBoundingClientRect();
        callback(fallbackInView, {
            isIntersecting: fallbackInView,
            target: element,
            intersectionRatio: typeof options.threshold === 'number' ? options.threshold : 0,
            time: 0,
            boundingClientRect: bounds,
            intersectionRect: bounds,
            rootBounds: bounds
        });
        return function() {};
    } // An observer with the same options can be reused, so lets use this fact
    var _createObserver = $04a1c75a07b1651f$var$createObserver(options), id = _createObserver.id, observer = _createObserver.observer, elements = _createObserver.elements; // Register the callback listener for this element
    var callbacks = elements.get(element) || [];
    if (!elements.has(element)) elements.set(element, callbacks);
    callbacks.push(callback);
    observer.observe(element);
    return function unobserve() {
        // Remove the callback from the callback list
        callbacks.splice(callbacks.indexOf(callback), 1);
        if (callbacks.length === 0) {
            // No more callback exists for element, so destroy it
            elements["delete"](element);
            observer.unobserve(element);
        }
        if (elements.size === 0) {
            // No more elements are being observer by this instance, so destroy it
            observer.disconnect();
            $04a1c75a07b1651f$var$observerMap["delete"](id);
        }
    };
}
var $04a1c75a07b1651f$var$_excluded = [
    "children",
    "as",
    "triggerOnce",
    "threshold",
    "root",
    "rootMargin",
    "onChange",
    "skip",
    "trackVisibility",
    "delay",
    "initialInView",
    "fallbackInView"
];
function $04a1c75a07b1651f$var$isPlainChildren(props) {
    return typeof props.children !== 'function';
}
/**
 ## Render props

 To use the `<InView>` component, you pass it a function. It will be called
 whenever the state changes, with the new value of `inView`. In addition to the
 `inView` prop, children also receive a `ref` that should be set on the
 containing DOM element. This is the element that the IntersectionObserver will
 monitor.

 If you need it, you can also access the
 [`IntersectionObserverEntry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry)
 on `entry`, giving you access to all the details about the current intersection
 state.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView>
 {({ inView, ref, entry }) => (
      <div ref={ref}>
        <h2>{`Header inside viewport ${inView}.`}</h2>
      </div>
    )}
 </InView>
 );

 export default Component;
 ```

 ## Plain children

 You can pass any element to the `<InView />`, and it will handle creating the
 wrapping DOM element. Add a handler to the `onChange` method, and control the
 state in your own component. Any extra props you add to `<InView>` will be
 passed to the HTML element, allowing you set the `className`, `style`, etc.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView as="div" onChange={(inView, entry) => console.log('Inview:', inView)}>
 <h2>Plain children are always rendered. Use onChange to monitor state.</h2>
 </InView>
 );

 export default Component;
 ```
 */ var $04a1c75a07b1651f$export$a62107ca74432f44 = /*#__PURE__*/ function(_React$Component) {
    $04a1c75a07b1651f$var$_inheritsLoose(InView, _React$Component);
    function InView(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.node = null;
        _this._unobserveCb = null;
        _this.handleNode = function(node) {
            if (_this.node) {
                // Clear the old observer, before we start observing a new element
                _this.unobserve();
                if (!node && !_this.props.triggerOnce && !_this.props.skip) // Reset the state if we get a new node, and we aren't ignoring updates
                _this.setState({
                    inView: !!_this.props.initialInView,
                    entry: undefined
                });
            }
            _this.node = node ? node : null;
            _this.observeNode();
        };
        _this.handleChange = function(inView, entry) {
            if (inView && _this.props.triggerOnce) // If `triggerOnce` is true, we should stop observing the element.
            _this.unobserve();
            if (!$04a1c75a07b1651f$var$isPlainChildren(_this.props)) // Store the current State, so we can pass it to the children in the next render update
            // There's no reason to update the state for plain children, since it's not used in the rendering.
            _this.setState({
                inView: inView,
                entry: entry
            });
            if (_this.props.onChange) // If the user is actively listening for onChange, always trigger it
            _this.props.onChange(inView, entry);
        };
        _this.state = {
            inView: !!props.initialInView,
            entry: undefined
        };
        return _this;
    }
    var _proto = InView.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        // If a IntersectionObserver option changed, reinit the observer
        if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
            this.unobserve();
            this.observeNode();
        }
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.unobserve();
        this.node = null;
    };
    _proto.observeNode = function observeNode() {
        if (!this.node || this.props.skip) return;
        var _this$props = this.props, threshold = _this$props.threshold, root = _this$props.root, rootMargin = _this$props.rootMargin, trackVisibility = _this$props.trackVisibility, delay = _this$props.delay, fallbackInView = _this$props.fallbackInView;
        this._unobserveCb = $04a1c75a07b1651f$export$d1203567a167490e(this.node, this.handleChange, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin,
            // @ts-ignore
            trackVisibility: trackVisibility,
            // @ts-ignore
            delay: delay
        }, fallbackInView);
    };
    _proto.unobserve = function unobserve() {
        if (this._unobserveCb) {
            this._unobserveCb();
            this._unobserveCb = null;
        }
    };
    _proto.render = function render() {
        if (!$04a1c75a07b1651f$var$isPlainChildren(this.props)) {
            var _this$state = this.state, inView = _this$state.inView, entry = _this$state.entry;
            return this.props.children({
                inView: inView,
                entry: entry,
                ref: this.handleNode
            });
        }
        var _this$props2 = this.props, children = _this$props2.children, as = _this$props2.as, props = $04a1c75a07b1651f$var$_objectWithoutPropertiesLoose(_this$props2, $04a1c75a07b1651f$var$_excluded);
        return /*#__PURE__*/ $eUqFw.createElement(as || 'div', $04a1c75a07b1651f$var$_extends({
            ref: this.handleNode
        }, props), children);
    };
    return InView;
}($eUqFw.Component);
$04a1c75a07b1651f$export$a62107ca74432f44.displayName = 'InView';
$04a1c75a07b1651f$export$a62107ca74432f44.defaultProps = {
    threshold: 0,
    triggerOnce: false,
    initialInView: false
};
/**
 * React Hooks make it easy to monitor the `inView` state of your components. Call
 * the `useInView` hook with the (optional) [options](#options) you need. It will
 * return an array containing a `ref`, the `inView` status and the current
 * [`entry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry).
 * Assign the `ref` to the DOM element you want to monitor, and the hook will
 * report the status.
 *
 * @example
 * ```jsx
 * import React from 'react';
 * import { useInView } from 'react-intersection-observer';
 *
 * const Component = () => {
 *   const { ref, inView, entry } = useInView({
 *       threshold: 0,
 *   });
 *
 *   return (
 *     <div ref={ref}>
 *       <h2>{`Header inside viewport ${inView}.`}</h2>
 *     </div>
 *   );
 * };
 * ```
 */ function $04a1c75a07b1651f$export$2f62ee6831462844(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, threshold = _ref.threshold, delay = _ref.delay, trackVisibility = _ref.trackVisibility, rootMargin = _ref.rootMargin, root = _ref.root, triggerOnce = _ref.triggerOnce, skip = _ref.skip, initialInView = _ref.initialInView, fallbackInView = _ref.fallbackInView;
    var unobserve = $eUqFw.useRef();
    var _React$useState = $eUqFw.useState({
        inView: !!initialInView
    }), state = _React$useState[0], setState = _React$useState[1];
    var setRef = $eUqFw.useCallback(function(node) {
        if (unobserve.current !== undefined) {
            unobserve.current();
            unobserve.current = undefined;
        } // Skip creating the observer
        if (skip) return;
        if (node) unobserve.current = $04a1c75a07b1651f$export$d1203567a167490e(node, function(inView, entry) {
            setState({
                inView: inView,
                entry: entry
            });
            if (entry.isIntersecting && triggerOnce && unobserve.current) {
                // If it should only trigger once, unobserve the element after it's inView
                unobserve.current();
                unobserve.current = undefined;
            }
        }, {
            root: root,
            rootMargin: rootMargin,
            threshold: threshold,
            // @ts-ignore
            trackVisibility: trackVisibility,
            // @ts-ignore
            delay: delay
        }, fallbackInView);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        // eslint-disable-next-line react-hooks/exhaustive-deps
        Array.isArray(threshold) ? threshold.toString() : threshold,
        root,
        rootMargin,
        triggerOnce,
        skip,
        trackVisibility,
        fallbackInView,
        delay
    ]);
    /* eslint-disable-next-line */ (0, $eUqFw.useEffect)(function() {
        if (!unobserve.current && state.entry && !triggerOnce && !skip) // If we don't have a ref, then reset the state (unless the hook is set to only `triggerOnce` or `skip`)
        // This ensures we correctly reflect the current state - If you aren't observing anything, then nothing is inView
        setState({
            inView: !!initialInView
        });
    });
    var result = [
        setRef,
        state.inView,
        state.entry
    ]; // Support object destructuring, by adding the specific values.
    result.ref = result[0];
    result.inView = result[1];
    result.entry = result[2];
    return result;
}

});

parcelRegister("4LhB6", function(module, exports) {

$parcel$export(module.exports, "default", () => $dde75f35762e3dcb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $tkrFt = parcelRequire("tkrFt");
parcelRequire("8ynlC");

var $gaA9C = parcelRequire("gaA9C");

var $lzLxZ = parcelRequire("lzLxZ");

var $6ROLN = parcelRequire("6ROLN");

var $jeetE = parcelRequire("jeetE");

var $2fFJv = parcelRequire("2fFJv");
function $dde75f35762e3dcb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $dde75f35762e3dcb$var$fieldWrapperStyles = {
    name: "wkpnc",
    styles: "margin-block-start:var(--ds-space-100, 8px)"
};
function $dde75f35762e3dcb$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $dde75f35762e3dcb$var$isFunction(x) {
    return typeof x === 'function';
}
function $dde75f35762e3dcb$var$usePreviousRef(current) {
    const ref = (0, $eUqFw.useRef)(current);
    // will be updated on the next render
    (0, $eUqFw.useEffect)(()=>{
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $dde75f35762e3dcb$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $dde75f35762e3dcb$export$2e2bcd8739ae039(props) {
    const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $eUqFw.useContext)((0, $lzLxZ.FormContext));
    const isDisabled = (0, $eUqFw.useContext)((0, $lzLxZ.IsDisabledContext)) || props.isDisabled || false;
    const defaultValue = $dde75f35762e3dcb$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    const latestPropsRef = $dde75f35762e3dcb$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ const isDefaultValueChanged = !$dde75f35762e3dcb$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    const [state, setState] = (0, $eUqFw.useState)({
        fieldProps: {
            onChange: ()=>{},
            onBlur: ()=>{},
            onFocus: ()=>{},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
       * effectively made it an optional prop to external consumers of Field. However the
       * prop types defined defaultValue as required, so inside the component it was not
       * valid for defaultValue to be undefined. We need to suppress the error
       * after changing defaultValue to explictly be an optional prop.
       * If default value has changed we are using new default value.
       * Otherwise we need to check if we already have value for this field
       * (because we are using changing key prop to re-run field level validation, and that
       * cause the component re-mounting) to not override the actual value with the default value.
       */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    });
    const latestStateRef = $dde75f35762e3dcb$var$usePreviousRef(state);
    (0, $eUqFw.useEffect)(()=>{
        typeof $2fFJv;
        function fieldStateToMeta(value = {}) {
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        const unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $dde75f35762e3dcb$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($dde75f35762e3dcb$var$isEvent(eventOrValue)) {
                    const { currentTarget: currentTarget } = eventOrValue;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: (e)=>{
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: ()=>function validate(value, formState, fieldState) {
                    const supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isDefaultValueChanged
    ]);
    const fieldId = (0, $eUqFw.useMemo)(// eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    ()=>props.id ? props.id : `${props.name}-${(0, $tkrFt.uid)({
            id: props.name
        })}`, [
        props.id,
        props.name
    ]);
    const getDescribedBy = ()=>{
        let value = '';
        if (state.error) value += `${fieldId}-error `;
        if (state.valid) value += `${fieldId}-valid `;
        return `${value}${fieldId}-helper`;
    };
    const extendedFieldProps = {
        ...state.fieldProps,
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': `${fieldId}-label`,
        id: fieldId
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $dde75f35762e3dcb$var$fieldWrapperStyles,
        "data-testid": props.testId
    }, props.label && /*#__PURE__*/ (0, $byn9U.jsx)((0, $6ROLN.Label), {
        htmlFor: fieldId,
        id: `${fieldId}-label`,
        testId: props.testId && `${props.testId}--label`
    }, props.label, props.isRequired && /*#__PURE__*/ (0, $byn9U.jsx)((0, $jeetE.default), null), props.elementAfterLabel), /*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Provider, {
        value: fieldId
    }, props.children({
        fieldProps: extendedFieldProps,
        error: state.error,
        valid: state.valid,
        meta: state.meta
    })));
}

});
parcelRegister("6ROLN", function(module, exports) {

$parcel$export(module.exports, "Label", () => $7dbb02f7c217159b$export$b04be29aa201d4f5);
$parcel$export(module.exports, "Legend", () => $7dbb02f7c217159b$export$ed247974535929c7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $PdmhA = parcelRequire("PdmhA");
function $7dbb02f7c217159b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7dbb02f7c217159b$var$fieldsetLabelStyles = {
    name: "1v8a0r4",
    styles: "display:inline-block;font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-end:var(--ds-space-050, 4px);margin-block-start:var(--ds-space-0, 0px)"
};
const $7dbb02f7c217159b$var$oldFieldsetLabelStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-subtle, ${(0, $PdmhA.N200)})`,
    fontWeight: "var(--ds-font-weight-semibold, 600)"
});
const $7dbb02f7c217159b$var$newFieldsetLabelStyles = {
    name: "1btbeoi",
    styles: "color:var(--ds-text-subtle, #44546F);font-weight:var(--ds-font-weight-bold, 700)"
};
const $7dbb02f7c217159b$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("label", {
        css: [
            $7dbb02f7c217159b$var$fieldsetLabelStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $XHGTv.getBooleanFF)('platform.design-system-team.form-label-typography-updates') ? $7dbb02f7c217159b$var$newFieldsetLabelStyles : $7dbb02f7c217159b$var$oldFieldsetLabelStyles
        ],
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId
    }, children);
const $7dbb02f7c217159b$export$ed247974535929c7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("legend", {
        css: [
            $7dbb02f7c217159b$var$fieldsetLabelStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $XHGTv.getBooleanFF)('platform.design-system-team.form-label-typography-updates') ? $7dbb02f7c217159b$var$newFieldsetLabelStyles : $7dbb02f7c217159b$var$oldFieldsetLabelStyles
        ]
    }, children);
};
var $7dbb02f7c217159b$export$2e2bcd8739ae039 = $7dbb02f7c217159b$export$b04be29aa201d4f5;

});


parcelRegister("5wCDk", function(module, exports) {

$parcel$export(module.exports, "SelectWithoutAnalytics", () => $eb73e877c5661200$export$d1de3b251ccaa8a3);
$parcel$export(module.exports, "default", () => $eb73e877c5661200$export$2e2bcd8739ae039);

var $hOLnS = parcelRequire("hOLnS");

var $hM7RE = parcelRequire("hM7RE");
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $5FjBr = parcelRequire("5FjBr");
const $eb73e877c5661200$var$packageName = "platform-pkg";
const $eb73e877c5661200$var$packageVersion = "0.0.0-use.local";
const $eb73e877c5661200$export$d1de3b251ccaa8a3 = (0, $5FjBr.default)((0, $hOLnS.default));
const $eb73e877c5661200$var$createAndFireEventOnAtlaskit = (0, $hM7RE.default)('atlaskit');
const $eb73e877c5661200$var$Select = (0, $1ngde.default)({
    componentName: 'select',
    packageName: $eb73e877c5661200$var$packageName,
    packageVersion: $eb73e877c5661200$var$packageVersion
})((0, $2jDha.default)({
    onChange: $eb73e877c5661200$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $eb73e877c5661200$var$packageName,
            packageVersion: $eb73e877c5661200$var$packageVersion
        }
    })
})($eb73e877c5661200$export$d1de3b251ccaa8a3));
var $eb73e877c5661200$export$2e2bcd8739ae039 = $eb73e877c5661200$var$Select;

});
parcelRegister("hOLnS", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf8bdca71ec4c4b4$export$2e2bcd8739ae039);

var $7IqRg = parcelRequire("7IqRg");

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $4WmDP = parcelRequire("4WmDP");

var $i4xqP = parcelRequire("i4xqP");

var $jQxSL = parcelRequire("jQxSL");
parcelRequire("1Xn5q");
parcelRequire("aKcqM");
parcelRequire("bwPfh");
parcelRequire("lDSrn");
parcelRequire("lIEGP");
parcelRequire("eT4IF");
parcelRequire("7Dzgl");
parcelRequire("fVK4C");

parcelRequire("5sKOb");
parcelRequire("jqNEH");
parcelRequire("5zQU9");
parcelRequire("lEfVV");

parcelRequire("k286k");
var $cf8bdca71ec4c4b4$var$StateManagedSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $7IqRg.u)(props);
    return /*#__PURE__*/ $eUqFw.createElement((0, $cEc3i.S), (0, $kU09D.default)({
        ref: ref
    }, baseSelectProps));
});
var $cf8bdca71ec4c4b4$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $eUqFw.useMemo)(function() {
        return (0, $i4xqP.default)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $eUqFw.createElement((0, $4WmDP.C), {
        value: emotionCache
    }, children);
};
var $cf8bdca71ec4c4b4$export$2e2bcd8739ae039 = $cf8bdca71ec4c4b4$var$StateManagedSelect;

});
parcelRegister("7IqRg", function(module, exports) {

$parcel$export(module.exports, "u", () => $59e179ee89746bd6$export$3b14a55fb2447963);

var $1Xn5q = parcelRequire("1Xn5q");

var $aKcqM = parcelRequire("aKcqM");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");
var $59e179ee89746bd6$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $59e179ee89746bd6$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $bwPfh.default)(_ref, $59e179ee89746bd6$var$_excluded);
    var _useState = (0, $eUqFw.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $aKcqM.default)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $eUqFw.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $aKcqM.default)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $eUqFw.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $aKcqM.default)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $eUqFw.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $eUqFw.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $eUqFw.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $eUqFw.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}

});
parcelRegister("1Xn5q", function(module, exports) {

$parcel$export(module.exports, "default", () => $16cd35a30248fb20$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");
function $16cd35a30248fb20$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $16cd35a30248fb20$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $16cd35a30248fb20$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $16cd35a30248fb20$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});

parcelRegister("aKcqM", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d27d7cb7c770f64$export$2e2bcd8739ae039);

var $kcDiK = parcelRequire("kcDiK");

var $61Jn4 = parcelRequire("61Jn4");

var $e5SQy = parcelRequire("e5SQy");

var $gP5fl = parcelRequire("gP5fl");
function $7d27d7cb7c770f64$export$2e2bcd8739ae039(arr, i) {
    return (0, $kcDiK.default)(arr) || (0, $61Jn4.default)(arr, i) || (0, $e5SQy.default)(arr, i) || (0, $gP5fl.default)();
}

});
parcelRegister("kcDiK", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb536a1805ce1726$export$2e2bcd8739ae039);
function $eb536a1805ce1726$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("61Jn4", function(module, exports) {

$parcel$export(module.exports, "default", () => $463607d84fb47652$export$2e2bcd8739ae039);
function $463607d84fb47652$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("e5SQy", function(module, exports) {

$parcel$export(module.exports, "default", () => $a42c13bbb83e195c$export$2e2bcd8739ae039);

var $aLrjs = parcelRequire("aLrjs");
function $a42c13bbb83e195c$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $aLrjs.default)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $aLrjs.default)(o, minLen);
}

});
parcelRegister("aLrjs", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d637af256120630$export$2e2bcd8739ae039);
function $7d637af256120630$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("gP5fl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3f57a97be8f63bf$export$2e2bcd8739ae039);
function $c3f57a97be8f63bf$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("bwPfh", function(module, exports) {

$parcel$export(module.exports, "default", () => $864a6f28f9285041$export$2e2bcd8739ae039);

var $6XgOP = parcelRequire("6XgOP");
function $864a6f28f9285041$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = (0, $6XgOP.default)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});


parcelRegister("cEc3i", function(module, exports) {

$parcel$export(module.exports, "c", () => $935291c440101c41$export$db3b6bfb95261072);
$parcel$export(module.exports, "b", () => $935291c440101c41$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "g", () => $935291c440101c41$export$39b482c5e57630a8);
$parcel$export(module.exports, "m", () => $935291c440101c41$export$953cecd6e717a553);
$parcel$export(module.exports, "S", () => $935291c440101c41$export$25ce5a424b770e84);

var $kU09D = parcelRequire("kU09D");

var $1Xn5q = parcelRequire("1Xn5q");

var $lDSrn = parcelRequire("lDSrn");

var $lIEGP = parcelRequire("lIEGP");

var $eT4IF = parcelRequire("eT4IF");

var $7Dzgl = parcelRequire("7Dzgl");

var $fVK4C = parcelRequire("fVK4C");

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $byn9U = parcelRequire("byn9U");

var $5iWql = parcelRequire("5iWql");

var $bwPfh = parcelRequire("bwPfh");
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $935291c440101c41$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $935291c440101c41$var$A11yText = function A11yText(props) {
    return (0, $byn9U.jsx)("span", (0, $kU09D.default)({
        css: $935291c440101c41$var$_ref
    }, props));
};
var $935291c440101c41$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, isDisabled = props.isDisabled, tabSelectsValue = props.tabSelectsValue, context = props.context;
        switch(context){
            case 'menu':
                return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu").concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
            case 'input':
                return "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return "option ".concat(label, ", deselected.");
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
            case 'select-option':
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return '';
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? '' : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
        };
        if (context === 'value' && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === 'menu') {
            var disabled = isDisabled ? ' disabled' : '';
            var status = "".concat(isSelected ? 'selected' : 'focused').concat(disabled);
            return "option ".concat(label, " ").concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return '';
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
    }
};
var $935291c440101c41$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue;
    var ariaLabel = selectProps['aria-label'];
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, $eUqFw.useMemo)(function() {
        return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $935291c440101c41$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $eUqFw.useMemo)(function() {
        var message = '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $1Xn5q.default)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $eUqFw.useMemo)(function() {
        var focusMsg = '';
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue
    ]);
    var ariaResults = (0, $eUqFw.useMemo)(function() {
        var resultsMsg = '';
        if (menuIsOpen && options.length && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus
    ]);
    var ariaGuidance = (0, $eUqFw.useMemo)(function() {
        var guidanceMsg = '';
        if (messages.guidance) {
            var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue
    ]);
    var ariaContext = "".concat(ariaFocused, " ").concat(ariaResults, " ").concat(ariaGuidance);
    var ScreenReaderText = (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $byn9U.jsx)("span", {
        id: "aria-context"
    }, ariaContext));
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)($935291c440101c41$var$A11yText, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $byn9U.jsx)($935291c440101c41$var$A11yText, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $935291c440101c41$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $935291c440101c41$var$anyDiacritic = new RegExp('[' + $935291c440101c41$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $935291c440101c41$var$diacriticToBase = {};
for(var $935291c440101c41$var$i = 0; $935291c440101c41$var$i < $935291c440101c41$var$diacritics.length; $935291c440101c41$var$i++){
    var $935291c440101c41$var$diacritic = $935291c440101c41$var$diacritics[$935291c440101c41$var$i];
    for(var $935291c440101c41$var$j = 0; $935291c440101c41$var$j < $935291c440101c41$var$diacritic.letters.length; $935291c440101c41$var$j++)$935291c440101c41$var$diacriticToBase[$935291c440101c41$var$diacritic.letters[$935291c440101c41$var$j]] = $935291c440101c41$var$diacritic.base;
}
var $935291c440101c41$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($935291c440101c41$var$anyDiacritic, function(match) {
        return $935291c440101c41$var$diacriticToBase[match];
    });
};
var $935291c440101c41$var$memoizedStripDiacriticsForInput = (0, $5iWql.default)($935291c440101c41$var$stripDiacritics);
var $935291c440101c41$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $935291c440101c41$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $935291c440101c41$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $1Xn5q.default)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $935291c440101c41$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $935291c440101c41$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $935291c440101c41$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $935291c440101c41$var$memoizedStripDiacriticsForInput(input);
            candidate = $935291c440101c41$var$stripDiacritics(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $935291c440101c41$var$_excluded = [
    "innerRef"
];
function $935291c440101c41$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $bwPfh.default)(_ref, $935291c440101c41$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $jQxSL.r)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return (0, $byn9U.jsx)("input", (0, $kU09D.default)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $byn9U.css)({
            label: 'dummyInput',
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: 'transparent',
            fontSize: 'inherit',
            gridArea: '1 / 1 / 2 / 3',
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: 'transparent',
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: 'relative',
            transform: 'scale(.01)'
        }, "", "")
    }));
}
var $935291c440101c41$var$cancelScroll = function cancelScroll(event) {
    event.preventDefault();
    event.stopPropagation();
};
function $935291c440101c41$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $eUqFw.useRef)(false);
    var isTop = (0, $eUqFw.useRef)(false);
    var touchStart = (0, $eUqFw.useRef)(0);
    var scrollTarget = (0, $eUqFw.useRef)(null);
    var handleEventDelta = (0, $eUqFw.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $935291c440101c41$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $eUqFw.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $eUqFw.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $eUqFw.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $eUqFw.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $jQxSL.s) ? {
            passive: false
        } : false;
        el.addEventListener('wheel', onWheel, notPassive);
        el.addEventListener('touchstart', onTouchStart, notPassive);
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $eUqFw.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener('wheel', onWheel, false);
        el.removeEventListener('touchstart', onTouchStart, false);
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $eUqFw.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $935291c440101c41$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $935291c440101c41$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $935291c440101c41$var$preventTouchMove(e) {
    e.preventDefault();
}
function $935291c440101c41$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $935291c440101c41$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $935291c440101c41$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $935291c440101c41$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $935291c440101c41$var$activeScrollLocks = 0;
var $935291c440101c41$var$listenerOptions = {
    capture: false,
    passive: false
};
function $935291c440101c41$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $eUqFw.useRef)({});
    var scrollTarget = (0, $eUqFw.useRef)(null);
    var addScrollLock = (0, $eUqFw.useCallback)(function(touchScrollTarget) {
        if (!$935291c440101c41$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $935291c440101c41$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $935291c440101c41$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($935291c440101c41$var$LOCK_STYLES).forEach(function(key) {
                var val = $935291c440101c41$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $935291c440101c41$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener('touchmove', $935291c440101c41$var$preventTouchMove, $935291c440101c41$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener('touchstart', $935291c440101c41$var$preventInertiaScroll, $935291c440101c41$var$listenerOptions);
                touchScrollTarget.addEventListener('touchmove', $935291c440101c41$var$allowTouchMove, $935291c440101c41$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $935291c440101c41$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $eUqFw.useCallback)(function(touchScrollTarget) {
        if (!$935291c440101c41$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $935291c440101c41$var$activeScrollLocks = Math.max($935291c440101c41$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $935291c440101c41$var$activeScrollLocks < 1) $935291c440101c41$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $935291c440101c41$var$isTouchDevice()) {
            target.removeEventListener('touchmove', $935291c440101c41$var$preventTouchMove, $935291c440101c41$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener('touchstart', $935291c440101c41$var$preventInertiaScroll, $935291c440101c41$var$listenerOptions);
                touchScrollTarget.removeEventListener('touchmove', $935291c440101c41$var$allowTouchMove, $935291c440101c41$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $eUqFw.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $935291c440101c41$var$blurSelectInput = function blurSelectInput() {
    return document.activeElement && document.activeElement.blur();
};
var $935291c440101c41$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $935291c440101c41$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $935291c440101c41$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $935291c440101c41$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, lockEnabled && (0, $byn9U.jsx)("div", {
        onClick: $935291c440101c41$var$blurSelectInput,
        css: $935291c440101c41$var$_ref2$1
    }), children(targetRef));
}
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $935291c440101c41$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $935291c440101c41$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $byn9U.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $935291c440101c41$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $935291c440101c41$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $935291c440101c41$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $935291c440101c41$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $935291c440101c41$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $935291c440101c41$var$defaultStyles = {
    clearIndicator: (0, $jQxSL.a),
    container: (0, $jQxSL.b),
    control: (0, $jQxSL.d),
    dropdownIndicator: (0, $jQxSL.e),
    group: (0, $jQxSL.g),
    groupHeading: (0, $jQxSL.f),
    indicatorsContainer: (0, $jQxSL.i),
    indicatorSeparator: (0, $jQxSL.h),
    input: (0, $jQxSL.j),
    loadingIndicator: (0, $jQxSL.l),
    loadingMessage: (0, $jQxSL.k),
    menu: (0, $jQxSL.m),
    menuList: (0, $jQxSL.n),
    menuPortal: (0, $jQxSL.o),
    multiValue: (0, $jQxSL.p),
    multiValueLabel: (0, $jQxSL.q),
    multiValueRemove: (0, $jQxSL.t),
    noOptionsMessage: (0, $jQxSL.u),
    option: (0, $jQxSL.v),
    placeholder: (0, $jQxSL.w),
    singleValue: (0, $jQxSL.x),
    valueContainer: (0, $jQxSL.y)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $935291c440101c41$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $1Xn5q.default)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $935291c440101c41$var$colors = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
var $935291c440101c41$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $935291c440101c41$var$baseUnit = 4;
// The minimum height of the control
var $935291c440101c41$var$controlHeight = 38;
// The amount of space between the control and menu */
var $935291c440101c41$var$menuGutter = $935291c440101c41$var$baseUnit * 2;
var $935291c440101c41$var$spacing = {
    baseUnit: $935291c440101c41$var$baseUnit,
    controlHeight: $935291c440101c41$var$controlHeight,
    menuGutter: $935291c440101c41$var$menuGutter
};
var $935291c440101c41$export$4368d992c4eafac0 = {
    borderRadius: $935291c440101c41$var$borderRadius,
    colors: $935291c440101c41$var$colors,
    spacing: $935291c440101c41$var$spacing
};
var $935291c440101c41$export$407448d2b89b1813 = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $jQxSL.z)(),
    captureMenuScroll: !(0, $jQxSL.z)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $935291c440101c41$export$db3b6bfb95261072(),
    formatGroupLabel: $935291c440101c41$var$formatGroupLabel,
    getOptionLabel: $935291c440101c41$export$8b22cf2602fb60ce,
    getOptionValue: $935291c440101c41$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $935291c440101c41$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $jQxSL.A)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $935291c440101c41$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $935291c440101c41$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $935291c440101c41$var$_isOptionSelected(props, option, selectValue);
    var label = $935291c440101c41$var$getOptionLabel(props, option);
    var value = $935291c440101c41$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $935291c440101c41$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $935291c440101c41$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $935291c440101c41$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $935291c440101c41$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $935291c440101c41$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $jQxSL.G));
}
function $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $fVK4C.default)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $935291c440101c41$var$buildFocusableOptions(props, selectValue) {
    return $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions($935291c440101c41$var$buildCategorizedOptions(props, selectValue));
}
function $935291c440101c41$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$935291c440101c41$var$shouldHideSelectedOptions(props) || !isSelected) && $935291c440101c41$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $935291c440101c41$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $935291c440101c41$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $935291c440101c41$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $935291c440101c41$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $935291c440101c41$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $935291c440101c41$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $935291c440101c41$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $935291c440101c41$var$getOptionValue(props, i) === candidate;
    });
}
function $935291c440101c41$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $935291c440101c41$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $935291c440101c41$var$instanceId = 1;
var $935291c440101c41$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $eT4IF.default)(Select, _Component);
    var _super = (0, $7Dzgl.default)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $lDSrn.default)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.instancePrefix = '';
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $jQxSL.B)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $jQxSL.B)([].concat((0, $fVK4C.default)(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, $jQxSL.C)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, $jQxSL.C)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $jQxSL.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $jQxSL.D)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $jQxSL.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $jQxSL.E).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $935291c440101c41$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $935291c440101c41$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $935291c440101c41$var$defaultStyles[key](props, unstyled);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $jQxSL.F)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $935291c440101c41$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $1Xn5q.default)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
            event.stopPropagation();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            event.stopPropagation();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $jQxSL.H)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            _this.setState({
                focusedOption: focusedOption
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $935291c440101c41$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$935291c440101c41$var$instanceId);
        _this.state.selectValue = (0, $jQxSL.I)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusedOption = focusableOptions[optionIndex];
        }
        return _this;
    }
    (0, $lIEGP.default)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $jQxSL.J)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $jQxSL.J)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex]
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $935291c440101c41$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === 'function') return this.props.theme($935291c440101c41$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $935291c440101c41$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $935291c440101c41$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $935291c440101c41$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $935291c440101c41$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('touchstart', this.onTouchStart);
                    document.removeEventListener('touchmove', this.onTouchMove);
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $1Xn5q.default)((0, $1Xn5q.default)((0, $1Xn5q.default)({
                    'aria-autocomplete': 'list',
                    'aria-expanded': menuIsOpen,
                    'aria-haspopup': true,
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-invalid': this.props['aria-invalid'],
                    'aria-label': this.props['aria-label'],
                    'aria-labelledby': this.props['aria-labelledby'],
                    'aria-required': required,
                    role: 'combobox'
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox'),
                    'aria-owns': this.getElementId('listbox')
                }), !isSearchable && {
                    'aria-readonly': true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
                    'aria-describedby': this.getElementId('live-region')
                } : {
                    'aria-describedby': this.getElementId('placeholder')
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$DummyInput, (0, $kU09D.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $jQxSL.K),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $eUqFw.createElement(Input, (0, $kU09D.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $eUqFw.createElement(Placeholder, (0, $kU09D.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId('placeholder')
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $eUqFw.createElement(MultiValue, (0, $kU09D.default)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                                e.stopPropagation();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $eUqFw.createElement(SingleValue, (0, $kU09D.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(ClearIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(LoadingIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $eUqFw.createElement(IndicatorSeparator, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(DropdownIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1
                    };
                    return /*#__PURE__*/ $eUqFw.createElement(Option, (0, $kU09D.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === 'group') {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $eUqFw.createElement(Group, (0, $kU09D.default)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === 'option') return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $eUqFw.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $eUqFw.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $eUqFw.createElement((0, $jQxSL.M), (0, $kU09D.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $eUqFw.createElement(Menu, (0, $kU09D.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove,
                            id: _this4.getElementId('listbox')
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $eUqFw.createElement(MenuList, (0, $kU09D.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ $eUqFw.createElement(MenuPortal, (0, $kU09D.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$RequiredInput, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $eUqFw.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $eUqFw.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $eUqFw.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $eUqFw.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ $eUqFw.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$LiveRegion, (0, $kU09D.default)({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $eUqFw.createElement(SelectContainer, (0, $kU09D.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $eUqFw.createElement(Control, (0, $kU09D.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $eUqFw.createElement(ValueContainer, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $eUqFw.createElement(IndicatorsContainer, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $jQxSL.I)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $935291c440101c41$var$buildFocusableOptions(props, selectValue) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $935291c440101c41$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $935291c440101c41$var$getNextFocusedOption(state, focusableOptions);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $jQxSL.D)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return (0, $1Xn5q.default)((0, $1Xn5q.default)((0, $1Xn5q.default)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $eUqFw.Component));
$935291c440101c41$export$25ce5a424b770e84.defaultProps = $935291c440101c41$export$407448d2b89b1813;

});
parcelRegister("lDSrn", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc177843783b087f$export$2e2bcd8739ae039);
function $fc177843783b087f$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("lIEGP", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcfd452a83bb612a$export$2e2bcd8739ae039);

var $aM0Ke = parcelRequire("aM0Ke");
function $fcfd452a83bb612a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $aM0Ke.default)(descriptor.key), descriptor);
    }
}
function $fcfd452a83bb612a$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $fcfd452a83bb612a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $fcfd452a83bb612a$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}

});

parcelRegister("eT4IF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad69dceb97fc37d0$export$2e2bcd8739ae039);

var $c2pQl = parcelRequire("c2pQl");
function $ad69dceb97fc37d0$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $c2pQl.default)(subClass, superClass);
}

});

parcelRegister("7Dzgl", function(module, exports) {

$parcel$export(module.exports, "default", () => $58f7875a71af82f1$export$2e2bcd8739ae039);

var $i3rTN = parcelRequire("i3rTN");

var $8c5pC = parcelRequire("8c5pC");

var $4mIeV = parcelRequire("4mIeV");
function $58f7875a71af82f1$export$2e2bcd8739ae039(Derived) {
    var hasNativeReflectConstruct = (0, $8c5pC.default)();
    return function _createSuperInternal() {
        var Super = (0, $i3rTN.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $i3rTN.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $4mIeV.default)(this, result);
    };
}

});
parcelRegister("i3rTN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d24e25f7bdedc6a7$export$2e2bcd8739ae039);
function $d24e25f7bdedc6a7$export$2e2bcd8739ae039(o) {
    $d24e25f7bdedc6a7$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $d24e25f7bdedc6a7$export$2e2bcd8739ae039(o);
}

});

parcelRegister("8c5pC", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f73a47aa7a9581c$export$2e2bcd8739ae039);
function $5f73a47aa7a9581c$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($5f73a47aa7a9581c$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("4mIeV", function(module, exports) {

$parcel$export(module.exports, "default", () => $32db889076b63d40$export$2e2bcd8739ae039);

var $5sKOb = parcelRequire("5sKOb");

var $aCdHv = parcelRequire("aCdHv");
function $32db889076b63d40$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $5sKOb.default)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $aCdHv.default)(self);
}

});


parcelRegister("fVK4C", function(module, exports) {

$parcel$export(module.exports, "default", () => $b98feb1d5dd86921$export$2e2bcd8739ae039);

var $b7OIr = parcelRequire("b7OIr");

var $2B3l3 = parcelRequire("2B3l3");

var $e5SQy = parcelRequire("e5SQy");

var $csAMF = parcelRequire("csAMF");
function $b98feb1d5dd86921$export$2e2bcd8739ae039(arr) {
    return (0, $b7OIr.default)(arr) || (0, $2B3l3.default)(arr) || (0, $e5SQy.default)(arr) || (0, $csAMF.default)();
}

});
parcelRegister("b7OIr", function(module, exports) {

$parcel$export(module.exports, "default", () => $8197b040df4187a0$export$2e2bcd8739ae039);

var $aLrjs = parcelRequire("aLrjs");
function $8197b040df4187a0$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $aLrjs.default)(arr);
}

});

parcelRegister("2B3l3", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e41a0710a3b4a62$export$2e2bcd8739ae039);
function $1e41a0710a3b4a62$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("csAMF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9124a21752235a23$export$2e2bcd8739ae039);
function $9124a21752235a23$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("jQxSL", function(module, exports) {

$parcel$export(module.exports, "K", () => $e72d27f6b1599862$export$3466f893ebf79586);
$parcel$export(module.exports, "E", () => $e72d27f6b1599862$export$a9c23c6ac3fc3eca);
$parcel$export(module.exports, "I", () => $e72d27f6b1599862$export$9bb611d729802a56);
$parcel$export(module.exports, "L", () => $e72d27f6b1599862$export$61196ced6d74a310);
$parcel$export(module.exports, "H", () => $e72d27f6b1599862$export$7f8ddf7c7c20b3cd);
$parcel$export(module.exports, "J", () => $e72d27f6b1599862$export$b4171a6734a65d42);
$parcel$export(module.exports, "z", () => $e72d27f6b1599862$export$df995fae86a55f06);
$parcel$export(module.exports, "A", () => $e72d27f6b1599862$export$ebd11618f299a286);
$parcel$export(module.exports, "s", () => $e72d27f6b1599862$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "G", () => $e72d27f6b1599862$export$2329c99376c9d0a4);
$parcel$export(module.exports, "D", () => $e72d27f6b1599862$export$96f57966bedc81b4);
$parcel$export(module.exports, "C", () => $e72d27f6b1599862$export$e7094788287c5e9b);
$parcel$export(module.exports, "B", () => $e72d27f6b1599862$export$ef35774e6d314e91);
$parcel$export(module.exports, "r", () => $e72d27f6b1599862$export$43caf9889c228507);
$parcel$export(module.exports, "m", () => $e72d27f6b1599862$export$953cecd6e717a553);
$parcel$export(module.exports, "M", () => $e72d27f6b1599862$export$3a1a48c8f6ef640e);
$parcel$export(module.exports, "n", () => $e72d27f6b1599862$export$7ccc53e8f1e7dfc5);
$parcel$export(module.exports, "u", () => $e72d27f6b1599862$export$3b14a55fb2447963);
$parcel$export(module.exports, "k", () => $e72d27f6b1599862$export$342063e11d6c3cad);
$parcel$export(module.exports, "o", () => $e72d27f6b1599862$export$ae1af26003f05816);
$parcel$export(module.exports, "b", () => $e72d27f6b1599862$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "y", () => $e72d27f6b1599862$export$4a5767248b18ef41);
$parcel$export(module.exports, "i", () => $e72d27f6b1599862$export$23f2a1d2818174ef);
$parcel$export(module.exports, "e", () => $e72d27f6b1599862$export$f1e1789686576879);
$parcel$export(module.exports, "a", () => $e72d27f6b1599862$export$407448d2b89b1813);
$parcel$export(module.exports, "h", () => $e72d27f6b1599862$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "l", () => $e72d27f6b1599862$export$882b5998b3b9117c);
$parcel$export(module.exports, "d", () => $e72d27f6b1599862$export$4368d992c4eafac0);
$parcel$export(module.exports, "g", () => $e72d27f6b1599862$export$39b482c5e57630a8);
$parcel$export(module.exports, "f", () => $e72d27f6b1599862$export$2d1720544b23b823);
$parcel$export(module.exports, "j", () => $e72d27f6b1599862$export$35e795649ee09318);
$parcel$export(module.exports, "p", () => $e72d27f6b1599862$export$ffb5f4729a158638);
$parcel$export(module.exports, "q", () => $e72d27f6b1599862$export$9e5f44173e64f162);
$parcel$export(module.exports, "t", () => $e72d27f6b1599862$export$625550452a3fa3ec);
$parcel$export(module.exports, "v", () => $e72d27f6b1599862$export$90a7f3efeed30595);
$parcel$export(module.exports, "w", () => $e72d27f6b1599862$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "x", () => $e72d27f6b1599862$export$d141bba7fdc215a3);
$parcel$export(module.exports, "c", () => $e72d27f6b1599862$export$db3b6bfb95261072);
$parcel$export(module.exports, "F", () => $e72d27f6b1599862$export$d66501df72047452);

var $1Xn5q = parcelRequire("1Xn5q");

var $kU09D = parcelRequire("kU09D");

var $byn9U = parcelRequire("byn9U");

var $aKcqM = parcelRequire("aKcqM");

var $bwPfh = parcelRequire("bwPfh");

var $5sKOb = parcelRequire("5sKOb");

var $jqNEH = parcelRequire("jqNEH");

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $5O3G9 = parcelRequire("5O3G9");

var $k286k = parcelRequire("k286k");
var $e72d27f6b1599862$var$_excluded$3 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $e72d27f6b1599862$export$3466f893ebf79586 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $e72d27f6b1599862$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $e72d27f6b1599862$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($e72d27f6b1599862$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}
// ==============================
// Clean Value
// ==============================
var $e72d27f6b1599862$export$9bb611d729802a56 = function cleanValue(value) {
    if ($e72d27f6b1599862$var$isArray(value)) return value.filter(Boolean);
    if ((0, $5sKOb.default)(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $e72d27f6b1599862$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $bwPfh.default)(props, $e72d27f6b1599862$var$_excluded$3);
    return (0, $1Xn5q.default)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $e72d27f6b1599862$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $e72d27f6b1599862$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === 'string') return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $e72d27f6b1599862$var$normalizedHeight(el) {
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $e72d27f6b1599862$var$getScrollTop(el) {
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $e72d27f6b1599862$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $e72d27f6b1599862$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $e72d27f6b1599862$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $e72d27f6b1599862$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $e72d27f6b1599862$export$3466f893ebf79586;
    var start = $e72d27f6b1599862$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $e72d27f6b1599862$var$easeOutCubic(currentTime, start, change, duration);
        $e72d27f6b1599862$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $e72d27f6b1599862$export$b4171a6734a65d42(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $e72d27f6b1599862$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $e72d27f6b1599862$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $e72d27f6b1599862$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $e72d27f6b1599862$export$df995fae86a55f06() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $e72d27f6b1599862$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $e72d27f6b1599862$var$passiveOptionAccessed = false;
var $e72d27f6b1599862$var$options = {
    get passive () {
        return $e72d27f6b1599862$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $e72d27f6b1599862$var$w = typeof window !== 'undefined' ? window : {};
if ($e72d27f6b1599862$var$w.addEventListener && $e72d27f6b1599862$var$w.removeEventListener) {
    $e72d27f6b1599862$var$w.addEventListener('p', $e72d27f6b1599862$export$3466f893ebf79586, $e72d27f6b1599862$var$options);
    $e72d27f6b1599862$var$w.removeEventListener('p', $e72d27f6b1599862$export$3466f893ebf79586, false);
}
var $e72d27f6b1599862$export$2408f22a0fab9ae5 = $e72d27f6b1599862$var$passiveOptionAccessed;
function $e72d27f6b1599862$export$2329c99376c9d0a4(item) {
    return item != null;
}
function $e72d27f6b1599862$var$isArray(arg) {
    return Array.isArray(arg);
}
function $e72d27f6b1599862$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $e72d27f6b1599862$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $e72d27f6b1599862$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $e72d27f6b1599862$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $aKcqM.default)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $aKcqM.default)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
function $e72d27f6b1599862$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $e72d27f6b1599862$var$getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $e72d27f6b1599862$var$normalizedHeight(scrollParent);
    var scrollTop = $e72d27f6b1599862$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $e72d27f6b1599862$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $e72d27f6b1599862$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
var $e72d27f6b1599862$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $e72d27f6b1599862$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $1Xn5q.default)((_objectSpread2 = {
        label: 'menu'
    }, (0, $5zQU9.default)(_objectSpread2, $e72d27f6b1599862$var$alignToControl(placement), '100%'), (0, $5zQU9.default)(_objectSpread2, "position", 'absolute'), (0, $5zQU9.default)(_objectSpread2, "width", '100%'), (0, $5zQU9.default)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $e72d27f6b1599862$var$PortalPlacementContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
// NOTE: internal only
var $e72d27f6b1599862$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $eUqFw.useContext)($e72d27f6b1599862$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $eUqFw.useRef)(null);
    var _useState = (0, $eUqFw.useState)(maxMenuHeight), _useState2 = (0, $aKcqM.default)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $eUqFw.useState)(null), _useState4 = (0, $aKcqM.default)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $k286k.default)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $e72d27f6b1599862$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, props), {}, {
            placement: placement || $e72d27f6b1599862$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $e72d27f6b1599862$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'menu', {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu List
// ==============================
var $e72d27f6b1599862$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $1Xn5q.default)({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch'
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $e72d27f6b1599862$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $e72d27f6b1599862$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $1Xn5q.default)({
        textAlign: 'center'
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $e72d27f6b1599862$export$3b14a55fb2447963 = $e72d27f6b1599862$var$noticeCSS;
var $e72d27f6b1599862$export$342063e11d6c3cad = $e72d27f6b1599862$var$noticeCSS;
var $e72d27f6b1599862$var$NoOptionsMessage = function NoOptionsMessage(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), innerProps), children);
};
$e72d27f6b1599862$var$NoOptionsMessage.defaultProps = {
    children: 'No options'
};
var $e72d27f6b1599862$var$LoadingMessage = function LoadingMessage(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), innerProps), children);
};
$e72d27f6b1599862$var$LoadingMessage.defaultProps = {
    children: 'Loading...'
};
// ==============================
// Menu Portal
// ==============================
var $e72d27f6b1599862$export$ae1af26003f05816 = function menuPortalCSS(_ref6) {
    var rect = _ref6.rect, offset = _ref6.offset, position = _ref6.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $e72d27f6b1599862$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $eUqFw.useRef)(null);
    var cleanupRef = (0, $eUqFw.useRef)(null);
    var _useState5 = (0, $eUqFw.useState)($e72d27f6b1599862$var$coercePlacement(menuPlacement)), _useState6 = (0, $aKcqM.default)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $eUqFw.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $eUqFw.useState)(null), _useState8 = (0, $aKcqM.default)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $eUqFw.useCallback)(function() {
        if (!controlElement) return;
        var rect = $e72d27f6b1599862$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $k286k.default)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $eUqFw.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $5O3G9.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $k286k.default)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $eUqFw.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        ref: setMenuPortalElement
    }, $e72d27f6b1599862$var$getStyleProps((0, $1Xn5q.default)((0, $1Xn5q.default)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), innerProps), children);
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $lEfVV.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $e72d27f6b1599862$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        pointerEvents: isDisabled ? 'none' : undefined,
        // cancel mouse events when disabled
        position: 'relative'
    };
};
var $e72d27f6b1599862$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $e72d27f6b1599862$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $1Xn5q.default)({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden'
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $e72d27f6b1599862$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $e72d27f6b1599862$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    };
};
var $e72d27f6b1599862$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'indicatorsContainer', {
        indicators: true
    }), innerProps), children);
};
var $e72d27f6b1599862$var$_templateObject;
var $e72d27f6b1599862$var$_excluded$2 = [
    "size"
];
function $e72d27f6b1599862$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $e72d27f6b1599862$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $e72d27f6b1599862$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $bwPfh.default)(_ref, $e72d27f6b1599862$var$_excluded$2);
    return (0, $byn9U.jsx)("svg", (0, $kU09D.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $e72d27f6b1599862$var$_ref2
    }, props));
};
var $e72d27f6b1599862$var$CrossIcon = function CrossIcon(props) {
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$Svg, (0, $kU09D.default)({
        size: 20
    }, props), (0, $byn9U.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $e72d27f6b1599862$var$DownChevron = function DownChevron(props) {
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$Svg, (0, $kU09D.default)({
        size: 20
    }, props), (0, $byn9U.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $e72d27f6b1599862$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ':hover': {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $e72d27f6b1599862$export$f1e1789686576879 = $e72d27f6b1599862$var$baseCSS;
var $e72d27f6b1599862$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$DownChevron, null));
};
var $e72d27f6b1599862$export$407448d2b89b1813 = $e72d27f6b1599862$var$baseCSS;
var $e72d27f6b1599862$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $e72d27f6b1599862$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $e72d27f6b1599862$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $byn9U.jsx)("span", (0, $kU09D.default)({}, innerProps, $e72d27f6b1599862$var$getStyleProps(props, 'indicatorSeparator', {
        'indicator-separator': true
    })));
};
// ==============================
// Loading
// ==============================
var $e72d27f6b1599862$var$loadingDotAnimations = (0, $byn9U.keyframes)($e72d27f6b1599862$var$_templateObject || ($e72d27f6b1599862$var$_templateObject = (0, $jqNEH.default)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $e72d27f6b1599862$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $1Xn5q.default)({
        label: 'loadingIndicator',
        display: 'flex',
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $e72d27f6b1599862$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $byn9U.jsx)("span", {
        css: /*#__PURE__*/ (0, $byn9U.css)({
            animation: "".concat($e72d27f6b1599862$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : undefined,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        }, "", "")
    });
};
var $e72d27f6b1599862$var$LoadingIndicator = function LoadingIndicator(props) {
    var innerProps = props.innerProps, isRtl = props.isRtl;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), innerProps), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
$e72d27f6b1599862$var$LoadingIndicator.defaultProps = {
    size: 4
};
var $e72d27f6b1599862$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $1Xn5q.default)({
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms'
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: 'solid',
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        '&:hover': {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $e72d27f6b1599862$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        ref: innerRef
    }, $e72d27f6b1599862$var$getStyleProps(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), innerProps), children);
};
var $e72d27f6b1599862$var$_excluded$1 = [
    "data"
];
var $e72d27f6b1599862$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $e72d27f6b1599862$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'group', {
        group: true
    }), innerProps), (0, $byn9U.jsx)(Heading, (0, $kU09D.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $byn9U.jsx)("div", null, children));
};
var $e72d27f6b1599862$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $1Xn5q.default)({
        label: 'group',
        cursor: 'default',
        display: 'block'
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: '75%',
        fontWeight: 500,
        marginBottom: '0.25em',
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: 'uppercase'
    });
};
var $e72d27f6b1599862$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $e72d27f6b1599862$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $bwPfh.default)(_cleanCommonProps, $e72d27f6b1599862$var$_excluded$1);
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'groupHeading', {
        'group-heading': true
    }), innerProps));
};
var $e72d27f6b1599862$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $e72d27f6b1599862$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : ''
    }, $e72d27f6b1599862$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $e72d27f6b1599862$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $e72d27f6b1599862$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': (0, $1Xn5q.default)({
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre'
    }, $e72d27f6b1599862$var$spacingStyle)
};
var $e72d27f6b1599862$var$inputStyle = function inputStyle(isHidden) {
    return (0, $1Xn5q.default)({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%'
    }, $e72d27f6b1599862$var$spacingStyle);
};
var $e72d27f6b1599862$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $e72d27f6b1599862$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $bwPfh.default)(_cleanCommonProps, $e72d27f6b1599862$var$_excluded);
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'input', {
        'input-container': true
    }), {
        "data-value": value || ''
    }), (0, $byn9U.jsx)("input", (0, $kU09D.default)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $e72d27f6b1599862$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $e72d27f6b1599862$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'multiValue',
        display: 'flex',
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $1Xn5q.default)({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: '85%',
        padding: 3,
        paddingLeft: 6
    });
};
var $e72d27f6b1599862$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $1Xn5q.default)({
        alignItems: 'center',
        display: 'flex'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ':hover': {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $e72d27f6b1599862$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $byn9U.jsx)("div", innerProps, children);
};
var $e72d27f6b1599862$var$MultiValueContainer = $e72d27f6b1599862$var$MultiValueGeneric;
var $e72d27f6b1599862$var$MultiValueLabel = $e72d27f6b1599862$var$MultiValueGeneric;
function $e72d27f6b1599862$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        role: "button"
    }, innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$CrossIcon, {
        size: 14
    }));
}
var $e72d27f6b1599862$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $byn9U.jsx)(Container, {
        data: data,
        innerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValue', {
            'multi-value': true,
            'multi-value--is-disabled': isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $byn9U.jsx)(Label, {
        data: data,
        innerProps: (0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValueLabel', {
            'multi-value__label': true
        })),
        selectProps: selectProps
    }, children), (0, $byn9U.jsx)(Remove, {
        data: data,
        innerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValueRemove', {
            'multi-value__remove': true
        })), {}, {
            'aria-label': "Remove ".concat(children || 'option')
        }, removeProps),
        selectProps: selectProps
    }));
};
var $e72d27f6b1599862$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'option',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)'
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $e72d27f6b1599862$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $e72d27f6b1599862$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3'
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'placeholder', {
        placeholder: true
    }), innerProps), children);
};
var $e72d27f6b1599862$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), innerProps), children);
};
var $e72d27f6b1599862$export$db3b6bfb95261072 = {
    ClearIndicator: $e72d27f6b1599862$var$ClearIndicator,
    Control: $e72d27f6b1599862$var$Control,
    DropdownIndicator: $e72d27f6b1599862$var$DropdownIndicator,
    DownChevron: $e72d27f6b1599862$var$DownChevron,
    CrossIcon: $e72d27f6b1599862$var$CrossIcon,
    Group: $e72d27f6b1599862$var$Group,
    GroupHeading: $e72d27f6b1599862$var$GroupHeading,
    IndicatorsContainer: $e72d27f6b1599862$var$IndicatorsContainer,
    IndicatorSeparator: $e72d27f6b1599862$var$IndicatorSeparator,
    Input: $e72d27f6b1599862$var$Input,
    LoadingIndicator: $e72d27f6b1599862$var$LoadingIndicator,
    Menu: $e72d27f6b1599862$var$Menu,
    MenuList: $e72d27f6b1599862$var$MenuList,
    MenuPortal: $e72d27f6b1599862$var$MenuPortal,
    LoadingMessage: $e72d27f6b1599862$var$LoadingMessage,
    NoOptionsMessage: $e72d27f6b1599862$var$NoOptionsMessage,
    MultiValue: $e72d27f6b1599862$var$MultiValue,
    MultiValueContainer: $e72d27f6b1599862$var$MultiValueContainer,
    MultiValueLabel: $e72d27f6b1599862$var$MultiValueLabel,
    MultiValueRemove: $e72d27f6b1599862$var$MultiValueRemove,
    Option: $e72d27f6b1599862$var$Option,
    Placeholder: $e72d27f6b1599862$var$Placeholder,
    SelectContainer: $e72d27f6b1599862$var$SelectContainer,
    SingleValue: $e72d27f6b1599862$var$SingleValue,
    ValueContainer: $e72d27f6b1599862$var$ValueContainer
};
var $e72d27f6b1599862$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$export$db3b6bfb95261072), props.components);
};

});
parcelRegister("jqNEH", function(module, exports) {

$parcel$export(module.exports, "default", () => $e256f68f3295e6bf$export$2e2bcd8739ae039);
function $e256f68f3295e6bf$export$2e2bcd8739ae039(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

});

parcelRegister("5O3G9", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", () => $023d07731ce8610f$export$deee3a793edee05f);

var $7MIdi = parcelRequire("7MIdi");
function $023d07731ce8610f$var$n(t) {
    var e;
    return (null == (e = t.ownerDocument) ? void 0 : e.defaultView) || window;
}
function $023d07731ce8610f$var$o(t) {
    return $023d07731ce8610f$var$n(t).getComputedStyle(t);
}
function $023d07731ce8610f$var$i(t) {
    return t instanceof $023d07731ce8610f$var$n(t).Node;
}
function $023d07731ce8610f$var$r(t) {
    return $023d07731ce8610f$var$i(t) ? (t.nodeName || "").toLowerCase() : "";
}
let $023d07731ce8610f$var$l;
function $023d07731ce8610f$var$c() {
    if ($023d07731ce8610f$var$l) return $023d07731ce8610f$var$l;
    const t = navigator.userAgentData;
    return t && Array.isArray(t.brands) ? ($023d07731ce8610f$var$l = t.brands.map((t)=>t.brand + "/" + t.version).join(" "), $023d07731ce8610f$var$l) : navigator.userAgent;
}
function $023d07731ce8610f$var$s(t) {
    return t instanceof $023d07731ce8610f$var$n(t).HTMLElement;
}
function $023d07731ce8610f$var$f(t) {
    return t instanceof $023d07731ce8610f$var$n(t).Element;
}
function $023d07731ce8610f$var$u(t) {
    if ("undefined" == typeof ShadowRoot) return !1;
    return t instanceof $023d07731ce8610f$var$n(t).ShadowRoot || t instanceof ShadowRoot;
}
function $023d07731ce8610f$var$a(t) {
    const { overflow: e, overflowX: n, overflowY: i, display: r } = $023d07731ce8610f$var$o(t);
    return /auto|scroll|overlay|hidden|clip/.test(e + i + n) && ![
        "inline",
        "contents"
    ].includes(r);
}
function $023d07731ce8610f$var$d(t) {
    return [
        "table",
        "td",
        "th"
    ].includes($023d07731ce8610f$var$r(t));
}
function $023d07731ce8610f$var$h(t) {
    const e = /firefox/i.test($023d07731ce8610f$var$c()), n = $023d07731ce8610f$var$o(t), i = n.backdropFilter || n.WebkitBackdropFilter;
    return "none" !== n.transform || "none" !== n.perspective || !!i && "none" !== i || e && "filter" === n.willChange || e && !!n.filter && "none" !== n.filter || [
        "transform",
        "perspective"
    ].some((t)=>n.willChange.includes(t)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((t)=>{
        const e = n.contain;
        return null != e && e.includes(t);
    });
}
function $023d07731ce8610f$var$p() {
    return /^((?!chrome|android).)*safari/i.test($023d07731ce8610f$var$c());
}
function $023d07731ce8610f$var$g(t) {
    return [
        "html",
        "body",
        "#document"
    ].includes($023d07731ce8610f$var$r(t));
}
const $023d07731ce8610f$var$m = Math.min, $023d07731ce8610f$var$y = Math.max, $023d07731ce8610f$var$x = Math.round;
function $023d07731ce8610f$var$w(t) {
    const e = $023d07731ce8610f$var$o(t);
    let n = parseFloat(e.width), i = parseFloat(e.height);
    const r = $023d07731ce8610f$var$s(t), l = r ? t.offsetWidth : n, c = r ? t.offsetHeight : i, f = $023d07731ce8610f$var$x(n) !== l || $023d07731ce8610f$var$x(i) !== c;
    return f && (n = l, i = c), {
        width: n,
        height: i,
        fallback: f
    };
}
function $023d07731ce8610f$var$v(t) {
    return $023d07731ce8610f$var$f(t) ? t : t.contextElement;
}
const $023d07731ce8610f$var$b = {
    x: 1,
    y: 1
};
function $023d07731ce8610f$var$L(t) {
    const e = $023d07731ce8610f$var$v(t);
    if (!$023d07731ce8610f$var$s(e)) return $023d07731ce8610f$var$b;
    const n = e.getBoundingClientRect(), { width: o, height: i, fallback: r } = $023d07731ce8610f$var$w(e);
    let l = (r ? $023d07731ce8610f$var$x(n.width) : n.width) / o, c = (r ? $023d07731ce8610f$var$x(n.height) : n.height) / i;
    return l && Number.isFinite(l) || (l = 1), c && Number.isFinite(c) || (c = 1), {
        x: l,
        y: c
    };
}
function $023d07731ce8610f$var$E(e, o, i, r) {
    var l, c;
    void 0 === o && (o = !1), void 0 === i && (i = !1);
    const s = e.getBoundingClientRect(), u = $023d07731ce8610f$var$v(e);
    let a = $023d07731ce8610f$var$b;
    o && (r ? $023d07731ce8610f$var$f(r) && (a = $023d07731ce8610f$var$L(r)) : a = $023d07731ce8610f$var$L(e));
    const d = u ? $023d07731ce8610f$var$n(u) : window, h = $023d07731ce8610f$var$p() && i;
    let g = (s.left + (h && (null == (l = d.visualViewport) ? void 0 : l.offsetLeft) || 0)) / a.x, m = (s.top + (h && (null == (c = d.visualViewport) ? void 0 : c.offsetTop) || 0)) / a.y, y = s.width / a.x, x = s.height / a.y;
    if (u) {
        const t = $023d07731ce8610f$var$n(u), e = r && $023d07731ce8610f$var$f(r) ? $023d07731ce8610f$var$n(r) : r;
        let o = t.frameElement;
        for(; o && r && e !== t;){
            const t = $023d07731ce8610f$var$L(o), e = o.getBoundingClientRect(), i = getComputedStyle(o);
            e.x += (o.clientLeft + parseFloat(i.paddingLeft)) * t.x, e.y += (o.clientTop + parseFloat(i.paddingTop)) * t.y, g *= t.x, m *= t.y, y *= t.x, x *= t.y, g += e.x, m += e.y, o = $023d07731ce8610f$var$n(o).frameElement;
        }
    }
    return (0, $7MIdi.rectToClientRect)({
        width: y,
        height: x,
        x: g,
        y: m
    });
}
function $023d07731ce8610f$var$T(t) {
    return (($023d07731ce8610f$var$i(t) ? t.ownerDocument : t.document) || window.document).documentElement;
}
function $023d07731ce8610f$var$R(t) {
    return $023d07731ce8610f$var$f(t) ? {
        scrollLeft: t.scrollLeft,
        scrollTop: t.scrollTop
    } : {
        scrollLeft: t.pageXOffset,
        scrollTop: t.pageYOffset
    };
}
function $023d07731ce8610f$var$C(t) {
    return $023d07731ce8610f$var$E($023d07731ce8610f$var$T(t)).left + $023d07731ce8610f$var$R(t).scrollLeft;
}
function $023d07731ce8610f$var$F(t) {
    if ("html" === $023d07731ce8610f$var$r(t)) return t;
    const e = t.assignedSlot || t.parentNode || $023d07731ce8610f$var$u(t) && t.host || $023d07731ce8610f$var$T(t);
    return $023d07731ce8610f$var$u(e) ? e.host : e;
}
function $023d07731ce8610f$var$W(t) {
    const e = $023d07731ce8610f$var$F(t);
    return $023d07731ce8610f$var$g(e) ? e.ownerDocument.body : $023d07731ce8610f$var$s(e) && $023d07731ce8610f$var$a(e) ? e : $023d07731ce8610f$var$W(e);
}
function $023d07731ce8610f$export$3b57c1601291186b(t, e) {
    var o;
    void 0 === e && (e = []);
    const i = $023d07731ce8610f$var$W(t), r = i === (null == (o = t.ownerDocument) ? void 0 : o.body), l = $023d07731ce8610f$var$n(i);
    return r ? e.concat(l, l.visualViewport || [], $023d07731ce8610f$var$a(i) ? i : []) : e.concat(i, $023d07731ce8610f$export$3b57c1601291186b(i));
}
function $023d07731ce8610f$var$S(e, i, r) {
    let l;
    if ("viewport" === i) l = function(t, e) {
        const o = $023d07731ce8610f$var$n(t), i = $023d07731ce8610f$var$T(t), r = o.visualViewport;
        let l = i.clientWidth, c = i.clientHeight, s = 0, f = 0;
        if (r) {
            l = r.width, c = r.height;
            const t = $023d07731ce8610f$var$p();
            (!t || t && "fixed" === e) && (s = r.offsetLeft, f = r.offsetTop);
        }
        return {
            width: l,
            height: c,
            x: s,
            y: f
        };
    }(e, r);
    else if ("document" === i) l = function(t) {
        const e = $023d07731ce8610f$var$T(t), n = $023d07731ce8610f$var$R(t), i = t.ownerDocument.body, r = $023d07731ce8610f$var$y(e.scrollWidth, e.clientWidth, i.scrollWidth, i.clientWidth), l = $023d07731ce8610f$var$y(e.scrollHeight, e.clientHeight, i.scrollHeight, i.clientHeight);
        let c = -n.scrollLeft + $023d07731ce8610f$var$C(t);
        const s = -n.scrollTop;
        return "rtl" === $023d07731ce8610f$var$o(i).direction && (c += $023d07731ce8610f$var$y(e.clientWidth, i.clientWidth) - r), {
            width: r,
            height: l,
            x: c,
            y: s
        };
    }($023d07731ce8610f$var$T(e));
    else if ($023d07731ce8610f$var$f(i)) l = function(t, e) {
        const n = $023d07731ce8610f$var$E(t, !0, "fixed" === e), o = n.top + t.clientTop, i = n.left + t.clientLeft, r = $023d07731ce8610f$var$s(t) ? $023d07731ce8610f$var$L(t) : {
            x: 1,
            y: 1
        };
        return {
            width: t.clientWidth * r.x,
            height: t.clientHeight * r.y,
            x: i * r.x,
            y: o * r.y
        };
    }(i, r);
    else {
        const t = {
            ...i
        };
        if ($023d07731ce8610f$var$p()) {
            var c, u;
            const o = $023d07731ce8610f$var$n(e);
            t.x -= (null == (c = o.visualViewport) ? void 0 : c.offsetLeft) || 0, t.y -= (null == (u = o.visualViewport) ? void 0 : u.offsetTop) || 0;
        }
        l = t;
    }
    return (0, $7MIdi.rectToClientRect)(l);
}
function $023d07731ce8610f$var$A(t, e) {
    return $023d07731ce8610f$var$s(t) && "fixed" !== $023d07731ce8610f$var$o(t).position ? e ? e(t) : t.offsetParent : null;
}
function $023d07731ce8610f$var$H(t, e) {
    const i = $023d07731ce8610f$var$n(t);
    if (!$023d07731ce8610f$var$s(t)) return i;
    let l = $023d07731ce8610f$var$A(t, e);
    for(; l && $023d07731ce8610f$var$d(l) && "static" === $023d07731ce8610f$var$o(l).position;)l = $023d07731ce8610f$var$A(l, e);
    return l && ("html" === $023d07731ce8610f$var$r(l) || "body" === $023d07731ce8610f$var$r(l) && "static" === $023d07731ce8610f$var$o(l).position && !$023d07731ce8610f$var$h(l)) ? i : l || function(t) {
        let e = $023d07731ce8610f$var$F(t);
        for(; $023d07731ce8610f$var$s(e) && !$023d07731ce8610f$var$g(e);){
            if ($023d07731ce8610f$var$h(e)) return e;
            e = $023d07731ce8610f$var$F(e);
        }
        return null;
    }(t) || i;
}
function $023d07731ce8610f$var$V(t, e, n) {
    const o = $023d07731ce8610f$var$s(e), i = $023d07731ce8610f$var$T(e), l = $023d07731ce8610f$var$E(t, !0, "fixed" === n, e);
    let c = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const f = {
        x: 0,
        y: 0
    };
    if (o || !o && "fixed" !== n) {
        if (("body" !== $023d07731ce8610f$var$r(e) || $023d07731ce8610f$var$a(i)) && (c = $023d07731ce8610f$var$R(e)), $023d07731ce8610f$var$s(e)) {
            const t = $023d07731ce8610f$var$E(e, !0);
            f.x = t.x + e.clientLeft, f.y = t.y + e.clientTop;
        } else i && (f.x = $023d07731ce8610f$var$C(i));
    }
    return {
        x: l.left + c.scrollLeft - f.x,
        y: l.top + c.scrollTop - f.y,
        width: l.width,
        height: l.height
    };
}
const $023d07731ce8610f$export$722a64dea1b767dc = {
    getClippingRect: function(t) {
        let { element: e, boundary: n, rootBoundary: i, strategy: l } = t;
        const c = "clippingAncestors" === n ? function(t, e) {
            const n = e.get(t);
            if (n) return n;
            let i = $023d07731ce8610f$export$3b57c1601291186b(t).filter((t)=>$023d07731ce8610f$var$f(t) && "body" !== $023d07731ce8610f$var$r(t)), l = null;
            const c = "fixed" === $023d07731ce8610f$var$o(t).position;
            let s = c ? $023d07731ce8610f$var$F(t) : t;
            for(; $023d07731ce8610f$var$f(s) && !$023d07731ce8610f$var$g(s);){
                const t = $023d07731ce8610f$var$o(s), e = $023d07731ce8610f$var$h(s);
                "fixed" === t.position ? l = null : (c ? e || l : e || "static" !== t.position || !l || ![
                    "absolute",
                    "fixed"
                ].includes(l.position)) ? l = t : i = i.filter((t)=>t !== s), s = $023d07731ce8610f$var$F(s);
            }
            return e.set(t, i), i;
        }(e, this._c) : [].concat(n), s = [
            ...c,
            i
        ], u = s[0], a = s.reduce((t, n)=>{
            const o = $023d07731ce8610f$var$S(e, n, l);
            return t.top = $023d07731ce8610f$var$y(o.top, t.top), t.right = $023d07731ce8610f$var$m(o.right, t.right), t.bottom = $023d07731ce8610f$var$m(o.bottom, t.bottom), t.left = $023d07731ce8610f$var$y(o.left, t.left), t;
        }, $023d07731ce8610f$var$S(e, u, l));
        return {
            width: a.right - a.left,
            height: a.bottom - a.top,
            x: a.left,
            y: a.top
        };
    },
    convertOffsetParentRelativeRectToViewportRelativeRect: function(t) {
        let { rect: e, offsetParent: n, strategy: o } = t;
        const i = $023d07731ce8610f$var$s(n), l = $023d07731ce8610f$var$T(n);
        if (n === l) return e;
        let c = {
            scrollLeft: 0,
            scrollTop: 0
        }, f = {
            x: 1,
            y: 1
        };
        const u = {
            x: 0,
            y: 0
        };
        if ((i || !i && "fixed" !== o) && (("body" !== $023d07731ce8610f$var$r(n) || $023d07731ce8610f$var$a(l)) && (c = $023d07731ce8610f$var$R(n)), $023d07731ce8610f$var$s(n))) {
            const t = $023d07731ce8610f$var$E(n);
            f = $023d07731ce8610f$var$L(n), u.x = t.x + n.clientLeft, u.y = t.y + n.clientTop;
        }
        return {
            width: e.width * f.x,
            height: e.height * f.y,
            x: e.x * f.x - c.scrollLeft * f.x + u.x,
            y: e.y * f.y - c.scrollTop * f.y + u.y
        };
    },
    isElement: $023d07731ce8610f$var$f,
    getDimensions: function(t) {
        return $023d07731ce8610f$var$w(t);
    },
    getOffsetParent: $023d07731ce8610f$var$H,
    getDocumentElement: $023d07731ce8610f$var$T,
    getScale: $023d07731ce8610f$var$L,
    async getElementRects (t) {
        let { reference: e, floating: n, strategy: o } = t;
        const i = this.getOffsetParent || $023d07731ce8610f$var$H, r = this.getDimensions;
        return {
            reference: $023d07731ce8610f$var$V(e, await i(n), o),
            floating: {
                x: 0,
                y: 0,
                ...await r(n)
            }
        };
    },
    getClientRects: (t)=>Array.from(t.getClientRects()),
    isRTL: (t)=>"rtl" === $023d07731ce8610f$var$o(t).direction
};
function $023d07731ce8610f$export$deee3a793edee05f(t, e, n, o) {
    void 0 === o && (o = {});
    const { ancestorScroll: i = !0, ancestorResize: r = !0, elementResize: l = !0, animationFrame: c = !1 } = o, s = i && !c, u = s || r ? [
        ...$023d07731ce8610f$var$f(t) ? $023d07731ce8610f$export$3b57c1601291186b(t) : t.contextElement ? $023d07731ce8610f$export$3b57c1601291186b(t.contextElement) : [],
        ...$023d07731ce8610f$export$3b57c1601291186b(e)
    ] : [];
    u.forEach((t)=>{
        s && t.addEventListener("scroll", n, {
            passive: !0
        }), r && t.addEventListener("resize", n);
    });
    let a, d = null;
    l && (d = new ResizeObserver(()=>{
        n();
    }), $023d07731ce8610f$var$f(t) && !c && d.observe(t), $023d07731ce8610f$var$f(t) || !t.contextElement || c || d.observe(t.contextElement), d.observe(e));
    let h = c ? $023d07731ce8610f$var$E(t) : null;
    return c && function e() {
        const o = $023d07731ce8610f$var$E(t);
        !h || o.x === h.x && o.y === h.y && o.width === h.width && o.height === h.height || n();
        h = o, a = requestAnimationFrame(e);
    }(), n(), ()=>{
        var t;
        u.forEach((t)=>{
            s && t.removeEventListener("scroll", n), r && t.removeEventListener("resize", n);
        }), null == (t = d) || t.disconnect(), d = null, c && cancelAnimationFrame(a);
    };
}
const $023d07731ce8610f$export$48a53dcb22e581d0 = (t, n, o)=>{
    const i = new Map, r = {
        platform: $023d07731ce8610f$export$722a64dea1b767dc,
        ...o
    }, l = {
        ...r.platform,
        _c: i
    };
    return (0, $7MIdi.computePosition)(t, n, {
        ...r,
        platform: l
    });
};

});
parcelRegister("7MIdi", function(module, exports) {

$parcel$export(module.exports, "computePosition", () => $4dacbd6c81f90f16$export$48a53dcb22e581d0);
$parcel$export(module.exports, "rectToClientRect", () => $4dacbd6c81f90f16$export$ee05aea0aeecbad4);
function $4dacbd6c81f90f16$var$t(t) {
    return t.split("-")[1];
}
function $4dacbd6c81f90f16$var$e(t) {
    return "y" === t ? "height" : "width";
}
function $4dacbd6c81f90f16$var$n(t) {
    return t.split("-")[0];
}
function $4dacbd6c81f90f16$var$o(t) {
    return [
        "top",
        "bottom"
    ].includes($4dacbd6c81f90f16$var$n(t)) ? "x" : "y";
}
function $4dacbd6c81f90f16$var$i(i, r, a) {
    let { reference: l, floating: s } = i;
    const c = l.x + l.width / 2 - s.width / 2, f = l.y + l.height / 2 - s.height / 2, m = $4dacbd6c81f90f16$var$o(r), u = $4dacbd6c81f90f16$var$e(m), g = l[u] / 2 - s[u] / 2, d = "x" === m;
    let p;
    switch($4dacbd6c81f90f16$var$n(r)){
        case "top":
            p = {
                x: c,
                y: l.y - s.height
            };
            break;
        case "bottom":
            p = {
                x: c,
                y: l.y + l.height
            };
            break;
        case "right":
            p = {
                x: l.x + l.width,
                y: f
            };
            break;
        case "left":
            p = {
                x: l.x - s.width,
                y: f
            };
            break;
        default:
            p = {
                x: l.x,
                y: l.y
            };
    }
    switch($4dacbd6c81f90f16$var$t(r)){
        case "start":
            p[m] -= g * (a && d ? -1 : 1);
            break;
        case "end":
            p[m] += g * (a && d ? -1 : 1);
    }
    return p;
}
const $4dacbd6c81f90f16$export$48a53dcb22e581d0 = async (t, e, n)=>{
    const { placement: o = "bottom", strategy: r = "absolute", middleware: a = [], platform: l } = n, s = a.filter(Boolean), c = await (null == l.isRTL ? void 0 : l.isRTL(e));
    let f = await l.getElementRects({
        reference: t,
        floating: e,
        strategy: r
    }), { x: m, y: u } = $4dacbd6c81f90f16$var$i(f, o, c), g = o, d = {}, p = 0;
    for(let n = 0; n < s.length; n++){
        const { name: a, fn: h } = s[n], { x: y, y: x, data: w, reset: v } = await h({
            x: m,
            y: u,
            initialPlacement: o,
            placement: g,
            strategy: r,
            middlewareData: d,
            rects: f,
            platform: l,
            elements: {
                reference: t,
                floating: e
            }
        });
        m = null != y ? y : m, u = null != x ? x : u, d = {
            ...d,
            [a]: {
                ...d[a],
                ...w
            }
        }, v && p <= 50 && (p++, "object" == typeof v && (v.placement && (g = v.placement), v.rects && (f = !0 === v.rects ? await l.getElementRects({
            reference: t,
            floating: e,
            strategy: r
        }) : v.rects), { x: m, y: u } = $4dacbd6c81f90f16$var$i(f, g, c)), n = -1);
    }
    return {
        x: m,
        y: u,
        placement: g,
        strategy: r,
        middlewareData: d
    };
};
function $4dacbd6c81f90f16$var$a(t) {
    return "number" != typeof t ? function(t) {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...t
        };
    }(t) : {
        top: t,
        right: t,
        bottom: t,
        left: t
    };
}
function $4dacbd6c81f90f16$export$ee05aea0aeecbad4(t) {
    return {
        ...t,
        top: t.y,
        left: t.x,
        right: t.x + t.width,
        bottom: t.y + t.height
    };
}
async function $4dacbd6c81f90f16$export$37b6bde19b108ecc(t, e) {
    var n;
    void 0 === e && (e = {});
    const { x: o, y: i, platform: r, rects: s, elements: c, strategy: f } = t, { boundary: m = "clippingAncestors", rootBoundary: u = "viewport", elementContext: g = "floating", altBoundary: d = !1, padding: p = 0 } = e, h = $4dacbd6c81f90f16$var$a(p), y = c[d ? "floating" === g ? "reference" : "floating" : g], x = $4dacbd6c81f90f16$export$ee05aea0aeecbad4(await r.getClippingRect({
        element: null == (n = await (null == r.isElement ? void 0 : r.isElement(y))) || n ? y : y.contextElement || await (null == r.getDocumentElement ? void 0 : r.getDocumentElement(c.floating)),
        boundary: m,
        rootBoundary: u,
        strategy: f
    })), w = "floating" === g ? {
        ...s.floating,
        x: o,
        y: i
    } : s.reference, v = await (null == r.getOffsetParent ? void 0 : r.getOffsetParent(c.floating)), b = await (null == r.isElement ? void 0 : r.isElement(v)) && await (null == r.getScale ? void 0 : r.getScale(v)) || {
        x: 1,
        y: 1
    }, A = $4dacbd6c81f90f16$export$ee05aea0aeecbad4(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: w,
        offsetParent: v,
        strategy: f
    }) : w);
    return {
        top: (x.top - A.top + h.top) / b.y,
        bottom: (A.bottom - x.bottom + h.bottom) / b.y,
        left: (x.left - A.left + h.left) / b.x,
        right: (A.right - x.right + h.right) / b.x
    };
}
const $4dacbd6c81f90f16$var$c = Math.min, $4dacbd6c81f90f16$var$f = Math.max;
function $4dacbd6c81f90f16$var$m(t, e, n) {
    return $4dacbd6c81f90f16$var$f(t, $4dacbd6c81f90f16$var$c(e, n));
}
const $4dacbd6c81f90f16$export$f2120bbfa5450bd2 = (n)=>({
        name: "arrow",
        options: n,
        async fn (i) {
            const { element: r, padding: l = 0 } = n || {}, { x: s, y: c, placement: f, rects: u, platform: g, elements: d } = i;
            if (null == r) return {};
            const p = $4dacbd6c81f90f16$var$a(l), h = {
                x: s,
                y: c
            }, y = $4dacbd6c81f90f16$var$o(f), x = $4dacbd6c81f90f16$var$e(y), w = await g.getDimensions(r), v = "y" === y, b = v ? "top" : "left", A = v ? "bottom" : "right", R = v ? "clientHeight" : "clientWidth", P = u.reference[x] + u.reference[y] - h[y] - u.floating[x], E = h[y] - u.reference[y], T = await (null == g.getOffsetParent ? void 0 : g.getOffsetParent(r));
            let D = T ? T[R] : 0;
            D && await (null == g.isElement ? void 0 : g.isElement(T)) || (D = d.floating[R] || u.floating[x]);
            const L = P / 2 - E / 2, k = p[b], O = D - w[x] - p[A], B = D / 2 - w[x] / 2 + L, C = $4dacbd6c81f90f16$var$m(k, B, O), H = null != $4dacbd6c81f90f16$var$t(f) && B != C && u.reference[x] / 2 - (B < k ? p[b] : p[A]) - w[x] / 2 < 0;
            return {
                [y]: h[y] - (H ? B < k ? k - B : O - B : 0),
                data: {
                    [y]: C,
                    centerOffset: B - C
                }
            };
        }
    }), $4dacbd6c81f90f16$var$g = [
    "top",
    "right",
    "bottom",
    "left"
], $4dacbd6c81f90f16$var$d = $4dacbd6c81f90f16$var$g.reduce((t, e)=>t.concat(e, e + "-start", e + "-end"), []), $4dacbd6c81f90f16$var$p = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $4dacbd6c81f90f16$var$h(t) {
    return t.replace(/left|right|bottom|top/g, (t)=>$4dacbd6c81f90f16$var$p[t]);
}
function $4dacbd6c81f90f16$var$y(n, i, r) {
    void 0 === r && (r = !1);
    const a = $4dacbd6c81f90f16$var$t(n), l = $4dacbd6c81f90f16$var$o(n), s = $4dacbd6c81f90f16$var$e(l);
    let c = "x" === l ? a === (r ? "end" : "start") ? "right" : "left" : "start" === a ? "bottom" : "top";
    return i.reference[s] > i.floating[s] && (c = $4dacbd6c81f90f16$var$h(c)), {
        main: c,
        cross: $4dacbd6c81f90f16$var$h(c)
    };
}
const $4dacbd6c81f90f16$var$x = {
    start: "end",
    end: "start"
};
function $4dacbd6c81f90f16$var$w(t) {
    return t.replace(/start|end/g, (t)=>$4dacbd6c81f90f16$var$x[t]);
}
const $4dacbd6c81f90f16$export$91fb6ecbd551914 = function(e) {
    return void 0 === e && (e = {}), {
        name: "autoPlacement",
        options: e,
        async fn (o) {
            var i, r, a;
            const { rects: l, middlewareData: c, placement: f, platform: m, elements: u } = o, { crossAxis: g = !1, alignment: p, allowedPlacements: h = $4dacbd6c81f90f16$var$d, autoAlignment: x = !0, ...v } = e, b = void 0 !== p || h === $4dacbd6c81f90f16$var$d ? function(e, o, i) {
                return (e ? [
                    ...i.filter((n)=>$4dacbd6c81f90f16$var$t(n) === e),
                    ...i.filter((n)=>$4dacbd6c81f90f16$var$t(n) !== e)
                ] : i.filter((t)=>$4dacbd6c81f90f16$var$n(t) === t)).filter((n)=>!e || $4dacbd6c81f90f16$var$t(n) === e || !!o && $4dacbd6c81f90f16$var$w(n) !== n);
            }(p || null, x, h) : h, A = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(o, v), R = (null == (i = c.autoPlacement) ? void 0 : i.index) || 0, P = b[R];
            if (null == P) return {};
            const { main: E, cross: T } = $4dacbd6c81f90f16$var$y(P, l, await (null == m.isRTL ? void 0 : m.isRTL(u.floating)));
            if (f !== P) return {
                reset: {
                    placement: b[0]
                }
            };
            const D = [
                A[$4dacbd6c81f90f16$var$n(P)],
                A[E],
                A[T]
            ], L = [
                ...(null == (r = c.autoPlacement) ? void 0 : r.overflows) || [],
                {
                    placement: P,
                    overflows: D
                }
            ], k = b[R + 1];
            if (k) return {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: k
                }
            };
            const O = L.map((e)=>{
                const n = $4dacbd6c81f90f16$var$t(e.placement);
                return [
                    e.placement,
                    n && g ? e.overflows.slice(0, 2).reduce((t, e)=>t + e, 0) : e.overflows[0],
                    e.overflows
                ];
            }).sort((t, e)=>t[1] - e[1]), B = (null == (a = O.filter((e)=>e[2].slice(0, $4dacbd6c81f90f16$var$t(e[0]) ? 2 : 3).every((t)=>t <= 0))[0]) ? void 0 : a[0]) || O[0][0];
            return B !== f ? {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: B
                }
            } : {};
        }
    };
};
const $4dacbd6c81f90f16$export$8a83211c878a3f1f = function(e) {
    return void 0 === e && (e = {}), {
        name: "flip",
        options: e,
        async fn (o) {
            var i;
            const { placement: r, middlewareData: a, rects: l, initialPlacement: c, platform: f, elements: m } = o, { mainAxis: u = !0, crossAxis: g = !0, fallbackPlacements: d, fallbackStrategy: p = "bestFit", fallbackAxisSideDirection: x = "none", flipAlignment: v = !0, ...b } = e, A = $4dacbd6c81f90f16$var$n(r), R = $4dacbd6c81f90f16$var$n(c) === c, P = await (null == f.isRTL ? void 0 : f.isRTL(m.floating)), E = d || (R || !v ? [
                $4dacbd6c81f90f16$var$h(c)
            ] : function(t) {
                const e = $4dacbd6c81f90f16$var$h(t);
                return [
                    $4dacbd6c81f90f16$var$w(t),
                    e,
                    $4dacbd6c81f90f16$var$w(e)
                ];
            }(c));
            d || "none" === x || E.push(...function(e, o, i, r) {
                const a = $4dacbd6c81f90f16$var$t(e);
                let l = function(t, e, n) {
                    const o = [
                        "left",
                        "right"
                    ], i = [
                        "right",
                        "left"
                    ], r = [
                        "top",
                        "bottom"
                    ], a = [
                        "bottom",
                        "top"
                    ];
                    switch(t){
                        case "top":
                        case "bottom":
                            return n ? e ? i : o : e ? o : i;
                        case "left":
                        case "right":
                            return e ? r : a;
                        default:
                            return [];
                    }
                }($4dacbd6c81f90f16$var$n(e), "start" === i, r);
                return a && (l = l.map((t)=>t + "-" + a), o && (l = l.concat(l.map($4dacbd6c81f90f16$var$w)))), l;
            }(c, v, x, P));
            const T = [
                c,
                ...E
            ], D = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(o, b), L = [];
            let k = (null == (i = a.flip) ? void 0 : i.overflows) || [];
            if (u && L.push(D[A]), g) {
                const { main: t, cross: e } = $4dacbd6c81f90f16$var$y(r, l, P);
                L.push(D[t], D[e]);
            }
            if (k = [
                ...k,
                {
                    placement: r,
                    overflows: L
                }
            ], !L.every((t)=>t <= 0)) {
                var O, B;
                const t = ((null == (O = a.flip) ? void 0 : O.index) || 0) + 1, e = T[t];
                if (e) return {
                    data: {
                        index: t,
                        overflows: k
                    },
                    reset: {
                        placement: e
                    }
                };
                let n = null == (B = k.filter((t)=>t.overflows[0] <= 0).sort((t, e)=>t.overflows[1] - e.overflows[1])[0]) ? void 0 : B.placement;
                if (!n) switch(p){
                    case "bestFit":
                        {
                            var C;
                            const t = null == (C = k.map((t)=>[
                                    t.placement,
                                    t.overflows.filter((t)=>t > 0).reduce((t, e)=>t + e, 0)
                                ]).sort((t, e)=>t[1] - e[1])[0]) ? void 0 : C[0];
                            t && (n = t);
                            break;
                        }
                    case "initialPlacement":
                        n = c;
                }
                if (r !== n) return {
                    reset: {
                        placement: n
                    }
                };
            }
            return {};
        }
    };
};
function $4dacbd6c81f90f16$var$A(t, e) {
    return {
        top: t.top - e.height,
        right: t.right - e.width,
        bottom: t.bottom - e.height,
        left: t.left - e.width
    };
}
function $4dacbd6c81f90f16$var$R(t) {
    return $4dacbd6c81f90f16$var$g.some((e)=>t[e] >= 0);
}
const $4dacbd6c81f90f16$export$fe8985bb6374093c = function(t) {
    return void 0 === t && (t = {}), {
        name: "hide",
        options: t,
        async fn (e) {
            const { strategy: n = "referenceHidden", ...o } = t, { rects: i } = e;
            switch(n){
                case "referenceHidden":
                    {
                        const t = $4dacbd6c81f90f16$var$A(await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, {
                            ...o,
                            elementContext: "reference"
                        }), i.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: t,
                                referenceHidden: $4dacbd6c81f90f16$var$R(t)
                            }
                        };
                    }
                case "escaped":
                    {
                        const t = $4dacbd6c81f90f16$var$A(await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, {
                            ...o,
                            altBoundary: !0
                        }), i.floating);
                        return {
                            data: {
                                escapedOffsets: t,
                                escaped: $4dacbd6c81f90f16$var$R(t)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $4dacbd6c81f90f16$var$E(t) {
    const e = $4dacbd6c81f90f16$var$c(...t.map((t)=>t.left)), n = $4dacbd6c81f90f16$var$c(...t.map((t)=>t.top));
    return {
        x: e,
        y: n,
        width: $4dacbd6c81f90f16$var$f(...t.map((t)=>t.right)) - e,
        height: $4dacbd6c81f90f16$var$f(...t.map((t)=>t.bottom)) - n
    };
}
const $4dacbd6c81f90f16$export$18c8ad048e32c7d5 = function(t) {
    return void 0 === t && (t = {}), {
        name: "inline",
        options: t,
        async fn (e) {
            const { placement: i, elements: r, rects: s, platform: m, strategy: u } = e, { padding: g = 2, x: d, y: p } = t, h = Array.from(await (null == m.getClientRects ? void 0 : m.getClientRects(r.reference)) || []), y = function(t) {
                const e = t.slice().sort((t, e)=>t.y - e.y), n = [];
                let o = null;
                for(let t = 0; t < e.length; t++){
                    const i = e[t];
                    !o || i.y - o.y > o.height / 2 ? n.push([
                        i
                    ]) : n[n.length - 1].push(i), o = i;
                }
                return n.map((t)=>$4dacbd6c81f90f16$export$ee05aea0aeecbad4($4dacbd6c81f90f16$var$E(t)));
            }(h), x = $4dacbd6c81f90f16$export$ee05aea0aeecbad4($4dacbd6c81f90f16$var$E(h)), w = $4dacbd6c81f90f16$var$a(g);
            const v = await m.getElementRects({
                reference: {
                    getBoundingClientRect: function() {
                        if (2 === y.length && y[0].left > y[1].right && null != d && null != p) return y.find((t)=>d > t.left - w.left && d < t.right + w.right && p > t.top - w.top && p < t.bottom + w.bottom) || x;
                        if (y.length >= 2) {
                            if ("x" === $4dacbd6c81f90f16$var$o(i)) {
                                const t = y[0], e = y[y.length - 1], o = "top" === $4dacbd6c81f90f16$var$n(i), r = t.top, a = e.bottom, l = o ? t.left : e.left, s = o ? t.right : e.right;
                                return {
                                    top: r,
                                    bottom: a,
                                    left: l,
                                    right: s,
                                    width: s - l,
                                    height: a - r,
                                    x: l,
                                    y: r
                                };
                            }
                            const t = "left" === $4dacbd6c81f90f16$var$n(i), e = $4dacbd6c81f90f16$var$f(...y.map((t)=>t.right)), r = $4dacbd6c81f90f16$var$c(...y.map((t)=>t.left)), a = y.filter((n)=>t ? n.left === r : n.right === e), l = a[0].top, s = a[a.length - 1].bottom;
                            return {
                                top: l,
                                bottom: s,
                                left: r,
                                right: e,
                                width: e - r,
                                height: s - l,
                                x: r,
                                y: l
                            };
                        }
                        return x;
                    }
                },
                floating: r.floating,
                strategy: u
            });
            return s.reference.x !== v.reference.x || s.reference.y !== v.reference.y || s.reference.width !== v.reference.width || s.reference.height !== v.reference.height ? {
                reset: {
                    rects: v
                }
            } : {};
        }
    };
};
const $4dacbd6c81f90f16$export$cc800923e997bb8 = function(e) {
    return void 0 === e && (e = 0), {
        name: "offset",
        options: e,
        async fn (i) {
            const { x: r, y: a } = i, l = await async function(e, i) {
                const { placement: r, platform: a, elements: l } = e, s = await (null == a.isRTL ? void 0 : a.isRTL(l.floating)), c = $4dacbd6c81f90f16$var$n(r), f = $4dacbd6c81f90f16$var$t(r), m = "x" === $4dacbd6c81f90f16$var$o(r), u = [
                    "left",
                    "top"
                ].includes(c) ? -1 : 1, g = s && m ? -1 : 1, d = "function" == typeof i ? i(e) : i;
                let { mainAxis: p, crossAxis: h, alignmentAxis: y } = "number" == typeof d ? {
                    mainAxis: d,
                    crossAxis: 0,
                    alignmentAxis: null
                } : {
                    mainAxis: 0,
                    crossAxis: 0,
                    alignmentAxis: null,
                    ...d
                };
                return f && "number" == typeof y && (h = "end" === f ? -1 * y : y), m ? {
                    x: h * g,
                    y: p * u
                } : {
                    x: p * u,
                    y: h * g
                };
            }(i, e);
            return {
                x: r + l.x,
                y: a + l.y,
                data: l
            };
        }
    };
};
function $4dacbd6c81f90f16$var$L(t) {
    return "x" === t ? "y" : "x";
}
const $4dacbd6c81f90f16$export$fba63a578e423eb = function(t) {
    return void 0 === t && (t = {}), {
        name: "shift",
        options: t,
        async fn (e) {
            const { x: i, y: r, placement: a } = e, { mainAxis: l = !0, crossAxis: c = !1, limiter: f = {
                fn: (t)=>{
                    let { x: e, y: n } = t;
                    return {
                        x: e,
                        y: n
                    };
                }
            }, ...u } = t, g = {
                x: i,
                y: r
            }, d = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, u), p = $4dacbd6c81f90f16$var$o($4dacbd6c81f90f16$var$n(a)), h = $4dacbd6c81f90f16$var$L(p);
            let y = g[p], x = g[h];
            if (l) {
                const t = "y" === p ? "bottom" : "right";
                y = $4dacbd6c81f90f16$var$m(y + d["y" === p ? "top" : "left"], y, y - d[t]);
            }
            if (c) {
                const t = "y" === h ? "bottom" : "right";
                x = $4dacbd6c81f90f16$var$m(x + d["y" === h ? "top" : "left"], x, x - d[t]);
            }
            const w = f.fn({
                ...e,
                [p]: y,
                [h]: x
            });
            return {
                ...w,
                data: {
                    x: w.x - i,
                    y: w.y - r
                }
            };
        }
    };
}, $4dacbd6c81f90f16$export$7bf07e38f3dc4b69 = function(t) {
    return void 0 === t && (t = {}), {
        options: t,
        fn (e) {
            const { x: i, y: r, placement: a, rects: l, middlewareData: s } = e, { offset: c = 0, mainAxis: f = !0, crossAxis: m = !0 } = t, u = {
                x: i,
                y: r
            }, g = $4dacbd6c81f90f16$var$o(a), d = $4dacbd6c81f90f16$var$L(g);
            let p = u[g], h = u[d];
            const y = "function" == typeof c ? c(e) : c, x = "number" == typeof y ? {
                mainAxis: y,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...y
            };
            if (f) {
                const t = "y" === g ? "height" : "width", e = l.reference[g] - l.floating[t] + x.mainAxis, n = l.reference[g] + l.reference[t] - x.mainAxis;
                p < e ? p = e : p > n && (p = n);
            }
            if (m) {
                var w, v;
                const t = "y" === g ? "width" : "height", e = [
                    "top",
                    "left"
                ].includes($4dacbd6c81f90f16$var$n(a)), o = l.reference[d] - l.floating[t] + (e && (null == (w = s.offset) ? void 0 : w[d]) || 0) + (e ? 0 : x.crossAxis), i = l.reference[d] + l.reference[t] + (e ? 0 : (null == (v = s.offset) ? void 0 : v[d]) || 0) - (e ? x.crossAxis : 0);
                h < o ? h = o : h > i && (h = i);
            }
            return {
                [g]: p,
                [d]: h
            };
        }
    };
}, $4dacbd6c81f90f16$export$346677f925de839c = function(e) {
    return void 0 === e && (e = {}), {
        name: "size",
        options: e,
        async fn (i) {
            const { placement: r, rects: a, platform: l, elements: m } = i, { apply: u = ()=>{}, ...g } = e, d = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(i, g), p = $4dacbd6c81f90f16$var$n(r), h = $4dacbd6c81f90f16$var$t(r), y = "x" === $4dacbd6c81f90f16$var$o(r), { width: x, height: w } = a.floating;
            let v, b;
            "top" === p || "bottom" === p ? (v = p, b = h === (await (null == l.isRTL ? void 0 : l.isRTL(m.floating)) ? "start" : "end") ? "left" : "right") : (b = p, v = "end" === h ? "top" : "bottom");
            const A = w - d[v], R = x - d[b];
            let P = A, E = R;
            if (y ? E = $4dacbd6c81f90f16$var$c(x - d.right - d.left, R) : P = $4dacbd6c81f90f16$var$c(w - d.bottom - d.top, A), !i.middlewareData.shift && !h) {
                const t = $4dacbd6c81f90f16$var$f(d.left, 0), e = $4dacbd6c81f90f16$var$f(d.right, 0), n = $4dacbd6c81f90f16$var$f(d.top, 0), o = $4dacbd6c81f90f16$var$f(d.bottom, 0);
                y ? E = x - 2 * (0 !== t || 0 !== e ? t + e : $4dacbd6c81f90f16$var$f(d.left, d.right)) : P = w - 2 * (0 !== n || 0 !== o ? n + o : $4dacbd6c81f90f16$var$f(d.top, d.bottom));
            }
            await u({
                ...i,
                availableWidth: E,
                availableHeight: P
            });
            const T = await l.getDimensions(m.floating);
            return x !== T.width || w !== T.height ? {
                reset: {
                    rects: !0
                }
            } : {};
        }
    };
};

});


parcelRegister("k286k", function(module, exports) {

$parcel$export(module.exports, "default", () => $e95a473d1e65c2a9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
var $e95a473d1e65c2a9$var$index = (0, $eUqFw.useLayoutEffect);
var $e95a473d1e65c2a9$export$2e2bcd8739ae039 = $e95a473d1e65c2a9$var$index;

});




parcelRegister("5FjBr", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba6ba00681316b2f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $jQirI = parcelRequire("jQirI");

var $hgqfZ = parcelRequire("hgqfZ");

var $o2lI9 = parcelRequire("o2lI9");
var $7HYS7 = parcelRequire("7HYS7");

var $bKJfr = parcelRequire("bKJfr");

var $lT14u = parcelRequire("lT14u");
function $ba6ba00681316b2f$export$2e2bcd8739ae039(WrappedComponent) {
    const AtlaskitSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        const { appearance: appearance, ariaLiveMessages: ariaLiveMessages, components: componentsProp, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, spacing: spacing = 'default', styles: styles = {}, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
        const internalSelectRef = (0, $eUqFw.useRef)(null);
        const components = (0, $eUqFw.useMemo)(()=>({
                ClearIndicator: $o2lI9.ClearIndicator,
                DropdownIndicator: $o2lI9.DropdownIndicator,
                LoadingIndicator: $o2lI9.LoadingIndicator,
                MultiValueRemove: $7HYS7.MultiValueRemove,
                IndicatorSeparator: $7HYS7.IndicatorSeparator,
                Input: $jQirI.Input,
                NoOptionsMessage: $hgqfZ.NoOptionsMessage,
                ...componentsProp
            }), [
            componentsProp
        ]);
        const descriptionId = props['aria-describedby'];
        const isSearchable = props.isSearchable;
        (0, $eUqFw.useEffect)(()=>{
            if (!isSearchable && descriptionId) {
                // when isSearchable is false, react-select will create its own dummy input instead of using ours,
                // so we need to manually add the additional aria-describedby using ref.
                const input = internalSelectRef.current?.inputRef;
                const ariaDescribedby = input?.getAttribute('aria-describedby');
                if (!ariaDescribedby?.includes(descriptionId)) input?.setAttribute('aria-describedby', `${ariaDescribedby} ${descriptionId}`);
            }
        }, [
            descriptionId,
            isSearchable
        ]);
        const isCompact = spacing === 'compact';
        /**
		 * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
		 * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
		 * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
		 * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
		 * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
		 */ (0, $eUqFw.useImperativeHandle)(forwardedRef, ()=>({
                select: internalSelectRef.current,
                focus: ()=>internalSelectRef.current?.focus(),
                blur: ()=>internalSelectRef.current?.blur()
            }), []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ref: internalSelectRef,
            "aria-live": "assertive",
            ariaLiveMessages: (0, $lT14u.isOptionsGrouped)(props.options) ? {
                onFocus: $lT14u.onFocus,
                ...ariaLiveMessages
            } : {
                ...ariaLiveMessages
            },
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            ...restProps,
            components: components,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            styles: (0, $cEc3i.m)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $bKJfr.default)(// This will cover both props for invalid state while giving priority to isInvalid. When cleaning up validationState, we can just keep the inner condition.
            typeof isInvalid !== 'undefined' ? isInvalid ? 'error' : 'default' : validationState, isCompact, appearance || 'default'), styles)
        });
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

});
parcelRegister("jQirI", function(module, exports) {

$parcel$export(module.exports, "Input", () => $644d9bc3d652d5d7$export$f5b8910cec6cf069);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");
function $644d9bc3d652d5d7$export$f5b8910cec6cf069(props) {
    let ariaDescribedByAttribute;
    const passed_describedby = props.selectProps['aria-describedby'];
    if (props['aria-describedby'] && passed_describedby) ariaDescribedByAttribute = props['aria-describedby'] + ' ' + passed_describedby;
    else ariaDescribedByAttribute = props['aria-describedby'] || passed_describedby;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Input, {
        ...props,
        "aria-describedby": ariaDescribedByAttribute
    });
}

});

parcelRegister("hgqfZ", function(module, exports) {

$parcel$export(module.exports, "NoOptionsMessage", () => $4d0dc96eef1d75f0$export$d58b72b7d3c4072c);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");
const $4d0dc96eef1d75f0$export$d58b72b7d3c4072c = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).NoOptionsMessage, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        id: "no-options",
        role: "alert"
    }, props.children || `No options`));
};

});

parcelRegister("o2lI9", function(module, exports) {

$parcel$export(module.exports, "ClearIndicator", () => $a14d8b5e9bff27a8$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "DropdownIndicator", () => $a14d8b5e9bff27a8$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "LoadingIndicator", () => $a14d8b5e9bff27a8$export$7c20be4c1d342248);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $jQxSL = parcelRequire("jQxSL");

var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $hUbUe = parcelRequire("hUbUe");

var $86Ndv = parcelRequire("86Ndv");
const $a14d8b5e9bff27a8$var$iconContainerStyles = (0, $1ZAYh.xcss)({
    all: 'unset',
    outline: 'revert',
    display: 'flex',
    alignItems: 'center'
});
const $a14d8b5e9bff27a8$export$ecf9cf59142dd54a = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).ClearIndicator, {
        ...props,
        innerProps: {
            ...props.innerProps,
            'aria-hidden': 'false'
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4ZL0y.default), {
        xcss: $a14d8b5e9bff27a8$var$iconContainerStyles,
        tabIndex: -1
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hUbUe))), {
        size: "small",
        label: "clear"
    })));
const $a14d8b5e9bff27a8$export$ec98719d3db7f2e4 = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).DropdownIndicator, props, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
        label: "open"
    }));
const $a14d8b5e9bff27a8$export$7c20be4c1d342248 = (props)=>{
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const loadingStyles = /*#__PURE__*/ (0, $byn9U.css)(props.getStyles('loadingIndicator', props));
    return(// This *must* be constructed this way because this is being consumed by
    // `react-select` and we don't control what it wants.
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: loadingStyles,
        ...props.innerProps
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4Bees.default), {
        size: "small"
    })));
};

});
parcelRegister("hUbUe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d090e6e9cc89e346$var$_react = $d090e6e9cc89e346$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $d090e6e9cc89e346$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d090e6e9cc89e346$var$SelectClearIcon = (props)=>/*#__PURE__*/ $d090e6e9cc89e346$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" cx="12" cy="12" r="9"/><path d="M16.155 14.493a1.174 1.174 0 11-1.662 1.663L12 13.662l-2.494 2.494a1.172 1.172 0 01-1.662 0 1.176 1.176 0 010-1.663L10.337 12 7.844 9.507a1.176 1.176 0 011.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 111.662 1.662L13.662 12l2.493 2.493z" fill="inherit"/></g></svg>`
    }, props));
$d090e6e9cc89e346$var$SelectClearIcon.displayName = 'SelectClearIcon';
var $d090e6e9cc89e346$var$_default = $d090e6e9cc89e346$var$SelectClearIcon;
module.exports.default = $d090e6e9cc89e346$var$_default;

});


parcelRegister("7HYS7", function(module, exports) {

$parcel$export(module.exports, "MultiValueRemove", () => $7fda2332979a5c13$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "IndicatorSeparator", () => $7fda2332979a5c13$export$bd638c2ba7915668);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $hUbUe = parcelRequire("hUbUe");

var $jQxSL = parcelRequire("jQxSL");

var $o2lI9 = parcelRequire("o2lI9");
function $7fda2332979a5c13$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7fda2332979a5c13$var$disabledStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $7fda2332979a5c13$var$enabledStyles = {
    name: "ck88l6",
    styles: "display:inherit"
};
const $7fda2332979a5c13$export$8e1fd1a40e7a2f4a = (props)=>{
    const { isDisabled: isDisabled } = props.selectProps;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).MultiValueRemove, props, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: isDisabled ? $7fda2332979a5c13$var$disabledStyles : $7fda2332979a5c13$var$enabledStyles,
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hUbUe))), {
        label: "Clear",
        size: "small",
        primaryColor: "transparent",
        secondaryColor: "inherit"
    })));
};
const $7fda2332979a5c13$export$bd638c2ba7915668 = null;

});

parcelRegister("bKJfr", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eba8612e97e7e89$export$2e2bcd8739ae039);

var $PdmhA = parcelRequire("PdmhA");

var $XHGTv = parcelRequire("XHGTv");
function $6eba8612e97e7e89$export$2e2bcd8739ae039(validationState, isCompact = false, appearance) {
    return {
        container: (css, { isDisabled: isDisabled })=>({
                ...css,
                ...(0, $XHGTv.getBooleanFF)('platform.design-system-team.select-new-typography_7m89c') ? {
                    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
                } : {
                    fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
                },
                // react-select disables pointer events when isDisabled is true.
                // We override this and make the inner container turn it off instead.
                pointerEvents: 'all',
                cursor: isDisabled ? 'not-allowed' : css.cursor
            }),
        input: (css)=>({
                ...css,
                color: "var(--ds-text, hsl(0, 0%, 20%))"
            }),
        control: (css, { isFocused: isFocused, isDisabled: isDisabled })=>{
            let borderColor = isFocused ? `var(--ds-border-focused, ${0, $PdmhA.B100})` : `var(--ds-border-input, ${0, $PdmhA.N100})`;
            let backgroundColor = isFocused ? `var(--ds-background-input-pressed, ${0, $PdmhA.N0})` : `var(--ds-background-input, ${0, $PdmhA.N20})`;
            let backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $PdmhA.N0})` : `var(--ds-background-input-hovered, ${0, $PdmhA.N30})`;
            if (isDisabled) {
                backgroundColor = `var(--ds-background-disabled, ${0, $PdmhA.N20})`;
                borderColor = `var(--ds-background-disabled, ${0, $PdmhA.N20})`;
            }
            if (validationState === 'error') borderColor = `var(--ds-border-danger, ${0, $PdmhA.R400})`;
            if (validationState === 'success') borderColor = `var(--ds-border-success, ${0, $PdmhA.G400})`;
            let borderColorHover = isFocused ? `var(--ds-border-focused, ${0, $PdmhA.B100})` : `var(--ds-border-input, ${0, $PdmhA.N100})`;
            if (validationState === 'error') borderColorHover = `var(--ds-border-danger, ${0, $PdmhA.R400})`;
            if (validationState === 'success') borderColorHover = `var(--ds-border-success, ${0, $PdmhA.G400})`;
            const transitionDuration = '200ms';
            if (appearance === 'subtle') {
                borderColor = isFocused ? `var(--ds-border-focused, ${0, $PdmhA.B100})` : 'transparent';
                backgroundColor = isFocused ? `var(--ds-surface, ${0, $PdmhA.N0})` : 'transparent';
                backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $PdmhA.N0})` : `var(--ds-background-input-hovered, ${0, $PdmhA.N30})`;
            }
            if (appearance === 'none') {
                borderColor = 'transparent';
                backgroundColor = 'transparent';
                backgroundColorHover = 'transparent';
                borderColorHover = 'transparent';
            }
            return {
                ...css,
                // Turn pointer events off when disabled - this makes it so hover etc don't work.
                pointerEvents: isDisabled ? 'none' : undefined,
                backgroundColor: backgroundColor,
                borderColor: borderColor,
                borderStyle: 'solid',
                borderRadius: "var(--ds-border-radius-100, 3px)",
                borderWidth: "var(--ds-border-width, 1px)",
                boxShadow: validationState === 'error' ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
                '&:focus-within': {
                    boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
                },
                minHeight: isCompact ? 32 : 40,
                padding: 0,
                transition: `background-color ${transitionDuration} ease-in-out,
        border-color ${transitionDuration} ease-in-out`,
                '::-webkit-scrollbar': {
                    height: 8,
                    width: 8
                },
                '::-webkit-scrollbar-corner': {
                    display: 'none'
                },
                ':hover': {
                    '::-webkit-scrollbar-thumb': {
                        // scrollbars occur only if the user passes in a custom component with overflow: scroll
                        backgroundColor: 'rgba(0,0,0,0.2)'
                    },
                    cursor: 'pointer',
                    backgroundColor: backgroundColorHover,
                    borderColor: borderColorHover
                },
                '::-webkit-scrollbar-thumb:hover': {
                    backgroundColor: 'rgba(0,0,0,0.4)'
                }
            };
        },
        valueContainer: (css)=>({
                ...css,
                paddingLeft: "var(--ds-space-075, 6px)",
                paddingRight: "var(--ds-space-075, 6px)",
                paddingBottom: isCompact ? 0 : 2,
                paddingTop: isCompact ? 0 : 2
            }),
        clearIndicator: (css)=>({
                ...css,
                color: `var(--ds-text-subtlest, ${0, $PdmhA.N70})`,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $PdmhA.N500})`
                }
            }),
        loadingIndicator: (css)=>({
                ...css,
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6
            }),
        dropdownIndicator: (css, { isDisabled: isDisabled })=>{
            let color = `var(--ds-text-subtle, ${(0, $PdmhA.N500)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $PdmhA.N70})`;
            return {
                ...css,
                color: color,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $PdmhA.N200})`
                }
            };
        },
        indicatorsContainer: (css)=>({
                ...css,
                paddingRight: "var(--ds-space-050, 4px)"
            }),
        option: (css, { isFocused: isFocused, isSelected: isSelected, isDisabled: isDisabled })=>{
            let color = `var(--ds-text, ${(0, $PdmhA.N800)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $PdmhA.N70})`;
            else if (isSelected) color = `var(--ds-text-selected, ${0, $PdmhA.B400})`;
            let boxShadow;
            let backgroundColor;
            if (isDisabled) backgroundColor = undefined;
            else if (isSelected && isFocused) backgroundColor = `var(--ds-background-selected-hovered, ${0, $PdmhA.B50})`;
            else if (isSelected) backgroundColor = `var(--ds-background-selected, ${0, $PdmhA.B50})`;
            else if (isFocused) backgroundColor = `var(--ds-background-neutral-subtle-hovered, ${0, $PdmhA.N20})`;
            if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${`var(--ds-border-selected, ${0, $PdmhA.B400})`}`;
            const cursor = isDisabled ? 'not-allowed' : css.cursor;
            return {
                ...css,
                padding: '6px 12px',
                backgroundColor: backgroundColor,
                color: color,
                cursor: cursor,
                boxShadow: boxShadow,
                ':active': {
                    backgroundColor: !isDisabled ? isSelected ? `var(--ds-background-selected-pressed, ${0, $PdmhA.N20})` : `var(--ds-background-neutral-subtle-pressed, ${0, $PdmhA.N30})` : undefined
                },
                '@media screen and (-ms-high-contrast: active)': {
                    borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
                }
            };
        },
        placeholder: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $PdmhA.N300})` : `var(--ds-text-subtlest, ${0, $PdmhA.N200})`
            }),
        singleValue: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $PdmhA.N70})` : `var(--ds-text, ${0, $PdmhA.N800})`,
                ...!(0, $XHGTv.getBooleanFF)('platform.design-system-team.select-new-typography_7m89c') && {
                    lineHeight: '1rem'
                }
            }),
        menu: (css)=>({
                ...css,
                backgroundColor: "var(--ds-surface-overlay, white)",
                boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
            }),
        menuList: (css)=>({
                ...css,
                paddingTop: "var(--ds-space-100, 8px)",
                paddingBottom: "var(--ds-space-100, 8px)"
            }),
        multiValue: (css, { isDisabled: isDisabled, isFocused: isFocused })=>{
            let backgroundColor;
            let color;
            if (isDisabled) {
                // Use the basic neutral background so it is slightly separate from the
                // field's background
                backgroundColor = `var(--ds-background-neutral, ${0, $PdmhA.N40})`;
                color = `var(--ds-text-disabled, ${0, $PdmhA.N70})`;
            } else if (isFocused) {
                backgroundColor = `var(--ds-background-selected, ${0, $PdmhA.N40})`;
                color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
            } else {
                backgroundColor = `var(--ds-background-neutral, ${0, $PdmhA.N40})`;
                color = "var(--ds-text, hsl(0, 0%, 20%))";
            }
            return {
                ...css,
                borderRadius: "var(--ds-border-radius-050, 2px)",
                backgroundColor: backgroundColor,
                boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
                maxWidth: '100%',
                '@media screen and (-ms-high-contrast: active)': {
                    border: isFocused ? '1px solid transparent' : 'none'
                },
                color: color
            };
        },
        multiValueLabel: (css, { isDisabled: isDisabled })=>({
                ...css,
                padding: "var(--ds-space-025, 2px)",
                color: isDisabled ? `var(--ds-text-disabled, ${0, $PdmhA.N70})` : 'inherit',
                paddingRight: "var(--ds-space-025, 2px)"
            }),
        multiValueRemove: (css, { isFocused: isFocused })=>({
                ...css,
                backgroundColor: isFocused ? `var(--ds-UNSAFE-transparent, ${0, $PdmhA.R75})` : undefined,
                fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                borderRadius: '0px 2px 2px 0px',
                // DSP-6470 we should style like Tag once we have the :has selector
                ':hover': {
                    backgroundColor: `var(--ds-background-danger-hovered, ${0, $PdmhA.R75})`,
                    fill: "var(--ds-text-danger, #000)"
                },
                ':active': {
                    backgroundColor: `var(--ds-background-danger-pressed, ${0, $PdmhA.R75})`,
                    fill: "var(--ds-text-danger, #000)"
                }
            }),
        groupHeading: (css)=>({
                ...css,
                ...(0, $XHGTv.getBooleanFF)('platform.design-system-team.select-new-typography_7m89c') && {
                    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
                },
                color: `var(--ds-text-subtle, ${0, $PdmhA.N200})`
            })
    };
}

});

parcelRegister("lT14u", function(module, exports) {

$parcel$export(module.exports, "onFocus", () => $7ccc5140c845bc58$export$ecf9bf35ad97eb74);
$parcel$export(module.exports, "isOptionsGrouped", () => $7ccc5140c845bc58$export$d2756249f53f9f8);
function $7ccc5140c845bc58$export$ecf9bf35ad97eb74(props) {
    const { focused: focused, options: options } = props;
    const isOptionFocused = (option)=>{
        return option === focused;
    };
    const groupData = options?.find((option)=>{
        return option.options?.some(isOptionFocused);
    });
    const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
    return `Option ${focused.label}, ${groupData?.label} group, item ${groupOptionIndex + 1} out of ${groupData?.options.length}. All in all `;
}
const $7ccc5140c845bc58$export$d2756249f53f9f8 = (arr)=>{
    return arr?.every((obj)=>obj.hasOwnProperty('options'));
};

});



const $7e206d83f4cfe846$export$c0ae0768e117bb0e = 10;
const $7e206d83f4cfe846$export$9b2c73c824a302e4 = 5;

parcelRegister("yCziW", function(module, exports) {

$parcel$export(module.exports, "HelpCenterOptionCustomLabel", () => $f6aa7da0a8a4d2da$export$317d9a2165584877);

var $eUqFw = parcelRequire("eUqFw");

var $ffiyv = parcelRequire("ffiyv");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gvAZB = parcelRequire("gvAZB");
const $f6aa7da0a8a4d2da$export$317d9a2165584877 = ({ value: value })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, value), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        xcss: $f6aa7da0a8a4d2da$var$lozengeStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        appearance: "default"
    }, formatMessage((0, $gvAZB.default).default)))));
};
const $f6aa7da0a8a4d2da$var$lozengeStyles = (0, $1ZAYh.xcss)({
    marginLeft: 'space.050'
});

});
parcelRegister("gvAZB", function(module, exports) {

$parcel$export(module.exports, "default", () => $9af359a1a8caae84$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9af359a1a8caae84$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    default: {
        "id": "servicedesk-help-center-select-field.common.help-center-option-custom-label.default",
        "defaultMessage": "Default"
    }
});

});


parcelRegister("12r3d", function(module, exports) {

$parcel$export(module.exports, "HelpMe", () => $2d01b5661baf98ee$export$eea793d1998993d6);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $aUqTb = parcelRequire("aUqTb");

var $29yDk = parcelRequire("29yDk");

var $b5IAe = parcelRequire("b5IAe");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $c9TLT = parcelRequire("c9TLT");
const $2d01b5661baf98ee$export$eea793d1998993d6 = ({ helperText: helperText })=>{
    const [showHelp, setShowHelp] = (0, $eUqFw.useState)(false);
    const helpMeContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $2d01b5661baf98ee$var$helpMeWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        as: "p"
    }, helperText));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $29yDk.default), {
        onClose: ()=>{
            setShowHelp(false);
        },
        content: helpMeContent,
        isOpen: showHelp,
        placement: "top-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        xcss: $2d01b5661baf98ee$var$helpMeButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        "aria-label": "Help",
        appearance: "subtle-link",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aUqTb))), {
            label: "info",
            size: "medium"
        }),
        spacing: "none",
        onMouseOver: ()=>setShowHelp(!showHelp),
        onMouseLeave: ()=>setShowHelp(!showHelp)
    })));
};
const $2d01b5661baf98ee$var$helpMeWrapperStyles = (0, $1ZAYh.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $c9TLT.gridSize) * 24}px`
});
const $2d01b5661baf98ee$var$helpMeButtonStyles = (0, $1ZAYh.xcss)({
    verticalAlign: 'middle'
});

});
parcelRegister("aUqTb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7f13fdf9f823d771$var$_react = $7f13fdf9f823d771$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $7f13fdf9f823d771$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $7f13fdf9f823d771$var$EditorPanelIcon = (props)=>/*#__PURE__*/ $7f13fdf9f823d771$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12 19a7 7 0 110-14 7 7 0 010 14zm0-1.5a5.5 5.5 0 100-11 5.5 5.5 0 000 11zm0-6a1 1 0 011 1v2a1 1 0 01-2 0v-2a1 1 0 011-1zm0-3a1 1 0 110 2 1 1 0 010-2z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$7f13fdf9f823d771$var$EditorPanelIcon.displayName = 'EditorPanelIcon';
var $7f13fdf9f823d771$var$_default = $7f13fdf9f823d771$var$EditorPanelIcon;
module.exports.default = $7f13fdf9f823d771$var$_default;

});


parcelRegister("iJNtC", function(module, exports) {

$parcel$export(module.exports, "useHelpCenterFetchService", () => $b5c1377e68df52ce$export$8581cb4ff7245d45);

var $eGabw = parcelRequire("eGabw");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $cNy9K = parcelRequire("cNy9K");

var $cPGDt = parcelRequire("cPGDt");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $4rWQe = parcelRequire("4rWQe");
var $dWLk9 = parcelRequire("dWLk9");


var $1v2pF = parcelRequire("1v2pF");

var $hCPs4 = parcelRequire("hCPs4");
const $b5c1377e68df52ce$export$8581cb4ff7245d45 = ()=>{
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [data, setData] = (0, $eUqFw.useState)([]);
    const [error, setError] = (0, $eUqFw.useState)(null);
    const [after, setAfter] = (0, $eUqFw.useState)(undefined);
    const [page, setPage] = (0, $eUqFw.useState)(0);
    const [hasNext, setHasMore] = (0, $eUqFw.useState)(false);
    const environment = (0, $iWLL0.useRelayEnvironment)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const activationId = (0, $4rWQe.useActivationId)();
    const workSpaceAri = (0, $cPGDt.JiraWorkspaceAri).create({
        siteId: cloudId,
        activationId: activationId
    });
    const helpCenterData = (0, $cNy9K.fetchQuery)(environment, (0, $eGabw.default), {
        first: (0, $7e206d83f4cfe846$export$c0ae0768e117bb0e),
        cloudId: cloudId,
        workspaceAri: workSpaceAri.toString(),
        SORT_ORDER: 'CREATED_DATE_ASCENDING',
        after: after
    }, {
        fetchPolicy: 'store-or-network'
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const fetch = (0, $eUqFw.useCallback)(async ()=>{
        (0, $hCPs4.helpCenterFetchExperience).start();
        let helpCenters = [];
        setIsLoading(true);
        setError(null);
        await helpCenterData.toPromise().then((res)=>{
            const helpCentersList = res?.helpCenter?.helpCenters;
            const errorNodes = helpCentersList?.nodes;
            if (!helpCentersList) // This could occur when the request did not reach Kosh and failed at AGG
            throw new Error(`Missing required fields in helpCenterFetchQuery response, possibly an AGG error. ${JSON.stringify(res)}`);
            else if (helpCentersList?.__typename === 'HelpCenterQueryResultConnection') {
                helpCenters = helpCentersList.edges?.filter((hc)=>hc?.node?.name?.default && hc?.node?.id).map((hc)=>{
                    const name = hc?.node?.name?.default || '';
                    const slug = hc?.node?.slug || null;
                    const helpCenterAri = hc?.node?.id || '';
                    return {
                        name: name,
                        slug: slug,
                        helpCenterAri: helpCenterAri
                    };
                }) || [];
                setData(helpCenters);
                setAfter(helpCentersList.pageInfo?.endCursor || undefined);
                setHasMore(helpCentersList.pageInfo?.hasNextPage || false);
                setPage(page + 1);
                setIsLoading(false);
                (0, $hCPs4.helpCenterFetchExperience).success();
                const analyticsEvent = createAnalyticsEvent({});
                (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'jsmHelpCenterFetch succeeded', {
                    helpCentersCount: helpCenters.length,
                    page: page
                });
            } else if (Array.isArray(errorNodes) && errorNodes[0].__typename === 'QueryError') {
                const { message: message, identifier: identifier, extensions: extensions } = errorNodes[0];
                const { statusCode: statusCode, errorType: errorType } = extensions?.[0] || {};
                const err = new Error(`QueryError: ${JSON.stringify({
                    message: message,
                    identifier: identifier,
                    statusCode: statusCode,
                    errorType: errorType
                })}`);
                err.statusCode = statusCode ? Number(statusCode) : undefined;
                throw err;
            } else throw new Error(`Unknown error occurred ${JSON.stringify(res)}`);
        }).catch((err)=>{
            setError(err);
            setIsLoading(false);
            (0, $hCPs4.helpCenterFetchExperience).failure();
        });
        return helpCenters;
    }, [
        createAnalyticsEvent,
        helpCenterData,
        page
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (error) (0, $1v2pF.logError)(error);
    }, [
        error
    ]);
    return {
        isLoading: isLoading,
        error: error,
        data: data,
        after: after,
        hasNext: hasNext,
        fetch: fetch
    };
};

});
parcelRegister("eGabw", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c52a8c135c00cc6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<600d7442f15f4a40d29f41a1084dacd6>>
 * @relayHash 4e079704002ecfaadcb864b248ac074d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9dd44a542e3ffa79060b2c2cde60374e5e945816ebbb26ec6f1f03c228492e44
const $4c52a8c135c00cc6$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "SORT_ORDER"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "workspaceAri"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v6 = {
        "kind": "Variable",
        "name": "sortOrder",
        "variableName": "SORT_ORDER"
    }, v7 = {
        "kind": "Variable",
        "name": "workspaceAri",
        "variableName": "workspaceAri"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "InlineFragment",
        "selections": [
            v9 /*: any*/ ,
            {
                "concreteType": "HelpCenterName",
                "kind": "LinkedField",
                "name": "name",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "default"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "slug"
            }
        ],
        "type": "HelpCenter"
    }, v11 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v12 = {
        "kind": "ScalarField",
        "name": "message"
    }, v13 = {
        "kind": "ScalarField",
        "name": "identifier"
    }, v14 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v15 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v16 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v17 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        v6 /*: any*/ ,
        v7 /*: any*/ 
    ], v18 = {
        "kind": "InlineFragment",
        "selections": [
            v9 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "helpCenterFetchQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "helpCenters",
                            "args": [
                                v6 /*: any*/ ,
                                v7 /*: any*/ 
                            ],
                            "concreteType": "HelpCenterQueryResultConnection",
                            "kind": "LinkedField",
                            "name": "__multiHcDropdownContentFragment_helpCenters_connection",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "concreteType": "HelpCenterQueryResultEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        },
                                        v11 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v12 /*: any*/ ,
                                                v13 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": true,
                                                    "selections": [
                                                        v14 /*: any*/ ,
                                                        v15 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                },
                                v16 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "helpCenterFetchQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v17 /*: any*/ ,
                            "concreteType": "HelpCenterQueryResultConnection",
                            "kind": "LinkedField",
                            "name": "helpCenters",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "concreteType": "HelpCenterQueryResultEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                v10 /*: any*/ ,
                                                v18 /*: any*/ 
                                            ]
                                        },
                                        v11 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v12 /*: any*/ ,
                                                v13 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": true,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        v15 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "QueryError"
                                        },
                                        v18 /*: any*/ 
                                    ]
                                },
                                v16 /*: any*/ 
                            ]
                        },
                        {
                            "args": v17 /*: any*/ ,
                            "filters": [
                                "workspaceAri",
                                "sortOrder"
                            ],
                            "handle": "connection",
                            "key": "multiHcDropdownContentFragment_helpCenters",
                            "kind": "LinkedHandle",
                            "name": "helpCenters"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9dd44a542e3ffa79060b2c2cde60374e5e945816ebbb26ec6f1f03c228492e44",
            "metadata": {
                "connection": [
                    {
                        "count": "first",
                        "cursor": "after",
                        "direction": "forward",
                        "path": [
                            "helpCenter",
                            "helpCenters"
                        ]
                    }
                ]
            },
            "name": "helpCenterFetchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$4c52a8c135c00cc6$var$node.hash = "0efd5ddafccbf9644af93c0d9a8ea221";
var $4c52a8c135c00cc6$export$2e2bcd8739ae039 = $4c52a8c135c00cc6$var$node;

});

parcelRegister("1v2pF", function(module, exports) {

$parcel$export(module.exports, "logError", () => $2e5176428a6081d3$export$58da9968c3170cb1);

var $guiFP = parcelRequire("guiFP");
const $2e5176428a6081d3$export$1a5a4674dd906e7e = (statusCode)=>statusCode === 0;
const $2e5176428a6081d3$export$d31fd506ce75fa65 = (statusCode)=>statusCode >= 400 && statusCode < 500;
const $2e5176428a6081d3$export$53ee51427129200c = (statusCode)=>$2e5176428a6081d3$export$1a5a4674dd906e7e(statusCode) || $2e5176428a6081d3$export$d31fd506ce75fa65(statusCode);
const $2e5176428a6081d3$export$58da9968c3170cb1 = (err)=>{
    if ($2e5176428a6081d3$export$53ee51427129200c(Number(err.statusCode))) return;
    (0, $guiFP.default)({
        meta: {
            id: 'helpCenterFetchService',
            packageName: 'jiraServicedeskHelpCenterSelectField',
            teamName: 'jsm-megatron'
        },
        error: err,
        sendToPrivacyUnsafeSplunk: true
    });
};
const $2e5176428a6081d3$export$2b62e563f0fadcee = (statusCode)=>statusCode === 0 || statusCode >= 400 && statusCode < 500;

});

parcelRegister("hCPs4", function(module, exports) {

$parcel$export(module.exports, "helpCenterFetchExperience", () => $a11fb7e70c6fd30e$export$191cbf8bc5a77d43);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
const $a11fb7e70c6fd30e$export$191cbf8bc5a77d43 = new (0, $kDfSL.UFOExperience)('jsm-help-center-data-fetch', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult
});

});


parcelRegister("1RhQ9", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f91f8ff9c94d0e8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1f91f8ff9c94d0e8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    addToHelpCenterUpdated: {
        "id": "servicedesk-help-center-select-field.add-to-help-center-updated",
        "defaultMessage": "Choose help center"
    },
    info: {
        "id": "servicedesk-help-center-select-field.info",
        "defaultMessage": "Customers will receive a link to this help center in the invitation email. However, they\u2019ll still be able to access other help centers on your site."
    },
    placeHolder: {
        "id": "servicedesk-help-center-select-field.place-holder",
        "defaultMessage": "Choose a help center"
    },
    somethingWentWrong: {
        "id": "servicedesk-help-center-select-field.something-went-wrong",
        "defaultMessage": "Something went wrong. Check your connection, then give it another try."
    }
});

});


parcelRegister("cZz4A", function(module, exports) {

$parcel$export(module.exports, "CustomerNotificationHelpText", () => $be730c3e052e7a8d$export$d881b2d295b47b14);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $2bv8J = parcelRequire("2bv8J");

var $PdmhA = parcelRequire("PdmhA");

var $giAhk = parcelRequire("giAhk");

var $5DQ8u = parcelRequire("5DQ8u");

var $jss65 = parcelRequire("jss65");
const $be730c3e052e7a8d$export$23259d84ca627877 = ({ intl: { formatMessage: formatMessage }, isOutgoingMailEnabled: isOutgoingMailEnabled, isInviteEmailEnabled: isInviteEmailEnabled, isAdmin: isAdmin, isMultiHcAndInviteRoutingEnabled: isMultiHcAndInviteRoutingEnabled = false })=>{
    const inviteEmailDescription = isMultiHcAndInviteRoutingEnabled ? formatMessage((0, $5DQ8u.default).updatedCustomersWillReceiveHelpCenterEmail) : formatMessage((0, $5DQ8u.default).updatedCustomersWillReceiveEmail);
    if (isInviteEmailEnabled && isOutgoingMailEnabled && isAdmin) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, inviteEmailDescription, " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jss65.CustomerNotificationHelpTextForAdminLink), null));
    if (isInviteEmailEnabled && isOutgoingMailEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, inviteEmailDescription, " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, formatMessage((0, $5DQ8u.default).notificationsForNonAdmin)));
    if (!isInviteEmailEnabled && isAdmin) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($be730c3e052e7a8d$var$LabelContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2bv8J))), {
        label: "",
        primaryColor: `var(--ds-icon-discovery, ${(0, $PdmhA).P300})`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($be730c3e052e7a8d$var$Label, null, formatMessage((0, $5DQ8u.default).invitationNotificationDisabled), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jss65.ViewConfigurationLink), null))));
    if (!isInviteEmailEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($be730c3e052e7a8d$var$LabelContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2bv8J))), {
        label: "",
        primaryColor: `var(--ds-icon-discovery, ${(0, $PdmhA).P300})`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($be730c3e052e7a8d$var$Label, null, formatMessage((0, $5DQ8u.default).viewConfigurationForNonAdmin)));
    return null;
};
$be730c3e052e7a8d$export$23259d84ca627877.defaultProps = {
    isOutgoingMailEnabled: false,
    isInviteEmailEnabled: false,
    isAdmin: false
};
const $be730c3e052e7a8d$export$d881b2d295b47b14 = (0, $giAhk.injectIntlV2)($be730c3e052e7a8d$export$23259d84ca627877); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $be730c3e052e7a8d$var$LabelContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvrv2br",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $be730c3e052e7a8d$var$Label = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _4cvrv2br _18u0u2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5DQ8u", function(module, exports) {

$parcel$export(module.exports, "default", () => $5724ff717772ffa1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5724ff717772ffa1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    notificationsForNonAdmin: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.form.fields.customer-notification-help-text.notifications-for-non-admin",
        "defaultMessage": "Project admins can disable or customize invitation emails."
    },
    invitationNotificationDisabled: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.form.fields.customer-notification-help-text.invitation-notification-disabled",
        "defaultMessage": "You have disabled the invitation email to customers."
    },
    viewConfigurationForAdmin: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.form.fields.customer-notification-help-text.view-configuration-for-admin",
        "defaultMessage": "View configuration"
    },
    viewConfigurationForNonAdmin: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.form.fields.customer-notification-help-text.view-configuration-for-non-admin",
        "defaultMessage": "The project admin has disabled the invitation email to customers."
    },
    updatedCustomersWillReceiveEmail: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.form.fields.customer-notification-help-text.updated-customers-will-receive-email",
        "defaultMessage": "Customers will receive an invitation email if they haven\u2019t already been added to a project on this site."
    },
    updatedCustomersWillReceiveHelpCenterEmail: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.form.fields.customer-notification-help-text.updated-customers-will-receive-help-center-email",
        "defaultMessage": "Customers will receive an invitation email if they haven\u2019t been added to your site yet. Once signed up, they\u2019ll be directed to the chosen help center."
    },
    updatedNotificationsForAdmin: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.form.fields.customer-notification-help-text.updated-notifications-for-admin",
        "defaultMessage": "{tagStart}Customize your invitation email{tagEnd}."
    },
    updatedNotificationsForAdminNew: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.form.fields.customer-notification-help-text.updated-notifications-for-admin-new",
        "defaultMessage": "Customize your invitation email."
    }
});

});

parcelRegister("jss65", function(module, exports) {

$parcel$export(module.exports, "CustomerNotificationHelpTextForAdminLink", () => $58cf93759a6642a0$export$cf6065b11ab148db);
$parcel$export(module.exports, "ViewConfigurationLink", () => $58cf93759a6642a0$export$a106611cd7bc2989);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $1ybV0 = parcelRequire("1ybV0");

var $giAhk = parcelRequire("giAhk");
var $5JgJ2 = parcelRequire("5JgJ2");

var $7d1RI = parcelRequire("7d1RI");

var $1H7E7 = parcelRequire("1H7E7");

var $5DQ8u = parcelRequire("5DQ8u");
const $58cf93759a6642a0$export$cf6065b11ab148db = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { baseUrl: baseUrl, projectKey: projectKey } = (0, $7d1RI.useCommonPageContext)();
    const customerNotificationLink = `${baseUrl}/jira/servicedesk/projects/${projectKey}/settings/customer-notifications/account-notification/invite-customer`;
    const notificationMsg = (0, $5DQ8u.default).updatedNotificationsForAdmin;
    return (0, $1ybV0.ff)('jsm-csm-a11y-fixes_ho588') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "link",
        spacing: "none",
        target: "_blank",
        href: customerNotificationLink
    }, formatMessage((0, $5DQ8u.default).updatedNotificationsForAdminNew)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1H7E7.default), {
        ...notificationMsg,
        values: {
            tagStart: `<a href="${customerNotificationLink}" target="_blank"/>`,
            tagEnd: '</a>'
        }
    });
};
const $58cf93759a6642a0$var$ConfigurationLinkView = ({ intl: { formatMessage: formatMessage } })=>{
    const { baseUrl: baseUrl, projectKey: projectKey } = (0, $7d1RI.useCommonPageContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "link",
        spacing: "none",
        href: `${baseUrl}/jira/servicedesk/projects/${projectKey}/settings/customer-notifications/account-notification/invite-customer`
    }, formatMessage((0, $5DQ8u.default).viewConfigurationForAdmin));
};
const $58cf93759a6642a0$export$a106611cd7bc2989 = (0, $giAhk.injectIntlV2)($58cf93759a6642a0$var$ConfigurationLinkView);

});


parcelRegister("erYQo", function(module, exports) {

$parcel$export(module.exports, "DynamicInputField", () => $c70f5b1253bc47c7$export$27f2f893e71eab06);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $4LhB6 = parcelRequire("4LhB6");

var $gO9Xw = parcelRequire("gO9Xw");

var $aUqTb = parcelRequire("aUqTb");

var $29yDk = parcelRequire("29yDk");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $c9TLT = parcelRequire("c9TLT");

var $giAhk = parcelRequire("giAhk");

var $7DTLe = parcelRequire("7DTLe");

var $1l35M = parcelRequire("1l35M");

var $dgUkL = parcelRequire("dgUkL");
var $cYWvB = parcelRequire("cYWvB");

var $hBBzI = parcelRequire("hBBzI");

var $fsAzS = parcelRequire("fsAzS");

var $hjxMV = parcelRequire("hjxMV");
const $c70f5b1253bc47c7$export$d1d17b110fe0be6e = ({ intl: { formatMessage: formatMessage } })=>{
    const { email: email, emails: emails, showInput: showInput, showHelp: showHelp, setShowHelp: setShowHelp, isValidating: isValidating, failed: failed, failedWithErrors: failedWithErrors, showErrorFlag: showErrorFlag, setEmailOnChange: // Methods
    setEmailOnChange, handleOnRemoved: handleOnRemoved, handleAddMore: handleAddMore, handleOnKeyDown: handleOnKeyDown, setShowErrorFlag: setShowErrorFlag } = (0, $cYWvB.useDynamicInputHook)();
    const helpMeContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $c70f5b1253bc47c7$var$helpMeWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $fsAzS.default).info)));
    const renderHelpMe = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $29yDk.default), {
            onClose: ()=>{
                setShowHelp(false);
            },
            content: helpMeContent,
            isOpen: showHelp,
            placement: "top-start"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            as: "span",
            xcss: $c70f5b1253bc47c7$var$helpMeButtonStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            "aria-label": "Help",
            appearance: "subtle-link",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aUqTb))), {
                label: "info",
                size: "medium"
            }),
            spacing: "none",
            onMouseOver: ()=>setShowHelp(!showHelp),
            onMouseLeave: ()=>setShowHelp(!showHelp)
        })));
    const addMoreButtonProps = {
        'aria-label': 'Add More',
        appearance: 'subtle-link',
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gO9Xw))), {
            label: "add",
            size: "small"
        }),
        spacing: 'none',
        isDisabled: isValidating,
        onClick: handleAddMore,
        testId: 'servicedesk-customers-organization-common.ui.add-customers-dialog.form.fields.dynamic-input-field.add-more-button'
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        name: "customer-emails-field",
        label: formatMessage((0, $fsAzS.default).customerEmails),
        isRequired: true
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, renderHelpMe(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hBBzI.InputListView), {
            inputs: emails,
            onRemoved: handleOnRemoved
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1l35M.MultiLineText), {
            isInvalid: failed.length > 0,
            isMultiline: !showInput,
            isValidating: isValidating,
            value: email,
            onKeyDown: handleOnKeyDown,
            setEmailOnChange: setEmailOnChange
        }))), showErrorFlag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7DTLe.AsyncInviteFailed), {
        failedEmails: (0, $hjxMV.transformToInviteFailedEmails)(failedWithErrors),
        onClosed: ()=>setShowErrorFlag(false)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $c70f5b1253bc47c7$var$addMoreStyles
    }, isValidating ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        ...addMoreButtonProps,
        className: (0, $7JEyt.default)([
            "_80omggyl"
        ])
    }, "\xa0Add") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), addMoreButtonProps, "\xa0Add")));
};
$c70f5b1253bc47c7$export$d1d17b110fe0be6e.defaultProps = {
    useAddCustomersDialogContext: (0, $dgUkL.useAddCustomersDialogContext)
};
const $c70f5b1253bc47c7$export$27f2f893e71eab06 = (0, $giAhk.injectIntlV2)($c70f5b1253bc47c7$export$d1d17b110fe0be6e);
const $c70f5b1253bc47c7$var$addMoreStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    justifyContent: 'right',
    marginTop: 'space.050',
    marginBottom: 'space.050'
});
const $c70f5b1253bc47c7$var$helpMeWrapperStyles = (0, $1ZAYh.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $c9TLT.gridSize) * 24}px`
});
const $c70f5b1253bc47c7$var$helpMeButtonStyles = (0, $1ZAYh.xcss)({
    verticalAlign: 'middle'
});

});
parcelRegister("1l35M", function(module, exports) {

$parcel$export(module.exports, "MultiLineText", () => $c490c43a9212c1e2$export$759041031fe19470);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $xeS7R = parcelRequire("xeS7R");

var $5JgJ2 = parcelRequire("5JgJ2");

var $5Dz3q = parcelRequire("5Dz3q");
const $c490c43a9212c1e2$export$759041031fe19470 = ({ isInvalid: isInvalid, isMultiline: isMultiline = false, isValidating: isValidating, value: value, onKeyDown: onKeyDown, setEmailOnChange: setEmailOnChange })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c490c43a9212c1e2$export$3cf7de0b39bab18b, {
        isMultiline: isMultiline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $xeS7R.default), {
        "aria-label": formatMessage((0, $5Dz3q.default).placeHolder),
        resize: "vertical",
        name: "customer-emails-multiple",
        value: value,
        onChange: (event)=>setEmailOnChange(event.target.value),
        placeholder: formatMessage((0, $5Dz3q.default).placeHolder),
        isCompact: true // @ts-expect-error - TS2322 - Type '(event: KeyboardEvent) => void' is not assignable to type 'KeyboardEventHandler<HTMLTextAreaElement>'.
        ,
        onKeyDown: onKeyDown,
        isReadOnly: isValidating,
        isInvalid: isInvalid,
        testId: "servicedesk-customers-organization-common.common.ui.multiline-text.dynamic-input"
    }));
};
const $c490c43a9212c1e2$export$3cf7de0b39bab18b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isMultiline: isMultiline, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.isMultiline ? "_74a41pg8" : "_17ocglyw _12ew1a66 _1aqv9w6u",
            __cmplp.className
        ])
    });
});

});
parcelRegister("xeS7R", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fe3143162b284fd$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $dkGpW = parcelRequire("dkGpW");
const $2fe3143162b284fd$var$packageName = "platform-pkg";
const $2fe3143162b284fd$var$packageVersion = "0.0.0-use.local";
const $2fe3143162b284fd$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $2fe3143162b284fd$var$packageName,
    packageVersion: $2fe3143162b284fd$var$packageVersion
};
const $2fe3143162b284fd$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = (0, $dkGpW.borderWidth);
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $2fe3143162b284fd$var$InnerTextArea = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const ourRef = (0, $eUqFw.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, ...rest } = props;
    (0, $eUqFw.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $2fe3143162b284fd$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$2fe3143162b284fd$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$2fe3143162b284fd$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $eUqFw.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $2fe3143162b284fd$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const baseStyles = (0, $eUqFw.useMemo)(()=>(0, $dkGpW.getBaseStyles)({
            minimumRows: minimumRows,
            resize: resize,
            appearance: appearance,
            isMonospaced: isMonospaced,
            maxHeight: maxHeight
        }), [
        minimumRows,
        resize,
        appearance,
        isMonospaced,
        maxHeight
    ]);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-array-arguments, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    const textAreaStyles = /*#__PURE__*/ (0, $byn9U.css)([
        baseStyles,
        (0, $dkGpW.dynamicStyles)(appearance)
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        // TODO refactor to follow emotion styling rules
        // see: https://product-fabric.atlassian.net/browse/DSP-6060
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: textAreaStyles,
        ...rest
    });
});
/**
 * __Text area__
 *
 * A text area lets users enter long form text which spans over multiple lines.
 *
 * - [Examples](https://atlassian.design/components/textarea/examples)
 * - [Code](https://atlassian.design/components/textarea/code)
 * - [Usage](https://atlassian.design/components/textarea/usage)
 */ const $2fe3143162b284fd$var$TextArea = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, $byn9U.jsx)($2fe3143162b284fd$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$2fe3143162b284fd$var$TextArea.displayName = 'TextArea';
var $2fe3143162b284fd$export$2e2bcd8739ae039 = $2fe3143162b284fd$var$TextArea;

});
parcelRegister("dkGpW", function(module, exports) {

$parcel$export(module.exports, "borderWidth", () => $ffa47244c710aa2a$export$12879c7697ed953d);
$parcel$export(module.exports, "getBaseStyles", () => $ffa47244c710aa2a$export$bff8031d86bb089);
$parcel$export(module.exports, "dynamicStyles", () => $ffa47244c710aa2a$export$98856a888ef36079);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $9rnqv = parcelRequire("9rnqv");
function $ffa47244c710aa2a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ffa47244c710aa2a$var$disabledRules = {
    backgroundColor: $9rnqv.disabledBackground,
    backgroundColorFocus: $9rnqv.disabledBackground,
    backgroundColorHover: $9rnqv.disabledBackground,
    borderColor: $9rnqv.disabledBorder,
    borderColorFocus: $9rnqv.defaultBorderColorFocus,
    textColor: $9rnqv.disabledTextColor
};
const $ffa47244c710aa2a$var$invalidRules = {
    borderColor: $9rnqv.invalidBorderColor,
    borderColorFocus: $9rnqv.defaultBorderColorFocus,
    backgroundColor: $9rnqv.defaultBackgroundColor,
    backgroundColorFocus: $9rnqv.defaultBackgroundColorFocus,
    backgroundColorHover: $9rnqv.defaultBackgroundColorHover
};
const $ffa47244c710aa2a$var$backgroundColor = {
    standard: $9rnqv.defaultBackgroundColor,
    subtle: $9rnqv.transparent,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$backgroundColorFocus = {
    standard: $9rnqv.defaultBackgroundColorFocus,
    subtle: $9rnqv.defaultBackgroundColorFocus,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$backgroundColorHover = {
    standard: $9rnqv.defaultBackgroundColorHover,
    subtle: $9rnqv.defaultBackgroundColorHover,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$borderColor = {
    standard: $9rnqv.defaultBorderColor,
    subtle: $9rnqv.transparent,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$borderColorFocus = {
    standard: $9rnqv.defaultBorderColorFocus,
    subtle: $9rnqv.defaultBorderColorFocus,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$borderColorHover = {
    standard: $9rnqv.defaultBorderColor,
    subtle: $9rnqv.subtleBorderColorHover,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$lineHeightBase = 20;
const $ffa47244c710aa2a$var$lineHeightCompact = 16;
const $ffa47244c710aa2a$var$compactVerticalPadding = 2;
const $ffa47244c710aa2a$var$verticalPadding = 6;
const $ffa47244c710aa2a$var$horizontalPadding = 8;
const $ffa47244c710aa2a$var$transitionDuration = '0.2s';
const $ffa47244c710aa2a$var$fontFamily = "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)";
const $ffa47244c710aa2a$var$codeFontFamily = "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)";
const $ffa47244c710aa2a$export$12879c7697ed953d = 2;
// Safari puts on some difficult to remove styles, mainly for disabled inputs
// but we want full control so need to override them in all cases
const $ffa47244c710aa2a$var$overrideSafariDisabledStyles = {
    WebkitTextFillColor: 'unset',
    WebkitOpacity: '1'
};
const $ffa47244c710aa2a$var$borderBoxMinHeight = (minimumRows, borderHeight)=>{
    const contentHeight = $ffa47244c710aa2a$var$lineHeightBase * minimumRows;
    return contentHeight + $ffa47244c710aa2a$var$verticalPadding * 2 + borderHeight * 2;
};
const $ffa47244c710aa2a$var$borderBoxMinHeightCompact = (minimumRows, borderHeight)=>{
    const contentHeightCompact = $ffa47244c710aa2a$var$lineHeightCompact * minimumRows;
    return contentHeightCompact + $ffa47244c710aa2a$var$compactVerticalPadding * 2 + borderHeight * 2;
};
const $ffa47244c710aa2a$var$bgAndBorderColorStyles = (appearance)=>appearance && /*#__PURE__*/ (0, $byn9U.css)({
        '&:focus': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $ffa47244c710aa2a$var$backgroundColorFocus[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $ffa47244c710aa2a$var$borderColorFocus[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$ffa47244c710aa2a$var$borderColorFocus[appearance]}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $ffa47244c710aa2a$var$backgroundColor[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $ffa47244c710aa2a$var$borderColor[appearance]
        },
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-invalid]:focus': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $ffa47244c710aa2a$var$invalidRules.backgroundColorFocus,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $ffa47244c710aa2a$var$invalidRules.borderColorFocus,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$ffa47244c710aa2a$var$invalidRules.borderColorFocus}`
        },
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-invalid]:not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $ffa47244c710aa2a$var$invalidRules.backgroundColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $ffa47244c710aa2a$var$invalidRules.borderColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$ffa47244c710aa2a$var$invalidRules.borderColor}`
        },
        // Disabled background and border styles should not be applied to components that
        // have either no background or transparent background to begin with
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...appearance === 'standard' ? {
            '&:disabled:focus': {
                backgroundColor: $ffa47244c710aa2a$var$disabledRules.backgroundColorFocus,
                borderColor: $ffa47244c710aa2a$var$disabledRules.borderColorFocus
            },
            '&:disabled:not(:focus)': {
                backgroundColor: $ffa47244c710aa2a$var$disabledRules.backgroundColor,
                borderColor: $ffa47244c710aa2a$var$disabledRules.borderColor
            }
        } : {}
    });
const $ffa47244c710aa2a$var$placeholderStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&::placeholder': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $9rnqv.placeholderTextColor
    },
    '&:disabled::placeholder': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $ffa47244c710aa2a$var$disabledRules.textColor
    }
});
const $ffa47244c710aa2a$var$hoverBackgroundAndBorderStyles = (appearance)=>appearance && /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:hover:not(:read-only):not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $ffa47244c710aa2a$var$backgroundColorHover[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $ffa47244c710aa2a$var$borderColorHover[appearance],
            '&:disabled': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                backgroundColor: $ffa47244c710aa2a$var$disabledRules.backgroundColorHover
            },
            // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&[data-invalid]': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                backgroundColor: $ffa47244c710aa2a$var$invalidRules.backgroundColorHover,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderColor: $ffa47244c710aa2a$var$invalidRules.borderColor,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$ffa47244c710aa2a$var$invalidRules.borderColor}`
            }
        }
    });
var $ffa47244c710aa2a$var$_ref = {
    name: "utehjx",
    styles: "resize:none"
};
var $ffa47244c710aa2a$var$_ref2 = {
    name: "bolgb9",
    styles: "resize:both"
};
const $ffa47244c710aa2a$var$resizeStyle = (resize)=>{
    if (resize === 'horizontal' || resize === 'vertical') // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $byn9U.css)({
        resize: resize
    });
    if (resize === 'auto') return $ffa47244c710aa2a$var$_ref2;
    return $ffa47244c710aa2a$var$_ref;
};
const $ffa47244c710aa2a$var$borderStyle = (appearance)=>/*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderStyle: appearance === 'none' ? 'none' : 'solid'
    });
const $ffa47244c710aa2a$var$fontFamilyStyle = (isMonospaced)=>/*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        fontFamily: isMonospaced ? $ffa47244c710aa2a$var$codeFontFamily : $ffa47244c710aa2a$var$fontFamily
    });
const $ffa47244c710aa2a$var$borderPaddingAndHeightStyles = (minimumRows = 1, appearance)=>{
    const borderWidth = appearance !== 'none' ? 1 : 2;
    const horizontalPaddingWithoutBorderWidth = $ffa47244c710aa2a$var$horizontalPadding - borderWidth;
    const borderHeight = borderWidth;
    return /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-compact]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            minHeight: $ffa47244c710aa2a$var$borderBoxMinHeightCompact(minimumRows, borderHeight),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            padding: `${$ffa47244c710aa2a$var$compactVerticalPadding}px ${horizontalPaddingWithoutBorderWidth}px`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values
            lineHeight: $ffa47244c710aa2a$var$lineHeightCompact / 14
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:not([data-compact])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            minHeight: $ffa47244c710aa2a$var$borderBoxMinHeight(minimumRows, borderHeight),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            padding: `${$ffa47244c710aa2a$var$verticalPadding}px ${horizontalPaddingWithoutBorderWidth}px`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values
            lineHeight: $ffa47244c710aa2a$var$lineHeightBase / 14
        }
    });
};
const $ffa47244c710aa2a$var$staticStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'block',
    boxSizing: 'border-box',
    width: '100%',
    minWidth: 0,
    maxWidth: '100%',
    margin: 0,
    position: 'relative',
    flex: '1 1 100%',
    borderRadius: "var(--ds-border-radius, 3px)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    borderWidth: 1,
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    outline: 'none',
    overflow: 'auto',
    transition: `background-color ${$ffa47244c710aa2a$var$transitionDuration} ease-in-out,
               border-color ${$ffa47244c710aa2a$var$transitionDuration} ease-in-out`,
    wordWrap: 'break-word',
    '&:disabled': {
        cursor: 'not-allowed',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$ffa47244c710aa2a$var$overrideSafariDisabledStyles
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-ms-clear': {
        display: 'none'
    },
    '&:invalid': {
        boxShadow: 'none'
    }
});
const $ffa47244c710aa2a$export$bff8031d86bb089 = ({ minimumRows: minimumRows, resize: resize, appearance: appearance, isMonospaced: isMonospaced, maxHeight: maxHeight })=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $byn9U.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$staticStyles, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$borderPaddingAndHeightStyles(minimumRows, appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$resizeStyle(resize), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$borderStyle(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$fontFamilyStyle(isMonospaced), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    {
        maxHeight: maxHeight
    });
const $ffa47244c710aa2a$export$98856a888ef36079 = (appearance)=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $byn9U.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$bgAndBorderColorStyles(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$hoverBackgroundAndBorderStyles(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$placeholderStyles, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $9rnqv.textColor,
        '&:disabled': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: $ffa47244c710aa2a$var$disabledRules.textColor
        }
    });

});
parcelRegister("9rnqv", function(module, exports) {

$parcel$export(module.exports, "disabledBackground", () => $f5064939140dcbf4$export$ae3cba7672df0890);
$parcel$export(module.exports, "disabledBorder", () => $f5064939140dcbf4$export$fe505fe3c5edbdf6);
$parcel$export(module.exports, "invalidBorderColor", () => $f5064939140dcbf4$export$7f333bbf7ddab792);
$parcel$export(module.exports, "defaultBorderColor", () => $f5064939140dcbf4$export$dafd83031c202ca8);
$parcel$export(module.exports, "defaultBorderColorFocus", () => $f5064939140dcbf4$export$e8320c09dc1e4012);
$parcel$export(module.exports, "defaultBackgroundColor", () => $f5064939140dcbf4$export$b13414ee9ac9cae6);
$parcel$export(module.exports, "defaultBackgroundColorHover", () => $f5064939140dcbf4$export$bca15982c103d57b);
$parcel$export(module.exports, "defaultBackgroundColorFocus", () => $f5064939140dcbf4$export$21287e4b7f134f09);
$parcel$export(module.exports, "subtleBorderColorHover", () => $f5064939140dcbf4$export$a87538d56ee366ec);
$parcel$export(module.exports, "placeholderTextColor", () => $f5064939140dcbf4$export$5e076b2557ef7bbb);
$parcel$export(module.exports, "textColor", () => $f5064939140dcbf4$export$32f78bffcd82ff28);
$parcel$export(module.exports, "disabledTextColor", () => $f5064939140dcbf4$export$eb4a7d363eec53c8);
$parcel$export(module.exports, "transparent", () => $f5064939140dcbf4$export$f4d082c200a4b4b8);

var $PdmhA = parcelRequire("PdmhA");
const $f5064939140dcbf4$export$ae3cba7672df0890 = `var(--ds-background-disabled, ${(0, $PdmhA.N20)})`;
const $f5064939140dcbf4$export$fe505fe3c5edbdf6 = `var(--ds-border-disabled, ${(0, $PdmhA.N40)})`;
const $f5064939140dcbf4$export$7f333bbf7ddab792 = `var(--ds-border-danger, ${(0, $PdmhA.R400)})`;
const $f5064939140dcbf4$export$dafd83031c202ca8 = `var(--ds-border-input, ${(0, $PdmhA.N100)})`;
const $f5064939140dcbf4$export$e8320c09dc1e4012 = `var(--ds-border-focused, ${(0, $PdmhA.B200)})`;
const $f5064939140dcbf4$export$b13414ee9ac9cae6 = `var(--ds-background-input, ${(0, $PdmhA.N10)})`;
const $f5064939140dcbf4$export$bca15982c103d57b = `var(--ds-background-input-hovered, ${(0, $PdmhA.N30)})`;
const $f5064939140dcbf4$export$21287e4b7f134f09 = `var(--ds-background-input-pressed, ${(0, $PdmhA.N0)})`;
const $f5064939140dcbf4$export$a87538d56ee366ec = "var(--ds-border-input, transparent)";
const $f5064939140dcbf4$export$5e076b2557ef7bbb = `var(--ds-text-subtlest, ${(0, $PdmhA.N200)})`;
const $f5064939140dcbf4$export$32f78bffcd82ff28 = `var(--ds-text, ${(0, $PdmhA.N900)})`;
const $f5064939140dcbf4$export$eb4a7d363eec53c8 = `var(--ds-text-disabled, ${(0, $PdmhA.N70)})`;
const $f5064939140dcbf4$export$f4d082c200a4b4b8 = 'transparent';

});



parcelRegister("5Dz3q", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d2ca21acc7961d0$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1d2ca21acc7961d0$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    placeHolder: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.form.fields.dynamic-input-field.place-holder",
        "defaultMessage": "Enter email address(es)"
    }
});

});


parcelRegister("cYWvB", function(module, exports) {

$parcel$export(module.exports, "useDynamicInputHook", () => $c5db7d8f5c83b0e7$export$afc2933ac433b06a);

var $eUqFw = parcelRequire("eUqFw");

var $gtzuR = parcelRequire("gtzuR");

var $dgUkL = parcelRequire("dgUkL");

var $5r71C = parcelRequire("5r71C");
const $c5db7d8f5c83b0e7$export$afc2933ac433b06a = ()=>{
    const [showInput, setShowInput] = (0, $eUqFw.useState)(true);
    const [showHelp, setShowHelp] = (0, $eUqFw.useState)(false);
    const [showErrorFlag, setShowErrorFlag] = (0, $eUqFw.useState)(false);
    const [{ isValidating: isValidating, emailValidationErrors: emailValidationErrors, customers: customers, emailPresetValue: emailPresetValue }, { setCustomerEmailsInputFieldValue: setCustomerEmailsInputFieldValue, onValidateCustomerEmails: onValidateCustomerEmails, setCustomers: setCustomers, setEmailPresetValue: setEmailPresetValue }] = (0, $dgUkL.useAddCustomersDialogContext)();
    const failed = emailValidationErrors?.failed || [];
    const failedWithErrors = emailValidationErrors?.failedWithErrors || [];
    // User input
    const [email, setEmail] = (0, $eUqFw.useState)(emailPresetValue);
    // Validated email list yet to be submitted
    const [emails, setEmails] = (0, $eUqFw.useState)(()=>customers.map((customer)=>customer.emailAddress));
    // also Toggles input view to text area if input contains comma seperated values
    const setEmailOnChange = (input)=>{
        let toSet = input;
        // split the input into one-email-per-line before setting the email value
        // only when input length is > 3. SPLIT BY [',' , ';' , '\n']
        if ((0, $5r71C.hasMultipleEmails)(toSet)) {
            toSet = (0, $5r71C.newLineForText)(toSet);
            setShowInput(false);
        }
        setEmail(toSet);
        setEmailPresetValue(toSet);
        const allTrimmed = (0, $5r71C.trimAll)(toSet);
        if (allTrimmed.length > 0) {
            const toParent = [
                ...new Set(emails.concat(allTrimmed))
            ];
            setCustomerEmailsInputFieldValue(toParent.join(','));
        }
    };
    const handleOnRemoved = (removedEmail)=>{
        const newEmails = emails.filter((eachEmail)=>eachEmail !== removedEmail);
        setEmails(newEmails);
        setCustomers(customers.filter((customer)=>customer.emailAddress !== removedEmail));
    };
    // Whenever `emails` changes update the parent's email and customer state
    (0, $eUqFw.useEffect)(()=>{
        if ((0, $5r71C.hasMultipleEmails)(email)) // Show textarea expanded when prefill has multiple emails
        setShowInput(false);
        if (emails.length === 0) setCustomerEmailsInputFieldValue(email);
        else {
            const toParent = [
                ...new Set(emails.concat(email))
            ];
            setCustomerEmailsInputFieldValue(toParent.join(','));
        }
    }, [
        email,
        emails,
        setCustomerEmailsInputFieldValue,
        setCustomers
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // Set validated email lists on validation
        const passedList = emailValidationErrors ? emailValidationErrors.passed : [];
        const failedList = emailValidationErrors ? emailValidationErrors.failed : [];
        if (passedList.length > 0 && failedList.length === 0) {
            setEmails((prev)=>[
                    ...new Set([
                        ...prev,
                        ...passedList
                    ])
                ]);
            setEmail('');
            setEmailPresetValue('');
            setShowInput(true);
        }
        if (failedWithErrors.length > 0) setShowErrorFlag(true);
    }, [
        emailValidationErrors,
        failedWithErrors.length,
        setEmailPresetValue
    ]);
    const validateEmails = (emailArr)=>{
        const toValidate = [
            ...new Set(emailArr)
        ];
        onValidateCustomerEmails(toValidate);
    };
    const handleAddMore = ()=>{
        const emailArr = (0, $5r71C.trimAll)(email);
        if (emailArr.length > 0) validateEmails(emailArr);
    };
    const handleBackspace = (event)=>{
        if (event.target instanceof HTMLTextAreaElement && event.target.selectionEnd >= 2 && event.target.selectionEnd === event.target.selectionStart && email.substring(event.target.selectionEnd - 2, event.target.selectionEnd) === ',\n') {
            event.preventDefault();
            setEmail(email.substring(0, event.target.selectionEnd - 2) + email.substring(event.target.selectionEnd));
            // this will adjust a cursor position in case deletion was in the middle of a text, as it places the cursor at the end by default
            // setting selection must happen after email is set and textarea rerendered
            setTimeout((target, selectionStart, selectionEnd)=>{
                target.setSelectionRange(selectionStart, selectionEnd);
            }, 0, event.target, event.target.selectionEnd - 2, event.target.selectionEnd - 2);
        }
    };
    // mimic + Add on enter or space
    const handleOnKeyDown = (event)=>{
        if (([
            (0, (/*@__PURE__*/$parcel$interopDefault($gtzuR)))('enter'),
            (0, (/*@__PURE__*/$parcel$interopDefault($gtzuR)))('space')
        ].includes(event.keyCode) || [
            'Enter',
            ' ',
            'Spacebar'
        ].includes(event.key)) && email.trim()) {
            event.preventDefault();
            handleAddMore();
        } else if (((0, (/*@__PURE__*/$parcel$interopDefault($gtzuR)))('backspace') === event.keyCode || event.key === 'Backspace') && email.trim()) handleBackspace(event);
    };
    return {
        email: email,
        setEmail: setEmail,
        emails: emails,
        setEmails: setEmails,
        showInput: showInput,
        setShowInput: setShowInput,
        showHelp: showHelp,
        setShowHelp: setShowHelp,
        isValidating: isValidating,
        emailValidationErrors: emailValidationErrors,
        setCustomerEmailsInputFieldValue: setCustomerEmailsInputFieldValue,
        onValidateCustomerEmails: onValidateCustomerEmails,
        failed: failed,
        failedWithErrors: failedWithErrors,
        showErrorFlag: showErrorFlag,
        setEmailOnChange: // Methods
        setEmailOnChange,
        handleOnRemoved: handleOnRemoved,
        validateEmails: validateEmails,
        handleAddMore: handleAddMore,
        handleOnKeyDown: handleOnKeyDown,
        setShowErrorFlag: setShowErrorFlag
    };
};

});
parcelRegister("gtzuR", function(module, exports) {
// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */ function keyCode(searchInput) {
    // Keyboard Events
    if (searchInput && 'object' === typeof searchInput) {
        var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode;
        if (hasKeyCode) searchInput = hasKeyCode;
    }
    // Numbers
    if ('number' === typeof searchInput) return names[searchInput];
    // Everything else (cast to string)
    var search = String(searchInput);
    // check codes
    var foundNamedKey = codes[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // check aliases
    var foundNamedKey = aliases[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // weird character?
    if (search.length === 1) return search.charCodeAt(0);
    return undefined;
}
/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */ keyCode.isEventKey = function isEventKey(event, nameOrCode) {
    if (event && 'object' === typeof event) {
        var keyCode = event.which || event.keyCode || event.charCode;
        if (keyCode === null || keyCode === undefined) return false;
        if (typeof nameOrCode === 'string') {
            // check codes
            var foundNamedKey = codes[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
            // check aliases
            var foundNamedKey = aliases[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
        } else if (typeof nameOrCode === 'number') return nameOrCode === keyCode;
        return false;
    }
};
exports = module.exports = keyCode;
/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */ var codes = exports.code = exports.codes = {
    'backspace': 8,
    'tab': 9,
    'enter': 13,
    'shift': 16,
    'ctrl': 17,
    'alt': 18,
    'pause/break': 19,
    'caps lock': 20,
    'esc': 27,
    'space': 32,
    'page up': 33,
    'page down': 34,
    'end': 35,
    'home': 36,
    'left': 37,
    'up': 38,
    'right': 39,
    'down': 40,
    'insert': 45,
    'delete': 46,
    'command': 91,
    'left command': 91,
    'right command': 93,
    'numpad *': 106,
    'numpad +': 107,
    'numpad -': 109,
    'numpad .': 110,
    'numpad /': 111,
    'num lock': 144,
    'scroll lock': 145,
    'my computer': 182,
    'my calculator': 183,
    ';': 186,
    '=': 187,
    ',': 188,
    '-': 189,
    '.': 190,
    '/': 191,
    '`': 192,
    '[': 219,
    '\\': 220,
    ']': 221,
    "'": 222
};
// Helper aliases
var aliases = exports.aliases = {
    'windows': 91,
    "\u21E7": 16,
    "\u2325": 18,
    "\u2303": 17,
    "\u2318": 91,
    'ctl': 17,
    'control': 17,
    'option': 18,
    'pause': 19,
    'break': 19,
    'caps': 20,
    'return': 13,
    'escape': 27,
    'spc': 32,
    'spacebar': 32,
    'pgup': 33,
    'pgdn': 34,
    'ins': 45,
    'del': 46,
    'cmd': 91
};
/*!
 * Programatically add the following
 */ // lower case chars
for(i = 97; i < 123; i++)codes[String.fromCharCode(i)] = i - 32;
// numbers
for(var i = 48; i < 58; i++)codes[i - 48] = i;
// function keys
for(i = 1; i < 13; i++)codes['f' + i] = i + 111;
// numpad keys
for(i = 0; i < 10; i++)codes['numpad ' + i] = i + 96;
/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */ var names = exports.names = exports.title = {} // title for backward compat
;
// Create reverse mapping
for(i in codes)names[codes[i]] = i;
// Add aliases
for(var alias in aliases)codes[alias] = aliases[alias];

});

parcelRegister("5r71C", function(module, exports) {

$parcel$export(module.exports, "trimAll", () => $fc103c5237edf39b$export$75c3f1d2ea877262);
$parcel$export(module.exports, "newLineForText", () => $fc103c5237edf39b$export$dcd449be4da8e0b5);
$parcel$export(module.exports, "hasMultipleEmails", () => $fc103c5237edf39b$export$73603e62fe14f07b);
// Trim empty space and new lines
const $fc103c5237edf39b$export$75c3f1d2ea877262 = (str)=>str.replace('\n', '').split(',').map((e)=>e.trim()).filter(Boolean);
// Inserts new lines to the input in between comma-separated values for display in a text area
const $fc103c5237edf39b$export$dcd449be4da8e0b5 = (str)=>str.split(/[;,\n]+/).map((e)=>e.trim()).join(',\n');
// check if email input value length is > 3 and is seperated BY [',' , ';' , '\n']
const $fc103c5237edf39b$export$73603e62fe14f07b = (email)=>{
    const moreDelineators = new RegExp(/[;,\n]+/);
    const hasDelineators = email.match(moreDelineators) !== null;
    return email.length > 3 && hasDelineators;
};

});


parcelRegister("hBBzI", function(module, exports) {

$parcel$export(module.exports, "InputListView", () => $17b0b0c0ccf44f67$export$70ece18bfb20ea18);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $jWuk1 = parcelRequire("jWuk1");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $cf2Y4 = parcelRequire("cf2Y4");

var $giAhk = parcelRequire("giAhk");
const $17b0b0c0ccf44f67$var$InputLists = ({ input: input, onRemoved: onRemoved })=>{
    const key = `${input}_${Math.random()}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $17b0b0c0ccf44f67$var$inputStyles,
        key: key
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
        "aria-label": "default text field",
        value: input,
        isReadOnly: true,
        elemAfterInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            "aria-label": "Remove",
            title: "Remove",
            appearance: "subtle-link",
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))), {
                label: "remove",
                size: "small"
            }),
            spacing: "compact",
            onClick: ()=>onRemoved(input)
        })
    }));
};
const $17b0b0c0ccf44f67$export$70ece18bfb20ea18 = (props)=>{
    const lists = props.inputs;
    const allLists = [];
    lists.forEach((input)=>{
        allLists.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($17b0b0c0ccf44f67$var$InputLists, {
            input: input,
            key: Math.random(),
            onRemoved: props.onRemoved
        }));
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "servicedesk-customers-organization-common.ui.add-customers-dialog.form.fields.dynamic-input-field.input-lists.valid-input-list"
    }, allLists);
};
const $17b0b0c0ccf44f67$export$f8e84d94e9def29c = (0, $giAhk.injectIntlV2)($17b0b0c0ccf44f67$export$70ece18bfb20ea18);
const $17b0b0c0ccf44f67$var$inputStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    position: 'relative',
    marginBottom: 'space.050',
    alignItems: 'center'
});

});
parcelRegister("cf2Y4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecaf8c9a10cf48c9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $abUSh = parcelRequire("abUSh");
const $ecaf8c9a10cf48c9$var$analyticsParams = {
    componentName: 'textField',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
/**
 * __Textfield__
 *
 * A text field is an input that allows a user to write or edit text.
 *
 * - [Examples](https://atlassian.design/components/textfield/examples)
 * - [Code](https://atlassian.design/components/textfield/code)
 * - [Usage](https://atlassian.design/components/textfield/usage)
 */ const $ecaf8c9a10cf48c9$var$Textfield = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
    const inputRef = (0, $eUqFw.useRef)(null);
    const handleOnFocus = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$ecaf8c9a10cf48c9$var$analyticsParams
    });
    const handleOnBlur = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$ecaf8c9a10cf48c9$var$analyticsParams
    });
    const handleOnMouseDown = (0, $eUqFw.useCallback)((event)=>{
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        const target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    const setInputRef = (0, $eUqFw.useCallback)((inputElement)=>{
        inputRef.current = inputElement;
        if (!ref) return;
        if (typeof ref === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    const containerStyles = (0, $eUqFw.useMemo)(()=>(0, $abUSh.containerStyles)(appearance, width), [
        appearance,
        width
    ]);
    const inputStyle = (0, $abUSh.inputStyles)();
    return(/**
     * It is not normally acceptable to add click and key handlers to
     * non-interactive elements as this is an accessibility anti-pattern.
     * However, because this instance is to handle events on all children that
     * should be associated with the input, we can add role="presentation" so
     * that there are no negative impacts to assistive technologies.
     */ /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && `${testId}-container`,
        onMouseDown: handleOnMouseDown,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: containerStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, elemBeforeInput, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ...spreadProps,
        "aria-invalid": isInvalid ? isInvalid : undefined,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: inputStyle,
        "data-compact": isCompact ? isCompact : undefined,
        "data-ds--text-field--input": true,
        "data-monospaced": isMonospaced ? isMonospaced : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        name: name,
        onBlur: handleOnBlur,
        onChange: onChange,
        onFocus: handleOnFocus,
        placeholder: placeholder,
        readOnly: isReadOnly,
        ref: setInputRef,
        required: isRequired
    }), elemAfterInput));
});
var $ecaf8c9a10cf48c9$export$2e2bcd8739ae039 = $ecaf8c9a10cf48c9$var$Textfield;

});
parcelRegister("abUSh", function(module, exports) {

$parcel$export(module.exports, "containerStyles", () => $6ff5b404db052892$export$5972a68b6e54f38f);
$parcel$export(module.exports, "inputStyles", () => $6ff5b404db052892$export$3eeb47dc8e6249d9);

var $PdmhA = parcelRequire("PdmhA");
const $6ff5b404db052892$var$backgroundColor = {
    standard: `var(--ds-background-input, ${(0, $PdmhA.N10)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $6ff5b404db052892$var$backgroundColorFocus = {
    standard: `var(--ds-background-input-pressed, ${(0, $PdmhA.N0)})`,
    subtle: `var(--ds-background-input-pressed, ${(0, $PdmhA.N0)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$backgroundColorHover = {
    standard: `var(--ds-background-input-hovered, ${(0, $PdmhA.N30)})`,
    subtle: `var(--ds-background-input-hovered, ${(0, $PdmhA.N30)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColor = {
    standard: `var(--ds-border-input, ${(0, $PdmhA.N100)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColorFocus = {
    standard: `var(--ds-border-focused, ${(0, $PdmhA.B200)})`,
    subtle: `var(--ds-border-focused, ${(0, $PdmhA.B200)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColorHover = {
    standard: `var(--ds-border-input, ${(0, $PdmhA.N100)})`,
    subtle: "var(--ds-border-input, transparent)",
    none: 'transparent'
};
const $6ff5b404db052892$var$getContainerTextBgAndBorderColor = (appearance)=>({
        backgroundColor: $6ff5b404db052892$var$backgroundColor[appearance],
        borderColor: $6ff5b404db052892$var$borderColor[appearance],
        color: `var(--ds-text, ${0, $PdmhA.N900})`,
        cursor: 'text',
        '&:hover:not([data-disabled])': {
            backgroundColor: $6ff5b404db052892$var$backgroundColorHover[appearance],
            borderColor: $6ff5b404db052892$var$borderColorHover[appearance]
        },
        '&:focus-within:not([data-disabled])': {
            backgroundColor: $6ff5b404db052892$var$backgroundColorFocus[appearance],
            borderColor: $6ff5b404db052892$var$borderColorFocus[appearance],
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$6ff5b404db052892$var$borderColorFocus[appearance]}`
        },
        '&[data-disabled]': {
            color: `var(--ds-text-disabled, ${0, $PdmhA.N70})`,
            cursor: 'not-allowed',
            // Disabled background and border styles should not be applied to components that
            // have either no background or transparent background to begin with
            ...appearance === 'standard' && {
                backgroundColor: `var(--ds-background-disabled, ${0, $PdmhA.N10})`,
                borderColor: `var(--ds-background-disabled, ${0, $PdmhA.N10})`
            }
        },
        '&[data-invalid], &[data-invalid]:hover': {
            borderColor: `var(--ds-border-danger, ${0, $PdmhA.R400})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${0, $PdmhA.R400})`}`
        },
        '&[data-invalid]:focus-within': {
            backgroundColor: `var(--ds-background-input-pressed, ${0, $PdmhA.N0})`,
            borderColor: `var(--ds-border-focused, ${0, $PdmhA.B200})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${0, $PdmhA.B200})`}`
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[data-invalid]:focus-within': {
                borderColor: 'Highlight'
            },
            '&:focus-within': {
                borderColor: 'Highlight'
            },
            '&[data-disabled]': {
                borderColor: 'GrayText'
            }
        }
    });
const $6ff5b404db052892$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
const $6ff5b404db052892$var$getMaxWidth = (width)=>!width ? `100%` : width in $6ff5b404db052892$var$widthMap ? $6ff5b404db052892$var$widthMap[width] : +width;
const $6ff5b404db052892$export$5972a68b6e54f38f = (appearance, width)=>({
        alignItems: 'center',
        ...$6ff5b404db052892$var$getContainerTextBgAndBorderColor(appearance),
        borderRadius: 3,
        borderWidth: "var(--ds-border-width, 1px)",
        // add 1px padding on both top and bottom to keep the same overall height after border reduced from 2px to 1px under feature flag
        ...appearance !== 'none' ? {
            padding: `${"var(--ds-border-width, 1px)"} 0`
        } : {},
        borderStyle: appearance === 'none' ? 'none' : 'solid',
        boxSizing: 'border-box',
        display: 'flex',
        flex: '1 1 100%',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        justifyContent: 'space-between',
        maxWidth: $6ff5b404db052892$var$getMaxWidth(width),
        overflow: 'hidden',
        transition: `background-color 0.2s ease-in-out, border-color 0.2s ease-in-out`,
        wordWrap: 'break-word',
        verticalAlign: 'top',
        pointerEvents: 'auto'
    });
const $6ff5b404db052892$export$3eeb47dc8e6249d9 = ()=>({
        backgroundColor: 'transparent',
        border: 0,
        boxSizing: 'border-box',
        color: 'inherit',
        cursor: 'inherit',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        minWidth: '0',
        outline: 'none',
        width: '100%',
        '&[data-monospaced]': {
            fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
        },
        '&[data-compact]': {
            padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&:not([data-compact])': {
            padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&[disabled]': {
            // Safari (WebKit) adds a -webkit-text-fill-color style to disabled inputs
            // which takes priority over color and makes the text unreadable. Need to
            // override it with the color we want.
            WebkitTextFillColor: `var(--ds-text-disabled, ${0, $PdmhA.N70})`
        },
        // Hide the clear indicator on Edge (Windows only)
        '&::-ms-clear': {
            display: 'none'
        },
        '&:invalid': {
            boxShadow: 'none'
        },
        '&:placeholder-shown': {
            textOverflow: 'ellipsis'
        },
        '&::placeholder': {
            color: `var(--ds-text-subtlest, ${0, $PdmhA.N200})`,
            '&:disabled': {
                color: `var(--ds-text-disabled, ${0, $PdmhA.N70})`
            }
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[disabled]': {
                color: 'GrayText'
            }
        }
    });

});



parcelRegister("fsAzS", function(module, exports) {

$parcel$export(module.exports, "default", () => $e359dea32bfde793$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e359dea32bfde793$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    customerEmails: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.form.fields.dynamic-input-field.customer-emails",
        "defaultMessage": "Customer email"
    },
    placeHolder: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.form.fields.dynamic-input-field.place-holder",
        "defaultMessage": "Enter email address(es)"
    },
    info: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.form.fields.dynamic-input-field.info",
        "defaultMessage": "Add email addresses one by one, or enter multiple email addresses separated by commas."
    },
    invalidEmail: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.form.fields.dynamic-input-field.invalid-email",
        "defaultMessage": "Enter a valid email address."
    },
    signupUnAvailable: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.form.fields.dynamic-input-field.signup-un-available",
        "defaultMessage": "Sign-up is currently unavailable."
    }
});

});

parcelRegister("hjxMV", function(module, exports) {

$parcel$export(module.exports, "transformToInviteFailedEmails", () => $7cdf68c42e668124$export$cd75681d7c6a14d3);
const $7cdf68c42e668124$export$cd75681d7c6a14d3 = (emails)=>{
    const failedEmails = emails.map((email)=>({
            email: email.email,
            errorMessage: email.error
        }));
    return failedEmails;
};

});


parcelRegister("1wCxQ", function(module, exports) {

$parcel$export(module.exports, "OrganizationsSelectField", () => $e115a1cf07b6b7a2$export$bcd3b277f4e72180);

var $eUqFw = parcelRequire("eUqFw");

var $4LhB6 = parcelRequire("4LhB6");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7d1RI = parcelRequire("7d1RI");

var $5kjXv = parcelRequire("5kjXv");

var $dgUkL = parcelRequire("dgUkL");

var $s2JIE = parcelRequire("s2JIE");
const $e115a1cf07b6b7a2$export$bcd3b277f4e72180 = ({ useCommonPageContext: useCommonPageContext })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { baseUrl: baseUrl, projectId: projectId, projectKey: projectKey } = useCommonPageContext();
    const [{ organization: organization }, { setOrganization: setOrganization }] = (0, $dgUkL.useAddCustomersDialogContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        name: "add-to-organizations-field",
        label: formatMessage((0, $s2JIE.default).addToOrganizationsUpdated)
    }, ({ fieldProps: { id: id } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5kjXv.OrganizationsSelectField), {
            hidePlaceholder: false,
            inputId: id,
            /* @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Argument of type 'string | undefined' is not assignable to parameter of type 'string' */ baseUrl: baseUrl,
            /* @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Argument of type 'string | undefined' is not assignable to parameter of type 'string' */ projectId: projectId,
            /* @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Argument of type 'string | undefined' is not assignable to parameter of type 'string' */ projectKey: projectKey,
            value: organization,
            // @ts-expect-error - TS2322 - Type '([selectedOption]: [any]) => void' is not assignable to type '(arg1: Organizations) => void'.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onModify: ([selectedOption])=>{
                setOrganization(selectedOption);
            }
        }));
};
$e115a1cf07b6b7a2$export$bcd3b277f4e72180.defaultProps = {
    useCommonPageContext: (0, $7d1RI.useCommonPageContext)
};

});
parcelRegister("5kjXv", function(module, exports) {

$parcel$export(module.exports, "OrganizationsSelectField", () => $c3711f784ed0bd1c$export$bcd3b277f4e72180);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $7jPhn = parcelRequire("7jPhn");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $giAhk = parcelRequire("giAhk");

var $iDv71 = parcelRequire("iDv71");

var $gUsKc = parcelRequire("gUsKc");

var $3bprD = parcelRequire("3bprD");

var $6S1Hp = parcelRequire("6S1Hp");

var $lDc85 = parcelRequire("lDc85");
const $c3711f784ed0bd1c$export$edf5a02e1c7f5a5b = ({ intl: { formatMessage: formatMessage }, baseUrl: baseUrl, projectKey: projectKey, projectId: projectId, isMulti: isMulti, useOrganizationSearchService: useOrganizationSearchService, onModify: onModify, selectedOrganizations: selectedOrganizations, ...props })=>{
    const { error: error, loading: loading, fetch: fetch } = useOrganizationSearchService({
        baseUrl: baseUrl,
        projectKey: projectKey,
        projectId: projectId
    });
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const fetchWithDebounce = (0, $eUqFw.useCallback)((0, $iDv71.debounce)(async ({ query: query, resolve: resolve })=>{
        const organizations = await fetch(query);
        const formattedOptions = (0, $lDc85.mapOrganizationsToLabelOptions)(organizations, formatMessage);
        resolve(formattedOptions);
    }), []);
    // @ts-expect-error - TS2304 - Cannot find name 'GetOptionsParams'.
    const handleOnInputChange = (args)=>{
        fetchWithDebounce(args);
    };
    // @ts-expect-error - TS7006 - Parameter 'selected' implicitly has an 'any' type.
    const onSelect = (selected)=>{
        if (!(0, $lDc85.isSelectedOptionValid)(selectedOrganizations, selected)) return undefined;
        return onModify([
            ...selectedOrganizations,
            selected
        ]);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $c3711f784ed0bd1c$var$spacedStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6S1Hp.OrganizationsSingleSelect), {
        ...props,
        isMulti: isMulti,
        onFetchOptions: handleOnInputChange,
        onSelect: onSelect
    }), !loading && error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, formatMessage((0, $gUsKc.default).somethingWentWrong)));
};
$c3711f784ed0bd1c$export$edf5a02e1c7f5a5b.defaultProps = {
    isMulti: false,
    useOrganizationSearchService: (0, $3bprD.useOrganizationSearchService),
    selectedOrganizations: [],
    onModify: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
const $c3711f784ed0bd1c$export$bcd3b277f4e72180 = (0, $giAhk.injectIntlV2)($c3711f784ed0bd1c$export$edf5a02e1c7f5a5b);
const $c3711f784ed0bd1c$var$spacedStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.050'
});

});
parcelRegister("iDv71", function(module, exports) {

$parcel$export(module.exports, "debounce", () => $3522e82790454c67$export$61fc7d43ac8f84b0);

var $dxIU5 = parcelRequire("dxIU5");
const $3522e82790454c67$export$e39301eefbc90236 = 300;
const $3522e82790454c67$export$61fc7d43ac8f84b0 = (callBack, timeout = $3522e82790454c67$export$e39301eefbc90236)=>(0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(callBack, timeout);

});

parcelRegister("3bprD", function(module, exports) {

$parcel$export(module.exports, "useOrganizationSearchService", () => $e784521689a28410$export$68d41c9eaa29b2a3);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $7I4H0 = parcelRequire("7I4H0");
// we debounce the success event firing, to more accurately represent a complete search
// as opposed to a search which is triggered mid-way through a user's search term
const $e784521689a28410$var$searchSuccessDebounceTime = 2000;
const $e784521689a28410$export$68d41c9eaa29b2a3 = ({ baseUrl: baseUrl, projectId: projectId })=>{
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const [data, setData] = (0, $eUqFw.useState)(null);
    const [error, setError] = (0, $eUqFw.useState)(null);
    const abortController = (0, $eUqFw.useRef)(null);
    const fireSearchSuccessEvent = (0, $eUqFw.useCallback)((// @ts-expect-error - TS7006 - Parameter 'analyticsEvent' implicitly has an 'any' type.
    analyticsEvent, { isSearchStringEmpty: isSearchStringEmpty })=>{
        (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'jsmOrganizationsSearch succeeded', {
            isSearchStringEmpty: isSearchStringEmpty
        });
    }, []);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedFireSearchSuccessEvent = (0, $eUqFw.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(fireSearchSuccessEvent, $e784521689a28410$var$searchSuccessDebounceTime, {
        leading: true,
        trailing: false
    }), []);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const fetch = (0, $eUqFw.useCallback)(async (query)=>{
        let organizationsResponse = [];
        setLoading(true);
        setError(null);
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        if (abortController.current && abortController.current.abort) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        abortController.current.abort();
        try {
            abortController.current = new AbortController();
            // @ts-expect-error - TS2339 - Property 'signal' does not exist on type 'unknown'.
            const { signal: signal } = abortController.current;
            const response = await (0, $lRmyA.performGetRequest)((0, $7I4H0.getFetchUrl)(baseUrl, projectId, query), {
                signal: signal
            });
            const analyticsEvent = createAnalyticsEvent({});
            debouncedFireSearchSuccessEvent(analyticsEvent, {
                isSearchStringEmpty: query === ''
            });
            organizationsResponse = response;
            setData(response);
            setLoading(false);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            if (err && err.name === 'AbortError') return organizationsResponse;
            (0, $guiFP.default)({
                meta: {
                    id: 'organizationSearchServiceFetch',
                    packageName: 'jiraServicedeskCustomersOrganizationCommon',
                    teamName: 'boysenberry'
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
            setLoading(false);
            setError(err);
        }
        return organizationsResponse;
    }, [
        baseUrl,
        createAnalyticsEvent,
        debouncedFireSearchSuccessEvent,
        projectId
    ]);
    return {
        loading: loading,
        error: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'ServiceError'.
        error,
        data: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'ServiceData<Organizations>'.
        data,
        fetch: // @ts-expect-error - TS2322 - Type '(query: string) => Promise<any>' is not assignable to type '(() => Promise<void>) & ((query: string) => Promise<Organizations>)'.
        fetch
    };
};

});
parcelRegister("7I4H0", function(module, exports) {

$parcel$export(module.exports, "getFetchUrl", () => $6cd9df8daaba30a5$export$e6bbfc5a530be3a5);

var $53ciZ = parcelRequire("53ciZ");
const $6cd9df8daaba30a5$export$e6bbfc5a530be3a5 = (baseUrl, projectId, query = '')=>`${baseUrl}/rest/servicedesk/1/organisations/project/${projectId}/invite/search?${(0, $53ciZ.stringify)({
        query: query
    })}`;

});


parcelRegister("6S1Hp", function(module, exports) {

$parcel$export(module.exports, "OrganizationsSingleSelect", () => $7b0dcb6667d9dbd9$export$47e1db464d15fcd1);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $1ZpeU = parcelRequire("1ZpeU");

var $c9TLT = parcelRequire("c9TLT");

var $5JgJ2 = parcelRequire("5JgJ2");


var $7qsUN = parcelRequire("7qsUN");

var $eWXlq = parcelRequire("eWXlq");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7b0dcb6667d9dbd9$var$menuPortal = (base)=>({
        ...base,
        zIndex: (0, $c9TLT.layers).modal
    });
const $7b0dcb6667d9dbd9$export$47e1db464d15fcd1 = ({ onFetchOptions: onFetchOptions, onSelect: onSelect, hidePlaceholder: hidePlaceholder = true, inputId: inputId, value: value, isMulti: isMulti })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { onChange: onChange, loadOptions: loadOptions, isValidNewOption: isValidNewOption, formatOptionLabel: formatOptionLabel, getNewOptionData: getNewOptionData } = (0, $eWXlq.useSelectUtils)({
        onSelect: onSelect,
        onFetchOptions: onFetchOptions
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ZpeU.default), {
        classNamePrefix: (0, $7f387e8fcff8ab0c$export$60fb28d4aee3606e),
        controlShouldRenderValue: !isMulti,
        defaultOptions: true,
        formatCreateLabel: (orgName)=>`${formatMessage((0, $7qsUN.default).createNew, {
                orgName: orgName
            })}`,
        formatOptionLabel: formatOptionLabel,
        getNewOptionData: getNewOptionData,
        isClearable: !isMulti,
        isValidNewOption: isValidNewOption,
        menuPortalTarget: document.body,
        noOptionsMessage: ()=>formatMessage((0, $7qsUN.default).noOptionsMessage),
        // @ts-expect-error - TS2322 - Type '(selectedOption: Option) => void' is not assignable to type '(value: Option | null, action: ActionMeta<Option>) => void'.
        onChange: onChange,
        styles: {
            menuPortal: $7b0dcb6667d9dbd9$var$menuPortal
        },
        value: value,
        placeholder: hidePlaceholder ? '' : formatMessage((0, $7qsUN.default).placeHolder),
        loadOptions: loadOptions,
        id: "servicedesk-customers-organization-common.common.ui.organizations-select-field.organizations-single-select.ak-select",
        inputId: inputId
    });
};
$7b0dcb6667d9dbd9$export$47e1db464d15fcd1.defaultProps = {
    onFetchOptions: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onSelect: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    isMulti: false
};

});
parcelRegister("1ZpeU", function(module, exports) {

$parcel$export(module.exports, "default", () => $724bfa4358c46735$export$2e2bcd8739ae039);

var $03F4S = parcelRequire("03F4S");

var $5FjBr = parcelRequire("5FjBr");
const $724bfa4358c46735$var$AsyncCreatableSelect = (0, $5FjBr.default)((0, $03F4S.default));
var $724bfa4358c46735$export$2e2bcd8739ae039 = $724bfa4358c46735$var$AsyncCreatableSelect;

});
parcelRegister("03F4S", function(module, exports) {

$parcel$export(module.exports, "default", () => $00b02518902b6778$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $3IL7Z = parcelRequire("3IL7Z");

var $7IqRg = parcelRequire("7IqRg");

var $6xNN4 = parcelRequire("6xNN4");
parcelRequire("1Xn5q");
parcelRequire("lDSrn");
parcelRequire("lIEGP");
parcelRequire("eT4IF");
parcelRequire("7Dzgl");
parcelRequire("fVK4C");


parcelRequire("aKcqM");
parcelRequire("bwPfh");
parcelRequire("5sKOb");
parcelRequire("jqNEH");
parcelRequire("5zQU9");
parcelRequire("lEfVV");

parcelRequire("k286k");

var $00b02518902b6778$var$AsyncCreatableSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function(props, ref) {
    var stateManagerProps = (0, $3IL7Z.u)(props);
    var creatableProps = (0, $7IqRg.u)(stateManagerProps);
    var selectProps = (0, $6xNN4.u)(creatableProps);
    return /*#__PURE__*/ $eUqFw.createElement((0, $cEc3i.S), (0, $kU09D.default)({
        ref: ref
    }, selectProps));
});
var $00b02518902b6778$export$2e2bcd8739ae039 = $00b02518902b6778$var$AsyncCreatableSelect;

});
parcelRegister("3IL7Z", function(module, exports) {

$parcel$export(module.exports, "u", () => $2b5a09c16d37496a$export$3b14a55fb2447963);

var $5zQU9 = parcelRequire("5zQU9");

var $1Xn5q = parcelRequire("1Xn5q");

var $aKcqM = parcelRequire("aKcqM");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");
var $2b5a09c16d37496a$var$_excluded = [
    "defaultOptions",
    "cacheOptions",
    "loadOptions",
    "options",
    "isLoading",
    "onInputChange",
    "filterOption"
];
function $2b5a09c16d37496a$export$3b14a55fb2447963(_ref) {
    var _ref$defaultOptions = _ref.defaultOptions, propsDefaultOptions = _ref$defaultOptions === void 0 ? false : _ref$defaultOptions, _ref$cacheOptions = _ref.cacheOptions, cacheOptions = _ref$cacheOptions === void 0 ? false : _ref$cacheOptions, propsLoadOptions = _ref.loadOptions;
    _ref.options;
    var _ref$isLoading = _ref.isLoading, propsIsLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, propsOnInputChange = _ref.onInputChange, _ref$filterOption = _ref.filterOption, filterOption = _ref$filterOption === void 0 ? null : _ref$filterOption, restSelectProps = (0, $bwPfh.default)(_ref, $2b5a09c16d37496a$var$_excluded);
    var propsInputValue = restSelectProps.inputValue;
    var lastRequest = (0, $eUqFw.useRef)(undefined);
    var mounted = (0, $eUqFw.useRef)(false);
    var _useState = (0, $eUqFw.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined), _useState2 = (0, $aKcqM.default)(_useState, 2), defaultOptions = _useState2[0], setDefaultOptions = _useState2[1];
    var _useState3 = (0, $eUqFw.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : ''), _useState4 = (0, $aKcqM.default)(_useState3, 2), stateInputValue = _useState4[0], setStateInputValue = _useState4[1];
    var _useState5 = (0, $eUqFw.useState)(propsDefaultOptions === true), _useState6 = (0, $aKcqM.default)(_useState5, 2), isLoading = _useState6[0], setIsLoading = _useState6[1];
    var _useState7 = (0, $eUqFw.useState)(undefined), _useState8 = (0, $aKcqM.default)(_useState7, 2), loadedInputValue = _useState8[0], setLoadedInputValue = _useState8[1];
    var _useState9 = (0, $eUqFw.useState)([]), _useState10 = (0, $aKcqM.default)(_useState9, 2), loadedOptions = _useState10[0], setLoadedOptions = _useState10[1];
    var _useState11 = (0, $eUqFw.useState)(false), _useState12 = (0, $aKcqM.default)(_useState11, 2), passEmptyOptions = _useState12[0], setPassEmptyOptions = _useState12[1];
    var _useState13 = (0, $eUqFw.useState)({}), _useState14 = (0, $aKcqM.default)(_useState13, 2), optionsCache = _useState14[0], setOptionsCache = _useState14[1];
    var _useState15 = (0, $eUqFw.useState)(undefined), _useState16 = (0, $aKcqM.default)(_useState15, 2), prevDefaultOptions = _useState16[0], setPrevDefaultOptions = _useState16[1];
    var _useState17 = (0, $eUqFw.useState)(undefined), _useState18 = (0, $aKcqM.default)(_useState17, 2), prevCacheOptions = _useState18[0], setPrevCacheOptions = _useState18[1];
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, $eUqFw.useEffect)(function() {
        mounted.current = true;
        return function() {
            mounted.current = false;
        };
    }, []);
    var loadOptions = (0, $eUqFw.useCallback)(function(inputValue, callback) {
        if (!propsLoadOptions) return callback();
        var loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') loader.then(callback, function() {
            return callback();
        });
    }, [
        propsLoadOptions
    ]);
    (0, $eUqFw.useEffect)(function() {
        if (propsDefaultOptions === true) loadOptions(stateInputValue, function(options) {
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var onInputChange = (0, $eUqFw.useCallback)(function(newValue, actionMeta) {
        var inputValue = (0, $jQxSL.L)(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue('');
            setLoadedInputValue('');
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            var request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, function(options) {
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? (0, $1Xn5q.default)((0, $1Xn5q.default)({}, optionsCache), {}, (0, $5zQU9.default)({}, inputValue, options)) : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    var options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, restSelectProps), {}, {
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    });
}

});

parcelRegister("6xNN4", function(module, exports) {

$parcel$export(module.exports, "u", () => $4c3c7280e822f6fb$export$3b14a55fb2447963);

var $1Xn5q = parcelRequire("1Xn5q");

var $fVK4C = parcelRequire("fVK4C");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $cEc3i = parcelRequire("cEc3i");
var $4c3c7280e822f6fb$var$_excluded = [
    "allowCreateWhileLoading",
    "createOptionPosition",
    "formatCreateLabel",
    "isValidNewOption",
    "getNewOptionData",
    "onCreateOption",
    "options",
    "onChange"
];
var $4c3c7280e822f6fb$var$compareOption = function compareOption() {
    var inputValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var option = arguments.length > 1 ? arguments[1] : undefined;
    var accessors = arguments.length > 2 ? arguments[2] : undefined;
    var candidate = String(inputValue).toLowerCase();
    var optionValue = String(accessors.getOptionValue(option)).toLowerCase();
    var optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
    return optionValue === candidate || optionLabel === candidate;
};
var $4c3c7280e822f6fb$var$builtins = {
    formatCreateLabel: function formatCreateLabel(inputValue) {
        return "Create \"".concat(inputValue, "\"");
    },
    isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions, accessors) {
        return !(!inputValue || selectValue.some(function(option) {
            return $4c3c7280e822f6fb$var$compareOption(inputValue, option, accessors);
        }) || selectOptions.some(function(option) {
            return $4c3c7280e822f6fb$var$compareOption(inputValue, option, accessors);
        }));
    },
    getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
        return {
            label: optionLabel,
            value: inputValue,
            __isNew__: true
        };
    }
};
function $4c3c7280e822f6fb$export$3b14a55fb2447963(_ref) {
    var _ref$allowCreateWhile = _ref.allowCreateWhileLoading, allowCreateWhileLoading = _ref$allowCreateWhile === void 0 ? false : _ref$allowCreateWhile, _ref$createOptionPosi = _ref.createOptionPosition, createOptionPosition = _ref$createOptionPosi === void 0 ? 'last' : _ref$createOptionPosi, _ref$formatCreateLabe = _ref.formatCreateLabel, formatCreateLabel = _ref$formatCreateLabe === void 0 ? $4c3c7280e822f6fb$var$builtins.formatCreateLabel : _ref$formatCreateLabe, _ref$isValidNewOption = _ref.isValidNewOption, isValidNewOption = _ref$isValidNewOption === void 0 ? $4c3c7280e822f6fb$var$builtins.isValidNewOption : _ref$isValidNewOption, _ref$getNewOptionData = _ref.getNewOptionData, getNewOptionData = _ref$getNewOptionData === void 0 ? $4c3c7280e822f6fb$var$builtins.getNewOptionData : _ref$getNewOptionData, onCreateOption = _ref.onCreateOption, _ref$options = _ref.options, propsOptions = _ref$options === void 0 ? [] : _ref$options, propsOnChange = _ref.onChange, restSelectProps = (0, $bwPfh.default)(_ref, $4c3c7280e822f6fb$var$_excluded);
    var _restSelectProps$getO = restSelectProps.getOptionValue, getOptionValue$1 = _restSelectProps$getO === void 0 ? (0, $cEc3i.g) : _restSelectProps$getO, _restSelectProps$getO2 = restSelectProps.getOptionLabel, getOptionLabel$1 = _restSelectProps$getO2 === void 0 ? (0, $cEc3i.b) : _restSelectProps$getO2, inputValue = restSelectProps.inputValue, isLoading = restSelectProps.isLoading, isMulti = restSelectProps.isMulti, value = restSelectProps.value, name = restSelectProps.name;
    var newOption = (0, $eUqFw.useMemo)(function() {
        return isValidNewOption(inputValue, (0, $jQxSL.I)(value), propsOptions, {
            getOptionValue: getOptionValue$1,
            getOptionLabel: getOptionLabel$1
        }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined;
    }, [
        formatCreateLabel,
        getNewOptionData,
        getOptionLabel$1,
        getOptionValue$1,
        inputValue,
        isValidNewOption,
        propsOptions,
        value
    ]);
    var options = (0, $eUqFw.useMemo)(function() {
        return (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [
            newOption
        ].concat((0, $fVK4C.default)(propsOptions)) : [].concat((0, $fVK4C.default)(propsOptions), [
            newOption
        ]) : propsOptions;
    }, [
        allowCreateWhileLoading,
        createOptionPosition,
        isLoading,
        newOption,
        propsOptions
    ]);
    var onChange = (0, $eUqFw.useCallback)(function(newValue, actionMeta) {
        if (actionMeta.action !== 'select-option') return propsOnChange(newValue, actionMeta);
        var valueArray = Array.isArray(newValue) ? newValue : [
            newValue
        ];
        if (valueArray[valueArray.length - 1] === newOption) {
            if (onCreateOption) onCreateOption(inputValue);
            else {
                var newOptionData = getNewOptionData(inputValue, inputValue);
                var newActionMeta = {
                    action: 'create-option',
                    name: name,
                    option: newOptionData
                };
                propsOnChange((0, $jQxSL.D)(isMulti, [].concat((0, $fVK4C.default)((0, $jQxSL.I)(value)), [
                    newOptionData
                ]), newOptionData), newActionMeta);
            }
            return;
        }
        propsOnChange(newValue, actionMeta);
    }, [
        getNewOptionData,
        inputValue,
        isMulti,
        name,
        newOption,
        onCreateOption,
        propsOnChange,
        value
    ]);
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, restSelectProps), {}, {
        options: options,
        onChange: onChange
    });
}

});



parcelRegister("7qsUN", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ea3a72995e03d72$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9ea3a72995e03d72$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    placeHolder: {
        "id": "servicedesk-customers-organization-common.common.organizations-select-field.organizations-single-select.place-holder",
        "defaultMessage": "Choose or create an organization"
    },
    createNew: {
        "id": "servicedesk-customers-organization-common.common.organizations-select-field.organizations-single-select.create-new",
        "defaultMessage": "{orgName} (create new)"
    },
    noOptionsMessage: {
        "id": "servicedesk-customers-organization-common.common.organizations-select-field.organizations-single-select.no-options-message",
        "defaultMessage": "Start typing to create a new organization"
    }
});

});

parcelRegister("eWXlq", function(module, exports) {

$parcel$export(module.exports, "useSelectUtils", () => $0736d317a6c3fcc7$export$4c82a60b518ea238);

var $hbLiM = parcelRequire("hbLiM");
const $0736d317a6c3fcc7$export$4c82a60b518ea238 = ({ onSelect: onSelect, onFetchOptions: onFetchOptions })=>{
    const onChange = (selectedOption)=>{
        onSelect(selectedOption);
    };
    const getNewOptionData = (name, label)=>({
            label: label,
            name: name,
            value: (0, $hbLiM.NEW),
            status: '',
            numberOfOtherProjects: 0
        });
    const loadOptions = (query, resolve)=>{
        onFetchOptions({
            query: query,
            resolve: resolve
        });
    };
    const isValidNewOption = (inputValue, inputAsOption, OptionList)=>{
        if (!inputValue || !inputValue.trim()) return false;
        return !OptionList.some(({ name: name })=>name.toLowerCase() === inputValue.trim().toLowerCase());
    };
    const formatOptionLabel = ({ label: label, name: name, status: status, value: value })=>{
        if ((0, $hbLiM.isNew)(value)) return label;
        return `${name}${status ? ` (${status})` : ''}`;
    };
    return {
        onChange: onChange,
        loadOptions: loadOptions,
        getNewOptionData: getNewOptionData,
        isValidNewOption: isValidNewOption,
        formatOptionLabel: formatOptionLabel
    };
};

});
parcelRegister("hbLiM", function(module, exports) {

$parcel$export(module.exports, "NEW", () => $a6f248decad2c0d7$export$591d0ec9c2f920ab);
$parcel$export(module.exports, "isNew", () => $a6f248decad2c0d7$export$d113f15803554ffb);
const $a6f248decad2c0d7$export$591d0ec9c2f920ab = 'new';
const $a6f248decad2c0d7$export$d113f15803554ffb = (value)=>value === $a6f248decad2c0d7$export$591d0ec9c2f920ab;

});




parcelRegister("s2JIE", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9c94394490b3ac8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b9c94394490b3ac8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    addToOrganizationsUpdated: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.form.fields.organizations-select-field.add-to-organizations-updated",
        "defaultMessage": "Add customers to organization"
    }
});

});


parcelRegister("7voIf", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $2070df14597ace48$export$a06f1c675e846f6f);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $jMP2a = parcelRequire("jMP2a");

var $kzvQD = parcelRequire("kzvQD");

var $dgUkL = parcelRequire("dgUkL");
const $2070df14597ace48$export$a06f1c675e846f6f = ({ useAddCustomersDialogContext: useAddCustomersDialogContext, isLoading: isLoading, onCancel: onCancel, hasMultiHcAndInviteRouting: hasMultiHcAndInviteRouting })=>{
    const [{ customerEmailsInputFieldValue: customerEmailsInputFieldValue, customers: customers, helpCenter: helpCenter }] = useAddCustomersDialogContext();
    const isCustomerFormValid = Boolean(customerEmailsInputFieldValue || customers.length);
    const isValidHelpCenterSelected = hasMultiHcAndInviteRouting ? Boolean(helpCenter) : true;
    const isFormValid = isCustomerFormValid && isValidHelpCenterSelected;
    // @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type.
    const onSubmit = (0, $eUqFw.useCallback)((_, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'addCustomerButton');
    }, []);
    const handleOnCancel = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type. | TS7006 - Parameter 'analyticsEvent' implicitly has an 'any' type.
    (_, analyticsEvent)=>{
        onCancel();
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'cancelAddCustomerButton');
    }, [
        onCancel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kzvQD.FooterControls), {
        isFormValid: isFormValid,
        isLoading: isLoading,
        onSubmit: onSubmit,
        onCancel: handleOnCancel
    });
};
$2070df14597ace48$export$a06f1c675e846f6f.defaultProps = {
    useAddCustomersDialogContext: (0, $dgUkL.useAddCustomersDialogContext),
    isLoading: false,
    onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};

});

parcelRegister("aNlDF", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fd4dff087086116$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0fd4dff087086116$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    addCustomers: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.form.add-customers",
        "defaultMessage": "Add customers"
    },
    requiredField: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.form.required-field",
        "defaultMessage": "Required fields are marked with an asterisk"
    }
});

});



parcelRegister("4PQRQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0fe3e6873afa040$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f0fe3e6873afa040$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    addCustomers: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.add-customers",
        "defaultMessage": "Add customers"
    },
    addedCustomersNew: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.added-customers-new",
        "defaultMessage": "{count, plural, one {One customer has} other {{count} customers have}} been added"
    },
    addedCustomersNewMultipleHelpCenters: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.added-customers-new-multiple-help-centers",
        "defaultMessage": "{count, plural, one {Customer} other {Customers}} added to project"
    },
    addedCustomersDescriptionNew: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.added-customers-description-new",
        "defaultMessage": "They\u2019ll receive an invitation email if they haven\u2019t already been added to a project on this site."
    },
    addedCustomersWhenEmailDisabled: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.added-customers-when-email-disabled",
        "defaultMessage": "Their details will be visible in the table soon."
    }
});

});

parcelRegister("1OmMe", function(module, exports) {

$parcel$export(module.exports, "useFormSubmissionUtils", () => $0926542c95892d8f$export$306794bcfd14cc20);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $7d1RI = parcelRequire("7d1RI");


var $NDFJi = parcelRequire("NDFJi");

var $dgUkL = parcelRequire("dgUkL");

var $3FCzD = parcelRequire("3FCzD");
const $0926542c95892d8f$export$306794bcfd14cc20 = (useCommonPageContext = (0, $7d1RI.useCommonPageContext), useAddCustomersDialogContext = (0, $dgUkL.useAddCustomersDialogContext))=>{
    const { baseUrl: baseUrl, projectKey: projectKey } = useCommonPageContext();
    const isMultiHcAndInviteRoutingEnabled = (0, $1ybV0.ff)('multi_help_center_kosh_integration') && (0, $1ybV0.ff)('enable_invitation_routing_with_channel_44900');
    const { data: invitedCustomers, loading: isSubmitting, error: error, fetch: inviteCustomersFetch, resetAll: resetInviteCustomer } = (0, $3FCzD.useInviteCustomerService)(baseUrl, projectKey);
    const [{ customerEmailsInputFieldValue: customerEmailsInputFieldValue, customers: customers, defaultOrganization: defaultOrganization, organization: organization, helpCenter: helpCenter }, { resetForm: resetForm }] = useAddCustomersDialogContext();
    // onSubmit get email's from validated list and
    // concat with email's from input text field and pass it down to api
    // When multiHc is disabled we send the helpCenter as undefined which will result to default help center
    const selectedHelpCenter = isMultiHcAndInviteRoutingEnabled ? helpCenter : undefined;
    const onFormSubmit = (0, $eUqFw.useCallback)(()=>{
        inviteCustomersFetch([
            ...customers.map(({ emailAddress: emailAddress })=>emailAddress),
            ...(0, $NDFJi.splitInputTextBySeparator)(customerEmailsInputFieldValue)
        ], organization || defaultOrganization, selectedHelpCenter);
    }, [
        customerEmailsInputFieldValue,
        customers,
        defaultOrganization,
        inviteCustomersFetch,
        organization,
        selectedHelpCenter
    ]);
    // if there are any failed errors switch to Unsuccessful view.
    const formSubmissionStatus = (0, $eUqFw.useMemo)(()=>{
        if (invitedCustomers) {
            const { failed: failed } = invitedCustomers;
            return failed.length > 0 ? (0, $f03a99a9199936f4$export$8a5cac0f50542e41) : (0, $f03a99a9199936f4$export$523ddafd4d035371);
        }
        return 0, $f03a99a9199936f4$export$f5940ec982f5760a;
    }, [
        invitedCustomers
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            if (formSubmissionStatus !== (0, $f03a99a9199936f4$export$f5940ec982f5760a)) {
                resetForm();
                resetInviteCustomer();
            }
        }, [
        formSubmissionStatus,
        resetForm,
        resetInviteCustomer
    ]);
    return {
        invitedCustomers: invitedCustomers,
        isSubmitting: isSubmitting,
        formSubmissionStatus: formSubmissionStatus,
        error: error,
        onFormSubmit: onFormSubmit
    };
};

});
parcelRegister("3FCzD", function(module, exports) {

$parcel$export(module.exports, "useInviteCustomerService", () => $3917880676ec71f4$export$87fa0fb80753bd93);

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");

var $guiFP = parcelRequire("guiFP");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $fV97Z = parcelRequire("fV97Z");

var $hbLiM = parcelRequire("hbLiM");

var $9bAhP = parcelRequire("9bAhP");

var $jbVye = parcelRequire("jbVye");
const $3917880676ec71f4$export$87fa0fb80753bd93 = (baseUrl, projectKey)=>{
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const [data, setData] = (0, $eUqFw.useState)(null);
    const [error, setError] = (0, $eUqFw.useState)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const resetAll = (0, $eUqFw.useCallback)(()=>{
        setLoading(false);
        setError(null);
        setData(null);
    }, []);
    const fetch = (0, $eUqFw.useCallback)(async (emails, selectedOrganization, helpCenter)=>{
        setLoading(true);
        setError(null);
        const name = selectedOrganization ? selectedOrganization.name : undefined;
        const value = selectedOrganization ? selectedOrganization.value : undefined;
        const isExistingOrganization = !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(value) && !(0, $hbLiM.isNew)(value);
        const asyncRequest = isExistingOrganization ? (0, $fV97Z.performPutRequest) : (0, $fV97Z.performPostRequest);
        const requestParams = isExistingOrganization ? {
            id: value
        } : {
            name: name
        };
        const helpCenterAri = helpCenter ? helpCenter.value : undefined;
        (0, $9bAhP.addCustomersExperience).start();
        try {
            const response = await asyncRequest((0, $jbVye.getUrl)(baseUrl, projectKey, requestParams), {
                body: JSON.stringify({
                    emails: emails,
                    helpCenterAri: helpCenterAri
                })
            });
            setData(response);
            setLoading(false);
            const event = createAnalyticsEvent({
                action: 'added',
                actionSubject: 'customer'
            });
            (0, $jMP2a.fireTrackAnalytics)(event, 'customer added', {
                helpCenterAri: helpCenterAri,
                organizationId: isExistingOrganization ? value : 'new',
                customerCount: response?.success.length
            });
            (0, $9bAhP.addCustomersExperience).success();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            const { reasonKey: reasonKey, errors: errors, response: response, message: message } = err;
            // Only fire analytics for unexpected errors. ValidationErrors are used when
            // the backend returns a 400. Expected 400 errors from the backend include:
            // - the email address is invalid (eg `bad@email@example.com`)
            // A 403 is also returned if the user doesn't have permission to invite, but
            // we only show the invite button after a permission check -
            // it's an unexpected error if we see it here
            const shouldFireErrorAnalytics = err.statusCode !== 400;
            if (shouldFireErrorAnalytics) (0, $guiFP.default)({
                error: err,
                meta: {
                    id: 'useInviteCustomerService',
                    packageName: 'jiraServicedeskCustomersOrganizationCommon',
                    teamName: 'boysenberry'
                },
                sendToPrivacyUnsafeSplunk: true,
                attributes: {
                    reasonKey: reasonKey
                }
            });
            if (reasonKey || errors) {
                const errResponse = (0, $jbVye.getNormalisedErrorResponse)(emails, message);
                setData(errResponse);
            } else setData(response);
            setLoading(false);
            (0, $9bAhP.addCustomersExperience).failure();
        }
    }, [
        baseUrl,
        createAnalyticsEvent,
        projectKey
    ]);
    return {
        loading: loading,
        error: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type '((Error | ValidationErrors | { statusCode: number; message?: string | undefined; }) & ValidationErrors) | null'.
        error,
        data: data,
        fetch: // @ts-expect-error - TS2322 - Type '(emails: string[], selectedOrganization?: Organization | undefined) => Promise<void>' is not assignable to type '(() => Promise<void>) & ((emails: string[], organization?: Organization | undefined) => Promise<void>)'.
        fetch,
        resetAll: resetAll
    };
};

});
parcelRegister("9bAhP", function(module, exports) {

$parcel$export(module.exports, "customersSearchPageLoadExperience", () => $e1150f48b1fc7442$export$61e599b0d34da2ca);
$parcel$export(module.exports, "customersAddOrganizationsExperience", () => $e1150f48b1fc7442$export$84f192290bc89991);
$parcel$export(module.exports, "addCustomersExperience", () => $e1150f48b1fc7442$export$79bf9994161d022d);
$parcel$export(module.exports, "organizationsSearchPageLoadExperience", () => $e1150f48b1fc7442$export$279040ebcab27f66);
$parcel$export(module.exports, "organizationsEditOrganizationExperience", () => $e1150f48b1fc7442$export$5296ba6bbe54bab3);
$parcel$export(module.exports, "organizationsDeleteOrganizationExperience", () => $e1150f48b1fc7442$export$59d239ec2b4de868);
$parcel$export(module.exports, "organizationsRemoveFromProjectExperience", () => $e1150f48b1fc7442$export$72b1810a14185543);
$parcel$export(module.exports, "removeOrganizationExperience", () => $e1150f48b1fc7442$export$3963aeaf4a56bd80);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
const $e1150f48b1fc7442$export$61e599b0d34da2ca = new (0, $kDfSL.UFOExperience)('jsm-customers-component-search-page-load', {
    type: (0, $12kyE.ExperienceTypes).Load,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad
});
const $e1150f48b1fc7442$export$84f192290bc89991 = new (0, $kDfSL.UFOExperience)('jsm-customers-component-add-organizations', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult
});
const $e1150f48b1fc7442$export$79bf9994161d022d = new (0, $kDfSL.UFOExperience)('jsm-customers-component-add-customers', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult
});
const $e1150f48b1fc7442$export$279040ebcab27f66 = new (0, $kDfSL.UFOExperience)('jsm-organizations-component-search-page-load', {
    type: (0, $12kyE.ExperienceTypes).Load,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad
});
const $e1150f48b1fc7442$export$5296ba6bbe54bab3 = new (0, $kDfSL.UFOExperience)('jsm-organizations-component-edit-organization', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult
});
const $e1150f48b1fc7442$export$59d239ec2b4de868 = new (0, $kDfSL.UFOExperience)('jsm-organizations-component-delete-organization', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult
});
const $e1150f48b1fc7442$export$72b1810a14185543 = new (0, $kDfSL.UFOExperience)('jsm-organizations-component-remove-from-project', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult
});
const $e1150f48b1fc7442$export$3963aeaf4a56bd80 = new (0, $kDfSL.UFOExperience)('jsm-customers-component-remove-organization', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult
});
const $e1150f48b1fc7442$export$191cbf8bc5a77d43 = new (0, $kDfSL.UFOExperience)('jsm-help-center-data-fetch', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult
});

});

parcelRegister("jbVye", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $65771b787468621f$export$94df0e59ebebf4a7);
$parcel$export(module.exports, "getNormalisedErrorResponse", () => $65771b787468621f$export$5728355a49dfa06c);

var $ldoFd = parcelRequire("ldoFd");

var $53ciZ = parcelRequire("53ciZ");
const $65771b787468621f$var$stringifyOptions = {
    skipNull: true,
    skipEmptyString: true,
    sort: false
};
const $65771b787468621f$export$94df0e59ebebf4a7 = (baseUrl, projectKey, { name: name, id: id } = {})=>{
    const defaultUrl = `${baseUrl}/rest/servicedesk/1/pages/people/customers/pagination/${projectKey}/invite`;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(name) && (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(id)) return defaultUrl;
    // @ts-expect-error - TS2559 - Type '{ readonly skipNull: true; readonly skipEmptyString: true; readonly sort: false; }' has no properties in common with type 'StringifyOptions'.
    return `${defaultUrl}/organisation?${(0, $53ciZ.stringify)({
        name: name,
        id: id
    }, $65771b787468621f$var$stringifyOptions)}`;
};
const $65771b787468621f$export$747d1d330d4149d2 = (emails, errMsg)=>{
    const errArr = errMsg.split(' ').map((str)=>str.replace(',', ''));
    // exactly match email to error message eg: test in test@email.com should not be matched
    // should only match example@email.com in example@email.com, not in example@email.com.au
    return emails.filter((email)=>errArr.indexOf(email) > -1);
};
const $65771b787468621f$export$5728355a49dfa06c = (emails, reasonKey)=>{
    const invalidEmails = $65771b787468621f$export$747d1d330d4149d2(emails, reasonKey);
    const failed = invalidEmails.map((email)=>({
            displayName: email,
            emailAddress: email,
            key: email,
            error: reasonKey
        }));
    return {
        failed: failed,
        success: [],
        optimisticCustomerListUpdateResults: []
    };
};

});





parcelRegister("bwDmb", function(module, exports) {

$parcel$export(module.exports, "AddOrganizationsInlineDialogButton", () => $ab452dd4e61967c7$export$9797a7be620e94b7);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $29yDk = parcelRequire("29yDk");

var $giAhk = parcelRequire("giAhk");

var $NqqMP = parcelRequire("NqqMP");

var $lDc85 = parcelRequire("lDc85");

var $iRsWt = parcelRequire("iRsWt");

var $dat0s = parcelRequire("dat0s");
const $ab452dd4e61967c7$var$AddOrganizationsInlineDialogTrigger = ({ intl: { formatMessage: formatMessage } })=>{
    const [organizations, setOrganizations] = (0, $eUqFw.useState)([]);
    const [isOpen, togglePopup, onCloseDialog] = (0, $NqqMP.usePopupController)();
    const onReset = (0, $eUqFw.useCallback)(()=>{
        setOrganizations([]);
    }, []);
    const onResetAndCloseDialog = (0, $eUqFw.useCallback)(()=>{
        onReset();
        onCloseDialog();
    }, [
        onCloseDialog,
        onReset
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $29yDk.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iRsWt.AddOrganizationsForm), {
            // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'Organizations'.
            organizations: organizations,
            setOrganizations: setOrganizations,
            onReset: onReset,
            onCloseDialog: onCloseDialog,
            onResetAndCloseDialog: onResetAndCloseDialog
        }),
        isOpen: isOpen,
        onClose: ({ event: event })=>{
            // don't allow in-line dialog to close if close event is triggered from AkSelect.
            // @ts-expect-error - TS2345 - Argument of type 'Event' is not assignable to parameter of type 'MouseEvent'.
            if ((0, $lDc85.isEventFromOrganizationSelectDropList)(event)) return;
            togglePopup();
        },
        placement: "bottom-end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "servicedesk-customers.ui.header-actions.add-organizations-dialog.button",
        onClick: togglePopup
    }, formatMessage((0, $dat0s.default).addOrganizations)));
};
const $ab452dd4e61967c7$export$9797a7be620e94b7 = (0, $giAhk.injectIntlV2)($ab452dd4e61967c7$var$AddOrganizationsInlineDialogTrigger);

});
parcelRegister("iRsWt", function(module, exports) {

$parcel$export(module.exports, "AddOrganizationsForm", () => $8c03e57a1ba1044c$export$63d5eafb874a84e2);

var $eUqFw = parcelRequire("eUqFw");

var $giAhk = parcelRequire("giAhk");

var $8WuJm = parcelRequire("8WuJm");
var $bFzGY = parcelRequire("bFzGY");

var $7d1RI = parcelRequire("7d1RI");

var $9bAhP = parcelRequire("9bAhP");

var $8Iss3 = parcelRequire("8Iss3");
var $adPlo = parcelRequire("adPlo");

var $6OqHe = parcelRequire("6OqHe");

var $lnZYl = parcelRequire("lnZYl");

var $49meI = parcelRequire("49meI");

var $goUX0 = parcelRequire("goUX0");
const $8c03e57a1ba1044c$var$AddOrganizationsFormView = ({ intl: { formatMessage: formatMessage }, organizations: organizations, useInviteOrganizationService: useInviteOrganizationService, setOrganizations: setOrganizations, onReset: onReset, onCloseDialog: onCloseDialog, onResetAndCloseDialog: onResetAndCloseDialog })=>{
    const { baseUrl: baseUrl, projectId: projectId } = (0, $7d1RI.useCommonPageContext)();
    const { data: invitedOrganizations, loading: isSubmitting, error: error, fetch: onInvite } = useInviteOrganizationService(baseUrl, projectId);
    const [, { fetchAndUpdatePageData: fetchAndUpdatePageData }] = (0, $6OqHe.useAppStore)();
    const onSubmit = ()=>{
        (0, $9bAhP.customersAddOrganizationsExperience).start();
        onInvite(organizations);
    };
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        if (invitedOrganizations) {
            fetchAndUpdatePageData({
                createAnalyticsEvent: createAnalyticsEvent
            });
            (0, $9bAhP.customersAddOrganizationsExperience).success();
            onReset();
        }
    }, [
        createAnalyticsEvent,
        fetchAndUpdatePageData,
        invitedOrganizations,
        onReset
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (error) (0, $9bAhP.customersAddOrganizationsExperience).failure();
    }, [
        error
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Iss3.DialogWrapper), {
        "data-test-id": "servicedesk-customers.ui.header-actions.add-organizations-dialog.form.dialog-wrappper"
    }, invitedOrganizations ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $adPlo.SuccessFlag), {
        title: formatMessage((0, $goUX0.default).addOrganizations),
        description: formatMessage((0, $goUX0.default).successfullyAddedOrganizations, {
            organizationsCount: organizations.length
        }),
        onDismissed: onCloseDialog
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "addOrganizations",
        sourceType: (0, $41ea3621645e2acc$export$cae2783c9279926)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $49meI.Form), {
        isSubmitting: isSubmitting,
        error: error,
        onReset: onResetAndCloseDialog,
        onSubmit: onSubmit,
        organizations: organizations,
        setOrganizations: setOrganizations
    })));
};
$8c03e57a1ba1044c$var$AddOrganizationsFormView.defaultProps = {
    useInviteOrganizationService: (0, $lnZYl.useInviteOrganizationService)
};
const $8c03e57a1ba1044c$export$63d5eafb874a84e2 = (0, $giAhk.injectIntlV2)($8c03e57a1ba1044c$var$AddOrganizationsFormView);

});
parcelRegister("lnZYl", function(module, exports) {

$parcel$export(module.exports, "useInviteOrganizationService", () => $470741ba7336e379$export$e33069e484b04dbd);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $7byHA = parcelRequire("7byHA");
var $lRmyA = parcelRequire("lRmyA");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $eCyk6 = parcelRequire("eCyk6");
const $470741ba7336e379$export$e33069e484b04dbd = (baseUrl, projectId)=>{
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const [data, setData] = (0, $eUqFw.useState)(null);
    const [error, setError] = (0, $eUqFw.useState)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const fetch = (0, $eUqFw.useCallback)(async (organizations)=>{
        setLoading(true);
        setError(null);
        try {
            const response = await (0, $lRmyA.performPutRequest)((0, $eCyk6.getUrl)(baseUrl, projectId), {
                body: JSON.stringify((0, $eCyk6.getRequestPayload)(organizations))
            });
            if ((0, $1ybV0.ff)('organisation-domains-organisation-detail-page_j5f14') && response.organizationsCreated.length > 0) (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'organization created', {
                organizationCount: response.organizationsCreated.length
            });
            setData(response);
            setLoading(false);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setLoading(false);
            setError(err);
            // Only fire analytics for unexpected errors. ValidationErrors are used when
            // the backend returns a 400. Expected 400 errors from the backend include:
            // - organization name is > 200 characters
            // A 403 is returned if the user doesn't have permission to manage organizations,
            // but I'm not sure how to replicate that situation so I'll leave it as unexpected
            const shouldFireErrorAnalytics = !(0, $7byHA.isValidationError)(err);
            if (shouldFireErrorAnalytics) (0, $guiFP.default)({
                error: err,
                meta: {
                    id: 'useInviteOrganizationService',
                    packageName: 'jiraServicedeskCustomers',
                    teamName: 'boysenberry'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        baseUrl,
        projectId,
        createAnalyticsEvent
    ]);
    return {
        loading: loading,
        error: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type '((Error | ValidationErrors | { statusCode: number; message?: string | undefined; }) & ValidationErrors) | null'.
        error,
        data: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'ServiceData<Data>'.
        data,
        fetch: // @ts-expect-error - TS2322 - Type '(organizations: Organizations) => Promise<void>' is not assignable to type '(() => Promise<void>) & ((arg1: Organizations) => Promise<void>)'.
        fetch
    };
};

});
parcelRegister("eCyk6", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $0813a733ee675575$export$94df0e59ebebf4a7);
$parcel$export(module.exports, "getRequestPayload", () => $0813a733ee675575$export$6ef87b3284359833);

var $hbLiM = parcelRequire("hbLiM");
const $0813a733ee675575$export$94df0e59ebebf4a7 = (baseUrl, projectId)=>`${baseUrl}/rest/servicedesk/1/servicedesk/${projectId}/organisation/invite`;
const $0813a733ee675575$export$6ef87b3284359833 = (organizations = [])=>organizations.reduce((payload, { name: name, value: value })=>{
        if ((0, $hbLiM.isNew)(value)) // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        payload.newOrganisationNames.push(name);
        else // @ts-expect-error - TS2345 - Argument of type 'string | number | undefined' is not assignable to parameter of type 'never'.
        payload.existingOrganisationIds.push(value);
        return payload;
    }, {
        existingOrganisationIds: [],
        newOrganisationNames: []
    });

});


parcelRegister("49meI", function(module, exports) {

$parcel$export(module.exports, "Form", () => $5bf8592982b2de69$export$a7fed597f4b8afd8);

var $eUqFw = parcelRequire("eUqFw");

var $lzLxZ = parcelRequire("lzLxZ");
var $aYQ0Q = parcelRequire("aYQ0Q");
var $6ROLN = parcelRequire("6ROLN");

var $giAhk = parcelRequire("giAhk");

var $7d1RI = parcelRequire("7d1RI");

var $aOiov = parcelRequire("aOiov");

var $5TKMB = parcelRequire("5TKMB");
var $lh8mK = parcelRequire("lh8mK");
var $5kjXv = parcelRequire("5kjXv");

var $goUX0 = parcelRequire("goUX0");
const $5bf8592982b2de69$var$INPUT_ID = 'add-organizations-field';
const $5bf8592982b2de69$var$FormView = ({ intl: { formatMessage: formatMessage }, organizations: organizations, setOrganizations: setOrganizations, isSubmitting: isSubmitting, onReset: onReset, onSubmit: onSubmit, error: error })=>{
    const { baseUrl: baseUrl, projectId: projectId, projectKey: projectKey } = (0, $7d1RI.useCommonPageContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lzLxZ.default), {
        onSubmit: onSubmit
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("form", {
            ...formProps,
            name: "add-organizations-form"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aYQ0Q.default), {
            title: formatMessage((0, $goUX0.default).addOrganizations)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ROLN.Label), {
            htmlFor: $5bf8592982b2de69$var$INPUT_ID
        }, formatMessage((0, $goUX0.default).selectOrgLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5kjXv.OrganizationsSelectField), {
            inputId: $5bf8592982b2de69$var$INPUT_ID,
            // @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
            baseUrl: baseUrl,
            // @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
            projectId: projectId,
            // @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
            projectKey: projectKey,
            selectedOrganizations: organizations,
            onModify: setOrganizations,
            isMulti: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lh8mK.OrganizationList), {
            organizations: organizations,
            onRemove: setOrganizations
        }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOiov.FormErrors), {
            formErrors: error
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5TKMB.Footer), {
            isLoading: isSubmitting,
            organizations: organizations,
            onCancel: onReset
        })));
};
const $5bf8592982b2de69$export$a7fed597f4b8afd8 = (0, $giAhk.injectIntlV2)($5bf8592982b2de69$var$FormView);

});
parcelRegister("5TKMB", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $b464cef732aa1e37$export$a06f1c675e846f6f);

var $eUqFw = parcelRequire("eUqFw");

var $ietBz = parcelRequire("ietBz");
const $b464cef732aa1e37$export$a06f1c675e846f6f = ({ isLoading: isLoading, organizations: organizations, onCancel: onCancel })=>{
    const isFormValid = organizations && organizations.length > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ietBz.Footer), {
        isFormValid: isFormValid,
        isLoading: isLoading,
        onCancel: onCancel
    });
};
$b464cef732aa1e37$export$a06f1c675e846f6f.defaultProps = {
    isLoading: false
};

});

parcelRegister("lh8mK", function(module, exports) {

$parcel$export(module.exports, "OrganizationList", () => $4f279daa4f5ead8a$export$cd4ccaec2b292eeb);

var $eUqFw = parcelRequire("eUqFw");

var $cGL6G = parcelRequire("cGL6G");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $leWBI = parcelRequire("leWBI");
const $4f279daa4f5ead8a$export$cd4ccaec2b292eeb = (props)=>{
    const rows = (0, $leWBI.useRows)(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $4f279daa4f5ead8a$var$tableContainerStyles,
        "data-testId": "servicedesk-customers.ui.header-actions.add-organizations-dialog.form.fields.selected-list.table-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cGL6G.default), {
        rows: rows,
        // @ts-expect-error - TS2769 - No overload matches this call.
        paginationi18n: {
            prev: '',
            next: ''
        },
        isFixedSize: true
    }));
};
const $4f279daa4f5ead8a$var$tableContainerStyles = (0, $1ZAYh.xcss)({
    // @ts-expect-error - TS2322 - Object literal may only specify known properties
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    thead: {
        borderBottom: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    tbody: {
        borderBottom: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    tfoot: {
        borderBottom: 'none'
    },
    marginTop: 'space.250'
});

});
parcelRegister("cGL6G", function(module, exports) {

$parcel$export(module.exports, "default", () => $fee9e861fc13653b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");

var $fVXMO = parcelRequire("fVXMO");

var $clqWl = parcelRequire("clqWl");
class $fee9e861fc13653b$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.defaultProps = {
            defaultPage: 1,
            isLoading: false,
            isFixedSize: false,
            isRankable: false,
            onSetPage: (0, $5Q9wj.default),
            onSort: (0, $5Q9wj.default),
            rowsPerPage: Infinity
        };
    }
    UNSAFE_componentWillReceiveProps(newProps) {
        const sortKey = newProps.sortKey || this.state.sortKey;
        const sortOrder = newProps.sortOrder || this.state.sortOrder;
        const page = newProps.page || this.state.page;
        this.setState({
            page: page,
            sortKey: sortKey,
            sortOrder: sortOrder,
            rows: newProps.rows
        });
    }
    render() {
        const { page: page, sortKey: sortKey, sortOrder: sortOrder, rows: rows } = this.state;
        const { caption: caption, emptyView: emptyView, head: head, highlightedRowIndex: highlightedRowIndex, loadingSpinnerSize: loadingSpinnerSize, isLoading: isLoading, loadingLabel: loadingLabel, isFixedSize: isFixedSize, isRankable: isRankable, isRankingDisabled: isRankingDisabled, rowsPerPage: rowsPerPage, paginationi18n: paginationi18n, onRankStart: onRankStart, onPageRowsUpdate: onPageRowsUpdate, testId: testId, label: label } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $clqWl.default), {
            paginationi18n: paginationi18n,
            caption: caption,
            emptyView: emptyView,
            head: head,
            highlightedRowIndex: highlightedRowIndex,
            loadingSpinnerSize: loadingSpinnerSize,
            isLoading: isLoading,
            loadingLabel: loadingLabel,
            isFixedSize: isFixedSize,
            onSetPage: this.onSetPageHandler,
            onSort: this.onSortHandler,
            page: page,
            rows: rows,
            rowsPerPage: rowsPerPage,
            sortKey: sortKey,
            sortOrder: sortOrder,
            isRankable: isRankable,
            isRankingDisabled: isRankingDisabled,
            onRankEnd: this.onRankEndHandler,
            onRankStart: onRankStart,
            onPageRowsUpdate: onPageRowsUpdate,
            testId: testId,
            label: label
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            page: this.props.defaultPage,
            sortKey: this.props.defaultSortKey,
            sortOrder: this.props.defaultSortOrder,
            rows: this.props.rows
        };
        this.onSetPageHandler = (page, analyticsEvent)=>{
            const { onSetPage: onSetPage } = this.props;
            if (onSetPage) {
                onSetPage(page, analyticsEvent);
                this.setState({
                    page: page
                });
            }
        };
        this.onSortHandler = ({ key: key, item: item, sortOrder: sortOrder }, analyticsEvent)=>{
            const { onSort: onSort } = this.props;
            if (onSort) {
                onSort({
                    key: key,
                    item: item,
                    sortOrder: sortOrder
                }, analyticsEvent);
                this.setState({
                    sortKey: key,
                    sortOrder: sortOrder
                });
            }
        };
        this.onRankEndIfExistsHandler = (params)=>{
            if (this.props.onRankEnd) this.props.onRankEnd(params);
        };
        this.onRankEndHandler = (params)=>{
            const { destination: destination } = params;
            const { rows: rows, page: page } = this.state;
            const { rowsPerPage: rowsPerPage } = this.props;
            if (!destination || !rows) {
                this.onRankEndIfExistsHandler(params);
                return;
            }
            const reordered = (0, $fVXMO.reorderRows)(params, rows, page, rowsPerPage);
            this.setState({
                rows: reordered
            });
            this.onRankEndIfExistsHandler(params);
        };
    }
}

});
parcelRegister("fVXMO", function(module, exports) {

$parcel$export(module.exports, "getPageRows", () => $9778ffcbc0ef1196$export$3987dc24b734dcab);
$parcel$export(module.exports, "assertIsSortable", () => $9778ffcbc0ef1196$export$5eb35a4771ec4090);
$parcel$export(module.exports, "validateSortKey", () => $9778ffcbc0ef1196$export$9133f5a8bfe8a200);
$parcel$export(module.exports, "inlineStylesIfRanking", () => $9778ffcbc0ef1196$export$a601f1775e10043f);
$parcel$export(module.exports, "reorderRows", () => $9778ffcbc0ef1196$export$c476bbe5da59992d);
const $9778ffcbc0ef1196$export$3987dc24b734dcab = (allRows, pageNumber, rowsPerPage)=>{
    if (!pageNumber || !rowsPerPage || !allRows.length) return [];
    return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
};
const $9778ffcbc0ef1196$export$5eb35a4771ec4090 = (head)=>{
    if (!head || !head.cells) return;
    head.cells.forEach((cell)=>{
        if (cell.isSortable && !cell.key) try {
            throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    });
};
const $9778ffcbc0ef1196$export$9133f5a8bfe8a200 = (sortKey, head)=>{
    if (!sortKey) return;
    const headHasKey = head && head.cells.map((cell)=>cell.key).includes(sortKey);
    if (!headHasKey) try {
        throw Error(`Cell with ${sortKey} key not found in head.`);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};
const $9778ffcbc0ef1196$export$a601f1775e10043f = (isRanking, width, height)=>{
    if (!isRanking) return {};
    if (height) return {
        width: width,
        height: height
    };
    return {
        width: width
    };
};
const $9778ffcbc0ef1196$export$92bcb1ed38b134a1 = (index, page, rowsPerPage)=>{
    const itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
    return index + itemOnPreviousPages;
};
const $9778ffcbc0ef1196$export$c476bbe5da59992d = (rankEnd, rows, page = 1, rowsPerPage)=>{
    const { destination: destination, sourceIndex: sourceIndex } = rankEnd;
    if (!destination) return rows;
    const fromIndex = $9778ffcbc0ef1196$export$92bcb1ed38b134a1(sourceIndex, page, rowsPerPage);
    const toIndex = $9778ffcbc0ef1196$export$92bcb1ed38b134a1(destination.index, page, rowsPerPage);
    const reordered = rows.slice();
    const [removed] = reordered.splice(fromIndex, 1);
    reordered.splice(toIndex, 0, removed);
    return reordered;
};

});

parcelRegister("clqWl", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cd2847e492d5dd4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hM7RE = parcelRequire("hM7RE");
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $5Q9wj = parcelRequire("5Q9wj");


var $fVXMO = parcelRequire("fVXMO");

var $3tjuM = parcelRequire("3tjuM");

var $iK2U9 = parcelRequire("iK2U9");

var $9t1Ml = parcelRequire("9t1Ml");

var $aLrpD = parcelRequire("aLrpD");

var $a96y2 = parcelRequire("a96y2");

var $DPlg5 = parcelRequire("DPlg5");

var $i9y06 = parcelRequire("i9y06");

var $cTO8p = parcelRequire("cTO8p");
const $7cd2847e492d5dd4$var$packageName = "platform-pkg";
const $7cd2847e492d5dd4$var$packageVersion = "0.0.0-use.local";
function $7cd2847e492d5dd4$var$toggleSortOrder(currentSortOrder) {
    switch(currentSortOrder){
        case 0, $9ad1be2eb14b8d3d$export$b6abcf7fa1d94f65:
            return 0, $9ad1be2eb14b8d3d$export$1dee026a19752d6b;
        case 0, $9ad1be2eb14b8d3d$export$1dee026a19752d6b:
            return 0, $9ad1be2eb14b8d3d$export$b6abcf7fa1d94f65;
        default:
            return currentSortOrder;
    }
}
class $7cd2847e492d5dd4$export$613134f68684a686 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.defaultProps = {
            isLoading: false,
            isFixedSize: false,
            rowsPerPage: Infinity,
            onSetPage: (0, $5Q9wj.default),
            onSort: (0, $5Q9wj.default),
            page: 1,
            isRankable: false,
            isRankingDisabled: false,
            onRankStart: (0, $5Q9wj.default),
            onRankEnd: (0, $5Q9wj.default),
            paginationi18n: {
                prev: 'Previous',
                next: 'Next',
                label: 'Pagination',
                pageLabel: 'Page'
            }
        };
    }
    UNSAFE_componentWillMount() {
        (0, $fVXMO.validateSortKey)(this.props.sortKey, this.props.head);
        (0, $fVXMO.assertIsSortable)(this.props.head);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, $fVXMO.validateSortKey)(nextProps.sortKey, nextProps.head);
        if (this.props.head !== nextProps.head) (0, $fVXMO.assertIsSortable)(nextProps.head);
    }
    render() {
        const { caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, isFixedSize: isFixedSize, page: page, rows: rows, rowsPerPage: rowsPerPage, sortKey: sortKey, sortOrder: sortOrder, isLoading: isLoading, loadingLabel: loadingLabel, isRankable: isRankable, isRankingDisabled: isRankingDisabled, paginationi18n: paginationi18n, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label } = this.props;
        const rowsLength = rows && rows.length;
        let totalPages;
        // set a flag to denote the dynamic table might get only one page of data
        // for paginated data
        let isTotalPagesControlledExternally = false;
        if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
            /**
       * If total number of rows / records have been passed down as prop
       * Then table is being fed paginated data from server or other sources
       * In this case, we want to respect information passed down by server or external source
       * Rather than relying on our computation based on number of rows
       */ totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
            isTotalPagesControlledExternally = true;
        } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
        totalPages = totalPages < 1 ? 1 : totalPages;
        const getPageNumber = page > totalPages ? totalPages : page; // page! required, because typescript can't yet see defaultProps to know that this won't be undefined
        const bodyProps = {
            highlightedRowIndex: highlightedRowIndex,
            rows: rows,
            head: head,
            sortKey: sortKey,
            sortOrder: sortOrder,
            rowsPerPage: rowsPerPage,
            page: getPageNumber,
            isFixedSize: isFixedSize || false,
            onPageRowsUpdate: onPageRowsUpdate,
            isTotalPagesControlledExternally: isTotalPagesControlledExternally,
            ref: this.tableBody,
            testId: testId
        };
        const rowsExist = !!rowsLength;
        const spinnerSize = this.getSpinnerSize();
        const emptyBody = this.renderEmptyBody();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $DPlg5.default), {
            isLoading: isLoading && rowsExist,
            spinnerSize: spinnerSize,
            targetRef: ()=>this.tableBody.current,
            testId: testId,
            loadingLabel: loadingLabel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3tjuM.Table), {
            isFixedSize: isFixedSize,
            "aria-label": label,
            hasDataRow: rowsExist,
            testId: testId,
            isLoading: isLoading
        }, !!caption && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3tjuM.Caption), null, caption), head && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cTO8p.default), {
            head: head,
            onSort: this.onSortHandler,
            sortKey: sortKey,
            sortOrder: sortOrder,
            isRanking: this.state.isRanking,
            isRankable: isRankable,
            testId: testId
        }), rowsExist && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7cd2847e492d5dd4$var$TableBody, {
            ...bodyProps,
            isRankable: this.props.isRankable,
            isRanking: this.state.isRanking,
            onRankStart: this.onRankStartHandler,
            onRankEnd: this.onRankEndHandler,
            isRankingDisabled: isRankingDisabled || isLoading || false
        }))), totalPages <= 1 ? null : // only show pagination if there's MORE than 1 page
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3tjuM.PaginationWrapper), {
            testId: testId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i9y06.default), {
            value: getPageNumber,
            onChange: this.onSetPageHandler,
            total: totalPages,
            i18n: paginationi18n,
            isDisabled: isLoading,
            testId: testId
        })), !rowsExist && emptyBody && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a96y2.default), {
            isLoading: isLoading,
            spinnerSize: (0, $9ad1be2eb14b8d3d$export$7b93a10c0fefe3e3),
            testId: testId,
            loadingLabel: loadingLabel
        }, emptyBody));
    }
    constructor(...args){
        super(...args);
        this.tableBody = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.state = {
            isRanking: false
        };
        this.onSortHandler = (item)=>()=>{
                const { sortKey: sortKey, sortOrder: sortOrder, onSort: onSort, isRankable: isRankable } = this.props;
                const { key: key } = item;
                if (!key) return;
                if (onSort && isRankable && key === sortKey && sortOrder === (0, $9ad1be2eb14b8d3d$export$b6abcf7fa1d94f65)) {
                    onSort({
                        key: null,
                        sortOrder: null,
                        item: item
                    });
                    return;
                }
                const sortOrderFormatted = key !== sortKey ? (0, $9ad1be2eb14b8d3d$export$1dee026a19752d6b) : $7cd2847e492d5dd4$var$toggleSortOrder(sortOrder);
                if (onSort) onSort({
                    key: key,
                    item: item,
                    sortOrder: sortOrderFormatted
                });
            };
        this.onSetPageHandler = (page, event)=>{
            const { onSetPage: onSetPage } = this.props;
            if (onSetPage) onSetPage(page, event);
        };
        this.onRankStartHandler = (params)=>{
            this.setState({
                isRanking: true
            });
            if (this.props.onRankStart) this.props.onRankStart(params);
        };
        this.onRankEndHandler = (params)=>{
            this.setState({
                isRanking: false
            });
            if (this.props.onRankEnd) this.props.onRankEnd(params);
        };
        this.getSpinnerSize = ()=>{
            const { page: page, rows: rows, rowsPerPage: rowsPerPage, loadingSpinnerSize: loadingSpinnerSize } = this.props;
            if (loadingSpinnerSize) return loadingSpinnerSize;
            return (0, $fVXMO.getPageRows)(rows || [], page, rowsPerPage).length > 2 ? (0, $9ad1be2eb14b8d3d$export$7b93a10c0fefe3e3) : (0, $9ad1be2eb14b8d3d$export$71dd4c8ecd45e95f);
        };
        this.renderEmptyBody = ()=>{
            const { emptyView: emptyView, isLoading: isLoading, testId: testId } = this.props;
            if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iK2U9.EmptyViewWithFixedHeight), {
                testId: testId
            });
            return emptyView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iK2U9.EmptyViewContainer), {
                testId: testId
            }, emptyView);
        };
    }
}

const $7cd2847e492d5dd4$var$RankableTableBody = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("6muvm")));
const $7cd2847e492d5dd4$var$TableBody = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function TableBody({ isRankable: isRankable = false, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps }, ref) {
    const canRank = isRankable && !bodyProps.sortKey;
    /**
   * React 16 does not support SSR for lazy components,
   * so we avoid rendering the `Suspense` on the server.
   */ const [canRenderRankable, setCanRenderRankable] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (canRank) setCanRenderRankable(true);
    }, [
        canRank
    ]);
    const nonRankableBody = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9t1Ml.default), {
        ref: ref,
        ...bodyProps
    });
    return canRank && canRenderRankable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aLrpD.ErrorBoundary), {
        fallback: nonRankableBody
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
        fallback: nonRankableBody
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7cd2847e492d5dd4$var$RankableTableBody, {
        ref: ref,
        ...bodyProps,
        isRanking: isRanking,
        onRankStart: onRankStart,
        onRankEnd: onRankEnd,
        isRankingDisabled: isRankingDisabled
    }))) : nonRankableBody;
});
const $7cd2847e492d5dd4$var$createAndFireEventOnAtlaskit = (0, $hM7RE.default)('atlaskit');
/**
 * __Dynamic table stateless__
 *
 * A stateless table that requires consumers to manage the sorting, drag and drop, and pagination.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/dynamic-table)
 * - [Code](https://bitbucket.org/atlassian/atlassian-frontend/packages/design-system/dynamic-table)
 */ const $7cd2847e492d5dd4$var$DynamicTableStateless = (0, $1ngde.default)({
    componentName: 'dynamicTable',
    packageName: $7cd2847e492d5dd4$var$packageName,
    packageVersion: $7cd2847e492d5dd4$var$packageVersion
})((0, $2jDha.default)({
    onSort: $7cd2847e492d5dd4$var$createAndFireEventOnAtlaskit({
        action: 'sorted',
        actionSubject: 'dynamicTable',
        attributes: {
            componentName: 'dynamicTable',
            packageName: $7cd2847e492d5dd4$var$packageName,
            packageVersion: $7cd2847e492d5dd4$var$packageVersion
        }
    }),
    onRankEnd: $7cd2847e492d5dd4$var$createAndFireEventOnAtlaskit({
        action: 'ranked',
        actionSubject: 'dynamicTable',
        attributes: {
            componentName: 'dynamicTable',
            packageName: $7cd2847e492d5dd4$var$packageName,
            packageVersion: $7cd2847e492d5dd4$var$packageVersion
        }
    })
})($7cd2847e492d5dd4$export$613134f68684a686));
var $7cd2847e492d5dd4$export$2e2bcd8739ae039 = $7cd2847e492d5dd4$var$DynamicTableStateless;

});
const $9ad1be2eb14b8d3d$export$1dee026a19752d6b = 'ASC';
const $9ad1be2eb14b8d3d$export$b6abcf7fa1d94f65 = 'DESC';
const $9ad1be2eb14b8d3d$export$71dd4c8ecd45e95f = 'small';
const $9ad1be2eb14b8d3d$export$7b93a10c0fefe3e3 = 'large';
const $9ad1be2eb14b8d3d$export$3843c586a90b9cbf = 0.22;

parcelRegister("3tjuM", function(module, exports) {

$parcel$export(module.exports, "tableRowCSSVars", () => $1430aaf59e7cbeab$export$3b9ea2c10c245fdb);
$parcel$export(module.exports, "Table", () => $1430aaf59e7cbeab$export$54ec01a60f47d33d);
$parcel$export(module.exports, "Caption", () => $1430aaf59e7cbeab$export$32fbfacc5d962e0c);
$parcel$export(module.exports, "PaginationWrapper", () => $1430aaf59e7cbeab$export$3e5e12dc01f20a43);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $g2Ovh = parcelRequire("g2Ovh");
function $1430aaf59e7cbeab$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1430aaf59e7cbeab$export$3b9ea2c10c245fdb = {
    CSS_VAR_HOVER_BACKGROUND: '--local-dynamic-table-hover-bg',
    CSS_VAR_HIGHLIGHTED_BACKGROUND: '--local-dynamic-table-highlighted-bg',
    CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND: '--local-dynamic-table-hover-highlighted-bg',
    CSS_VAR_ROW_FOCUS_OUTLINE: '--local-dynamic-table-row-focus-outline'
};
const $1430aaf59e7cbeab$var$fixedSizeTableStyles = {
    name: "wgb42e",
    styles: "table-layout:fixed"
};
const $1430aaf59e7cbeab$var$tableStyles = {
    name: "mul4pg",
    styles: "width:100%;border-collapse:separate;border-spacing:0px"
};
const $1430aaf59e7cbeab$var$bodyBorder = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderBlockEnd: `2px solid ${(0, $g2Ovh.tableBorder).borderColor}`
});
const $1430aaf59e7cbeab$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("table", {
        inert: isLoading ? '' : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [$1430aaf59e7cbeab$export$3b9ea2c10c245fdb.CSS_VAR_HOVER_BACKGROUND]: (0, $g2Ovh.row).hoverBackground,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [$1430aaf59e7cbeab$export$3b9ea2c10c245fdb.CSS_VAR_HIGHLIGHTED_BACKGROUND]: (0, $g2Ovh.row).highlightedBackground,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [$1430aaf59e7cbeab$export$3b9ea2c10c245fdb.CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND]: (0, $g2Ovh.row).hoverHighlightedBackground,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [$1430aaf59e7cbeab$export$3b9ea2c10c245fdb.CSS_VAR_ROW_FOCUS_OUTLINE]: (0, $g2Ovh.row).focusOutline
        },
        css: [
            $1430aaf59e7cbeab$var$tableStyles,
            isFixedSize && $1430aaf59e7cbeab$var$fixedSizeTableStyles,
            hasDataRow && $1430aaf59e7cbeab$var$bodyBorder
        ],
        ref: ref,
        ...rest,
        "data-testid": testId && `${testId}--table`
    }, children);
});
const $1430aaf59e7cbeab$var$captionStyles = {
    name: "125out0",
    styles: "font:var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-end:var(--ds-space-100, 8px);will-change:transform"
};
const $1430aaf59e7cbeab$var$oldCaptionStyles = {
    name: "4vsxw5",
    styles: "font-weight:var(--ds-font-weight-regular, 400);margin-block-start:28px"
};
const $1430aaf59e7cbeab$var$newCaptionStyles = {
    name: "1trrfbb",
    styles: "margin-block-start:var(--ds-space-300, 24px)"
};
const $1430aaf59e7cbeab$export$32fbfacc5d962e0c = ({ children: children })=>/*#__PURE__*/ (0, $byn9U.jsx)("caption", {
        css: [
            $1430aaf59e7cbeab$var$captionStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $XHGTv.getBooleanFF)('platform.design-system-team.dynamic-table-typography_7zio6') ? $1430aaf59e7cbeab$var$newCaptionStyles : $1430aaf59e7cbeab$var$oldCaptionStyles
        ]
    }, children);
const $1430aaf59e7cbeab$var$paginationWrapperStyles = {
    name: "zl1inp",
    styles: "display:flex;justify-content:center"
};
const $1430aaf59e7cbeab$export$3e5e12dc01f20a43 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $1430aaf59e7cbeab$var$paginationWrapperStyles,
        "data-testid": testId && `${testId}--pagination--container`
    }, children);

});
parcelRegister("g2Ovh", function(module, exports) {

$parcel$export(module.exports, "MSThemeColors", () => $47d84a50d7c96182$export$34af08ce45c78352);
$parcel$export(module.exports, "arrow", () => $47d84a50d7c96182$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "row", () => $47d84a50d7c96182$export$120ff0929b202a6d);
$parcel$export(module.exports, "head", () => $47d84a50d7c96182$export$5fd5031fecdacec3);
$parcel$export(module.exports, "tableBorder", () => $47d84a50d7c96182$export$38d703b73e2cf64d);

var $PdmhA = parcelRequire("PdmhA");
const $47d84a50d7c96182$export$34af08ce45c78352 = {
    Background: 'Canvas',
    Text: 'CanvasText',
    SelectedBackground: 'Highlight',
    SelectedText: 'HighlightText'
};
const $47d84a50d7c96182$export$f2120bbfa5450bd2 = {
    defaultColor: `var(--ds-icon-disabled, ${$PdmhA.N40})`,
    selectedColor: `var(--ds-icon-subtle, ${$PdmhA.N300})`
};
const $47d84a50d7c96182$export$120ff0929b202a6d = {
    focusOutline: `var(--ds-border-focused, ${$PdmhA.B100})`,
    highlightedBackground: `var(--ds-background-selected, ${$PdmhA.B50})`,
    hoverBackground: `var(--ds-background-neutral-subtle-hovered, ${$PdmhA.N10})`,
    hoverHighlightedBackground: `var(--ds-background-selected-hovered, ${$PdmhA.B75})`
};
const $47d84a50d7c96182$export$5fd5031fecdacec3 = {
    textColor: `var(--ds-text-subtlest, ${$PdmhA.N300})`
};
const $47d84a50d7c96182$export$38d703b73e2cf64d = {
    borderColor: `var(--ds-border, ${$PdmhA.N40})`
};

});


parcelRegister("iK2U9", function(module, exports) {

$parcel$export(module.exports, "EmptyViewWithFixedHeight", () => $1c04c67c6d2e01dc$export$8f45b9407d4090d7);
$parcel$export(module.exports, "EmptyViewContainer", () => $1c04c67c6d2e01dc$export$381ea436de119582);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $byn9U = parcelRequire("byn9U");
function $1c04c67c6d2e01dc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1c04c67c6d2e01dc$var$fixedHeightStyles = {
    name: "50gc26",
    styles: "height:9rem"
};
const $1c04c67c6d2e01dc$export$8f45b9407d4090d7 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $1c04c67c6d2e01dc$var$fixedHeightStyles,
        "data-testid": testId && `${testId}--empty-view-with-fixed-height`
    }, children);
const $1c04c67c6d2e01dc$var$emptyViewContainerStyles = {
    name: "1yld51o",
    styles: "width:50%;margin:auto;padding:10px;text-align:center"
};
const $1c04c67c6d2e01dc$export$381ea436de119582 = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $1c04c67c6d2e01dc$var$emptyViewContainerStyles,
        "data-testid": testId && `${testId}--empty-view-container`
    }, children);
};

});

parcelRegister("9t1Ml", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdc1fe407cca2cd9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2c84N = parcelRequire("2c84N");

var $a8MUu = parcelRequire("a8MUu");
class $bdc1fe407cca2cd9$var$BodyComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { pageRows: pageRows, head: head, isFixedSize: isFixedSize, highlightedRowIndex: highlightedRowIndex, testId: testId, forwardedRef: forwardedRef } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tbody", {
            "data-testid": testId && `${testId}--body`,
            ref: forwardedRef
        }, pageRows.map((row, rowIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a8MUu.default), {
                head: head,
                isFixedSize: isFixedSize,
                key: row.key || rowIndex,
                row: row,
                isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                testId: testId
            })));
    }
}
const $bdc1fe407cca2cd9$var$Body = (0, $2c84N.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bdc1fe407cca2cd9$var$BodyComponent, {
        ...props,
        forwardedRef: ref
    });
}));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$bdc1fe407cca2cd9$export$2e2bcd8739ae039 = $bdc1fe407cca2cd9$var$Body;

});
parcelRegister("2c84N", function(module, exports) {

$parcel$export(module.exports, "default", () => $1514dd575e5332c4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");


var $fVXMO = parcelRequire("fVXMO");
const $1514dd575e5332c4$var$getSortingCellValue = (cells, head, sortKey)=>{
    for(let i = 0; i < cells.length; i++){
        if (head.cells[i] && head.cells[i]?.key === sortKey) return cells[i]?.key;
    }
    return undefined;
};
// sort all rows based on sort key and order
const $1514dd575e5332c4$var$getSortedRows = (head, rows, sortKey, sortOrder)=>{
    if (!sortKey || !head) return rows;
    if (!rows) return [];
    const modifier = sortOrder === (0, $9ad1be2eb14b8d3d$export$1dee026a19752d6b) ? 1 : -1;
    // Re-initialising an I18n Collator on every sort is performance intensive, thus constructed outside
    const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: 'accent'
    });
    // Get copy of rows to avoid sorting prop in place
    const sortableRows = Array.from(rows);
    // Reorder rows in table based on sorting cell value
    // Algorithm will sort numerics or strings, but not both
    return sortableRows.sort((a, b)=>{
        const valA = $1514dd575e5332c4$var$getSortingCellValue(a.cells, head, sortKey);
        const valB = $1514dd575e5332c4$var$getSortingCellValue(b.cells, head, sortKey);
        if (valA === undefined || valB === undefined) return modifier;
        if (typeof valA !== typeof valB) {
            // numbers are always grouped higher in the sort
            if (typeof valA === 'number') return -1;
            if (typeof valB === 'number') return 1;
            // strings are grouped next
            if (typeof valA === 'string') return -1;
            if (typeof valB === 'string') return 1;
        }
        if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
        if (!valA && valA !== 0 || valA < valB) return -modifier;
        if (!valB && valB !== 0 || valA > valB) return modifier;
        if (valA === valB) return 0;
        return 1;
    });
};
function $1514dd575e5332c4$export$2e2bcd8739ae039(WrappedComponent) {
    class WithSortedPageRows extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
        static getDerivedStateFromProps(props, state) {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, page: page, rowsPerPage: rowsPerPage, isTotalPagesControlledExternally: isTotalPagesControlledExternally } = props;
            (0, $fVXMO.validateSortKey)(sortKey, head);
            let sortedRows;
            let pageRows;
            if (isTotalPagesControlledExternally) {
                sortedRows = rows;
                pageRows = rows;
            } else {
                sortedRows = $1514dd575e5332c4$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                pageRows = (0, $fVXMO.getPageRows)(sortedRows, page, rowsPerPage);
            }
            return {
                ...state,
                pageRows: pageRows
            };
        }
        componentDidMount() {
            this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
        }
        componentDidUpdate(_prevProps, prevState) {
            if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
        }
        render() {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, rowsPerPage: rowsPerPage, page: page, forwardedRef: forwardedRef, ...restProps } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                pageRows: this.state.pageRows,
                head: head,
                ...restProps,
                ref: forwardedRef
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                pageRows: []
            };
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef((props, ref)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WithSortedPageRows, {
            ...props,
            forwardedRef: ref
        });
    });
}

});

parcelRegister("a8MUu", function(module, exports) {

$parcel$export(module.exports, "default", () => $2038a3700f41e476$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4RemJ = parcelRequire("4RemJ");

var $iqL3E = parcelRequire("iqL3E");
const $2038a3700f41e476$var$Row = ({ row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted })=>{
    const { cells: cells, ...restRowProps } = row;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iqL3E.TableBodyRow), {
        ...restRowProps,
        isHighlighted: isHighlighted,
        ...isHighlighted ? {
            'data-ts--dynamic-table--table-row--highlighted': true
        } : null,
        testId: row.testId || testId && `${testId}--row-${restRowProps.key}`
    }, cells.map((cell, cellIndex)=>{
        const { content: content, testId: cellTestId, ...restCellProps } = cell;
        const { shouldTruncate: shouldTruncate, width: width } = (head || {
            cells: []
        }).cells[cellIndex] || {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4RemJ.TableBodyCell), {
            "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`,
            ...restCellProps,
            isFixedSize: isFixedSize,
            key: cellIndex,
            shouldTruncate: shouldTruncate,
            width: width
        }, content);
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2038a3700f41e476$export$2e2bcd8739ae039 = $2038a3700f41e476$var$Row;

});
parcelRegister("4RemJ", function(module, exports) {

$parcel$export(module.exports, "TableBodyCell", () => $5915d36ce36ccacb$export$948e91fcef170792);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $39mp0 = parcelRequire("39mp0");
const $5915d36ce36ccacb$export$948e91fcef170792 = ({ width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...props })=>/*#__PURE__*/ (0, $byn9U.jsx)("td", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: (0, $39mp0.getTruncationStyleVars)({
            width: width
        }),
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $39mp0.truncationWidthStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            isFixedSize && shouldTruncate && (0, $39mp0.fixedSizeTruncateStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            isFixedSize && (0, $39mp0.overflowTruncateStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $39mp0.cellStyles)
        ],
        // HOC withDimensions complains about the types but it is working fine
        // @ts-ignore
        ref: innerRef,
        ...props
    });

});
parcelRegister("39mp0", function(module, exports) {

$parcel$export(module.exports, "truncationWidthStyles", () => $ad2974e69f235483$export$708a733455f59a29);
$parcel$export(module.exports, "fixedSizeTruncateStyles", () => $ad2974e69f235483$export$616c93ee022c8812);
$parcel$export(module.exports, "overflowTruncateStyles", () => $ad2974e69f235483$export$7f2cd17defa265d8);
$parcel$export(module.exports, "getTruncationStyleVars", () => $ad2974e69f235483$export$5e6497a652ae30b5);
$parcel$export(module.exports, "cellStyles", () => $ad2974e69f235483$export$f7913df521f684e2);

var $byn9U = parcelRequire("byn9U");
function $ad2974e69f235483$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ad2974e69f235483$var$CSS_VAR_WIDTH = '--local-dynamic-table-width';
const $ad2974e69f235483$export$708a733455f59a29 = /*#__PURE__*/ (0, $byn9U.css)({
    width: `var(${$ad2974e69f235483$var$CSS_VAR_WIDTH})`
});
const $ad2974e69f235483$export$616c93ee022c8812 = {
    name: "1s7jr4j",
    styles: "text-overflow:ellipsis;white-space:nowrap"
};
const $ad2974e69f235483$export$7f2cd17defa265d8 = {
    name: "d3v9zr",
    styles: "overflow:hidden"
};
const $ad2974e69f235483$export$5e6497a652ae30b5 = ({ width: width })=>typeof width !== 'undefined' ? {
        [$ad2974e69f235483$var$CSS_VAR_WIDTH]: `${width}%`
    } : undefined;
const $ad2974e69f235483$export$f7913df521f684e2 = /*#__PURE__*/ (0, $byn9U.css)({
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"}`,
    border: 'none',
    textAlign: 'left',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:first-of-type': {
        paddingInlineStart: "var(--ds-space-0, 0px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:last-child': {
        paddingInlineEnd: "var(--ds-space-0, 0px)"
    }
});

});


parcelRegister("iqL3E", function(module, exports) {

$parcel$export(module.exports, "TableBodyRow", () => $6b389a48d047c2ef$export$45f39d9c38b886d5);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $3tjuM = parcelRequire("3tjuM");
const $6b389a48d047c2ef$var$rowStyles = /*#__PURE__*/ (0, $byn9U.css)({
    backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
    '&:focus-visible': {
        outline: `2px solid ${`var(--ds-border-focused, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        `var(${(0, $3tjuM.tableRowCSSVars).CSS_VAR_HOVER_BACKGROUND})`})`}`,
        outlineOffset: `-2px`
    }
});
const $6b389a48d047c2ef$var$rowBackgroundStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&:hover': {
        backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        `var(${(0, $3tjuM.tableRowCSSVars).CSS_VAR_HOVER_BACKGROUND})`})`
    }
});
const $6b389a48d047c2ef$var$rowHighlightedBackgroundStyles = /*#__PURE__*/ (0, $byn9U.css)({
    backgroundColor: `var(--ds-background-selected, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    `var(${(0, $3tjuM.tableRowCSSVars).CSS_VAR_HIGHLIGHTED_BACKGROUND})`})`,
    '&:hover': {
        backgroundColor: `var(--ds-background-selected-hovered, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        `var(${(0, $3tjuM.tableRowCSSVars).CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND})`})`
    }
});
const $6b389a48d047c2ef$export$45f39d9c38b886d5 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("tr", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        css: [
            $6b389a48d047c2ef$var$rowStyles,
            isHighlighted ? $6b389a48d047c2ef$var$rowHighlightedBackgroundStyles : $6b389a48d047c2ef$var$rowBackgroundStyles
        ],
        ...rest,
        ref: ref,
        "data-testid": testId
    }, children);
});

});



parcelRegister("aLrpD", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $73b0e671a4d4f805$export$e926676385687eaf);

var $eUqFw = parcelRequire("eUqFw");
class $73b0e671a4d4f805$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    render() {
        if (this.state.hasError) // You can render any custom fallback UI
        return this.props.fallback;
        return this.props.children;
    }
}

});

parcelRegister("a96y2", function(module, exports) {

$parcel$export(module.exports, "default", () => $feff75185b46f730$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4Bees = parcelRequire("4Bees");


var $a53tD = parcelRequire("a53tD");
class $feff75185b46f730$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $9ad1be2eb14b8d3d$export$7b93a10c0fefe3e3),
            contentsOpacity: (0, $9ad1be2eb14b8d3d$export$3843c586a90b9cbf),
            loadingLabel: 'Loading table'
        };
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, contentsOpacity: contentsOpacity, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a53tD.Container), {
            testId: testId
        }, !isLoading ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a53tD.ContentsContainer), {
            contentsOpacity: contentsOpacity,
            testId: testId
        }, children), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a53tD.SpinnerContainer), {
            testId: testId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            size: spinnerSize,
            testId: testId && `${testId}--loadingSpinner`,
            label: loadingLabel
        })));
    }
}

});
parcelRegister("a53tD", function(module, exports) {

$parcel$export(module.exports, "Container", () => $aa6b103a00044c0b$export$42a852a2b6b56249);
$parcel$export(module.exports, "ContentsContainer", () => $aa6b103a00044c0b$export$67c29eae8ae2137a);
$parcel$export(module.exports, "SpinnerContainer", () => $aa6b103a00044c0b$export$a5e06607a5ac6158);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $byn9U = parcelRequire("byn9U");
function $aa6b103a00044c0b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $aa6b103a00044c0b$export$c335a80381ec61f5 = '--contents-opacity';
const $aa6b103a00044c0b$var$containerStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $aa6b103a00044c0b$export$42a852a2b6b56249 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $aa6b103a00044c0b$var$containerStyles,
        "data-testid": testId && `${testId}--container`
    }, children);
const $aa6b103a00044c0b$var$contentsContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    opacity: `var(${$aa6b103a00044c0b$export$c335a80381ec61f5})`,
    pointerEvents: 'none'
});
const $aa6b103a00044c0b$export$67c29eae8ae2137a = ({ children: children, contentsOpacity: contentsOpacity, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            [$aa6b103a00044c0b$export$c335a80381ec61f5]: contentsOpacity
        },
        css: [
            $aa6b103a00044c0b$var$contentsContainerStyles
        ],
        "data-testid": testId && `${testId}--contents--container`
    }, children);
const $aa6b103a00044c0b$var$spinnerContainerStyles = {
    name: "su4u96",
    styles: "display:flex;position:absolute;inset:0;align-items:center;justify-content:center"
};
const $aa6b103a00044c0b$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $aa6b103a00044c0b$var$spinnerContainerStyles,
        "data-testid": testId && `${testId}--spinner--container`
    }, children);

});


parcelRegister("DPlg5", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c0b56c99dd019f1$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ 
var $eUqFw = parcelRequire("eUqFw");

var $4Bees = parcelRequire("4Bees");


var $sM67g = parcelRequire("sM67g");
class $6c0b56c99dd019f1$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $9ad1be2eb14b8d3d$export$7b93a10c0fefe3e3),
            contentsOpacity: `var(--ds-opacity-loading, ${`${0, $9ad1be2eb14b8d3d$export$3843c586a90b9cbf}`})`,
            loadingLabel: 'Loading table'
        };
    }
    attachListeners() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
    }
    detachListeners() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    }
    updateSpinnerPosition() {
        const viewportHeight = window.innerHeight;
        const targetNode = this.getTargetNode();
        const spinnerNode = this.spinnerRef?.current;
        if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
        const targetRect = targetNode.getBoundingClientRect();
        const spinnerRect = spinnerNode.getBoundingClientRect();
        const spinnerHeight = spinnerRect.height;
        const isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
        const { top: top, bottom: bottom, height: height } = targetRect;
        if (isInViewport) {
            // The spinner may follow the element only if there is enough space:
            // Let's say the element can fit at least three spinners (vertically)
            const canFollow = height >= spinnerHeight * 3;
            if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                if (top >= 0) {
                    // Only the head of the element is visible
                    const viewportSpaceTakenByElement = viewportHeight - top;
                    const diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                    const y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                    this.translateSpinner(spinnerNode, y, true);
                } else if (top < 0 && bottom > viewportHeight) {
                    // The element takes all viewport, nor its head nor tail are visible
                    const y = viewportHeight / 2 - spinnerHeight / 2;
                    this.translateSpinner(spinnerNode, y, true);
                } else {
                    // Only the tail of the element is visible
                    const diff = bottom / 2 - spinnerHeight / 2;
                    const y = diff < spinnerHeight ? diff - (spinnerHeight - diff) : diff;
                    this.translateSpinner(spinnerNode, y, true);
                }
                return;
            }
        } else {
            // If both the element and the spinner are off screen - quit
            if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
        }
        // Three options here:
        // 1) the element is fully visible
        // 2) the element is too small for the spinner to follow
        // 3) the spinner might still be visible while the element isn't
        const containerNode = this.containerRef?.current;
        if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
            const thisTop = containerNode.getBoundingClientRect().top;
            const y = (top - thisTop) / 2;
            this.translateSpinner(spinnerNode, y, false);
        }
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $sM67g.Container), {
            testId: testId && `${testId}--loading--container--advanced`,
            ref: this.containerRef
        }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $sM67g.SpinnerBackdrop), {
            testId: testId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $sM67g.SpinnerContainer), {
            ref: this.spinnerRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            size: spinnerSize,
            testId: testId && `${testId}--loadingSpinner`,
            label: loadingLabel
        }))));
    }
    constructor(...args){
        super(...args);
        this.spinnerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.componentDidMount = ()=>{
            if (this.props.isLoading && this.hasTargetNode()) {
                this.attachListeners();
                this.updateTargetAppearance();
                this.updateSpinnerPosition();
            }
        };
        this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
            if (!nextProps.isLoading || !this.hasTargetNode(nextProps)) this.detachListeners();
            else if (!this.props.isLoading) this.attachListeners();
        };
        this.componentDidUpdate = ()=>{
            if (this.hasTargetNode()) {
                this.updateTargetAppearance();
                if (this.props.isLoading) this.updateSpinnerPosition();
            }
        };
        this.componentWillUnmount = ()=>{
            this.detachListeners();
        };
        this.getTargetNode = (nextProps = this.props)=>{
            const { targetRef: targetRef } = nextProps;
            const target = targetRef?.();
            return target || this.containerRef.current;
        };
        this.hasTargetNode = (nextProps)=>!!this.getTargetNode(nextProps);
        this.isVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            if (bottom <= 0) return false;
            return top < viewportHeight;
        };
        this.isFullyVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            return top >= 0 && bottom <= viewportHeight;
        };
        this.handleResize = ()=>{
            this.updateSpinnerPosition();
        };
        this.handleScroll = ()=>{
            this.updateSpinnerPosition();
        };
        this.translateSpinner = (spinnerNode, transformY, isFixed)=>{
            spinnerNode.style.position = isFixed ? 'fixed' : '';
            spinnerNode.style.transform = transformY !== 0 ? `translate3d(0, ${transformY}px, 0)` : '';
        };
        this.updateTargetAppearance = ()=>{
            const targetNode = this.getTargetNode();
            const { isLoading: isLoading, contentsOpacity: contentsOpacity } = this.props;
            if (targetNode && targetNode.style && typeof targetNode.style === 'object') {
                targetNode.style.pointerEvents = isLoading ? 'none' : '';
                targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
            }
        };
    }
}

});
parcelRegister("sM67g", function(module, exports) {

$parcel$export(module.exports, "Container", () => $e14096c71a70d04d$export$42a852a2b6b56249);
$parcel$export(module.exports, "SpinnerBackdrop", () => $e14096c71a70d04d$export$aa207050321b0c53);
$parcel$export(module.exports, "SpinnerContainer", () => $e14096c71a70d04d$export$a5e06607a5ac6158);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");
function $e14096c71a70d04d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e14096c71a70d04d$var$containerStyles = {
    name: "17fhw1k",
    styles: "position:relative;margin-block-end:var(--ds-space-300, 24px)"
};
const $e14096c71a70d04d$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, ...rest } = props;
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $e14096c71a70d04d$var$containerStyles,
        ...rest,
        "data-testid": testId,
        ref: ref
    }, children));
});
const $e14096c71a70d04d$var$spinnerBackdropStyles = {
    name: "1yy6mjk",
    styles: "display:flex;position:absolute;inset:0;align-items:center;justify-content:center;pointer-events:none"
};
const $e14096c71a70d04d$export$aa207050321b0c53 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $e14096c71a70d04d$var$spinnerBackdropStyles,
        "data-testid": testId && `${testId}--spinner-backdrop`
    }, children);
const $e14096c71a70d04d$var$spinnerContainerStyles = {
    name: "vi3nlf",
    styles: "position:relative;inset-block-start:0"
};
const $e14096c71a70d04d$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children }, ref)=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $e14096c71a70d04d$var$spinnerContainerStyles,
        ref: ref
    }, children));

});


parcelRegister("i9y06", function(module, exports) {

$parcel$export(module.exports, "default", () => $59228fe552548a0a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3KPTt = parcelRequire("3KPTt");
class $59228fe552548a0a$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { total: total, value: value = 1, i18n: i18n, testId: testId, isDisabled: isDisabled } = this.props;
        const pages = [
            ...Array(total)
        ].map((_, index)=>index + 1);
        // Pagination accepts array now thus selectedIndex starts with 0
        // So, we are substracting value by one thus not breaking dynamic table
        const selectedIndex = value - 1;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3KPTt.default), {
            selectedIndex: selectedIndex,
            isDisabled: isDisabled,
            label: i18n?.label,
            nextLabel: i18n?.next,
            previousLabel: i18n?.prev,
            pageLabel: i18n?.pageLabel,
            onChange: this.onChange,
            pages: pages,
            testId: testId && `${testId}--pagination`
        });
    }
    constructor(...args){
        super(...args);
        this.onChange = (_event, newValue, analyticsEvent)=>{
            this.props.onChange(newValue, analyticsEvent);
        };
    }
}

});
parcelRegister("3KPTt", function(module, exports) {

$parcel$export(module.exports, "default", () => $52d6d0a6ee26c024$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");

var $2WwAS = parcelRequire("2WwAS");

var $dXKde = parcelRequire("dXKde");

var $dwj4T = parcelRequire("dwj4T");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $4DxcJ = parcelRequire("4DxcJ");

var $7X9O4 = parcelRequire("7X9O4");

var $eDUla = parcelRequire("eDUla");

var $1ssgv = parcelRequire("1ssgv");

var $bZ2kD = parcelRequire("bZ2kD");
const $52d6d0a6ee26c024$var$analyticsAttributes = {
    componentName: 'pagination',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $52d6d0a6ee26c024$var$paginationMenuStyles = (0, $1ZAYh.xcss)({
    padding: 'space.0',
    margin: 'space.0'
});
const $52d6d0a6ee26c024$var$paginationMenuItemStyles = (0, $1ZAYh.xcss)({
    marginBlockStart: 'space.0'
});
function $52d6d0a6ee26c024$var$InnerPagination({ components: components = (0, $1ssgv.emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, $1ssgv.emptyObject), max: max = 7, onChange: onChange = (0, $5Q9wj.default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, $eDUla.default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
    const [selectedIndexValue, setSelectedIndexValue] = (0, $2WwAS.default)(selectedIndex, ()=>defaultSelectedIndex || 0);
    const onChangeWithAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            const { event: event, selectedPageIndex: selectedPageIndex } = value;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: 'changed',
        actionSubject: 'pageNumber',
        analyticsData: analyticsContext,
        ...$52d6d0a6ee26c024$var$analyticsAttributes
    });
    const transform = (page, currPageIndex, testId)=>{
        const selectedPage = pages[selectedIndexValue];
        const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
        const isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
            as: "li",
            xcss: $52d6d0a6ee26c024$var$paginationMenuItemStyles,
            key: `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7X9O4.default), {
            component: components.Page,
            onClick: (event)=>onChangeWithAnalytics({
                    event: event,
                    selectedPageIndex: currPageIndex
                }),
            "aria-current": isCurrentPage ? 'page' : undefined,
            "aria-label": pageIndexLabel,
            isSelected: isCurrentPage,
            isDisabled: isDisabled,
            page: page,
            testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`
        }, getPageLabel ? getPageLabel(page, currPageIndex) : page));
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.0",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4DxcJ.default), {
        key: "left-navigator",
        component: components.Previous,
        onClick: (event)=>onChangeWithAnalytics({
                event: event,
                selectedPageIndex: selectedIndexValue - 1
            }),
        isDisabled: isDisabled || selectedIndexValue === 0,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dXKde))), {
            label: ""
        }),
        "aria-label": previousLabel,
        testId: testId && `${testId}--left-navigator`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.0",
        alignBlock: "baseline",
        as: "ul",
        xcss: $52d6d0a6ee26c024$var$paginationMenuStyles
    }, (0, $bZ2kD.default)(pages, selectedIndexValue, {
        max: max,
        ellipsis: renderEllipsis,
        transform: transform
    }, testId)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4DxcJ.default), {
        key: "right-navigator",
        component: components.Next,
        onClick: (event)=>onChangeWithAnalytics({
                event: event,
                selectedPageIndex: selectedIndexValue + 1
            }),
        isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dwj4T))), {
            label: ""
        }),
        "aria-label": nextLabel,
        testId: testId && `${testId}--right-navigator`
    }))));
}
/**
 * __Pagination__
 *
 * Pagination allows you to divide large amounts of content into smaller chunks across multiple pages.
 *
 * - [Examples](https://atlassian.design/components/pagination/examples)
 * - [Code](https://atlassian.design/components/pagination/code)
 * - [Usage](https://atlassian.design/components/pagination/usage)
 */ const $52d6d0a6ee26c024$var$Pagination = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)($52d6d0a6ee26c024$var$InnerPagination));
var $52d6d0a6ee26c024$export$2e2bcd8739ae039 = $52d6d0a6ee26c024$var$Pagination;

});
parcelRegister("2WwAS", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc974ed9b9ba7adb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $fc974ed9b9ba7adb$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $eUqFw.useState)(getDefaultPropValue);
    const isControlledRef = (0, $eUqFw.useRef)(isControlled);
    (0, $eUqFw.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $eUqFw.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("dXKde", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a2a4a1e4b9148f86$var$_react = $a2a4a1e4b9148f86$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $a2a4a1e4b9148f86$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a2a4a1e4b9148f86$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $a2a4a1e4b9148f86$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="M9.005 10.995l4.593-4.593a.99.99 0 111.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 01-1.4 1.4L9.005 12.41a1 1 0 010-1.414z"/></svg>`
    }, props));
$a2a4a1e4b9148f86$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $a2a4a1e4b9148f86$var$_default = $a2a4a1e4b9148f86$var$ChevronLeftLargeIcon;
module.exports.default = $a2a4a1e4b9148f86$var$_default;

});

parcelRegister("dwj4T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9d7d0ffff46f5f00$var$_react = $9d7d0ffff46f5f00$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $9d7d0ffff46f5f00$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9d7d0ffff46f5f00$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $9d7d0ffff46f5f00$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 010 1.414l-4.593 4.593a.99.99 0 01-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 011.4-1.4l4.593 4.593z"/></svg>`
    }, props));
$9d7d0ffff46f5f00$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $9d7d0ffff46f5f00$var$_default = $9d7d0ffff46f5f00$var$ChevronRightLargeIcon;
module.exports.default = $9d7d0ffff46f5f00$var$_default;

});

parcelRegister("4DxcJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4d3c7b4b153b94a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");
function $a4d3c7b4b153b94a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        "aria-label": props['aria-label'],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
}

});

parcelRegister("7X9O4", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5f9797829cf4ad3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");
function $e5f9797829cf4ad3$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        ...props,
        appearance: "subtle"
    });
}

});

parcelRegister("eDUla", function(module, exports) {

$parcel$export(module.exports, "default", () => $ceba78dad21693c3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $lkPEe = parcelRequire("lkPEe");
const $ceba78dad21693c3$var$containerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    position: 'relative'
});
function $ceba78dad21693c3$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "li",
        testId: testId,
        key: key,
        xcss: $ceba78dad21693c3$var$containerStyles,
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        testId: testId && `${testId}-text`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lkPEe.default), null, "Skipped pages from ", from, " to ", to), "\u2026"));
}

});

parcelRegister("1ssgv", function(module, exports) {

$parcel$export(module.exports, "emptyObject", () => $3850a464bb1795dd$export$3f860eba1218f8d3);
const $3850a464bb1795dd$export$3f860eba1218f8d3 = {};

});

parcelRegister("bZ2kD", function(module, exports) {

$parcel$export(module.exports, "default", () => $a954a8bde9a3bed3$export$2e2bcd8739ae039);

var $5iWql = parcelRequire("5iWql");
// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
const $a954a8bde9a3bed3$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
    const total = pages.length;
    // only need ellipsis if we have more pages than we can display
    const needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    const hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    const hasEndEllipsis = needEllipsis && current < total - max + 3;
    const getPageComponents = (0, $5iWql.default)((startIndex = 0, lastIndex = total)=>{
        return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: total - pageCount
            }),
            ...getPageComponents(total - pageCount)
        ];
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, pageCount),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: pageCount + 1,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    }
    // we have both start and end ellipsis
    const pageCount = max - 4;
    return [
        ...getPageComponents(0, 1),
        ellipsis({
            key: 'ellipsis-1',
            testId: testId && `${testId}-ellipsis`,
            from: 2,
            to: current - Math.floor(pageCount / 2)
        }),
        ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
        ellipsis({
            key: 'ellipsis-2',
            testId: testId && `${testId}-ellipsis`,
            from: current + 3,
            to: total - 1
        }),
        ...getPageComponents(total - 1)
    ];
};
var $a954a8bde9a3bed3$export$2e2bcd8739ae039 = $a954a8bde9a3bed3$var$collapseRange;

});



parcelRegister("cTO8p", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e1cf364925ee2f7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fVXMO = parcelRequire("fVXMO");

var $iLooJ = parcelRequire("iLooJ");

var $6Ztqc = parcelRequire("6Ztqc");

var $jRqbA = parcelRequire("jRqbA");
class $7e1cf364925ee2f7$var$TableHead extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    UNSAFE_componentWillMount() {
        (0, $fVXMO.validateSortKey)(this.props.sortKey, this.props.head);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, $fVXMO.validateSortKey)(nextProps.sortKey, nextProps.head);
    }
    render() {
        const { head: head, sortKey: sortKey, sortOrder: sortOrder, isFixedSize: isFixedSize, onSort: onSort, isRanking: isRanking, isRankable: isRankable, testId: testId } = this.props;
        if (!head) return null;
        const HeadCellComponent = isRankable ? (0, $6Ztqc.default) : (0, $jRqbA.default);
        // TODO: Remove `rest` props and use only what is explicitly in the API.
        // Some tests use this to pass in onClick and other stuff within the `head`
        // variable here, but considering it's not in the API, it should probably
        // be removed.
        const { cells: cells, ...rest } = head;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iLooJ.Head), {
            ...rest,
            isRanking: isRanking,
            testId: testId && `${testId}--head`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", null, cells.map((cell, index)=>{
            const { colSpan: colSpan, content: content, isSortable: isSortable, key: key, shouldTruncate: shouldTruncate, testId: cellTestId, width: width, // TODO: Remove `rest` props and use only what is explicitly in
            // the API.
            ...restCellProps } = cell;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(HeadCellComponent, {
                colSpan: colSpan,
                content: content,
                isFixedSize: isFixedSize,
                isSortable: !!isSortable,
                isRanking: isRanking,
                key: key || index,
                onClick: isSortable ? onSort(cell) : undefined,
                testId: cellTestId || testId,
                shouldTruncate: shouldTruncate,
                sortOrder: key === sortKey ? sortOrder : undefined,
                width: width,
                ...restCellProps
            });
        })));
    }
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7e1cf364925ee2f7$export$2e2bcd8739ae039 = $7e1cf364925ee2f7$var$TableHead;

});
parcelRegister("iLooJ", function(module, exports) {

$parcel$export(module.exports, "Head", () => $e23e257a0c447ed4$export$e93312b7773dfcac);
$parcel$export(module.exports, "HeadCell", () => $e23e257a0c447ed4$export$4e8024263ace498b);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $PdmhA = parcelRequire("PdmhA");


var $g2Ovh = parcelRequire("g2Ovh");

var $39mp0 = parcelRequire("39mp0");
function $e23e257a0c447ed4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e23e257a0c447ed4$var$CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
const $e23e257a0c447ed4$var$rankingStyles = {
    name: "4zleql",
    styles: "display:block"
};
const $e23e257a0c447ed4$var$headStyles = /*#__PURE__*/ (0, $byn9U.css)({
    borderBlockEnd: `none`
});
const $e23e257a0c447ed4$export$e93312b7773dfcac = ({ isRanking: isRanking, testId: testId, ...props })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("thead", {
        css: [
            $e23e257a0c447ed4$var$headStyles,
            isRanking && $e23e257a0c447ed4$var$rankingStyles
        ],
        "data-testid": testId,
        ...props
    });
};
const $e23e257a0c447ed4$var$headCellBaseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    boxSizing: 'border-box',
    position: 'relative',
    border: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderBlockEnd: `2px solid ${(0, $g2Ovh.tableBorder).borderColor}`,
    color: `var(--ds-text-subtlest, ${`var(${$e23e257a0c447ed4$var$CSS_VAR_TEXT_COLOR})`})`,
    textAlign: 'left',
    verticalAlign: 'top',
    '&:focus-visible': {
        outline: `solid 2px ${`var(--ds-border-focused, ${(0, $PdmhA.B100)})`}`
    }
});
const $e23e257a0c447ed4$var$headCellOldStyles = {
    name: "an5sdn",
    styles: "font-size:0.75rem;font-weight:var(--ds-font-weight-semibold, 600)"
};
const $e23e257a0c447ed4$var$headCellNewStyles = {
    name: "1xm9io",
    styles: "font:var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
const $e23e257a0c447ed4$var$onClickStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&:hover': {
        backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $PdmhA.N30A)})`,
        cursor: 'pointer'
    }
});
const $e23e257a0c447ed4$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button': {
        padding: "var(--ds-space-0, 0)",
        position: 'relative',
        appearance: 'none',
        background: 'none',
        border: 'none',
        color: 'inherit',
        cursor: 'inherit',
        fontSize: 'inherit',
        fontWeight: 'inherit',
        '&::before, &::after': {
            display: 'block',
            width: 0,
            height: 0,
            position: 'absolute',
            border: '3px solid transparent',
            content: '""',
            insetInlineEnd: "var(--ds-space-negative-100, -8px)"
        },
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockEnd: `3px solid ${(0, $g2Ovh.arrow).defaultColor}`,
            insetBlockEnd: "var(--ds-space-100, 8px)"
        },
        '&::after': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockStart: `3px solid ${(0, $g2Ovh.arrow).defaultColor}`,
            insetBlockEnd: 0
        }
    },
    '@media (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > button': {
            '&::before, &::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                border: `3px solid ${(0, $g2Ovh.MSThemeColors).Background}`
            },
            '&::before': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockEnd: `3px solid ${(0, $g2Ovh.MSThemeColors).Text}`
            },
            '&::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockStart: `3px solid ${(0, $g2Ovh.MSThemeColors).Text}`
            }
        }
    }
});
const $e23e257a0c447ed4$var$ascendingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button': {
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockEnd: `3px solid ${(0, $g2Ovh.arrow).selectedColor}`
        }
    },
    '@media (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > button': {
            '&::before': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockEnd: `3px solid ${(0, $g2Ovh.MSThemeColors).SelectedBackground}`
            }
        }
    }
});
const $e23e257a0c447ed4$var$descendingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button': {
        '&::after': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockStart: `3px solid ${(0, $g2Ovh.arrow).selectedColor}`
        }
    },
    '@media (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > button': {
            '&::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockStart: `3px solid ${(0, $g2Ovh.MSThemeColors).SelectedBackground}`
            }
        }
    }
});
const $e23e257a0c447ed4$export$4e8024263ace498b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ width: width, children: children, isSortable: isSortable, sortOrder: sortOrder, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, onClick: onClick, style: style, testId: testId, ...rest }, ref)=>{
    const mergedStyles = {
        ...style,
        ...width && (0, $39mp0.getTruncationStyleVars)({
            width: width
        }),
        [$e23e257a0c447ed4$var$CSS_VAR_TEXT_COLOR]: (0, $g2Ovh.head).textColor
    };
    const isASC = sortOrder === (0, $9ad1be2eb14b8d3d$export$1dee026a19752d6b);
    const isDESC = sortOrder === (0, $9ad1be2eb14b8d3d$export$b6abcf7fa1d94f65);
    const getFormattedSortOrder = ()=>{
        if (isASC) return 'ascending';
        else if (isDESC) return 'descending';
    };
    // If there is no content in the cell, it should be rendered as an empty `td`, not a `th`.
    // https://dequeuniversity.com/rules/axe/4.7/empty-table-header
    const Component = children ? 'th' : 'td';
    return /*#__PURE__*/ (0, $byn9U.jsx)(Component, {
        "aria-sort": getFormattedSortOrder(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: mergedStyles,
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $39mp0.cellStyles),
            $e23e257a0c447ed4$var$headCellBaseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $XHGTv.getBooleanFF)('platform.design-system-team.dynamic-table-typography_7zio6') ? $e23e257a0c447ed4$var$headCellNewStyles : $e23e257a0c447ed4$var$headCellOldStyles,
            onClick && $e23e257a0c447ed4$var$onClickStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $39mp0.truncationWidthStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            isFixedSize && shouldTruncate && (0, $39mp0.fixedSizeTruncateStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            isFixedSize && (0, $39mp0.overflowTruncateStyles),
            isSortable && $e23e257a0c447ed4$var$baseStyles,
            isASC && $e23e257a0c447ed4$var$ascendingStyles,
            isDESC && $e23e257a0c447ed4$var$descendingStyles
        ],
        onClick: onClick,
        ref: ref,
        "data-testid": testId,
        ...rest
    }, children);
});

});

parcelRegister("6Ztqc", function(module, exports) {

$parcel$export(module.exports, "default", () => $0043750917848b87$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hwoBY = parcelRequire("hwoBY");

var $fVXMO = parcelRequire("fVXMO");

var $jRqbA = parcelRequire("jRqbA");
class $0043750917848b87$var$RankableTableHeadCellComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $fVXMO.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jRqbA.default), {
            inlineStyles: inlineStyles,
            ...restProps
        });
    }
}
const $0043750917848b87$var$RankableTableHeadCell = (0, $hwoBY.default)($0043750917848b87$var$RankableTableHeadCellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$0043750917848b87$export$2e2bcd8739ae039 = $0043750917848b87$var$RankableTableHeadCell;

});
parcelRegister("hwoBY", function(module, exports) {

$parcel$export(module.exports, "default", () => $f810d119edc97937$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $f810d119edc97937$export$2e2bcd8739ae039(WrappedComponent) {
    return class WithDimensions extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
        UNSAFE_componentWillReceiveProps(nextProps) {
            const wasRanking = this.props.isRanking;
            const willRanking = nextProps.isRanking;
            if (willRanking && !wasRanking) this.updateDimensions();
        }
        render() {
            const { refWidth: refWidth, refHeight: refHeight } = this.state;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refWidth: refWidth,
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refHeight: refHeight,
                innerRef: this.innerRef,
                ...this.props
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                refWidth: 0,
                refHeight: 0
            };
            this.innerRef = (ref)=>{
                if (ref && !this.props.isRanking) this.ref = ref;
            };
            this.updateDimensions = ()=>{
                if (!this.ref) return;
                const clientRect = this.ref.getBoundingClientRect();
                const { width: width } = clientRect;
                const { height: height } = clientRect;
                if (width !== this.state.refWidth || height !== this.state.refHeight) this.setState({
                    refWidth: width,
                    refHeight: height
                });
            };
        }
    };
}

});

parcelRegister("jRqbA", function(module, exports) {

$parcel$export(module.exports, "default", () => $635bc03d85c6882e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iLooJ = parcelRequire("iLooJ");
const $635bc03d85c6882e$var$TableHeadCell = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, onClick: onClick, ...rest })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iLooJ.HeadCell), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null,
        ...rest,
        onClick: onClick,
        isSortable: isSortable
    }, isSortable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
        type: "button",
        "aria-roledescription": "Sort button"
    }, content) : content);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$635bc03d85c6882e$export$2e2bcd8739ae039 = $635bc03d85c6882e$var$TableHeadCell;

});



parcelRegister("6muvm", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('aVYwg');
        const value = parcelRequire('jlg4D');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("aVYwg").then(()=>parcelRequire('jlg4D'));
}

});



parcelRegister("leWBI", function(module, exports) {

$parcel$export(module.exports, "useRows", () => $9d5d717ed827b64f$export$f74098d2a1be340c);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $ffiyv = parcelRequire("ffiyv");

var $cdZ92 = parcelRequire("cdZ92");
const $9d5d717ed827b64f$export$f74098d2a1be340c = ({ organizations: organizations, onRemove: onRemove })=>{
    const rows = (0, $eUqFw.useMemo)(()=>{
        if (!organizations) return [];
        return organizations.map((organization, orgIndex)=>{
            // @ts-expect-error - TS2304 - Cannot find name 'RowCellType'.
            const cells = [];
            const { name: name, status: status } = organization;
            cells.push({
                key: `display-org-${orgIndex}`,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9d5d717ed827b64f$var$Inline, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9d5d717ed827b64f$var$Label, null, name), status && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
                    maxWidth: 90,
                    isBold: true
                }, status)),
                colSpan: 80
            });
            cells.push({
                key: `remove-org-${orgIndex}`,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cdZ92.EditorCell), {
                    name: name,
                    onRemove: ()=>{
                        onRemove(organizations.filter((_, idx)=>idx !== orgIndex));
                    }
                }),
                colSpan: 20
            });
            return {
                key: `organization-name-${orgIndex}`,
                cells: cells
            };
        });
    }, [
        onRemove,
        organizations
    ]);
    return rows;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9d5d717ed827b64f$var$Label = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $9d5d717ed827b64f$var$Inline = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _19bv12x7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cdZ92", function(module, exports) {

$parcel$export(module.exports, "EditorCell", () => $2f5f6de4d303e5af$export$c1f633b9199aef47);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $cfNhr = parcelRequire("cfNhr");

var $5JgJ2 = parcelRequire("5JgJ2");

var $eTtXm = parcelRequire("eTtXm");

var $g2s6X = parcelRequire("g2s6X");
const $2f5f6de4d303e5af$export$c1f633b9199aef47 = ({ name: name, onRemove: onRemove })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eTtXm.RowActiveCellWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "servicedesk-customers-organization-common.common.ui.editable-table.editor-cell.button",
        appearance: "subtle",
        "aria-label": formatMessage((0, $g2s6X.default).removeOption, {
            name: name
        }),
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cfNhr))), {
            label: ""
        }),
        onClick: onRemove
    }));
};

});
parcelRegister("cfNhr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8ebd1cca56e1d8bd$var$_react = $8ebd1cca56e1d8bd$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $8ebd1cca56e1d8bd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $8ebd1cca56e1d8bd$var$EditorRemoveIcon = (props)=>/*#__PURE__*/ $8ebd1cca56e1d8bd$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M7 7h10a1 1 0 010 2H7a1 1 0 110-2zm2.78 11a1 1 0 01-.97-.757L7.156 10.62A.5.5 0 017.64 10h8.72a.5.5 0 01.485.621l-1.656 6.622a1 1 0 01-.97.757H9.781zM11 6h2a1 1 0 011 1h-4a1 1 0 011-1z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$8ebd1cca56e1d8bd$var$EditorRemoveIcon.displayName = 'EditorRemoveIcon';
var $8ebd1cca56e1d8bd$var$_default = $8ebd1cca56e1d8bd$var$EditorRemoveIcon;
module.exports.default = $8ebd1cca56e1d8bd$var$_default;

});

parcelRegister("eTtXm", function(module, exports) {

$parcel$export(module.exports, "RowActiveCellWrapper", () => $ce1ffe30494c1f40$export$aa416bd4626093c2);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $lDc85 = parcelRequire("lDc85");
var $5kjXv = parcelRequire("5kjXv");

var $cdZ92 = parcelRequire("cdZ92");


var $adPlo = parcelRequire("adPlo");

var $8Iss3 = parcelRequire("8Iss3");
var $ietBz = parcelRequire("ietBz");
var $kzvQD = parcelRequire("kzvQD");
var $aOiov = parcelRequire("aOiov");

var $81Khm = parcelRequire("81Khm");

var $8tGiw = parcelRequire("8tGiw");

var $1l35M = parcelRequire("1l35M");

const $ce1ffe30494c1f40$export$aa416bd4626093c2 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $ce1ffe30494c1f40$var$activeCellWrapperStyles,
        "data-class": "RowActiveCellWrapper"
    }, children);
const $ce1ffe30494c1f40$var$activeCellWrapperStyles = (0, $1ZAYh.xcss)({
    cursor: 'pointer',
    opacity: 0,
    ':hover': {
        opacity: 1
    },
    ':focus': {
        opacity: 1
    },
    ':focus-within': {
        opacity: 1
    }
});
const $ce1ffe30494c1f40$export$d3153e190f75eb24 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_113ekb7n _1lp8kb7n _ohpokb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("81Khm", function(module, exports) {

$parcel$export(module.exports, "CollapsibleSectionMessage", () => $c0018384e3874e99$export$763cd1d5b7849cf8);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $jWuk1 = parcelRequire("jWuk1");

var $lRvnl = parcelRequire("lRvnl");

var $giAhk = parcelRequire("giAhk");

var $aCLjP = parcelRequire("aCLjP");
const $c0018384e3874e99$var$CollapsibleSectionMessageView = ({ intl: { formatMessage: formatMessage }, message: message, appearance: appearance, isOpen: isOpen, title: title, onClose: onClose })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c0018384e3874e99$var$SectionMessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c0018384e3874e99$var$CloseButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: ()=>onClose(false),
        appearance: "subtle",
        spacing: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))), {
        size: "small",
        label: formatMessage((0, $aCLjP.default).closeModal)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
        appearance: appearance,
        title: title
    }, message)));
const $c0018384e3874e99$export$763cd1d5b7849cf8 = (0, $giAhk.injectIntlV2)($c0018384e3874e99$var$CollapsibleSectionMessageView); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c0018384e3874e99$var$SectionMessageContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _otyrpxbi",
            __cmplp.className
        ])
    });
});
const $c0018384e3874e99$var$CloseButtonContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1xi2u2gc _154iu2gc _80omtlke",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aCLjP", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed40ffbc891f338a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ed40ffbc891f338a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    closeModal: {
        "id": "servicedesk-customers-organization-common.common.collapsible-section-message.close-modal",
        "defaultMessage": "Close"
    }
});

});


parcelRegister("8tGiw", function(module, exports) {

$parcel$export(module.exports, "ResendInviteErrorFlag", () => $8fb981d25b693d60$export$489d4eae7c01f5fb);

var $eUqFw = parcelRequire("eUqFw");

var $96IgR = parcelRequire("96IgR");

var $PdmhA = parcelRequire("PdmhA");

var $cCFSU = parcelRequire("cCFSU");

var $k8Qyf = parcelRequire("k8Qyf");

var $eo17r = parcelRequire("eo17r");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dN6JO = parcelRequire("dN6JO");

var $bYCTQ = parcelRequire("bYCTQ");
const $8fb981d25b693d60$export$489d4eae7c01f5fb = ({ id: id, errorMessage: errorMessage })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagService)();
    const onDismissed = (0, $eUqFw.useCallback)(()=>{
        dismissFlag({
            command: (0, $eo17r.DISMISS_COMMAND),
            id: id
        });
    }, [
        dismissFlag,
        id
    ]);
    const onRefresh = (0, $eUqFw.useCallback)(()=>window.location.reload(), []);
    return (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cCFSU.default), {
            id: (0, $eo17r.fromFlagId)(id),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
                label: "error",
                primaryColor: `var(--ds-icon-danger, ${(0, $PdmhA.R400)})`
            }),
            title: formatMessage((0, $bYCTQ.default).resendInviteFailureFlagTitle),
            description: errorMessage ? // eslint-disable-next-line react/no-danger
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                dangerouslySetInnerHTML: {
                    __html: (0, $dN6JO.sanitizeHtml)(errorMessage)
                }
            }) : formatMessage((0, $bYCTQ.default).resendInviteFailureFlagDescription),
            onDismissed: onDismissed,
            actions: [
                {
                    content: formatMessage((0, $bYCTQ.default).refreshThePage),
                    onClick: onRefresh
                }
            ]
        }), [
        id,
        formatMessage,
        errorMessage,
        onDismissed,
        onRefresh
    ]);
};

});
parcelRegister("cCFSU", function(module, exports) {

$parcel$export(module.exports, "default", () => $f59aa209343f0b13$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5L0Jp = parcelRequire("5L0Jp");

var $kQ0RL = parcelRequire("kQ0RL");
const $f59aa209343f0b13$var$AkFlag = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQ0RL.CommonFlag), {
        flagType: "info",
        ...props
    }));
var $f59aa209343f0b13$export$2e2bcd8739ae039 = $f59aa209343f0b13$var$AkFlag;

});

parcelRegister("dN6JO", function(module, exports) {

$parcel$export(module.exports, "sanitizeHtml", () => $6ac587df15d6a67c$export$c0fc46c8edd7094a);

var $kfRpm = parcelRequire("kfRpm");
const $6ac587df15d6a67c$export$c0fc46c8edd7094a = (errorMessage)=>(0, (/*@__PURE__*/$parcel$interopDefault($kfRpm))).sanitize(errorMessage, {
        ALLOWED_TAGS: [
            'p',
            'a',
            'ol',
            'ul',
            'li'
        ],
        ALLOWED_ATTR: [
            'href',
            'target'
        ]
    });

});
parcelRegister("kfRpm", function(module, exports) {
/*! @license DOMPurify 2.5.1 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.5.1/LICENSE */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    function _typeof(obj) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _typeof(obj);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function _construct(Parent, args, Class) {
        if (_isNativeReflectConstruct()) _construct = Reflect.construct;
        else _construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
        return _construct.apply(null, arguments);
    }
    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
    }
    function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) return _arrayLikeToArray(arr);
    }
    function _iterableToArray(iter) {
        if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var hasOwnProperty = Object.hasOwnProperty, setPrototypeOf = Object.setPrototypeOf, isFrozen = Object.isFrozen, getPrototypeOf = Object.getPrototypeOf, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var freeze = Object.freeze, seal = Object.seal, create = Object.create; // eslint-disable-line import/no-mutable-exports
    var _ref = typeof Reflect !== 'undefined' && Reflect, apply = _ref.apply, construct = _ref.construct;
    if (!apply) apply = function apply(fun, thisValue, args) {
        return fun.apply(thisValue, args);
    };
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!construct) construct = function construct(Func, args) {
        return _construct(Func, _toConsumableArray(args));
    };
    var arrayForEach = unapply(Array.prototype.forEach);
    var arrayPop = unapply(Array.prototype.pop);
    var arrayPush = unapply(Array.prototype.push);
    var stringToLowerCase = unapply(String.prototype.toLowerCase);
    var stringToString = unapply(String.prototype.toString);
    var stringMatch = unapply(String.prototype.match);
    var stringReplace = unapply(String.prototype.replace);
    var stringIndexOf = unapply(String.prototype.indexOf);
    var stringTrim = unapply(String.prototype.trim);
    var regExpTest = unapply(RegExp.prototype.test);
    var typeErrorCreate = unconstruct(TypeError);
    function unapply(func) {
        return function(thisArg) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return apply(func, thisArg, args);
        };
    }
    function unconstruct(func) {
        return function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return construct(func, args);
        };
    }
    /* Add properties to a lookup table */ function addToSet(set, array, transformCaseFunc) {
        var _transformCaseFunc;
        transformCaseFunc = (_transformCaseFunc = transformCaseFunc) !== null && _transformCaseFunc !== void 0 ? _transformCaseFunc : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        var l = array.length;
        while(l--){
            var element = array[l];
            if (typeof element === 'string') {
                var lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /* Shallow clone an object */ function clone(object) {
        var newObject = create(null);
        var property;
        for(property in object)if (apply(hasOwnProperty, object, [
            property
        ]) === true) newObject[property] = object[property];
        return newObject;
    }
    /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */ function lookupGetter(object, prop) {
        while(object !== null){
            var desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === 'function') return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue(element) {
            console.warn('fallback value for', element);
            return null;
        }
        return fallbackValue;
    }
    var html$1 = freeze([
        'a',
        'abbr',
        'acronym',
        'address',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'bdi',
        'bdo',
        'big',
        'blink',
        'blockquote',
        'body',
        'br',
        'button',
        'canvas',
        'caption',
        'center',
        'cite',
        'code',
        'col',
        'colgroup',
        'content',
        'data',
        'datalist',
        'dd',
        'decorator',
        'del',
        'details',
        'dfn',
        'dialog',
        'dir',
        'div',
        'dl',
        'dt',
        'element',
        'em',
        'fieldset',
        'figcaption',
        'figure',
        'font',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'i',
        'img',
        'input',
        'ins',
        'kbd',
        'label',
        'legend',
        'li',
        'main',
        'map',
        'mark',
        'marquee',
        'menu',
        'menuitem',
        'meter',
        'nav',
        'nobr',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'picture',
        'pre',
        'progress',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'section',
        'select',
        'shadow',
        'small',
        'source',
        'spacer',
        'span',
        'strike',
        'strong',
        'style',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'tr',
        'track',
        'tt',
        'u',
        'ul',
        'var',
        'video',
        'wbr'
    ]);
    // SVG
    var svg$1 = freeze([
        'svg',
        'a',
        'altglyph',
        'altglyphdef',
        'altglyphitem',
        'animatecolor',
        'animatemotion',
        'animatetransform',
        'circle',
        'clippath',
        'defs',
        'desc',
        'ellipse',
        'filter',
        'font',
        'g',
        'glyph',
        'glyphref',
        'hkern',
        'image',
        'line',
        'lineargradient',
        'marker',
        'mask',
        'metadata',
        'mpath',
        'path',
        'pattern',
        'polygon',
        'polyline',
        'radialgradient',
        'rect',
        'stop',
        'style',
        'switch',
        'symbol',
        'text',
        'textpath',
        'title',
        'tref',
        'tspan',
        'view',
        'vkern'
    ]);
    var svgFilters = freeze([
        'feBlend',
        'feColorMatrix',
        'feComponentTransfer',
        'feComposite',
        'feConvolveMatrix',
        'feDiffuseLighting',
        'feDisplacementMap',
        'feDistantLight',
        'feFlood',
        'feFuncA',
        'feFuncB',
        'feFuncG',
        'feFuncR',
        'feGaussianBlur',
        'feImage',
        'feMerge',
        'feMergeNode',
        'feMorphology',
        'feOffset',
        'fePointLight',
        'feSpecularLighting',
        'feSpotLight',
        'feTile',
        'feTurbulence'
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    var svgDisallowed = freeze([
        'animate',
        'color-profile',
        'cursor',
        'discard',
        'fedropshadow',
        'font-face',
        'font-face-format',
        'font-face-name',
        'font-face-src',
        'font-face-uri',
        'foreignobject',
        'hatch',
        'hatchpath',
        'mesh',
        'meshgradient',
        'meshpatch',
        'meshrow',
        'missing-glyph',
        'script',
        'set',
        'solidcolor',
        'unknown',
        'use'
    ]);
    var mathMl$1 = freeze([
        'math',
        'menclose',
        'merror',
        'mfenced',
        'mfrac',
        'mglyph',
        'mi',
        'mlabeledtr',
        'mmultiscripts',
        'mn',
        'mo',
        'mover',
        'mpadded',
        'mphantom',
        'mroot',
        'mrow',
        'ms',
        'mspace',
        'msqrt',
        'mstyle',
        'msub',
        'msup',
        'msubsup',
        'mtable',
        'mtd',
        'mtext',
        'mtr',
        'munder',
        'munderover'
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    var mathMlDisallowed = freeze([
        'maction',
        'maligngroup',
        'malignmark',
        'mlongdiv',
        'mscarries',
        'mscarry',
        'msgroup',
        'mstack',
        'msline',
        'msrow',
        'semantics',
        'annotation',
        'annotation-xml',
        'mprescripts',
        'none'
    ]);
    var text = freeze([
        '#text'
    ]);
    var html = freeze([
        'accept',
        'action',
        'align',
        'alt',
        'autocapitalize',
        'autocomplete',
        'autopictureinpicture',
        'autoplay',
        'background',
        'bgcolor',
        'border',
        'capture',
        'cellpadding',
        'cellspacing',
        'checked',
        'cite',
        'class',
        'clear',
        'color',
        'cols',
        'colspan',
        'controls',
        'controlslist',
        'coords',
        'crossorigin',
        'datetime',
        'decoding',
        'default',
        'dir',
        'disabled',
        'disablepictureinpicture',
        'disableremoteplayback',
        'download',
        'draggable',
        'enctype',
        'enterkeyhint',
        'face',
        'for',
        'headers',
        'height',
        'hidden',
        'high',
        'href',
        'hreflang',
        'id',
        'inputmode',
        'integrity',
        'ismap',
        'kind',
        'label',
        'lang',
        'list',
        'loading',
        'loop',
        'low',
        'max',
        'maxlength',
        'media',
        'method',
        'min',
        'minlength',
        'multiple',
        'muted',
        'name',
        'nonce',
        'noshade',
        'novalidate',
        'nowrap',
        'open',
        'optimum',
        'pattern',
        'placeholder',
        'playsinline',
        'poster',
        'preload',
        'pubdate',
        'radiogroup',
        'readonly',
        'rel',
        'required',
        'rev',
        'reversed',
        'role',
        'rows',
        'rowspan',
        'spellcheck',
        'scope',
        'selected',
        'shape',
        'size',
        'sizes',
        'span',
        'srclang',
        'start',
        'src',
        'srcset',
        'step',
        'style',
        'summary',
        'tabindex',
        'title',
        'translate',
        'type',
        'usemap',
        'valign',
        'value',
        'width',
        'xmlns',
        'slot'
    ]);
    var svg = freeze([
        'accent-height',
        'accumulate',
        'additive',
        'alignment-baseline',
        'ascent',
        'attributename',
        'attributetype',
        'azimuth',
        'basefrequency',
        'baseline-shift',
        'begin',
        'bias',
        'by',
        'class',
        'clip',
        'clippathunits',
        'clip-path',
        'clip-rule',
        'color',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'cx',
        'cy',
        'd',
        'dx',
        'dy',
        'diffuseconstant',
        'direction',
        'display',
        'divisor',
        'dur',
        'edgemode',
        'elevation',
        'end',
        'fill',
        'fill-opacity',
        'fill-rule',
        'filter',
        'filterunits',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'fx',
        'fy',
        'g1',
        'g2',
        'glyph-name',
        'glyphref',
        'gradientunits',
        'gradienttransform',
        'height',
        'href',
        'id',
        'image-rendering',
        'in',
        'in2',
        'k',
        'k1',
        'k2',
        'k3',
        'k4',
        'kerning',
        'keypoints',
        'keysplines',
        'keytimes',
        'lang',
        'lengthadjust',
        'letter-spacing',
        'kernelmatrix',
        'kernelunitlength',
        'lighting-color',
        'local',
        'marker-end',
        'marker-mid',
        'marker-start',
        'markerheight',
        'markerunits',
        'markerwidth',
        'maskcontentunits',
        'maskunits',
        'max',
        'mask',
        'media',
        'method',
        'mode',
        'min',
        'name',
        'numoctaves',
        'offset',
        'operator',
        'opacity',
        'order',
        'orient',
        'orientation',
        'origin',
        'overflow',
        'paint-order',
        'path',
        'pathlength',
        'patterncontentunits',
        'patterntransform',
        'patternunits',
        'points',
        'preservealpha',
        'preserveaspectratio',
        'primitiveunits',
        'r',
        'rx',
        'ry',
        'radius',
        'refx',
        'refy',
        'repeatcount',
        'repeatdur',
        'restart',
        'result',
        'rotate',
        'scale',
        'seed',
        'shape-rendering',
        'specularconstant',
        'specularexponent',
        'spreadmethod',
        'startoffset',
        'stddeviation',
        'stitchtiles',
        'stop-color',
        'stop-opacity',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke',
        'stroke-width',
        'style',
        'surfacescale',
        'systemlanguage',
        'tabindex',
        'targetx',
        'targety',
        'transform',
        'transform-origin',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'textlength',
        'type',
        'u1',
        'u2',
        'unicode',
        'values',
        'viewbox',
        'visibility',
        'version',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'width',
        'word-spacing',
        'wrap',
        'writing-mode',
        'xchannelselector',
        'ychannelselector',
        'x',
        'x1',
        'x2',
        'xmlns',
        'y',
        'y1',
        'y2',
        'z',
        'zoomandpan'
    ]);
    var mathMl = freeze([
        'accent',
        'accentunder',
        'align',
        'bevelled',
        'close',
        'columnsalign',
        'columnlines',
        'columnspan',
        'denomalign',
        'depth',
        'dir',
        'display',
        'displaystyle',
        'encoding',
        'fence',
        'frame',
        'height',
        'href',
        'id',
        'largeop',
        'length',
        'linethickness',
        'lspace',
        'lquote',
        'mathbackground',
        'mathcolor',
        'mathsize',
        'mathvariant',
        'maxsize',
        'minsize',
        'movablelimits',
        'notation',
        'numalign',
        'open',
        'rowalign',
        'rowlines',
        'rowspacing',
        'rowspan',
        'rspace',
        'rquote',
        'scriptlevel',
        'scriptminsize',
        'scriptsizemultiplier',
        'selection',
        'separator',
        'separators',
        'stretchy',
        'subscriptshift',
        'supscriptshift',
        'symmetric',
        'voffset',
        'width',
        'xmlns'
    ]);
    var xml = freeze([
        'xlink:href',
        'xml:id',
        'xlink:title',
        'xml:space',
        'xmlns:xlink'
    ]);
    // eslint-disable-next-line unicorn/better-regex
    var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    var TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
    var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape
    var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    var DOCTYPE_NAME = seal(/^html$/i);
    var CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var getGlobal = function getGlobal() {
        return typeof window === 'undefined' ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */ var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
        if (_typeof(trustedTypes) !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        var suffix = null;
        var ATTR_NAME = 'data-tt-policy-suffix';
        if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) suffix = document.currentScript.getAttribute(ATTR_NAME);
        var policyName = 'dompurify' + (suffix ? '#' + suffix : '');
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML: function createHTML(html) {
                    return html;
                },
                createScriptURL: function createScriptURL(scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
            return null;
        }
    };
    function createDOMPurify() {
        var window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        var DOMPurify = function DOMPurify(root) {
            return createDOMPurify(root);
        };
        /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */ DOMPurify.version = '2.5.1';
        /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */ DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== 9) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        var originalDocument = window1.document;
        var document = window1.document;
        var DocumentFragment = window1.DocumentFragment, HTMLTemplateElement = window1.HTMLTemplateElement, Node = window1.Node, Element = window1.Element, NodeFilter = window1.NodeFilter, _window$NamedNodeMap = window1.NamedNodeMap, NamedNodeMap = _window$NamedNodeMap === void 0 ? window1.NamedNodeMap || window1.MozNamedAttrMap : _window$NamedNodeMap, HTMLFormElement = window1.HTMLFormElement, DOMParser = window1.DOMParser, trustedTypes = window1.trustedTypes;
        var ElementPrototype = Element.prototype;
        var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
        var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
        var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
        var getParentNode = lookupGetter(ElementPrototype, 'parentNode');
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === 'function') {
            var template = document.createElement('template');
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
        var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
        var _document = document, implementation = _document.implementation, createNodeIterator = _document.createNodeIterator, createDocumentFragment = _document.createDocumentFragment, getElementsByTagName = _document.getElementsByTagName;
        var importNode = originalDocument.importNode;
        var documentMode = {};
        try {
            documentMode = clone(document).documentMode ? document.documentMode : {};
        } catch (_) {}
        var hooks = {};
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined && documentMode !== 9;
        var MUSTACHE_EXPR$1 = MUSTACHE_EXPR, ERB_EXPR$1 = ERB_EXPR, TMPLIT_EXPR$1 = TMPLIT_EXPR, DATA_ATTR$1 = DATA_ATTR, ARIA_ATTR$1 = ARIA_ATTR, IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA, ATTR_WHITESPACE$1 = ATTR_WHITESPACE, CUSTOM_ELEMENT$1 = CUSTOM_ELEMENT;
        var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ var ALLOWED_TAGS = null;
        var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));
        /* Allowed attribute names */ var ALLOWED_ATTR = null;
        var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));
        /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ var FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ var FORBID_ATTR = null;
        /* Decide if ARIA attributes are okay */ var ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ var ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ var ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ var ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ var SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */ var SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ var WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ var SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ var FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ var RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ var RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ var RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ var SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ var SANITIZE_NAMED_PROPS = false;
        var SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
        /* Keep element content when removing element? */ var KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ var IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ var USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ var FORBID_CONTENTS = null;
        var DEFAULT_FORBID_CONTENTS = addToSet({}, [
            'annotation-xml',
            'audio',
            'colgroup',
            'desc',
            'foreignobject',
            'head',
            'iframe',
            'math',
            'mi',
            'mn',
            'mo',
            'ms',
            'mtext',
            'noembed',
            'noframes',
            'noscript',
            'plaintext',
            'script',
            'style',
            'svg',
            'template',
            'thead',
            'title',
            'video',
            'xmp'
        ]);
        /* Tags that are safe for data: URIs */ var DATA_URI_TAGS = null;
        var DEFAULT_DATA_URI_TAGS = addToSet({}, [
            'audio',
            'video',
            'img',
            'source',
            'image',
            'track'
        ]);
        /* Attributes safe for values like "javascript:" */ var URI_SAFE_ATTRIBUTES = null;
        var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            'alt',
            'class',
            'for',
            'id',
            'label',
            'name',
            'pattern',
            'placeholder',
            'role',
            'summary',
            'title',
            'value',
            'style',
            'xmlns'
        ]);
        var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
        var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
        /* Document namespace */ var NAMESPACE = HTML_NAMESPACE;
        var IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ var ALLOWED_NAMESPACES = null;
        var DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        /* Parsing of strict XHTML documents */ var PARSER_MEDIA_TYPE;
        var SUPPORTED_PARSER_MEDIA_TYPES = [
            'application/xhtml+xml',
            'text/html'
        ];
        var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
        var transformCaseFunc;
        /* Keep a reference to config to pass to hooks */ var CONFIG = null;
        /* Specify the maximum element nesting depth to prevent mXSS */ var MAX_NESTING_DEPTH = 255;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ var formElement = document.createElement('form');
        var isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */ // eslint-disable-next-line complexity
        var _parseConfig = function _parseConfig(cfg) {
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || _typeof(cfg) !== 'object') cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = 'ALLOWED_NAMESPACES' in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), // eslint-disable-line indent
            cfg.ADD_URI_SAFE_ATTR, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), // eslint-disable-line indent
            cfg.ADD_DATA_URI_TAGS, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
            FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
            USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
                ALLOWED_ATTR = [];
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }
            if (cfg.ADD_ATTR) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (cfg.FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                'html',
                'head',
                'body'
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    'tbody'
                ]);
                delete FORBID_TAGS.tbody;
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            'mi',
            'mo',
            'mn',
            'ms',
            'mtext'
        ]);
        var HTML_INTEGRATION_POINTS = addToSet({}, [
            'foreignobject',
            'desc',
            'title',
            'annotation-xml'
        ]);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            'title',
            'style',
            'font',
            'a',
            'script'
        ]);
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ var ALL_SVG_TAGS = addToSet({}, svg$1);
        addToSet(ALL_SVG_TAGS, svgFilters);
        addToSet(ALL_SVG_TAGS, svgDisallowed);
        var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
        addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
        /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ var _checkValidNamespace = function _checkValidNamespace(element) {
            var parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: 'template'
            };
            var tagName = stringToLowerCase(element.tagName);
            var parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
                // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */ var _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                node.parentNode.removeChild(node);
            } catch (_) {
                try {
                    node.outerHTML = emptyHTML;
                } catch (_) {
                    node.remove();
                }
            }
        };
        /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */ var _removeAttribute = function _removeAttribute(name, node) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: node.getAttributeNode(name),
                    from: node
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: node
                });
            }
            node.removeAttribute(name);
            // We void attribute values for unremovable "is"" attributes
            if (name === 'is' && !ALLOWED_ATTR[name]) {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(node);
                } catch (_) {}
                else try {
                    node.setAttribute(name, '');
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */ var _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ var doc;
            var leadingWhitespace;
            if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ var matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
            var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, 'template', null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            var body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */ var _createIterator = function _createIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null, false);
        };
        /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */ var _isClobbered = function _isClobbered(elm) {
            return elm instanceof HTMLFormElement && (typeof elm.__depth !== 'undefined' && typeof elm.__depth !== 'number' || typeof elm.__removalCount !== 'undefined' && typeof elm.__removalCount !== 'number' || typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
        };
        /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */ var _isNode = function _isNode(object) {
            return _typeof(Node) === 'object' ? object instanceof Node : object && _typeof(object) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
        };
        /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */ var _executeHook = function _executeHook(entryPoint, currentNode, data) {
            if (!hooks[entryPoint]) return;
            arrayForEach(hooks[entryPoint], function(hook) {
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        };
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */ var _sanitizeElements = function _sanitizeElements(currentNode) {
            var content;
            /* Execute a hook if present */ _executeHook('beforeSanitizeElements', currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Check if tagname contains Unicode */ if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ var tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHook('uponSanitizeElement', currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Mitigate a problem with templates inside select */ if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any ocurrence of processing instructions */ if (currentNode.nodeType === 7) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === 8 && regExpTest(/<[/\w]/g, currentNode.data)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    var parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    var childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        var childCount = childNodes.length;
                        for(var i = childCount - 1; i >= 0; --i){
                            var childClone = cloneNode(childNodes[i], true);
                            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                            parentNode.insertBefore(childClone, getNextSibling(currentNode));
                        }
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
                /* Get the element's text content */ content = currentNode.textContent;
                content = stringReplace(content, MUSTACHE_EXPR$1, ' ');
                content = stringReplace(content, ERB_EXPR$1, ' ');
                content = stringReplace(content, TMPLIT_EXPR$1, ' ');
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeElements', currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if (value) return false;
            return true;
        };
        /**
     * _basicCustomElementCheck
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     * @param {string} tagName name of the tag of the node to sanitize
     */ var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
            return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT$1);
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */ var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            var attr;
            var value;
            var lcName;
            var l;
            /* Execute a hook if present */ _executeHook('beforeSanitizeAttributes', currentNode, null);
            var attributes = currentNode.attributes;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes) return;
            var hookEvent = {
                attrName: '',
                attrValue: '',
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR
            };
            l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                attr = attributes[l];
                var _attr = attr, name = _attr.name, namespaceURI = _attr.namespaceURI;
                value = name === 'value' ? attr.value : stringTrim(attr.value);
                lcName = transformCaseFunc(name);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Remove attribute */ _removeAttribute(name, currentNode);
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) continue;
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) {
                    value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
                    value = stringReplace(value, ERB_EXPR$1, ' ');
                    value = stringReplace(value, TMPLIT_EXPR$1, ' ');
                }
                /* Is `value` valid for this attribute? */ var lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) continue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && _typeof(trustedTypes) === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case 'TrustedHTML':
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case 'TrustedScriptURL':
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    arrayPop(DOMPurify.removed);
                } catch (_) {}
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeAttributes', currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */ var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            var shadowNode;
            var shadowIterator = _createIterator(fragment);
            /* Execute a hook if present */ _executeHook('beforeSanitizeShadowDOM', fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHook('uponSanitizeShadowNode', shadowNode, null);
                /* Sanitize tags and elements */ if (_sanitizeElements(shadowNode)) continue;
                /* Set the nesting depth of an element */ if (shadowNode.nodeType === 1) {
                    if (shadowNode.parentNode && shadowNode.parentNode.__depth) /*
              We want the depth of the node in the original tree, which can
              change when it's removed from its parent.
            */ shadowNode.__depth = (shadowNode.__removalCount || 0) + shadowNode.parentNode.__depth + 1;
                    else shadowNode.__depth = 1;
                }
                /* Remove an element if nested too deeply to avoid mXSS */ if (shadowNode.__depth >= MAX_NESTING_DEPTH) _forceRemove(shadowNode);
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) {
                    shadowNode.content.__depth = shadowNode.__depth;
                    _sanitizeShadowDOM(shadowNode.content);
                }
                /* Check attributes, sanitize if necessary */ _sanitizeAttributes(shadowNode);
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeShadowDOM', fragment, null);
        };
        /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */ // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var body;
            var importedNode;
            var currentNode;
            var oldNode;
            var returnNode;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = '<!-->';
            /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
                if (typeof dirty.toString === 'function') {
                    dirty = dirty.toString();
                    if (typeof dirty !== 'string') throw typeErrorCreate('dirty is not a string, aborting');
                } else throw typeErrorCreate('toString is not a function');
            }
            /* Check we can run. Otherwise fall back or ignore */ if (!DOMPurify.isSupported) {
                if (_typeof(window1.toStaticHTML) === 'object' || typeof window1.toStaticHTML === 'function') {
                    if (typeof dirty === 'string') return window1.toStaticHTML(dirty);
                    if (_isNode(dirty)) return window1.toStaticHTML(dirty.outerHTML);
                }
                return dirty;
            }
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === 'string') IN_PLACE = false;
            if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
                if (dirty.nodeName) {
                    var tagName = transformCaseFunc(dirty.nodeName);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                }
            } else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument('<!---->');
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === 'HTML') body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Fix IE's strange behavior with manipulated textNodes #89 */ if (currentNode.nodeType === 3 && currentNode === oldNode) continue;
                /* Sanitize tags and elements */ if (_sanitizeElements(currentNode)) continue;
                /* Set the nesting depth of an element */ if (currentNode.nodeType === 1) {
                    if (currentNode.parentNode && currentNode.parentNode.__depth) /*
              We want the depth of the node in the original tree, which can
              change when it's removed from its parent.
            */ currentNode.__depth = (currentNode.__removalCount || 0) + currentNode.parentNode.__depth + 1;
                    else currentNode.__depth = 1;
                }
                /* Remove an element if nested too deeply to avoid mXSS */ if (currentNode.__depth >= MAX_NESTING_DEPTH) _forceRemove(currentNode);
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) {
                    currentNode.content.__depth = currentNode.__depth;
                    _sanitizeShadowDOM(currentNode.content);
                }
                /* Check attributes, sanitize if necessary */ _sanitizeAttributes(currentNode);
                oldNode = currentNode;
            }
            oldNode = null;
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmod) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) {
                serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, ' ');
                serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, ' ');
                serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR$1, ' ');
            }
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */ DOMPurify.setConfig = function(cfg) {
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        /**
     * Public method to remove the configuration
     * clearConfig
     *
     */ DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */ DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            var lcTag = transformCaseFunc(tag);
            var lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */ DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== 'function') return;
            hooks[entryPoint] = hooks[entryPoint] || [];
            arrayPush(hooks[entryPoint], hookFunction);
        };
        /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */ DOMPurify.removeHook = function(entryPoint) {
            if (hooks[entryPoint]) return arrayPop(hooks[entryPoint]);
        };
        /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */ DOMPurify.removeHooks = function(entryPoint) {
            if (hooks[entryPoint]) hooks[entryPoint] = [];
        };
        /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */ DOMPurify.removeAllHooks = function() {
            hooks = {};
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});

});


parcelRegister("bYCTQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $704e547e64302f2f$export$2e2bcd8739ae039);
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $704e547e64302f2f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    resendInviteFailureFlagDescription: {
        "id": "servicedesk-customers-organization-common.table.resend-invite-cell.error-flag.resend-invite-failure-flag-description",
        "defaultMessage": "Check your network connection, refresh the page and try again."
    },
    resendInviteFailureFlagTitle: {
        "id": "servicedesk-customers-organization-common.table.resend-invite-cell.error-flag.resend-invite-failure-flag-title",
        "defaultMessage": "We couldn\u2019t resend the invite"
    },
    refreshThePage: {
        "id": "servicedesk-customers-organization-common.table.resend-invite-cell.error-flag.refresh-the-page",
        "defaultMessage": "Refresh the page"
    }
});

});



parcelRegister("g2s6X", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f0a7599dc50e961$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0f0a7599dc50e961$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    removeOption: {
        "id": "servicedesk-customers-organization-common.common.editable-table.editor-cell.remove-option",
        "defaultMessage": "Remove {name}."
    }
});

});




parcelRegister("goUX0", function(module, exports) {

$parcel$export(module.exports, "default", () => $bca9f917318b5421$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $bca9f917318b5421$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    addOrganizations: {
        "id": "servicedesk-customers.header-actions.add-organizations-dialog.form.add-organizations",
        "defaultMessage": "Add organizations"
    },
    successfullyAddedOrganizations: {
        "id": "servicedesk-customers.header-actions.add-organizations-dialog.form.successfully-added-organizations",
        "defaultMessage": "Success! Your {organizationsCount, plural, =1 {organization} other {organizations}} have been added."
    },
    selectOrgLabel: {
        "id": "servicedesk-customers.header-actions.add-organizations-dialog.form.select-org-label",
        "defaultMessage": "Choose or create an organization"
    }
});

});



parcelRegister("dat0s", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd4a7bd5338276e4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $fd4a7bd5338276e4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    addOrganizations: {
        "id": "servicedesk-customers.header-actions.add-organizations-dialog.add-organizations",
        "defaultMessage": "Add organizations"
    }
});

});



parcelRegister("84MTW", function(module, exports) {

$parcel$export(module.exports, "SearchWithResults", () => $c074e6f8168b5709$export$2992fdd014352a12);

var $eUqFw = parcelRequire("eUqFw");

var $220ac = parcelRequire("220ac");

var $1ybV0 = parcelRequire("1ybV0");

var $4Es8k = parcelRequire("4Es8k");

var $ijRkr = parcelRequire("ijRkr");

var $giAhk = parcelRequire("giAhk");

var $d6f6c = parcelRequire("d6f6c");
var $bFzGY = parcelRequire("bFzGY");

var $5yh8X = parcelRequire("5yh8X");

var $be3PE = parcelRequire("be3PE");

var $9bAhP = parcelRequire("9bAhP");
var $iDv71 = parcelRequire("iDv71");
var $897TM = parcelRequire("897TM");
var $2rxYS = parcelRequire("2rxYS");
var $jICX4 = parcelRequire("jICX4");

var $6OqHe = parcelRequire("6OqHe");

var $49CiC = parcelRequire("49CiC");

var $10Dlh = parcelRequire("10Dlh");

var $eWZfO = parcelRequire("eWZfO");

var $mgvmo = parcelRequire("mgvmo");
// Use longer-than-normal debounce because this is a costly
// endpoint which triggers alerts.  See JIG-335
const $c074e6f8168b5709$var$DEBOUNCE_MILLISECONDS = 500;
const $c074e6f8168b5709$var$SearchWithResultsView = ({ intl: { formatMessage: formatMessage } })=>{
    const [{ searchString: searchString, loading: loading, pageData: pageData, userPermissions: { projectSimplified: // @ts-expect-error - TS2525 - Initializer provides no value for this binding element and the binding element has no default value.
    projectSimplified, serviceDeskOpenAccess: // @ts-expect-error - TS2525 - Initializer provides no value for this binding element and the binding element has no default value.
    serviceDeskOpenAccess, // @ts-expect-error - TS2525 - Initializer provides no value for this binding element and the binding element has no default value.
    canAdminister: canAdministerProject } = {}, error: error }, { updateSearchString: updateSearchString, updatePageNumber: updatePageNumber, fetchAndUpdatePageData: fetchAndUpdatePageData }] = (0, $6OqHe.useAppStore)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { total: total, query: query } = pageData || {};
    const shouldShowSearchTip = !loading && Boolean(pageData || error) && Boolean(searchString);
    const showEmptyState = !loading && !total && !query;
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debounceSearchAction = (0, $eUqFw.useCallback)((0, $iDv71.debounce)(// @ts-expect-error - TS2345 - Argument of type '() => void | Promise<void>' is not assignable to parameter of type '(...rest: readonly any[]) => Promise<any>'.
    fetchAndUpdatePageData.bind(null, {
        createAnalyticsEvent: createAnalyticsEvent
    }), $c074e6f8168b5709$var$DEBOUNCE_MILLISECONDS), []);
    const isEditable = projectSimplified && !serviceDeskOpenAccess && canAdministerProject;
    const onSearchChange = (value)=>{
        updateSearchString(value);
        debounceSearchAction();
        (0, $9bAhP.customersSearchPageLoadExperience).start();
    };
    const onPageChange = (value)=>{
        updatePageNumber(value);
        debounceSearchAction();
        (0, $9bAhP.customersSearchPageLoadExperience).start();
    };
    if (error) {
        (0, $9bAhP.customersSearchPageLoadExperience).failure();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2rxYS.ErrorView), null);
    }
    if (showEmptyState) // TODO: jsm-cs-assets-eng-health delete no-customers-or-orgs.svg from assets folder
    return (0, $1ybV0.ff)('jsm-cs-assets-eng-health') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireOperationalAnalytics), {
        eventName: "customersOrgsEmptyState loaded"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        header: "",
        maxImageWidth: 320,
        maxImageHeight: 300,
        description: formatMessage((0, $eWZfO.default).noCustomersJsm),
        renderImage: (0, $4Es8k.getAkEmptyStateRenderImageFn)((0, $ijRkr.default))
    })) : // EmptyState component from common folder can be removed along with jsm-cs-assets-eng-health
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $897TM.EmptyState), {
        message: formatMessage((0, $eWZfO.default).noCustomersJsm),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($10Dlh)))
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jICX4.Search), {
        shouldShowSearchTip: shouldShowSearchTip,
        onChange: onSearchChange,
        query: searchString,
        placeholder: formatMessage((0, $eWZfO.default).searchPlaceholder),
        description: formatMessage((0, $eWZfO.default).searchDescription)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $mgvmo.TableWithActions), {
        setPageData: fetchAndUpdatePageData,
        onPageChange: onPageChange,
        loading: loading,
        pageData: pageData,
        isEditable: isEditable
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $be3PE.JsmPageInteractiveEvent), {
        metricKey: "servicedesk.customers",
        withMarks: [
            (0, $5yh8X.appBundleReadyMark)
        ],
        appName: "servicedesk.customers",
        // @ts-expect-error - TS2322 - Type 'PageLoadMetric' is not assignable to type 'BM3Metric'.
        metric: (0, $49CiC.customersPageLoad),
        extra: {
            version: 2
        }
    }));
};
$c074e6f8168b5709$var$SearchWithResultsView.displayName = 'SearchWithResults';
const $c074e6f8168b5709$export$2992fdd014352a12 = (0, $giAhk.injectIntlV2)($c074e6f8168b5709$var$SearchWithResultsView);

});
parcelRegister("ijRkr", function(module, exports) {

$parcel$export(module.exports, "default", () => $61fab21a696705ca$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $9TZf5 = parcelRequire("9TZf5");

var $bGJ7S = parcelRequire("bGJ7S");
const $61fab21a696705ca$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($bGJ7S)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($bGJ7S))
});
var $61fab21a696705ca$export$2e2bcd8739ae039 = $61fab21a696705ca$var$Illustration;
// for advanced use only
const $61fab21a696705ca$export$a179c88182cb9d56 = [
    0,
    0,
    600,
    386
];

});
parcelRegister("bGJ7S", function(module, exports) {
module.exports = new URL("task-board-with-people.e468116d.svg", import.meta.url).toString();

});


parcelRegister("897TM", function(module, exports) {

$parcel$export(module.exports, "EmptyState", () => $9a7a3dfc7523aca9$export$fddf379e22a74b00);

var $eUqFw = parcelRequire("eUqFw");

var $220ac = parcelRequire("220ac");

var $c9TLT = parcelRequire("c9TLT");

var $d6f6c = parcelRequire("d6f6c");
const $9a7a3dfc7523aca9$export$fddf379e22a74b00 = ({ message: message, header: header = '', imageUrl: imageUrl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireOperationalAnalytics), {
        eventName: "customersOrgsEmptyState loaded"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        header: header,
        imageWidth: (0, $c9TLT.gridSize) * 62.5,
        maxImageWidth: (0, $c9TLT.gridSize) * 62.5,
        imageHeight: (0, $c9TLT.gridSize) * 37.5,
        maxImageHeight: (0, $c9TLT.gridSize) * 37.5,
        description: message,
        imageUrl: imageUrl,
        size: "wide"
    }));

});

parcelRegister("2rxYS", function(module, exports) {

$parcel$export(module.exports, "ErrorView", () => $62a96efcad1fa0df$export$8c68b6013ae44ca6);

var $eUqFw = parcelRequire("eUqFw");

var $d6f6c = parcelRequire("d6f6c");

var $2Ba2b = parcelRequire("2Ba2b");
const $62a96efcad1fa0df$export$8c68b6013ae44ca6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireOperationalAnalytics), {
        eventName: "customersOrgsErrorView loaded"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Ba2b.GenericError), null));

});
parcelRegister("2Ba2b", function(module, exports) {

$parcel$export(module.exports, "ProjectNotFound", () => $abcdf98f8a718d25$export$849d319c342682a2);
$parcel$export(module.exports, "GenericError", () => $abcdf98f8a718d25$export$7d465be8efa67280);

var $eUqFw = parcelRequire("eUqFw");

var $220ac = parcelRequire("220ac");

var $heNSb = parcelRequire("heNSb");

var $4Es8k = parcelRequire("4Es8k");

var $lQXqy = parcelRequire("lQXqy");

var $7QuzF = parcelRequire("7QuzF");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kJlBc = parcelRequire("kJlBc");

var $6Yj0X = parcelRequire("6Yj0X");
const $abcdf98f8a718d25$export$849d319c342682a2 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const projectsPath = '/jira/projects';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $heNSb.DocumentTitle), {
        title: formatMessage((0, $6Yj0X.default).notFoundDocumentTitleJsm)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        renderImage: (0, $4Es8k.getAkEmptyStateRenderImageFn)((0, $7QuzF.default)),
        maxImageWidth: 120,
        header: formatMessage((0, $6Yj0X.default).notFoundTitle),
        description: formatMessage((0, $6Yj0X.default).notFoundDescription),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Link), {
            to: projectsPath
        }, formatMessage((0, $6Yj0X.default).notFoundAction))
    }));
};
const $abcdf98f8a718d25$export$7d465be8efa67280 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $heNSb.DocumentTitle), {
        title: formatMessage((0, $6Yj0X.default).genericDocumentTitleJsm)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        renderImage: (0, $4Es8k.getAkEmptyStateRenderImageFn)((0, $lQXqy.default)),
        maxImageWidth: 120,
        header: formatMessage((0, $6Yj0X.default).genericErrorTitle),
        description: formatMessage((0, $6Yj0X.default).genericErrorDescription)
    }));
};

});
parcelRegister("heNSb", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $44af95caa6ad02db$export$dd5ad0b65cf665da);

var $eUqFw = parcelRequire("eUqFw");

var $1TtYL = parcelRequire("1TtYL");

var $3fq1f = parcelRequire("3fq1f");
class $44af95caa6ad02db$export$dd5ad0b65cf665da extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $1TtYL.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1TtYL.DocumentTitleHelper), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}

});

parcelRegister("lQXqy", function(module, exports) {

$parcel$export(module.exports, "default", () => $30559913302f86cb$export$2e2bcd8739ae039);
$parcel$export(module.exports, "viewBox", () => $30559913302f86cb$export$a179c88182cb9d56);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("jhcOe")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("6bGvz")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = m5v37k2r2scm86wgmrk6
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/m5v37k2r2scm86wgmrk6

var $9TZf5 = parcelRequire("9TZf5");

var $6bGvz = parcelRequire("6bGvz");

var $jhcOe = parcelRequire("jhcOe");
const $30559913302f86cb$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($jhcOe)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($6bGvz))
});
var $30559913302f86cb$export$2e2bcd8739ae039 = $30559913302f86cb$var$Illustration;
// for advanced use only
const $30559913302f86cb$export$a179c88182cb9d56 = [
    0,
    0,
    164,
    218
];

});
parcelRegister("6bGvz", function(module, exports) {
module.exports = new URL("error-darkmode.9dba78cd.svg", import.meta.url).toString();

});

parcelRegister("jhcOe", function(module, exports) {
module.exports = new URL("error.b7de7f77.svg", import.meta.url).toString();

});


parcelRegister("7QuzF", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ab5059cf2dfabb6$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 53grvvhrxck68z6q4s7ztq4p
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/53grvvhrxck68z6q4s7ztq4p

var $9TZf5 = parcelRequire("9TZf5");

var $h5DV7 = parcelRequire("h5DV7");
const $3ab5059cf2dfabb6$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($h5DV7)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($h5DV7))
});
var $3ab5059cf2dfabb6$export$2e2bcd8739ae039 = $3ab5059cf2dfabb6$var$Illustration;
// for advanced use only
const $3ab5059cf2dfabb6$export$a179c88182cb9d56 = [
    0,
    0,
    167,
    226
];

});
parcelRegister("h5DV7", function(module, exports) {
module.exports = new URL("search-error.a6df7c97.svg", import.meta.url).toString();

});


parcelRegister("6Yj0X", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c13e1fbd282caae$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6c13e1fbd282caae$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    notFoundDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-document-title-jsm",
        "defaultMessage": "Project not found - Service project"
    },
    notFoundTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-title",
        "defaultMessage": "This project isn't available"
    },
    notFoundDescription: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-description",
        "defaultMessage": "It may have been deleted or your permissions may have changed"
    },
    notFoundAction: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-action",
        "defaultMessage": "View a list of all projects"
    },
    genericDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-document-title-jsm",
        "defaultMessage": "Error - Service project"
    },
    genericErrorTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-error-title",
        "defaultMessage": "An error occurred"
    },
    genericErrorDescription: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-error-description",
        "defaultMessage": "An error occurred while loading this page"
    }
});

});



parcelRegister("jICX4", function(module, exports) {

$parcel$export(module.exports, "Search", () => $5aa9201ef452d64e$export$4b85d3515bd863a5);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hompL = parcelRequire("hompL");

var $giAhk = parcelRequire("giAhk");

var $8Ui86 = parcelRequire("8Ui86");

var $4o89K = parcelRequire("4o89K");
const $5aa9201ef452d64e$var$SearchView = ({ StyledSearchContainer: StyledSearchContainer, SearchTip: SearchTip, shouldShowSearchTip: shouldShowSearchTip, onChange: onChange, placeholder: placeholder, description: description, query: query, intl: { formatMessage: formatMessage } })=>{
    const descriptionId = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($hompL)))(), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(StyledSearchContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Ui86.SearchField), {
        placeholder: placeholder,
        isAlwaysExpanded: true,
        increasedWidth: true,
        onChange: onChange,
        value: query,
        placeholderAlwaysVisible: true,
        isAutocompleteDisabled: true,
        describedById: description && descriptionId
    }), shouldShowSearchTip && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SearchTip, {
        "data-test-id": "servicedesk-customers-organization-common.ui.search.search-tip"
    }, formatMessage((0, $4o89K.default).searchTip)), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        id: descriptionId,
        hidden: true
    }, description));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5aa9201ef452d64e$var$SearchTipDI = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l _18u0pxbi _y3gn1h6o _o5721q9c",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5aa9201ef452d64e$var$StyledSearchContainerDI = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0qv47k",
            __cmplp.className
        ])
    });
});
$5aa9201ef452d64e$var$SearchView.defaultProps = {
    StyledSearchContainer: $5aa9201ef452d64e$var$StyledSearchContainerDI,
    SearchTip: $5aa9201ef452d64e$var$SearchTipDI,
    shouldShowSearchTip: false
};
const $5aa9201ef452d64e$export$4b85d3515bd863a5 = (0, $giAhk.injectIntlV2)($5aa9201ef452d64e$var$SearchView);

});
parcelRegister("8Ui86", function(module, exports) {

$parcel$export(module.exports, "SearchField", () => $02c3e5e2cebd6ff7$export$b94867ecbd698f21);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $gtzuR = parcelRequire("gtzuR");

var $bFzGY = parcelRequire("bFzGY");

var $cf2Y4 = parcelRequire("cf2Y4");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $babBw = parcelRequire("babBw");

var $dAreR = parcelRequire("dAreR");
// This class prevents filled in input field causing confirmation dialog
// when user wants to navigate away. This functionality is coming from Jira monolith.
const $02c3e5e2cebd6ff7$var$className = 'ajs-dirty-warning-exempt';
const $02c3e5e2cebd6ff7$var$SearchFieldUnmemoized = ({ onEnter: onEnter, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', inputRef: inputRef, value: externalValue, autoFocus: autoFocus = false, isCompact: isCompact = false, isDisabled: isDisabled = false, shouldFitContainerWidth: shouldFitContainerWidth = false, isAutocompleteDisabled: isAutocompleteDisabled = false, placeholderAlwaysVisible: placeholderAlwaysVisible = false, searchIconVisible: searchIconVisible = true, isAlwaysExpanded: isAlwaysExpanded = false, increasedWidth: increasedWidth = false, maxLength: maxLength, describedById: describedById = '', ariaLabelText: ariaLabelText, id: id, renderCustomSearchField: renderCustomSearchField, searchIconPrimaryColor: searchIconPrimaryColor, testId: testId, inputProps: inputProps = {}, isResponsive: isResponsive = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [isFocused, setIsFocused] = (0, $eUqFw.useState)(false);
    const [value, setValue] = (0, $eUqFw.useState)(externalValue || '');
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const textInput = (0, $eUqFw.useRef)(null);
    const previousValueRef = (0, $eUqFw.useRef)();
    const previousValue = previousValueRef.current;
    if (externalValue !== previousValue && externalValue !== value) // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'SetStateAction<string>'.
    setValue(externalValue);
    previousValueRef.current = externalValue;
    const handleOnFocus = (0, $eUqFw.useCallback)((event)=>{
        setIsFocused(true);
        onFocus && onFocus(event);
    }, [
        onFocus
    ]);
    const handleOnBlur = (0, $eUqFw.useCallback)((event)=>{
        onBlur && onBlur(event);
        setIsFocused(false);
    }, [
        onBlur
    ]);
    const handleOnChange = (0, $eUqFw.useCallback)(({ currentTarget: currentTarget })=>{
        const { value: val } = currentTarget;
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        setValue(val);
        onChange(val, analyticsEvent);
    }, [
        createAnalyticsEvent,
        onChange
    ]);
    const handleKeyDown = (0, $eUqFw.useCallback)((event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        if (event.key === 'Escape') {
            setValue('');
            onChange('', analyticsEvent);
        }
        if (onEnter && event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($gtzuR)))('enter')) {
            event.preventDefault();
            onEnter(event.currentTarget && event.currentTarget.value);
        }
    }, [
        createAnalyticsEvent,
        onChange,
        onEnter
    ]);
    const handleOnClear = (0, $eUqFw.useCallback)(()=>{
        if (value !== '') {
            const analyticsEvent = createAnalyticsEvent({
                action: 'changed'
            });
            setValue('');
            onChange('', analyticsEvent);
        }
        if (inputRef && inputRef.current !== null) inputRef.current.blur();
        if (textInput.current !== null) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        textInput.current.blur();
    }, [
        createAnalyticsEvent,
        inputRef,
        onChange,
        value
    ]);
    const isExpanded = isFocused || value !== '' || isAlwaysExpanded;
    const textFieldProps = {
        ...inputProps,
        'aria-label': ariaLabelText || placeholder,
        'aria-describedby': describedById,
        type: 'text',
        // @ts-expect-error - TS2322 - Type '{ 'aria-label': string; 'aria-describedby': string; type: string; 'data-test-id': string; name: string; className: string; placeholder: string; onFocus: (event: React.SyntheticEvent<HTMLInputElement, Event>) => void; ... 9 more ...; maxLength: number | undefined; }' is not assignable to type 'TextfieldProps'.
        'data-test-id': 'searchfield',
        name: 'search',
        className: $02c3e5e2cebd6ff7$var$className,
        placeholder: placeholder,
        onFocus: handleOnFocus,
        onBlur: handleOnBlur,
        width: '120px',
        onChange: handleOnChange,
        onKeyDown: handleKeyDown,
        ref: inputRef || textInput,
        isCompact: isCompact,
        autoFocus: autoFocus,
        autoComplete: isAutocompleteDisabled ? 'off' : 'on',
        value: value,
        maxLength: maxLength,
        isDisabled: isDisabled
    };
    const searchIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dAreR.SearchFieldIcon), {
        onClear: handleOnClear,
        hasValue: value !== '',
        clearIconLabel: formatMessage((0, $babBw.messages).clear),
        searchIconVisible: searchIconVisible,
        primaryColor: searchIconPrimaryColor,
        onlyIconSpacing: isResponsive && !isExpanded
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02c3e5e2cebd6ff7$var$Container, {
        shouldFitContainerWidth: shouldFitContainerWidth
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02c3e5e2cebd6ff7$var$InputWrapper, {
        isExpanded: isExpanded,
        shouldFitContainerWidth: shouldFitContainerWidth,
        increasedWidth: increasedWidth,
        maxWidth: increasedWidth ? 328 : 184,
        placeholderAlwaysVisible: placeholderAlwaysVisible,
        isResponsive: isResponsive
    }, renderCustomSearchField !== undefined ? renderCustomSearchField({
        textFieldProps: textFieldProps,
        searchIcon: searchIcon
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
        ...textFieldProps,
        testId: testId,
        elemAfterInput: searchIcon,
        ...id !== undefined ? {
            id: id
        } : {}
    })));
};
$02c3e5e2cebd6ff7$var$SearchFieldUnmemoized.displayName = 'Search';
$02c3e5e2cebd6ff7$var$SearchFieldUnmemoized.whyDidYouRender = true;
const $02c3e5e2cebd6ff7$export$b94867ecbd698f21 = /*#__PURE__*/ (0, $eUqFw.memo)($02c3e5e2cebd6ff7$var$SearchFieldUnmemoized);
$02c3e5e2cebd6ff7$export$b94867ecbd698f21.displayName = 'Search'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $02c3e5e2cebd6ff7$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.shouldFitContainerWidth && "_1bsb1osq",
            __cmplp.className
        ])
    });
});
const $02c3e5e2cebd6ff7$var$InputWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { placeholderAlwaysVisible: placeholderAlwaysVisible, isResponsive: isResponsive, maxWidth: maxWidth, isExpanded: isExpanded, shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1et2rhb": (0, $9t7rW.default)(__cmplp.maxWidth, "px"),
            "--_47juog": (0, $9t7rW.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '30px'),
            "--_h8l327": (0, $9t7rW.default)(// Remove eslint-disable-next-line when nin-jql-builder-text-search-input-responsive-height-fix_t1y03 cleanup
            // Leave isExpanded ? 'auto' : '32px' when nin-jql-builder-text-search-input-responsive-height-fix_t1y03 is removed
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            !(0, $1ybV0.ff)('nin-jql-builder-text-search-input-responsive-height-fix_t1y03') || __cmplp.isExpanded ? 'auto' : '32px'),
            "--_jy5l88": (0, $9t7rW.default)(__cmplp.isExpanded ? `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}` : "var(--ds-space-0, 0px)"),
            "--_1skyi4s": (0, $9t7rW.default)(__cmplp.isExpanded ? 'auto' : 0),
            "--_1qenfck": (0, $9t7rW.default)(__cmplp.isExpanded ? 1 : 0),
            "--_1b7586u": (0, $9t7rW.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '120px'),
            "--_1b72lxu": (0, $9t7rW.default)(__cmplp.shouldFitContainerWidth ? '100%' : `${__cmplp.isExpanded ? __cmplp.maxWidth : 120}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _v564zpk5 _166qglyw _101ad2bq _i2ybkb7n",
            __cmplp.placeholderAlwaysVisible ? "_lav0kb7n" : "_lav0idpf",
            __cmplp.isResponsive ? "_1bsb1ayu _1s4pflvl _1kne9uv3 _odci1sf5 _wngi16hp _5xde1wic _1hr27bcq" : "_1bsb1di6",
            __cmplp.className
        ])
    });
});

});
parcelRegister("babBw", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1db92d5b4c5e946f$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $1db92d5b4c5e946f$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    clear: {
        "id": "searchfield.clear",
        "defaultMessage": "Clear"
    }
});

});

parcelRegister("dAreR", function(module, exports) {

$parcel$export(module.exports, "SearchFieldIcon", () => $81537fc79b34b1c4$export$8a82bff895521bd9);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $jWuk1 = parcelRequire("jWuk1");

var $dsroq = parcelRequire("dsroq");

var $b5IAe = parcelRequire("b5IAe");
var $4Ywu9 = parcelRequire("4Ywu9");
var $1ZAYh = parcelRequire("1ZAYh");
const $81537fc79b34b1c4$export$8a82bff895521bd9 = ({ onClear: onClear, hasValue: hasValue, searchIconVisible: searchIconVisible, clearIconLabel: clearIconLabel, primaryColor: primaryColor, onlyIconSpacing: onlyIconSpacing = false })=>{
    const akSearchIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dsroq))), {
        size: "small",
        label: "",
        primaryColor: primaryColor
    });
    const searchIcon = searchIconVisible ? akSearchIcon : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            $81537fc79b34b1c4$var$wrapperStyles,
            onlyIconSpacing && $81537fc79b34b1c4$var$spacingStyles
        ]
    }, hasValue ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        spacing: "none",
        "data-test-id": "searchfield.ui.searchfield-icon.clear-button",
        onClick: onClear,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))), {
            size: "small",
            label: clearIconLabel,
            primaryColor: primaryColor
        })
    }) : searchIcon);
};
const $81537fc79b34b1c4$var$wrapperStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.accent.gray',
    marginTop: 'space.0',
    marginRight: 'space.100',
    marginBottom: 'space.0',
    marginLeft: 'space.0',
    height: '16px',
    display: 'flex'
});
const $81537fc79b34b1c4$var$spacingStyles = (0, $1ZAYh.xcss)({
    marginRight: 'space.075',
    [(0, $4Ywu9.media).above.md]: {
        marginRight: 'space.100'
    }
});

});


parcelRegister("4o89K", function(module, exports) {

$parcel$export(module.exports, "default", () => $e29c8019fa1c8230$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e29c8019fa1c8230$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    searchTip: {
        "id": "servicedesk-customers-organization-common.search.search-tip",
        "defaultMessage": "Customer not found? Try refining your search."
    }
});

});


parcelRegister("49CiC", function(module, exports) {

$parcel$export(module.exports, "customersPageLoad", () => $8c27bfda7204ac88$export$f681daf850d5e9e4);

var $lNfG4 = parcelRequire("lNfG4");
const $8c27bfda7204ac88$export$f681daf850d5e9e4 = (0, $lNfG4.metrics).pageLoad({
    key: 'service-management.customers'
});

});

parcelRegister("10Dlh", function(module, exports) {
module.exports = new URL("no-customers-or-orgs.e468116d.svg", import.meta.url).toString();

});

parcelRegister("eWZfO", function(module, exports) {

$parcel$export(module.exports, "default", () => $acc0f8e03936199a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $acc0f8e03936199a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    customersBreadcrumbTitle: {
        "id": "servicedesk-customers.customers-breadcrumb-title",
        "defaultMessage": "Customers"
    },
    noCustomersJsm: {
        "id": "servicedesk-customers.no-customers-jsm",
        "defaultMessage": "There are no customers yet. Invite some to your service project."
    },
    searchPlaceholder: {
        "id": "servicedesk-customers.search-placeholder",
        "defaultMessage": "Search customers and organizations"
    },
    searchDescription: {
        "id": "servicedesk-customers.search-description",
        "defaultMessage": "Typing in the search field will update the results in the below table."
    }
});

});

parcelRegister("mgvmo", function(module, exports) {

$parcel$export(module.exports, "TableWithActions", () => $cfe79dd4e49f4675$export$5ac09e049b32e384);

var $eUqFw = parcelRequire("eUqFw");

var $5oIBC = parcelRequire("5oIBC");

var $7d1RI = parcelRequire("7d1RI");

var $NqqMP = parcelRequire("NqqMP");

var $9bAhP = parcelRequire("9bAhP");
var $5ei0n = parcelRequire("5ei0n");

var $a4UlN = parcelRequire("a4UlN");

var $6m6Lz = parcelRequire("6m6Lz");

var $1t6yB = parcelRequire("1t6yB");

var $7utas = parcelRequire("7utas");
const $cfe79dd4e49f4675$var$resendVerificationEmail = 'resendVerificationEmail';
const $cfe79dd4e49f4675$var$TableWithActionsView = ({ flagService: { showFlag: showFlag }, setPageData: setPageData, onPageChange: onPageChange, loading: loading, pageData: pageData, isEditable: isEditable })=>{
    const { baseUrl: baseUrl, projectKey: projectKey, projectName: projectName } = (0, $7d1RI.useCommonPageContext)();
    const { loading: removeCustomerLoading, data: removeCustomerData, fetch: removeCustomer, error: removeCustomerError } = (0, $1t6yB.useRemoveCustomerService)(baseUrl, projectKey);
    const [isRemoveOrganizationDialogOpen, toggleRemoveOrganizationDialog, closeRemoveOrganizationDialog] = (0, $NqqMP.usePopupController)();
    const [toBeRemovedOrganizationInfo, setToBeRemovedOrganizationInfo] = (0, $eUqFw.useState)({
        id: null,
        displayName: ''
    });
    const [toBeRemovedUserInfo, setToBeRemovedUserInfo] = (0, $eUqFw.useState)({
        identifier: '',
        displayName: ''
    });
    const onRemoveClick = (0, $eUqFw.useCallback)((customer)=>{
        const orgProfile = (0, $a4UlN.normalizeToOrgProfile)(customer);
        if (orgProfile) {
            const { id: id, displayName: displayName } = orgProfile;
            setToBeRemovedOrganizationInfo({
                id: id,
                displayName: displayName
            });
            toggleRemoveOrganizationDialog();
            return;
        }
        const userProfile = (0, $a4UlN.normalizeToUserProfile)(customer);
        if (userProfile) {
            const { identifier: identifier, displayName: displayName } = userProfile;
            setToBeRemovedUserInfo({
                displayName: displayName,
                identifier: identifier
            });
            removeCustomer(identifier);
        }
    }, [
        removeCustomer,
        toggleRemoveOrganizationDialog
    ]);
    const onRemoveOrganizationSuccess = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7031 - Binding element 'orgName' implicitly has an 'any' type.
    ({ orgName: orgName })=>{
        showFlag({
            type: 'success',
            title: [
                (0, $7utas.default).flagTitle,
                {
                    customerName: orgName,
                    projectName: projectName
                }
            ]
        });
        closeRemoveOrganizationDialog();
        setPageData();
    }, [
        closeRemoveOrganizationDialog,
        projectName,
        setPageData,
        showFlag
    ]);
    const onActionSuccess = (0, $eUqFw.useCallback)((email, successAction)=>{
        if (successAction === $cfe79dd4e49f4675$var$resendVerificationEmail) showFlag({
            type: 'success',
            title: (0, $7utas.default).resendVerificationEmailTitle,
            description: [
                (0, $7utas.default).resendVerificationEmailDescription,
                {
                    email: email
                }
            ]
        });
        else showFlag({
            type: 'success',
            title: (0, $7utas.default).resendInviteSuccessFlagTitle,
            description: [
                (0, $7utas.default).resendInviteSuccessFlagDescription,
                {
                    email: email
                }
            ]
        });
    }, [
        showFlag
    ]);
    const onActionFailure = (0, $eUqFw.useCallback)((id, errorFlagComponent)=>{
        showFlag({
            id: id,
            render: ()=>errorFlagComponent
        });
    }, [
        showFlag
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const { identifier: identifier, displayName: displayName } = toBeRemovedUserInfo;
        if (Boolean(removeCustomerData) && removeCustomerData === identifier) {
            showFlag({
                type: 'success',
                title: [
                    (0, $7utas.default).flagTitle,
                    {
                        customerName: displayName,
                        projectName: projectName
                    }
                ]
            });
            setPageData();
        }
        if (removeCustomerError) showFlag({
            type: 'error',
            title: (0, $7utas.default).removeCustomerError
        });
    }, [
        projectName,
        removeCustomerData,
        removeCustomerError,
        setPageData,
        showFlag,
        toBeRemovedUserInfo
    ]);
    (0, $eUqFw.useEffect)(()=>{
        (0, $9bAhP.customersSearchPageLoadExperience).success();
    }, [
        pageData
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ei0n.RemoveOrganizationDialog), {
        isOpen: isRemoveOrganizationDialogOpen,
        onClose: closeRemoveOrganizationDialog,
        orgName: toBeRemovedOrganizationInfo.displayName,
        orgId: Number(toBeRemovedOrganizationInfo.id),
        onSuccess: onRemoveOrganizationSuccess
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6m6Lz.Table), {
        loading: loading || removeCustomerLoading,
        // @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
        projectKey: projectKey,
        // @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
        projectName: projectName,
        pageData: pageData,
        onPageChange: onPageChange,
        isEditable: isEditable,
        onRemove: onRemoveClick,
        onActionSuccess: onActionSuccess,
        onActionFailure: onActionFailure
    }));
};
const $cfe79dd4e49f4675$export$5ac09e049b32e384 = (0, $5oIBC.default)($cfe79dd4e49f4675$var$TableWithActionsView);

});
parcelRegister("5ei0n", function(module, exports) {

$parcel$export(module.exports, "RemoveOrganizationDialog", () => $48e9cb50b225930d$export$4a49832503929763);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");
var $dxopF = parcelRequire("dxopF");

var $kGQen = parcelRequire("kGQen");

var $giAhk = parcelRequire("giAhk");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $7d1RI = parcelRequire("7d1RI");

var $81Khm = parcelRequire("81Khm");

var $9bAhP = parcelRequire("9bAhP");

var $fB9PH = parcelRequire("fB9PH");

var $LLzqL = parcelRequire("LLzqL");
const $48e9cb50b225930d$var$RemoveOrganizationConfirmation = ({ isOpen: isOpen = false, onClose: onClose, onSuccess: onSuccess, intl: { formatMessage: formatMessage }, orgName: orgName, orgId: orgId, confirmMessage: confirmMessage = '' })=>{
    const { baseUrl: baseUrl, projectId: projectId, projectName: projectName, projectKey: projectKey } = (0, $7d1RI.useCommonPageContext)();
    const [isErrorSectionOpen, setIsErrorSectionOpen] = (0, $eUqFw.useState)(true);
    const { error: isError, data: data, fetch: removeOrganization, loading: loading } = (0, $fB9PH.useRemoveOrganizationService)(baseUrl, projectId);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleClick = (_, analyticsEvent)=>{
        (0, $9bAhP.organizationsRemoveFromProjectExperience).start();
        removeOrganization(orgId, analyticsEvent);
    };
    (0, $eUqFw.useEffect)(()=>{
        if (Boolean(data) && data === orgId) /* @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Argument of type 'string | undefined' is not assignable to parameter of type 'string' */ onSuccess({
            projectKey: projectKey,
            orgName: orgName
        });
        if (isError) {
            (0, $9bAhP.organizationsRemoveFromProjectExperience).failure();
            setIsErrorSectionOpen(true);
        }
    }, [
        isError,
        onSuccess,
        orgId,
        orgName,
        projectKey,
        projectName,
        data
    ]);
    const actions = [
        {
            text: confirmMessage || formatMessage((0, $LLzqL.default).confirm),
            onClick: handleClick,
            'data-test-id': 'jsd.servicedesk.customers-organization-common.confirm-button',
            appearance: 'default',
            isLoading: loading
        },
        {
            text: formatMessage((0, $LLzqL.default).cancel),
            onClick: onClose,
            'data-test-id': 'jsd.servicedesk.customers-organization-common.close-button',
            appearance: 'link'
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        autoFocus: true,
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, formatMessage((0, $LLzqL.default).header, {
        orgName: orgName
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "removeOrganization",
        sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa)
    }, isError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $81Khm.CollapsibleSectionMessage), {
        appearance: "error",
        message: formatMessage((0, $LLzqL.default).errorMessage),
        isOpen: isErrorSectionOpen,
        title: formatMessage((0, $LLzqL.default).errorMessageTitle),
        onClose: setIsErrorSectionOpen
    }), formatMessage((0, $LLzqL.default).information, {
        projectName: projectName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, actions.map((props, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            key: index,
            ...props,
            appearance: index === 0 ? props.appearance || 'primary' : props.appearance || 'subtle'
        }, props.text))))));
};
const $48e9cb50b225930d$export$4a49832503929763 = (0, $giAhk.injectIntlV2)($48e9cb50b225930d$var$RemoveOrganizationConfirmation);

});
parcelRegister("fB9PH", function(module, exports) {

$parcel$export(module.exports, "useRemoveOrganizationService", () => $ecfa077aea5802a5$export$693e5ab5cf9df2e2);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $jMP2a = parcelRequire("jMP2a");

var $fV97Z = parcelRequire("fV97Z");

var $9bAhP = parcelRequire("9bAhP");

var $c0HgT = parcelRequire("c0HgT");
const $ecfa077aea5802a5$export$693e5ab5cf9df2e2 = (baseUrl, projectId)=>{
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const [data, setData] = (0, $eUqFw.useState)(null);
    const [error, setError] = (0, $eUqFw.useState)(null);
    const fetch = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'analyticsEvent' implicitly has an 'any' type.
    async (organizationId, analyticsEvent)=>{
        setLoading(true);
        setError(null);
        (0, $9bAhP.removeOrganizationExperience).start();
        try {
            await (0, $fV97Z.performPostRequest)((0, $c0HgT.getUrl)(baseUrl, projectId, organizationId));
            setData(organizationId);
            setLoading(false);
            (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'organization removed', `${organizationId}`);
            (0, $9bAhP.removeOrganizationExperience).success();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setLoading(false);
            setError(err);
            // Only fire analytics for unexpected errors. In this case the backend really
            // only returns a 403 if the current user doesn't have permission to manage
            // organizations. I'm not sure how to replicate that situation so I'll leave it as
            // unexpected, based on an assumption that such users wouldn't see the delete button
            (0, $guiFP.default)({
                error: err,
                meta: {
                    id: 'useRemoveOrganizationService',
                    packageName: 'jiraServicedeskCustomersOrganizationCommon',
                    teamName: 'boysenberry'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            (0, $9bAhP.removeOrganizationExperience).failure();
        }
    }, [
        baseUrl,
        projectId
    ]);
    return {
        loading: loading,
        error: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type '((Error | ValidationErrors | { statusCode: number; message?: string | undefined; }) & ValidationErrors) | null'.
        error,
        data: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'ServiceData<Data>'.
        data,
        fetch: // @ts-expect-error - TS2322 - Type '(organizationId: number, analyticsEvent: any) => Promise<void>' is not assignable to type '(() => Promise<void>) & ((organizationId: number, analyticsEvent: UIAnalyticsEventInterface) => Promise<void>)'.
        fetch
    };
};

});
parcelRegister("c0HgT", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $284d9de7f6551f8a$export$94df0e59ebebf4a7);
const $284d9de7f6551f8a$export$94df0e59ebebf4a7 = (baseUrl, projectId, organizationId)=>`${baseUrl}/rest/servicedesk/1/servicedesk/${projectId}/organisation/${organizationId}/dissasociate`;

});


parcelRegister("LLzqL", function(module, exports) {

$parcel$export(module.exports, "default", () => $e421db0dfa99ef48$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e421db0dfa99ef48$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    information: {
        "id": "servicedesk-customers-organization-common.remove-organization-dialog.information",
        "defaultMessage": "Organization members will lose access to {projectName} unless they have the Customers role for the project."
    },
    confirm: {
        "id": "servicedesk-customers-organization-common.remove-organization-dialog.confirm",
        "defaultMessage": "Confirm"
    },
    header: {
        "id": "servicedesk-customers-organization-common.remove-organization-dialog.header",
        "defaultMessage": "Remove {orgName} from project"
    },
    cancel: {
        "id": "servicedesk-customers-organization-common.remove-organization-dialog.cancel",
        "defaultMessage": "Cancel"
    },
    errorMessage: {
        "id": "servicedesk-customers-organization-common.remove-organization-dialog.error-message",
        "defaultMessage": "Something has gone wrong with your request. If symptoms persist contact your System Administrator."
    },
    errorMessageTitle: {
        "id": "servicedesk-customers-organization-common.remove-organization-dialog.error-message-title",
        "defaultMessage": "Error"
    }
});

});


parcelRegister("6m6Lz", function(module, exports) {

$parcel$export(module.exports, "Table", () => $5ce380cdfa3fce5f$export$54ec01a60f47d33d);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $clqWl = parcelRequire("clqWl");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");

var $giAhk = parcelRequire("giAhk");

var $d6f6c = parcelRequire("d6f6c");

var $a4UlN = parcelRequire("a4UlN");

var $5yUTM = parcelRequire("5yUTM");

var $fuV9u = parcelRequire("fuV9u");

var $1a5HF = parcelRequire("1a5HF");

var $5zPH1 = parcelRequire("5zPH1");

var $lIP0w = parcelRequire("lIP0w");

var $ak4QW = parcelRequire("ak4QW");

var $4YoJu = parcelRequire("4YoJu");

var $kSp6c = parcelRequire("kSp6c");
const $5ce380cdfa3fce5f$export$b3c27e869d856b7 = (props)=>{
    const { loading: loading, intl: intl, pageData: pageData, onPageChange: onPageChange } = props;
    const { page: page, total: total, customers: customers, totalHasBeenDetermined: totalHasBeenDetermined, lastDeterminedPaged: lastDeterminedPaged } = pageData || (0, $fuV9u.DEFAULT_PAGE_DATA);
    const hasOrganisationRow = customers?.some((0, $a4UlN.isOrganization));
    const head = props.head ? props.head : (0, $1a5HF.getHeader)(intl, props.isEditable || hasOrganisationRow);
    const { rows: rows, tablePage: tablePage, setTablePage: setTablePage } = (0, $lIP0w.useTableRows)(props);
    const { query: query } = pageData || {
        query: ''
    };
    const paginationProps = {
        query: query,
        totalHasBeenDetermined: totalHasBeenDetermined,
        total: total,
        pageNumber: page,
        lastDeterminedPaged: lastDeterminedPaged
    };
    const { isMaxLimitReached: isMaxLimitReached, paginationLabel: paginationLabel, showPagination: showPagination, totalPages: totalPages, bracketSize: bracketSize, hideRightEllipsis: hideRightEllipsis } = (0, $kSp6c.usePaginationHook)(paginationProps);
    (0, $eUqFw.useEffect)(()=>{
        if (query !== '') setTablePage(1);
    }, [
        query,
        setTablePage
    ]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const checkIfNeedsQuery = (pageNum)=>{
        const next = pageNum + 1;
        onPageChange(next);
        setTablePage(next);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $5ce380cdfa3fce5f$var$overflowWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $5ce380cdfa3fce5f$var$tableContainerStyles,
        "data-testId": "servicedesk-customers-organization-common.ui.dynamic-table.table-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $clqWl.default), {
        head: head,
        rows: rows,
        isLoading: loading,
        isFixedSize: true,
        emptyView: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ak4QW.EmptyState), null)
    }), rows.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, !loading && isMaxLimitReached && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5zPH1.LimitReached), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $5ce380cdfa3fce5f$var$paginationContainerStyles,
        "aria-disabled": "true"
    }, !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4YoJu.PaginationLabel), {
        label: paginationLabel,
        justifyCenter: showPagination
    }), showPagination && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5yUTM.default), {
        isDisabled: loading,
        pages: totalPages,
        selectedIndex: tablePage - 1,
        onChange: (newIndex)=>checkIfNeedsQuery(newIndex),
        bracketSize: bracketSize,
        hideRightEllipsis: hideRightEllipsis
    }))), !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireOperationalAnalytics), {
        eventName: "customersOrgsTable loaded"
    })));
};
$5ce380cdfa3fce5f$export$b3c27e869d856b7.defaultProps = {
    loading: false,
    onPageChange: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    isEditable: false,
    onRemove: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
const $5ce380cdfa3fce5f$export$54ec01a60f47d33d = (0, $giAhk.injectIntlV2)($5ce380cdfa3fce5f$export$b3c27e869d856b7);
const $5ce380cdfa3fce5f$var$tableContainerStyles = (0, $1ZAYh.xcss)({
    cursor: 'pointer',
    marginTop: 'space.0',
    // @ts-expect-error - TS2322 - Object literal may only specify known properties
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    thead: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        borderBottom: `2px solid ${`var(--ds-border, ${(0, $PdmhA).N40})`}`,
        position: 'sticky',
        top: 0,
        zIndex: 1,
        background: `${"var(--ds-surface, white)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    tbody: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        borderBottom: `2px solid ${`var(--ds-border, ${(0, $PdmhA).N40})`}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    tfoot: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        borderBottom: `2px solid ${`var(--ds-border, ${(0, $PdmhA).N40})`}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    table: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        borderBottom: 'none !important'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    div: {
        marginBottom: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    td: {
        wordBreak: 'break-word',
        padding: `0 ${"var(--ds-space-025, 2px)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    th: {
        wordBreak: 'break-word',
        padding: `${"var(--ds-space-100, 8px)"} 0`
    }
});
const $5ce380cdfa3fce5f$var$overflowWrapperStyles = (0, $1ZAYh.xcss)({
    overflow: 'auto',
    maxHeight: '100%',
    marginTop: 'space.250'
});
const $5ce380cdfa3fce5f$var$paginationContainerStyles = (0, $1ZAYh.xcss)({
    transition: `
        left 300ms cubic-bezier(0.2, 0, 0, 1) 0s,
        right 300ms cubic-bezier(0.2, 0, 0, 1) 0s,
        width 300ms cubic-bezier(0.2, 0, 0, 1) 0s;
    `,
    borderTop: '2px solid',
    zIndex: 'navigation',
    overflow: 'visible',
    borderTopColor: 'color.border',
    padding: 'space.200',
    boxSizing: 'border-box',
    background: 'color.elevation.surface',
    display: 'grid'
});

});
parcelRegister("5yUTM", function(module, exports) {

$parcel$export(module.exports, "default", () => $dda80741f1542519$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hompL = parcelRequire("hompL");

var $bFzGY = parcelRequire("bFzGY");

var $7u4fN = parcelRequire("7u4fN");

var $dXKde = parcelRequire("dXKde");

var $dwj4T = parcelRequire("dwj4T");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");


var $bU5nt = parcelRequire("bU5nt");
const $dda80741f1542519$var$renderLeftEllipsis = (currentBatch)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dda80741f1542519$var$BackupWrapper, {
        hide: currentBatch === 1,
        direction: "left"
    }, "...");
const $dda80741f1542519$var$renderRightEllipsis = (hideEllipsis)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dda80741f1542519$var$BackupWrapper, {
        hide: hideEllipsis,
        direction: "right"
    }, "...");
const $dda80741f1542519$var$renderChevron = (selectedIndex, pages, onClick, direction)=>{
    const onChevronClick = (event, analyticsEvent)=>{
        const pageNumber = direction === 'LEFT' ? selectedIndex - 1 : selectedIndex + 1;
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, (0, $e92e05dd1551af04$export$728b190245c34e32), {
            pageNumber: pageNumber
        });
        onClick(pageNumber, analyticsEvent);
    };
    const isDisabled = ()=>{
        if (direction === 'LEFT') return selectedIndex <= 0;
        if (direction === 'RIGHT') return selectedIndex >= (pages ? pages - 1 : 0);
        return true;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: (event, analyticsEvent)=>onChevronClick(event, analyticsEvent),
        appearance: "subtle",
        spacing: "compact",
        isDisabled: isDisabled(),
        testId: `servicedesk-customers-organization-common.ui.table.bracket-pagination.${direction.toLowerCase()}-button`
    }, direction === 'LEFT' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dXKde))), {
        label: "previous"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dwj4T))), {
        label: "next"
    }));
};
const $dda80741f1542519$var$renderMarkup = (selectedIndex, pages, currentBatch, onPaginationChange, bracketSize, formatMessage)=>{
    const onClick = (_, analyticsEvent, index)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, (0, $e92e05dd1551af04$export$728b190245c34e32), {
            pageNumber: index
        });
        onPaginationChange(index, analyticsEvent);
    };
    const markupBatch = [];
    let batches = [];
    Array.from({
        length: pages
    }, (_, index)=>index).forEach((value)=>{
        const isSelected = value === selectedIndex;
        const pageNumber = value + 1;
        batches.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dda80741f1542519$var$NumberWrapper, {
            key: `pagination-${value}`,
            "data-testId": "servicedesk-customers-organization-common.ui.table.bracket-pagination.page-number"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            onClick: (event, analyticsEvent)=>onClick(event, analyticsEvent, value),
            appearance: "subtle",
            spacing: "compact",
            isSelected: isSelected,
            "aria-label": formatMessage(isSelected ? (0, $bU5nt.default).pageLabelSelected : (0, $bU5nt.default).pageLabel, {
                pageNumber: pageNumber
            })
        }, pageNumber)));
        if (pageNumber % bracketSize === 0) {
            markupBatch.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dda80741f1542519$var$MarkupWrapper, null, batches));
            batches = [];
        }
    });
    if (batches.length > 0) {
        // add remaining item in the batch
        markupBatch.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dda80741f1542519$var$MarkupWrapper, null, batches));
        batches = [];
    }
    return markupBatch;
};
const $dda80741f1542519$var$renderFirstPageLink = (selectedIndex, onPaginationChange)=>{
    const onClick = (event, analyticsEvent, index)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, (0, $e92e05dd1551af04$export$728b190245c34e32), {
            pageNumber: index
        });
        onPaginationChange(index, analyticsEvent);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dda80741f1542519$var$NumberWrapper, {
        key: `pagination-first-${1}`,
        "data-testId": "servicedesk-customers-organization-common.ui.table.bracket-pagination.page-number"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: (event, analyticsEvent)=>onClick(event, analyticsEvent, 0),
        appearance: "subtle",
        spacing: "compact",
        isSelected: selectedIndex === 0
    }, 1));
};
const $dda80741f1542519$export$6a496545c3e44b7e = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const descriptionId = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($hompL)))(), []);
    const { currentBatch: currentBatch, selectedIndex: selectedIndex, pages: pages, onChange: onChange, bracketSize: bracketSize, hideRightEllipsis: hideRightEllipsis } = props;
    const hideEllipsis = undefined === hideRightEllipsis ? selectedIndex >= (pages ? pages - 1 : 0) : hideRightEllipsis;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dda80741f1542519$export$60cc8ca389d37b4f, {
        as: "nav",
        "aria-label": formatMessage((0, $bU5nt.default).navigationLabel),
        "aria-describedby": descriptionId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        id: descriptionId,
        hidden: true
    }, formatMessage((0, $bU5nt.default).navigationDescription)), $dda80741f1542519$var$renderChevron(selectedIndex, pages, onChange, 'LEFT'), selectedIndex + 1 > bracketSize ? $dda80741f1542519$var$renderFirstPageLink(selectedIndex, onChange) : '', $dda80741f1542519$var$renderLeftEllipsis(currentBatch), $dda80741f1542519$var$renderMarkup(selectedIndex, pages ?? 0, currentBatch, onChange, bracketSize, formatMessage)[currentBatch - 1], $dda80741f1542519$var$renderRightEllipsis(hideEllipsis), $dda80741f1542519$var$renderChevron(selectedIndex, pages, onChange, 'RIGHT'));
};
$dda80741f1542519$export$6a496545c3e44b7e.defaultProps = {
    currentBatch: 1
};
const $dda80741f1542519$var$BracketPagination = (props)=>{
    // isPaginationDisabled is passed because for any click bucket change happens,
    // and in case of fast click where things are still loading we don't want any action to happen
    // This cant be controlled at table layer because bucket logic exists in pagination
    // https://jdog.jira-dev.com/browse/DWP-297
    const { pages: pages, selectedIndex: selectedIndex, bracketSize: bracketSize, onChange: onChange, isDisabled: isDisabled, hideRightEllipsis: hideRightEllipsis } = props; // Batch is 1 based index
    const [currentBatch, updateBatch] = (0, $eUqFw.useState)(Math.ceil((selectedIndex + 1) / bracketSize));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: (0, $e92e05dd1551af04$export$d6a1e2db2153a1c3),
        actionSubject: (0, $e92e05dd1551af04$export$d3fecc7a37c6d2a2)
    });
    (0, $eUqFw.useEffect)(()=>{
        if (!isDisabled) updateBatch(Math.ceil((selectedIndex + 1) / bracketSize));
    }, [
        selectedIndex,
        bracketSize,
        isDisabled
    ]);
    const onPaginationChange = (newIndex)=>{
        if (!isDisabled) {
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, (0, $e92e05dd1551af04$export$728b190245c34e32), {
                pageNumberRequested: newIndex + 1
            });
            onChange(newIndex);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dda80741f1542519$export$6a496545c3e44b7e, {
        selectedIndex: selectedIndex,
        currentBatch: currentBatch,
        pages: pages,
        bracketSize: bracketSize,
        onChange: onPaginationChange,
        hideRightEllipsis: hideRightEllipsis
    });
};
$dda80741f1542519$var$BracketPagination.defaultProps = {
    bracketSize: 5
};
var $dda80741f1542519$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $dda80741f1542519$var$BracketPagination;
const $dda80741f1542519$var$MarkupWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _y3gn1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $dda80741f1542519$var$BackupWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hide: hide, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wpz1h6o _1yt4h8dc",
            __cmplp.hide ? "_1e0cglyw" : "_1e0c1o8l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $dda80741f1542519$var$NumberWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hide: hide, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.hide ? "_3um015vq" : "_3um0ewfl",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $dda80741f1542519$export$60cc8ca389d37b4f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _1bsb1wug _1bah1h6o _ae4v1h6o _1461kb7n _p3z3kb7n _10fpusic _94n5ze3t",
            __cmplp.className
        ])
    });
});

});
const $e92e05dd1551af04$export$728b190245c34e32 = 'customersTable';
const $e92e05dd1551af04$export$d6a1e2db2153a1c3 = 'changed';
const $e92e05dd1551af04$export$d3fecc7a37c6d2a2 = 'pageNumber';

parcelRegister("bU5nt", function(module, exports) {

$parcel$export(module.exports, "default", () => $077d1d578fc2b827$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $077d1d578fc2b827$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    navigationLabel: {
        "id": "servicedesk-customers-organization-common.table.bracket-pagination.navigation-label",
        "defaultMessage": "Customers pagination"
    },
    navigationDescription: {
        "id": "servicedesk-customers-organization-common.table.bracket-pagination.navigation-description",
        "defaultMessage": "Activating a pagination button will update the results above."
    },
    pageLabel: {
        "id": "servicedesk-customers-organization-common.table.bracket-pagination.page-label",
        "defaultMessage": "Page {pageNumber}"
    },
    pageLabelSelected: {
        "id": "servicedesk-customers-organization-common.table.bracket-pagination.page-label-selected",
        "defaultMessage": "Page {pageNumber}, current page"
    }
});

});


parcelRegister("fuV9u", function(module, exports) {

$parcel$export(module.exports, "SEARCH_PER_PAGE", () => $ea5eceb86ff0b4c3$export$74fcd9f6dcadebd3);
$parcel$export(module.exports, "LIST_PER_PAGE", () => $ea5eceb86ff0b4c3$export$2f9c012b71c09d3b);
$parcel$export(module.exports, "DEFAULT_PAGE_DATA", () => $ea5eceb86ff0b4c3$export$4271758629eddc5);
const $ea5eceb86ff0b4c3$export$74fcd9f6dcadebd3 = 20;
const $ea5eceb86ff0b4c3$export$2f9c012b71c09d3b = 50;
const $ea5eceb86ff0b4c3$export$4271758629eddc5 = {
    total: 0,
    customers: [],
    rowsPerPage: $ea5eceb86ff0b4c3$export$2f9c012b71c09d3b,
    page: 1,
    totalHasBeenDetermined: true,
    lastDeterminedPaged: 1,
    query: ''
};

});

parcelRegister("1a5HF", function(module, exports) {

$parcel$export(module.exports, "getHeader", () => $5787920e159cd1c0$export$47ed31abc613cf55);
$parcel$export(module.exports, "InlineMessageWrapper", () => $5787920e159cd1c0$export$6ced824235fb25b2);
$parcel$export(module.exports, "InlineMessageContent", () => $5787920e159cd1c0$export$cf18a118761851fd);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jOdsB = parcelRequire("jOdsB");

var $hXS8H = parcelRequire("hXS8H");
const $5787920e159cd1c0$export$47ed31abc613cf55 = ({ formatMessage: formatMessage }, isEditable)=>{
    const cells = [
        {
            key: 'displayName',
            content: formatMessage((0, $hXS8H.default).nameColumn),
            width: 58
        },
        {
            key: 'openRequests',
            content: formatMessage((0, $hXS8H.default).openRequestsColumn),
            width: 20
        },
        {
            key: 'closedRequests',
            content: formatMessage((0, $hXS8H.default).closedRequestsColumn),
            width: 20
        },
        {
            key: 'status',
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5787920e159cd1c0$export$6ced824235fb25b2, null, formatMessage((0, $hXS8H.default).statusColumn), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jOdsB.default), {
                appearance: "info",
                placement: "bottom-end"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5787920e159cd1c0$export$cf18a118761851fd, null, formatMessage((0, $hXS8H.default).statusAbsentAaDescription)))),
            width: 15
        },
        {
            key: 'actions',
            content: formatMessage((0, $hXS8H.default).actionsColumn),
            width: 17
        },
        ...isEditable ? [
            {
                key: 'editableColumn',
                content: '',
                width: 5
            }
        ] : []
    ];
    return {
        cells: cells
    };
};
const $5787920e159cd1c0$export$6ced824235fb25b2 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _jq8gpxbi _igocpxbi _k6cgpxbi _1d42pxbi _1sla1rc1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $5787920e159cd1c0$export$cf18a118761851fd = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _k48p4jg8 _p12fs1ma",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jOdsB", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ceaa73c399a515a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $7u4fN = parcelRequire("7u4fN");

var $29yDk = parcelRequire("29yDk");

var $9Amv1 = parcelRequire("9Amv1");
var $1Yimi = parcelRequire("1Yimi");

var $PdmhA = parcelRequire("PdmhA");

var $kDL8j = parcelRequire("kDL8j");
function $2ceaa73c399a515a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2ceaa73c399a515a$var$rootStyles = {
    name: "ssyr0c",
    styles: "display:inline-block;max-width:100%;&:focus{outline:1px solid;}&:hover{[data-ds--inline-message--icon]{color:var(--icon-accent-color);}[data-ds--inline-message--button]{text-decoration:underline;}}"
};
const $2ceaa73c399a515a$var$iconColor = (appearance)=>{
    switch(appearance){
        case 'connectivity':
            return `var(--ds-icon-brand, ${0, $PdmhA.B300})`;
        case 'confirmation':
            return `var(--ds-icon-success, ${0, $PdmhA.G200})`;
        case 'info':
            return `var(--ds-icon-discovery, ${0, $PdmhA.P200})`;
        case 'warning':
            return `var(--ds-icon-warning, ${0, $PdmhA.Y200})`;
        case 'error':
            return `var(--ds-icon-danger, ${0, $PdmhA.R300})`;
    }
};
/**
 * __Inline message__
 *
 * An inline message lets users know when important information is available or when an action is required.
 *
 * - [Examples](https://atlassian.design/components/inline-message/examples)
 * - [Code](https://atlassian.design/components/inline-message/code)
 * - [Usage](https://atlassian.design/components/inline-message/usage)
 *
 * @example
 *
 * ```jsx
 * const Component = () => (
 *   <InlineMessage
 *    title="Inline Message Title Example"
 *    secondaryText="Secondary Text"
 *   >
 *    <p>Some text that would be inside the open dialog and otherwise hidden.</p>
 *   </InlineMessage>
 * );
 * ```
 */ const $2ceaa73c399a515a$var$InlineMessage = ({ placement: placement = 'bottom-start', secondaryText: secondaryText = '', title: title = '', type: type = 'connectivity', appearance: appearance, children: children, testId: testId, iconLabel: iconLabel })=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const toggleDialog = (0, $eUqFw.useCallback)(()=>{
        setIsOpen((oldState)=>!oldState);
    }, [
        setIsOpen
    ]);
    const onCloseDialog = (0, $eUqFw.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    if (!appearance) appearance = type;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $2ceaa73c399a515a$var$rootStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            '--icon-accent-color': $2ceaa73c399a515a$var$iconColor(appearance)
        },
        "data-testid": testId
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $29yDk.default), {
        onClose: onCloseDialog,
        content: children,
        isOpen: isOpen,
        placement: placement,
        testId: testId && `${testId}--inline-dialog`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $7u4fN.default), {
        "data-ds--inline-message--button": true,
        appearance: "subtle-link",
        onClick: toggleDialog,
        spacing: "none",
        testId: testId && `${testId}--button`,
        "aria-expanded": isOpen
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $kDL8j.default), {
        isOpen: isOpen,
        appearance: appearance,
        label: iconLabel
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
        space: "space.100"
    }, title && /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
        weight: "medium",
        testId: testId && `${testId}--title`
    }, title), secondaryText && /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
        weight: "medium",
        color: "color.text.subtlest",
        maxLines: 1,
        testId: testId && `${testId}--text`
    }, secondaryText))))));
};
var $2ceaa73c399a515a$export$2e2bcd8739ae039 = $2ceaa73c399a515a$var$InlineMessage;

});
parcelRegister("kDL8j", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b39338dc4e2b071$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");

var $kAPh5 = parcelRequire("kAPh5");
function $2b39338dc4e2b071$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2b39338dc4e2b071$var$iconColor = (appearance)=>{
    switch(appearance){
        case 'connectivity':
            return `var(--ds-icon-brand, ${0, $PdmhA.B400})`;
        case 'confirmation':
            return `var(--ds-icon-success, ${0, $PdmhA.G300})`;
        case 'info':
            return `var(--ds-icon-discovery, ${0, $PdmhA.P300})`;
        case 'warning':
            return `var(--ds-icon-warning, ${0, $PdmhA.Y300})`;
        case 'error':
            return `var(--ds-icon-danger, ${0, $PdmhA.R400})`;
    }
};
const $2b39338dc4e2b071$var$iconWrapperStyles = {
    name: "kw6wgo",
    styles: "display:flex;align-items:center;flex:0 0 auto;color:var(--icon-color)"
};
const $2b39338dc4e2b071$var$iconColorStyles = {
    name: "1iy94md",
    styles: "color:var(--icon-accent-color)"
};
/**
 * __Selected icon__
 *
 * The selected icon is used as the primary interactive element for the dialog.
 * Can be used with or without supporting text.
 */ const $2b39338dc4e2b071$var$SelectedIcon = ({ appearance: appearance, isOpen: isOpen, label: label })=>{
    const { [appearance]: { icon: Icon, defaultLabel: defaultLabel } } = (0, $kAPh5.typesMapping);
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        "data-ds--inline-message--icon": true,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: {
            '--icon-color': $2b39338dc4e2b071$var$iconColor(appearance)
        },
        css: [
            $2b39338dc4e2b071$var$iconWrapperStyles,
            isOpen && $2b39338dc4e2b071$var$iconColorStyles
        ]
    }, /*#__PURE__*/ (0, $byn9U.jsx)(Icon, {
        testId: "inline-message-icon",
        label: label || defaultLabel,
        size: "medium"
    }));
};
var $2b39338dc4e2b071$export$2e2bcd8739ae039 = $2b39338dc4e2b071$var$SelectedIcon;

});
parcelRegister("kAPh5", function(module, exports) {

$parcel$export(module.exports, "typesMapping", () => $6da7ad19346443c2$export$4d111645c0b39d5d);

var $aWvIp = parcelRequire("aWvIp");

var $96IgR = parcelRequire("96IgR");

var $2bv8J = parcelRequire("2bv8J");

var $5YsMl = parcelRequire("5YsMl");
const $6da7ad19346443c2$export$4d111645c0b39d5d = {
    connectivity: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))),
        defaultLabel: 'connectivity inline message'
    },
    confirmation: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($aWvIp))),
        defaultLabel: 'confirmation inline message'
    },
    info: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2bv8J))),
        defaultLabel: 'info inline message'
    },
    warning: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))),
        defaultLabel: 'warning inline message'
    },
    error: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($96IgR))),
        defaultLabel: 'error inline message'
    }
};

});



parcelRegister("hXS8H", function(module, exports) {

$parcel$export(module.exports, "default", () => $f37e4fcaf064be84$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f37e4fcaf064be84$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    nameColumn: {
        "id": "servicedesk-customers-organization-common.table.header.name-column",
        "defaultMessage": "Name"
    },
    openRequestsColumn: {
        "id": "servicedesk-customers-organization-common.table.header.open-requests-column",
        "defaultMessage": "Open requests"
    },
    closedRequestsColumn: {
        "id": "servicedesk-customers-organization-common.table.header.closed-requests-column",
        "defaultMessage": "Closed requests"
    },
    statusColumn: {
        "id": "servicedesk-customers-organization-common.table.header.status-column",
        "defaultMessage": "Status"
    },
    statusAbsentAaDescription: {
        "id": "servicedesk-customers-organization-common.table.header.status-absent-aa-description",
        "defaultMessage": "Customers without status are Atlassian account users managed by your organization admins"
    },
    actionsColumn: {
        "id": "servicedesk-customers-organization-common.table.header.actions-column",
        "defaultMessage": "Actions"
    }
});

});


parcelRegister("5zPH1", function(module, exports) {

$parcel$export(module.exports, "LimitReached", () => $32b10384f46033a6$export$8ff9a255f76a015d);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $2CgwC = parcelRequire("2CgwC");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hkQwi = parcelRequire("hkQwi");
const $32b10384f46033a6$export$8ff9a255f76a015d = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($32b10384f46033a6$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2CgwC.default), {
        appearance: "announcement"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($32b10384f46033a6$var$Header, null, formatMessage((0, $hkQwi.default).header)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($32b10384f46033a6$var$Description, null, formatMessage((0, $hkQwi.default).description))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $32b10384f46033a6$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4zu5n _88dh16xe _1grg122n _1g6a1h6o _65g08a6j _18fj1ule _1nz71osq",
            __cmplp.className
        ])
    });
});
const $32b10384f46033a6$var$Header = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "h5", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1nu9",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $32b10384f46033a6$var$Description = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1nu9 _18u01b66 _syaz1wmz",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2CgwC", function(module, exports) {

$parcel$export(module.exports, "default", () => $eef92cec578fd4fa$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");
const $eef92cec578fd4fa$var$CSS_VAR_TEXT_COLOR = '--banner-text-color';
const $eef92cec578fd4fa$var$inlineStyles = (0, $1ZAYh.xcss)({
    minWidth: '0'
});
const $eef92cec578fd4fa$var$textStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(${$eef92cec578fd4fa$var$CSS_VAR_TEXT_COLOR})`,
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/design-system/no-nested-styles
    'a, a:visited, a:hover, a:focus, a:active': {
        color: 'currentColor',
        textDecoration: 'underline'
    }
});
const $eef92cec578fd4fa$var$backgroundColors = {
    warning: 'color.background.warning.bold',
    error: 'color.background.danger.bold',
    announcement: 'color.background.neutral.bold'
};
const $eef92cec578fd4fa$var$tokenBackgroundColors = {
    warning: `var(--ds-background-warning-bold, ${(0, $PdmhA.Y300)})`,
    error: `var(--ds-background-danger-bold, ${(0, $PdmhA.R400)})`,
    announcement: `var(--ds-background-neutral-bold, ${(0, $PdmhA.N500)})`
};
const $eef92cec578fd4fa$var$tokenTextColors = {
    warning: `var(--ds-text-warning-inverse, ${(0, $PdmhA.N700)})`,
    error: `var(--ds-text-inverse, ${(0, $PdmhA.N0)})`,
    announcement: `var(--ds-text-inverse, ${(0, $PdmhA.N0)})`
};
const $eef92cec578fd4fa$var$containerStyles = (0, $1ZAYh.xcss)({
    height: '3rem',
    alignItems: 'center',
    display: 'flex'
});
const $eef92cec578fd4fa$var$iconWrapperStyles = (0, $1ZAYh.xcss)({
    display: 'block',
    width: '1.5rem',
    height: '1.5rem',
    // This matches Icon's "medium" size, without this the (line-)height is greater than that of the Icon
    flexShrink: '0'
});
/**
 * __Banner__
 *
 * A banner displays a prominent message at the top of the screen.
 *
 * - [Examples](https://atlassian.design/components/banner/examples)
 * - [Code](https://atlassian.design/components/banner/code)
 * - [Usage](https://atlassian.design/components/banner/usage)
 */ const $eef92cec578fd4fa$var$Banner = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ appearance: appearance = 'warning', children: children, icon: icon, testId: testId }, ref)=>{
    const appearanceType = appearance in $eef92cec578fd4fa$var$backgroundColors ? appearance : 'warning';
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $eef92cec578fd4fa$var$containerStyles,
        backgroundColor: $eef92cec578fd4fa$var$backgroundColors[appearanceType],
        padding: "space.150",
        testId: testId,
        ref: ref,
        role: "alert"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
        space: "space.050",
        alignBlock: "center",
        alignInline: "start",
        xcss: $eef92cec578fd4fa$var$inlineStyles
    }, icon ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        as: "span",
        xcss: $eef92cec578fd4fa$var$iconWrapperStyles,
        style: {
            fill: $eef92cec578fd4fa$var$tokenBackgroundColors[appearanceType],
            color: $eef92cec578fd4fa$var$tokenTextColors[appearanceType]
        }
    }, icon) : null, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            [$eef92cec578fd4fa$var$CSS_VAR_TEXT_COLOR]: $eef92cec578fd4fa$var$tokenTextColors[appearanceType]
        },
        css: $eef92cec578fd4fa$var$textStyles
    }, children)));
});
var $eef92cec578fd4fa$export$2e2bcd8739ae039 = $eef92cec578fd4fa$var$Banner;

});

parcelRegister("hkQwi", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6d66203c445b38a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c6d66203c445b38a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    header: {
        "id": "servicedesk-customers-organization-common.table.limit-reached.header",
        "defaultMessage": "We can't load any more results."
    },
    description: {
        "id": "servicedesk-customers-organization-common.table.limit-reached.description",
        "defaultMessage": "Use the search bar to find the customers or organizations you're looking for."
    }
});

});


parcelRegister("lIP0w", function(module, exports) {

$parcel$export(module.exports, "useTableRows", () => $fdf2178ec0e1f615$export$a190e1af00082b41);

var $eUqFw = parcelRequire("eUqFw");

var $gJg6x = parcelRequire("gJg6x");

var $a4UlN = parcelRequire("a4UlN");

var $jYFc4 = parcelRequire("jYFc4");

var $fuV9u = parcelRequire("fuV9u");

var $lbQ6P = parcelRequire("lbQ6P");

var $71BiP = parcelRequire("71BiP");

var $8oBqB = parcelRequire("8oBqB");

var $5jZaz = parcelRequire("5jZaz");
const $fdf2178ec0e1f615$export$a190e1af00082b41 = ({ pageData: pageData, isEditable: isEditable, projectKey: projectKey, projectName: projectName, onRemove: onRemove, onActionSuccess: onActionSuccess, onActionFailure: onActionFailure, showRemoveCustomerTooltip: showRemoveCustomerTooltip, rows: customRows })=>{
    const { total: total, page: page, rowsPerPage: rowsPerPage, customers: customers } = pageData || (0, $fuV9u.DEFAULT_PAGE_DATA);
    const [tablePage, setTablePage] = (0, $eUqFw.useState)(1);
    const rows = (0, $eUqFw.useMemo)(()=>{
        let totalRows = [];
        if (!customers) return totalRows;
        const emptyRow = {
            cells: []
        };
        const numberOfPreviousRows = (page - 1) * rowsPerPage;
        const numberOfNextRows = Math.max(0, total - rowsPerPage - numberOfPreviousRows);
        const previousRows = (0, (/*@__PURE__*/$parcel$interopDefault($gJg6x)))(Array(numberOfPreviousRows), emptyRow);
        const nextRows = (0, (/*@__PURE__*/$parcel$interopDefault($gJg6x)))(Array(numberOfNextRows), emptyRow);
        if (customRows) return [
            ...previousRows,
            ...customRows,
            ...nextRows
        ];
        const hasOrganisationRow = customers.some((0, $a4UlN.isOrganization));
        const visibleRows = customers.map((customer)=>{
            const cells = [];
            cells.push({
                key: `name-${customer.identifier}`,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lbQ6P.CustomerCell), {
                    profile: customer,
                    projectKey: projectKey
                })
            });
            cells.push({
                key: `open-requests-${customer.identifier}`,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5jZaz.OpenRequestsCell), {
                    profile: customer
                })
            });
            cells.push({
                key: `closed-requests-${customer.identifier}`,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5jZaz.ClosedRequestsCell), {
                    profile: customer
                })
            });
            cells.push({
                key: `customer-logged-in-status-${customer.identifier}`,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8oBqB.LoggedInStatusCellView), {
                    profile: customer
                })
            });
            cells.push({
                key: `resend-invite-${customer.identifier}`,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jYFc4.ActionsCellView), {
                    profile: customer,
                    onActionSuccess: onActionSuccess,
                    onActionFailure: onActionFailure
                })
            });
            const isOrganizationRow = (0, $a4UlN.isOrganization)(customer);
            if (isEditable || isOrganizationRow) cells.push({
                key: `modify-${customer.identifier}`,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $71BiP.EditorCell), {
                    profile: customer,
                    projectName: projectName,
                    onRemove: onRemove,
                    showRemoveCustomerTooltip: showRemoveCustomerTooltip
                })
            });
            else if (hasOrganisationRow) cells.push({
                key: `modify-${customer.identifier}`,
                content: null
            });
            return {
                key: `customer-${customer.identifier}`,
                cells: cells
            };
        });
        totalRows = [
            ...previousRows,
            ...visibleRows,
            ...nextRows
        ];
        return totalRows;
    }, [
        customers,
        page,
        rowsPerPage,
        total,
        projectKey,
        onActionSuccess,
        onActionFailure,
        isEditable,
        projectName,
        onRemove,
        showRemoveCustomerTooltip,
        customRows
    ]);
    return {
        rows: rows,
        tablePage: tablePage,
        setTablePage: setTablePage
    };
};

});
parcelRegister("gJg6x", function(module, exports) {

var $iqd1y = parcelRequire("iqd1y");

var $3P7i5 = parcelRequire("3P7i5");
/**
 * Fills elements of `array` with `value` from `start` up to, but not
 * including, `end`.
 *
 * **Note:** This method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 3.2.0
 * @category Array
 * @param {Array} array The array to fill.
 * @param {*} value The value to fill `array` with.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = [1, 2, 3];
 *
 * _.fill(array, 'a');
 * console.log(array);
 * // => ['a', 'a', 'a']
 *
 * _.fill(Array(3), 2);
 * // => [2, 2, 2]
 *
 * _.fill([4, 6, 8, 10], '*', 1, 3);
 * // => [4, '*', '*', 10]
 */ function $c2dd574bf36173ad$var$fill(array, value, start, end) {
    var length = array == null ? 0 : array.length;
    if (!length) return [];
    if (start && typeof start != 'number' && $3P7i5(array, value, start)) {
        start = 0;
        end = length;
    }
    return $iqd1y(array, value, start, end);
}
module.exports = $c2dd574bf36173ad$var$fill;

});
parcelRegister("iqd1y", function(module, exports) {

var $hNahz = parcelRequire("hNahz");

var $kGXgP = parcelRequire("kGXgP");
/**
 * The base implementation of `_.fill` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to fill.
 * @param {*} value The value to fill `array` with.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns `array`.
 */ function $d694c20369ab79f8$var$baseFill(array, value, start, end) {
    var length = array.length;
    start = $hNahz(start);
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end === undefined || end > length ? length : $hNahz(end);
    if (end < 0) end += length;
    end = start > end ? 0 : $kGXgP(end);
    while(start < end)array[start++] = value;
    return array;
}
module.exports = $d694c20369ab79f8$var$baseFill;

});
parcelRegister("kGXgP", function(module, exports) {

var $1ImyS = parcelRequire("1ImyS");

var $hNahz = parcelRequire("hNahz");
/** Used as references for the maximum length and index of an array. */ var $f105b4bfba940e64$var$MAX_ARRAY_LENGTH = 4294967295;
/**
 * Converts `value` to an integer suitable for use as the length of an
 * array-like object.
 *
 * **Note:** This method is based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toLength(3.2);
 * // => 3
 *
 * _.toLength(Number.MIN_VALUE);
 * // => 0
 *
 * _.toLength(Infinity);
 * // => 4294967295
 *
 * _.toLength('3.2');
 * // => 3
 */ function $f105b4bfba940e64$var$toLength(value) {
    return value ? $1ImyS($hNahz(value), 0, $f105b4bfba940e64$var$MAX_ARRAY_LENGTH) : 0;
}
module.exports = $f105b4bfba940e64$var$toLength;

});
parcelRegister("1ImyS", function(module, exports) {
/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */ function $13fb66c0c405b8c7$var$baseClamp(number, lower, upper) {
    if (number === number) {
        if (upper !== undefined) number = number <= upper ? number : upper;
        if (lower !== undefined) number = number >= lower ? number : lower;
    }
    return number;
}
module.exports = $13fb66c0c405b8c7$var$baseClamp;

});




parcelRegister("jYFc4", function(module, exports) {

$parcel$export(module.exports, "ActionsCellView", () => $d64fb1b16861206b$export$f9f040b096bdc636);

var $eUqFw = parcelRequire("eUqFw");

var $7opLA = parcelRequire("7opLA");

var $1ybV0 = parcelRequire("1ybV0");

var $eo17r = parcelRequire("eo17r");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kJlBc = parcelRequire("kJlBc");

var $7d1RI = parcelRequire("7d1RI");

var $gd0Sp = parcelRequire("gd0Sp");

var $a4UlN = parcelRequire("a4UlN");

var $e46qA = parcelRequire("e46qA");

var $8tGiw = parcelRequire("8tGiw");

var $4IVFk = parcelRequire("4IVFk");

var $cTySI = parcelRequire("cTySI");
var $lIhc2 = parcelRequire("lIhc2");

var $l01iI = parcelRequire("l01iI");
const $d64fb1b16861206b$var$getCutoffDateForCustomerVerification = ()=>(0, $1ybV0.getFeatureFlagValue)('cut-off-date-for-tenants-for-customer-invite-verification-feature', '');
const $d64fb1b16861206b$export$f9f040b096bdc636 = ({ profile: profile, onActionSuccess: onActionSuccess, onActionFailure: onActionFailure })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { projectKey: projectKey } = (0, $7d1RI.useCommonPageContext)();
    const userProfile = (0, $a4UlN.normalizeToUserProfile)(profile);
    const [organizationId] = (0, $kJlBc.usePathParam)('organizationId');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { invitedSuccess: invitedSuccess, loading: loading, error: error, errorMessage: errorMessage, fetch: inviteCustomersFetch } = (0, $cTySI.useReinviteCustomerService)(projectKey);
    const { resendVerificationEmailSuccess: resendVerificationEmailSuccess, resendVerificationEmailLoading: resendVerificationEmailLoading, resendVerificationEmailError: resendVerificationEmailError, resendVerificationEmailFetch: resendVerificationEmailFetch, isRateLimited: isRateLimited } = (0, $lIhc2.useResendVerificationEmailService)();
    const actionType = {
        resendVerificationEmail: 'resendVerificationEmail',
        resendInvite: 'resendInvite'
    };
    const { email: email, loggedInStatus: loggedInStatus, emailVerifiedStatus: emailVerifiedStatus } = userProfile || {
        email: ''
    };
    (0, $eUqFw.useEffect)(()=>{
        if (error || resendVerificationEmailError) {
            if (error) {
                const id = (0, $eo17r.toFlagId)('resend-invite-error-flag');
                onActionFailure(id, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8tGiw.ResendInviteErrorFlag), {
                    id: id,
                    errorMessage: errorMessage
                }));
                const analyticsEventForResendVerificationEmailLinkGenericError = createAnalyticsEvent({
                    actionSubject: 'resendInvite',
                    action: 'clicked GenericError'
                });
                (0, $jMP2a.fireUIAnalytics)(analyticsEventForResendVerificationEmailLinkGenericError);
            } else if (resendVerificationEmailError) {
                const id = (0, $eo17r.toFlagId)('resend-verification-email-error-flag');
                onActionFailure(id, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4IVFk.ResendVerificationEmailErrorFlag), {
                    id: id,
                    isRateLimited: isRateLimited
                }));
                if (isRateLimited) {
                    const analyticsEventForResendVerificationEmailLinkRateLimitError = createAnalyticsEvent({
                        actionSubject: actionType.resendVerificationEmail,
                        action: 'clicked RateLimitError'
                    });
                    (0, $jMP2a.fireUIAnalytics)(analyticsEventForResendVerificationEmailLinkRateLimitError);
                } else {
                    const analyticsEventForResendVerificationEmailLinkGenericError = createAnalyticsEvent({
                        actionSubject: actionType.resendVerificationEmail,
                        action: 'clicked GenericError'
                    });
                    (0, $jMP2a.fireUIAnalytics)(analyticsEventForResendVerificationEmailLinkGenericError);
                }
            }
        } else if (invitedSuccess || resendVerificationEmailSuccess) {
            const successAction = invitedSuccess ? actionType.resendInvite : actionType.resendVerificationEmail;
            onActionSuccess(email, successAction);
            if (resendVerificationEmailSuccess) {
                const analyticsEventForResendVerificationEmailLink = createAnalyticsEvent({
                    actionSubject: actionType.resendVerificationEmail,
                    action: 'clicked Success'
                });
                (0, $jMP2a.fireUIAnalytics)(analyticsEventForResendVerificationEmailLink);
            }
        }
    }, [
        error,
        onActionSuccess,
        onActionFailure,
        invitedSuccess,
        email,
        errorMessage,
        resendVerificationEmailSuccess,
        resendVerificationEmailError,
        isRateLimited,
        actionType.resendInvite,
        actionType.resendVerificationEmail,
        createAnalyticsEvent
    ]);
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    if (tenantContext) {
        const { firstActivationDateMs: firstActivationDateMs } = tenantContext;
        const cutOffDate = $d64fb1b16861206b$var$getCutoffDateForCustomerVerification();
        const isTenantActivationAfterCutOffDate = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        new Date(firstActivationDateMs) >= new Date(cutOffDate);
        const isFeatureFlagEnabledToShowResendVerificationLink = (0, $1ybV0.ff)('sptn-1697-email-verified-signal-on-customers-page_v2g52') && isTenantActivationAfterCutOffDate;
        // logged status is Active and email is not verified, show resend email verification link
        const shouldShowResendVerificationEmail = loggedInStatus === (0, $e46qA.HAS_LOGGED_IN) && emailVerifiedStatus === false;
        if (isFeatureFlagEnabledToShowResendVerificationLink && shouldShowResendVerificationEmail) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
            appearance: "link",
            spacing: "none",
            isLoading: resendVerificationEmailLoading,
            onClick: ()=>{
                resendVerificationEmailFetch(email);
            }
        }, formatMessage((0, $l01iI.default).resendVerificationEmailLabel));
    }
    const shouldShowResendInviteLink = loggedInStatus === (0, $e46qA.PENDING_LOGIN);
    if (!shouldShowResendInviteLink) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
        appearance: "link",
        spacing: "none",
        isLoading: loading,
        onClick: ()=>{
            inviteCustomersFetch(email, organizationId);
        }
    }, formatMessage((0, $l01iI.default).resendInviteLinkLabel));
};

});
parcelRegister("4IVFk", function(module, exports) {

$parcel$export(module.exports, "ResendVerificationEmailErrorFlag", () => $fb58688a89e7cdfb$export$9e77eb81c350f1bb);

var $eUqFw = parcelRequire("eUqFw");

var $96IgR = parcelRequire("96IgR");

var $PdmhA = parcelRequire("PdmhA");

var $cCFSU = parcelRequire("cCFSU");

var $k8Qyf = parcelRequire("k8Qyf");

var $eo17r = parcelRequire("eo17r");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kSuP2 = parcelRequire("kSuP2");
const $fb58688a89e7cdfb$export$9e77eb81c350f1bb = ({ id: id, isRateLimited: isRateLimited = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagService)();
    const onDismissed = (0, $eUqFw.useCallback)(()=>{
        dismissFlag({
            command: (0, $eo17r.DISMISS_COMMAND),
            id: id
        });
    }, [
        dismissFlag,
        id
    ]);
    let flagDescription = '';
    let flagTitle = '';
    if (isRateLimited) {
        flagDescription = formatMessage((0, $kSuP2.default).resendVerificationEmailRateLimitFailureFlagDescription);
        flagTitle = formatMessage((0, $kSuP2.default).resendVerificationEmailRateLimitFailureFlagTitle);
    } else {
        flagDescription = formatMessage((0, $kSuP2.default).resendVerificationEmailGenericFailureFlagDescription);
        flagTitle = formatMessage((0, $kSuP2.default).resendVerificationEmailGenericFailureFlagTitle);
    }
    return (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cCFSU.default), {
            id: (0, $eo17r.fromFlagId)(id),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
                label: "error",
                primaryColor: `var(--ds-icon-danger, ${(0, $PdmhA.R400)})`
            }),
            title: flagTitle,
            description: flagDescription,
            onDismissed: onDismissed
        }), [
        id,
        flagTitle,
        flagDescription,
        onDismissed
    ]);
};

});
parcelRegister("kSuP2", function(module, exports) {

$parcel$export(module.exports, "default", () => $67e08683f5f675f8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $67e08683f5f675f8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    resendVerificationEmailGenericFailureFlagDescription: {
        "id": "servicedesk-customers-organization-common.common.resend-verification-email-error-flag.resend-verification-email-generic-failure-flag-description",
        "defaultMessage": "An error occurred while sending the verification email. Try again later."
    },
    resendVerificationEmailGenericFailureFlagTitle: {
        "id": "servicedesk-customers-organization-common.common.resend-verification-email-error-flag.resend-verification-email-generic-failure-flag-title",
        "defaultMessage": "We couldn\u2019t send verification email"
    },
    resendVerificationEmailRateLimitFailureFlagDescription: {
        "id": "servicedesk-customers-organization-common.common.resend-verification-email-error-flag.resend-verification-email-rate-limit-failure-flag-description",
        "defaultMessage": "An error occurred while sending the verification email. Resend it after 24 hours."
    },
    resendVerificationEmailRateLimitFailureFlagTitle: {
        "id": "servicedesk-customers-organization-common.common.resend-verification-email-error-flag.resend-verification-email-rate-limit-failure-flag-title",
        "defaultMessage": "Verification email couldn\u2019t be sent"
    }
});

});


parcelRegister("cTySI", function(module, exports) {

$parcel$export(module.exports, "useReinviteCustomerService", () => $9dff6cae73273548$export$18671b9f790ecb4c);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $fV97Z = parcelRequire("fV97Z");
const $9dff6cae73273548$export$18671b9f790ecb4c = (projectKey)=>{
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const [invitedSuccess, setInvitedSuccess] = (0, $eUqFw.useState)(false);
    const [error, setError] = (0, $eUqFw.useState)(null);
    const [errorMessage, setErrorMessage] = (0, $eUqFw.useState)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const fetch = (0, $eUqFw.useCallback)(async (email, organizationId)=>{
        setLoading(true);
        setError(null);
        setInvitedSuccess(false);
        setErrorMessage(null);
        try {
            await (0, $fV97Z.performPostRequest)(`/rest/servicedesk/1/pages/people/customers/pagination/${projectKey}/invite/resend`, {
                body: JSON.stringify({
                    email: email,
                    organizationId: organizationId
                })
            });
            setInvitedSuccess(true);
            setLoading(false);
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'customerInvite success');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            const { response: response } = err;
            if (response?.failed?.length > 0) setErrorMessage(response.failed[0].error);
            else if (response?.errors?.length > 0) setErrorMessage(response?.errors[0].errorMessage);
            setLoading(false);
            setError(err);
            (0, $guiFP.default)({
                event: createAnalyticsEvent({}),
                error: err,
                meta: {
                    id: 'resendInviteButton',
                    packageName: 'customerOrganisationCommon'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        createAnalyticsEvent,
        projectKey
    ]);
    return {
        loading: loading,
        error: error,
        invitedSuccess: invitedSuccess,
        errorMessage: errorMessage,
        fetch: fetch
    };
};

});

parcelRegister("lIhc2", function(module, exports) {

$parcel$export(module.exports, "useResendVerificationEmailService", () => $1c56e6eb5add868e$export$55652cef9139f6ed);

var $eUqFw = parcelRequire("eUqFw");

var $fV97Z = parcelRequire("fV97Z");
const $1c56e6eb5add868e$export$55652cef9139f6ed = ()=>{
    const [resendVerificationEmailLoading, setLoading] = (0, $eUqFw.useState)(false);
    const [isRateLimited, setIsRateLimited] = (0, $eUqFw.useState)(false);
    const [resendVerificationEmailSuccess, setResendVerificationEmailSuccess] = (0, $eUqFw.useState)(false);
    const [resendVerificationEmailError, setError] = (0, $eUqFw.useState)(null);
    const resendVerificationEmailFetch = (0, $eUqFw.useCallback)(async (email)=>{
        setLoading(true);
        setError(null);
        setResendVerificationEmailSuccess(false);
        try {
            await (0, $fV97Z.performPostRequest)('/rest/servicedesk/1/customer/pages/user/resend-verification-email', {
                body: JSON.stringify({
                    email: email,
                    verificationContext: {
                        portalId: null
                    }
                })
            });
            setResendVerificationEmailSuccess(true);
            setLoading(false);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            const { statusCode: statusCode } = err;
            if (statusCode === 429) setIsRateLimited(true);
            else setIsRateLimited(false);
            setLoading(false);
            setError(err);
        }
    }, []);
    return {
        resendVerificationEmailLoading: resendVerificationEmailLoading,
        resendVerificationEmailError: resendVerificationEmailError,
        resendVerificationEmailSuccess: resendVerificationEmailSuccess,
        resendVerificationEmailFetch: resendVerificationEmailFetch,
        isRateLimited: isRateLimited
    };
};

});

parcelRegister("l01iI", function(module, exports) {

$parcel$export(module.exports, "default", () => $de354b637cbccad0$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $de354b637cbccad0$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    resendInviteLinkLabel: {
        "id": "servicedesk-customers-organization-common.table.actions-cell-view.resend-invite-link-label",
        "defaultMessage": "Resend Invite"
    },
    resendVerificationEmailLabel: {
        "id": "servicedesk-customers-organization-common.table.actions-cell-view.resend-verification-email-label",
        "defaultMessage": "Resend verification email"
    }
});

});


parcelRegister("lbQ6P", function(module, exports) {

$parcel$export(module.exports, "CustomerCell", () => $902dd5cef4a0a9b5$export$24dc00c93079305a);

var $eUqFw = parcelRequire("eUqFw");

var $a4UlN = parcelRequire("a4UlN");

var $lvBjt = parcelRequire("lvBjt");

var $2ASiJ = parcelRequire("2ASiJ");
const $902dd5cef4a0a9b5$export$24dc00c93079305a = ({ profile: profile, projectKey: projectKey })=>{
    const orgProfile = (0, $a4UlN.normalizeToOrgProfile)(profile);
    if (orgProfile) {
        const { id: id, displayName: displayName } = orgProfile;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lvBjt.OrganizationCell), {
            id: id,
            displayName: displayName,
            projectKey: projectKey
        });
    }
    const userProfile = (0, $a4UlN.normalizeToUserProfile)(profile);
    if (userProfile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ASiJ.UserCell), {
        profile: userProfile
    });
    return null;
};

});
parcelRegister("lvBjt", function(module, exports) {

$parcel$export(module.exports, "OrganizationCell", () => $3911b574724d4eba$export$6f59e9f7993195f3);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $4nce6 = parcelRequire("4nce6");

var $PdmhA = parcelRequire("PdmhA");

var $kJlBc = parcelRequire("kJlBc");
const $3911b574724d4eba$export$6f59e9f7993195f3 = ({ id: id, displayName: displayName, projectKey: projectKey })=>{
    const baseUrl = '';
    const { push: push } = (0, $kJlBc.useRouterActions)();
    const organizationUrl = (0, $eUqFw.useMemo)(()=>`${baseUrl}/jira/servicedesk/projects/${projectKey}/organization/${id}`, [
        baseUrl,
        id,
        projectKey
    ]);
    const onClick = (0, $eUqFw.useCallback)((e)=>{
        // modifier key + click should open in a new tab/window so we let the default
        // href behaviour occur in that case. For a regular left click we want to prevent
        // the href behaviour since we're using the router to navigate.
        // Without this, we try to load the page twice which causes resources to start
        // loading and then be cut off, creating 'Failed to fetch' errors
        if (e.metaKey || e.ctrlKey || e.altKey || e.shiftKey) return;
        e.preventDefault();
        push(organizationUrl);
    }, [
        organizationUrl,
        push
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3911b574724d4eba$var$StyledWrapper, {
        "data-testid": "servicedesk-customers-organization-common.ui.table.customer-cell.organization.styled-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "link",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4nce6))), {
            primaryColor: `var(--ds-icon, ${(0, $PdmhA).DN30A})`,
            label: displayName
        }),
        onClick: onClick,
        href: organizationUrl
    }, displayName));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3911b574724d4eba$var$StyledWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i14no _1yt41b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4nce6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $32f2cb577afb3a41$var$_react = $32f2cb577afb3a41$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $32f2cb577afb3a41$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $32f2cb577afb3a41$var$PeopleIcon = (props)=>/*#__PURE__*/ $32f2cb577afb3a41$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><circle cx="16" cy="9" r="3"/><circle cx="8" cy="6" r="3"/><path d="M11 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0V15z"/><path d="M13 12a1.997 1.997 0 00-2-2H5c-1.113 0-2 .897-2 2.003v3.826c0 1.921 4.054 2.518 7 1.984v-2.807A3.001 3.001 0 0112.997 12H13z"/></g></svg>`
    }, props));
$32f2cb577afb3a41$var$PeopleIcon.displayName = 'PeopleIcon';
var $32f2cb577afb3a41$var$_default = $32f2cb577afb3a41$var$PeopleIcon;
module.exports.default = $32f2cb577afb3a41$var$_default;

});


parcelRegister("2ASiJ", function(module, exports) {

$parcel$export(module.exports, "UserCell", () => $69952be77b36aeb2$export$dc0ef711c0db7c30);
$parcel$export(module.exports, "StyledAgent", () => $69952be77b36aeb2$export$d54fe3905ccd077d);
$parcel$export(module.exports, "Wrapper", () => $69952be77b36aeb2$export$e6dfd72ab29f8598);
$parcel$export(module.exports, "Label", () => $69952be77b36aeb2$export$b04be29aa201d4f5);
$parcel$export(module.exports, "EmailWrapper", () => $69952be77b36aeb2$export$89ae56bbdaeedb7f);
$parcel$export(module.exports, "PrivateEmailLabel", () => $69952be77b36aeb2$export$468c2751f81ff59b);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iJlfe = parcelRequire("iJlfe");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $c9TLT = parcelRequire("c9TLT");

var $giAhk = parcelRequire("giAhk");

var $2NwGr = parcelRequire("2NwGr");

var $gd0Sp = parcelRequire("gd0Sp");

var $9GObf = parcelRequire("9GObf");

var $jhDEr = parcelRequire("jhDEr");
const $69952be77b36aeb2$var$UserCellView = ({ profile: { identifier: identifier, avatarUrl: avatarUrl, displayName: displayName, email: email, organisationNames: organisationNames }, intl: { formatMessage: formatMessage } })=>{
    const privateEmail = formatMessage((0, $jhDEr.default).privateEmail);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2NwGr.AsyncProfileCardNext), {
        accountId: identifier,
        TenantContextSubscriber: (0, $gd0Sp.TenantContextSubscriber),
        actions: [
            (0, $2f37035f7aaf1787$export$23cedd3261bd8015)
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $69952be77b36aeb2$var$wrapperStyles,
        testId: "servicedesk-customers-organization-common.ui.table.customer-cell.user.user-cell"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $69952be77b36aeb2$var$agentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        src: avatarUrl,
        size: "small",
        borderColor: "transparent"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $69952be77b36aeb2$var$emailStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        as: "span",
        xcss: $69952be77b36aeb2$var$labelStyles
    }, displayName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        as: "span",
        xcss: [
            $69952be77b36aeb2$var$labelStyles,
            $69952be77b36aeb2$var$privateEmailStyles
        ]
    }, email || privateEmail)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9GObf.LozengeGroup), {
        organizationNames: organisationNames
    }))));
};
const $69952be77b36aeb2$export$dc0ef711c0db7c30 = (0, $giAhk.injectIntlV2)($69952be77b36aeb2$var$UserCellView);
const $69952be77b36aeb2$var$wrapperStyles = (0, $1ZAYh.xcss)({
    padding: 'space.050',
    display: 'flex',
    textAlign: 'left'
});
const $69952be77b36aeb2$var$agentStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    border: 0,
    borderRadius: 'border.radius',
    paddingTop: 'space.0',
    paddingBottom: 'space.0',
    paddingLeft: 'space.050',
    paddingRight: 'space.050',
    width: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `${(0, $c9TLT.gridSize) * 4.5}px`,
    overflowX: 'hidden',
    /* CSS reset to Atlaskit defaults */ // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 'inherit',
    fontStyle: 'normal',
    fontWeight: 'normal',
    outline: 'none'
});
const $69952be77b36aeb2$var$labelStyles = (0, $1ZAYh.xcss)({
    lineHeight: '1.4',
    paddingLeft: 'space.050',
    overflowX: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    textAlign: 'left'
});
const $69952be77b36aeb2$var$emailStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    flexDirection: 'column'
});
const $69952be77b36aeb2$var$privateEmailStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.subtlest',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: '11px'
}); // These are still being imported in other packages...
const $69952be77b36aeb2$export$d54fe3905ccd077d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _4cvr1h6o _bfhk18uv _19itidpf _2rko1l7b _1yt4otz2 _1bsb1osq _4t3i14no _1reo15vq _syaz1kw7 _1wyb1kw7 _zg8l4jg8 _k48p4jg8 _12ji1r31 _1qu2glyw _12y31o36",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $69952be77b36aeb2$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt41b66 _1e0c1txw _y3gn1e5h",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $69952be77b36aeb2$export$b04be29aa201d4f5 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vwz419ii _19bv1b66 _1reo15vq _1bto1l2s _o5721q9c _y3gn1e5h",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $69952be77b36aeb2$export$89ae56bbdaeedb7f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $69952be77b36aeb2$export$468c2751f81ff59b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $69952be77b36aeb2$export$b04be29aa201d4f5, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1ifp _1wyb1skh",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2NwGr", function(module, exports) {

$parcel$export(module.exports, "AsyncProfileCardNext", () => $d91bacdeb64d663f$export$a3c0845f856d4292);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $1lXFP = parcelRequire("1lXFP");

var $gGtKh = parcelRequire("gGtKh");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d91bacdeb64d663f$var$LazyComponent = (0, $7rh0R.lazy)(()=>(parcelRequire("41OLy")).then((module)=>module.ProfileCard), {
    moduleId: "./src/packages/profilecard-next/src/main.tsx"
});
const $d91bacdeb64d663f$export$a3c0845f856d4292 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "AsyncProfileCardNext",
        packageName: "jiraProfilecardNext",
        render: ()=>// props.children in this context is the code being wrapped
            // in a <ProfileCardTrigger> (I.e. it is the thing a user hovers over to
            // display a profile card).
            // In the event of an unexpected error within @atlaskit/profilecard,
            // just render the unwrapped children (I.e. they will render but nothing
            // happens on hover)
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children),
        sendToPrivacyUnsafeSplunk: true,
        teamName: "empanada",
        attributes: (0, $1lXFP.isLoaderErrorAttributes)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-profile-card-next-view",
        fallback: props.children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d91bacdeb64d663f$var$LazyComponent, props)));
var $d91bacdeb64d663f$export$2e2bcd8739ae039 = $d91bacdeb64d663f$export$a3c0845f856d4292;

});
parcelRegister("1lXFP", function(module, exports) {

$parcel$export(module.exports, "isLoaderErrorAttributes", () => $1c31f74fac112a78$export$c7209ce2e0d060ea);

var $7rh0R = parcelRequire("7rh0R");
const $1c31f74fac112a78$export$c7209ce2e0d060ea = (error)=>({
        isLoaderError: (0, $7rh0R.isLoaderError)(error)
    });

});

// values which are passed into the tracking callback by atlaskit
const $2f37035f7aaf1787$export$febebefae5a09065 = 'profile-card.loaded';
const $2f37035f7aaf1787$export$3ca1936ee743bd18 = 'profile-card.view';
const $2f37035f7aaf1787$export$25bd35f2cd9ae0ea = 'profile-card.reload';
const $2f37035f7aaf1787$export$86aa8b9c379ebbbd = 'profile-card.error';
const $2f37035f7aaf1787$export$4442e31da6ba4127 = 'profile-card.click';
const $2f37035f7aaf1787$export$7ecd9c56ca354ac0 = 'profileCardNext';
const $2f37035f7aaf1787$export$81319ffa9c0d18d7 = 'profileCardNext';
const $2f37035f7aaf1787$export$3145fc6c544ad7bf = 'profileCardNextLegacy';
const $2f37035f7aaf1787$export$50632e21ea714398 = 'profileCardNextLegacy';
const $2f37035f7aaf1787$export$d053e144c034c8aa = 'teamProfileCardNextLegacy';
const $2f37035f7aaf1787$export$2549357601611c61 = 'loadError';
const $2f37035f7aaf1787$export$23cedd3261bd8015 = 'viewProfile';
const $2f37035f7aaf1787$export$6bef782d14a92db8 = 'assignedIssues';
const $2f37035f7aaf1787$export$6b36f20db7a18a86 = 'reportedIssues';
const $2f37035f7aaf1787$export$56da0dd0b0aa67b9 = 'viewFilters';

parcelRegister("41OLy", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('hPzOn'),
            load('keVAk')
        ]);
        const value = parcelRequire('12NzK');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("hPzOn"),
        load("keVAk")
    ]).then(()=>parcelRequire('12NzK'));
}

});


parcelRegister("9GObf", function(module, exports) {

$parcel$export(module.exports, "LozengeGroup", () => $a63ec4f7f11f7185$export$23762007a3044933);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $ffiyv = parcelRequire("ffiyv");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $a63ec4f7f11f7185$export$23762007a3044933 = ({ organizationNames: organizationNames })=>{
    if (!organizationNames || !organizationNames.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $a63ec4f7f11f7185$var$wrapperStyles,
        tabIndex: 0
    }, organizationNames.map((organizationName)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a63ec4f7f11f7185$var$Spaced, {
            key: organizationName
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
            value: "default"
        }, organizationName))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a63ec4f7f11f7185$var$Spaced = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $a63ec4f7f11f7185$var$wrapperStyles = (0, $1ZAYh.xcss)({
    marginLeft: 'space.100'
});

});

parcelRegister("jhDEr", function(module, exports) {

$parcel$export(module.exports, "default", () => $617afcd5eddc8d5b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $617afcd5eddc8d5b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    privateEmail: {
        "id": "servicedesk-customers-organization-common.table.customer-cell.user.private-email",
        "defaultMessage": "private email address"
    }
});

});



parcelRegister("71BiP", function(module, exports) {

$parcel$export(module.exports, "EditorCell", () => $16d36610fcdb338e$export$c1f633b9199aef47);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $cfNhr = parcelRequire("cfNhr");

var $8cU5f = parcelRequire("8cU5f");

var $giAhk = parcelRequire("giAhk");

var $jMP2a = parcelRequire("jMP2a");

var $a4UlN = parcelRequire("a4UlN");

var $dUwbu = parcelRequire("dUwbu");
const $16d36610fcdb338e$var$EditorCellView = ({ intl: { formatMessage: formatMessage }, projectName: projectName, profile: profile, onRemove: onRemove, showRemoveCustomerTooltip: showRemoveCustomerTooltip, fireUIAnalytics: fireUIAnalytics = (0, $jMP2a.fireUIAnalytics) })=>{
    const { displayName: displayName } = profile;
    const tooltipMessage = showRemoveCustomerTooltip === true ? formatMessage((0, $dUwbu.default).removeCustomerFromOrganization) : formatMessage((0, $dUwbu.default).removeProfile, {
        displayName: displayName,
        projectName: projectName
    });
    const handleRemoveClick = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type.
    (_, analyticsEvent)=>{
        onRemove(profile);
        const actionSubjectId = (0, $a4UlN.isOrganization)(profile) ? 'removeOrganizationButton' : 'removeCustomerButton';
        fireUIAnalytics(analyticsEvent, actionSubjectId);
    }, [
        onRemove,
        profile,
        fireUIAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: tooltipMessage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        testId: "servicedesk-customers-organization-common.ui.table.editor-cell.button",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cfNhr))), {
            label: tooltipMessage
        }),
        onClick: handleRemoveClick
    }));
};
const $16d36610fcdb338e$export$c1f633b9199aef47 = (0, $giAhk.injectIntlV2)($16d36610fcdb338e$var$EditorCellView);

});
parcelRegister("dUwbu", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd25b54d41ea2fcc$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $fd25b54d41ea2fcc$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    removeProfile: {
        "id": "servicedesk-customers-organization-common.table.editor-cell.remove-profile",
        "defaultMessage": "Remove {displayName} from {projectName}."
    },
    removeCustomerFromOrganization: {
        "id": "servicedesk-customers-organization-common.table.editor-cell.remove-customer-from-organization",
        "defaultMessage": "Remove customer from organization"
    }
});

});


parcelRegister("8oBqB", function(module, exports) {

$parcel$export(module.exports, "LoggedInStatusCellView", () => $479b0d42590695a9$export$43f24582ef577545);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jOdsB = parcelRequire("jOdsB");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gd0Sp = parcelRequire("gd0Sp");

var $a4UlN = parcelRequire("a4UlN");

var $e46qA = parcelRequire("e46qA");

var $jAEY9 = parcelRequire("jAEY9");
const $479b0d42590695a9$var$getCutoffDateForCustomerVerification = ()=>(0, $1ybV0.getFeatureFlagValue)('cut-off-date-for-tenants-for-customer-invite-verification-feature', '');
const $479b0d42590695a9$export$43f24582ef577545 = ({ profile: profile })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const userProfile = (0, $a4UlN.normalizeToUserProfile)(profile);
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    if (tenantContext) {
        const { firstActivationDateMs: firstActivationDateMs } = tenantContext;
        const cutOffDate = $479b0d42590695a9$var$getCutoffDateForCustomerVerification();
        const isTenantActivationAfterCutOffDate = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        new Date(firstActivationDateMs) >= new Date(cutOffDate);
        if (userProfile) {
            const { loggedInStatus: loggedInStatus, emailVerifiedStatus: emailVerifiedStatus } = userProfile;
            if (loggedInStatus === (0, $e46qA.NOT_AVAILABLE)) return null;
            const appendUnverifiedEmailText = (0, $1ybV0.ff)('sptn-1697-email-verified-signal-on-customers-page_v2g52') && isTenantActivationAfterCutOffDate;
            if (appendUnverifiedEmailText && emailVerifiedStatus === false) {
                let status = '';
                if (loggedInStatus === (0, $e46qA.HAS_LOGGED_IN)) status = formatMessage((0, $jAEY9.default).activeStatusLabel);
                else if (loggedInStatus === (0, $e46qA.PENDING_LOGIN)) status = formatMessage((0, $jAEY9.default).inviteStatusLabel);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, status), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($479b0d42590695a9$var$PrivateEmailLabel, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($479b0d42590695a9$var$InlineMessageWrapper, null, formatMessage((0, $jAEY9.default).unverifiedEmail), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jOdsB.default), {
                    appearance: "info",
                    placement: "bottom-end"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($479b0d42590695a9$var$InlineMessageContent, null, formatMessage((0, $jAEY9.default).unverifiedEmailTooltip))))));
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, loggedInStatus === (0, $e46qA.HAS_LOGGED_IN) ? formatMessage((0, $jAEY9.default).activeStatusLabel) : formatMessage((0, $jAEY9.default).inviteStatusLabel));
        }
    }
    return null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $479b0d42590695a9$var$InlineMessageWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _jq8gpxbi _igocpxbi _k6cgpxbi _1d42pxbi _1sla1rc1",
            __cmplp.className
        ])
    });
});
const $479b0d42590695a9$var$InlineMessageContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _k48p4jg8 _p12fs1ma _o5724jg8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $479b0d42590695a9$var$Label = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vwz419ii _1reo15vq _1bto1l2s _o5721q9c _y3gn1e5h",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $479b0d42590695a9$var$PrivateEmailLabel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $479b0d42590695a9$var$Label, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1ifp _1wyb1skh",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jAEY9", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a7657f797dfcf1e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9a7657f797dfcf1e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    activeStatusLabel: {
        "id": "servicedesk-customers-organization-common.table.logged-in-status-cell.active-status-label",
        "defaultMessage": "Active"
    },
    inviteStatusLabel: {
        "id": "servicedesk-customers-organization-common.table.logged-in-status-cell.invite-status-label",
        "defaultMessage": "Invited"
    },
    unverifiedEmail: {
        "id": "servicedesk-customers-organization-common.table.logged-in-status-cell.unverified-email",
        "defaultMessage": "Unverified email"
    },
    unverifiedEmailTooltip: {
        "id": "servicedesk-customers-organization-common.table.logged-in-status-cell.unverified-email-tooltip",
        "defaultMessage": "Customer needs to verify email address to receive notifications"
    }
});

});


parcelRegister("5jZaz", function(module, exports) {

$parcel$export(module.exports, "OpenRequestsCell", () => $b2f4c6c4ebe5a14d$export$6232c8d38dd75a76);
$parcel$export(module.exports, "ClosedRequestsCell", () => $b2f4c6c4ebe5a14d$export$217e2042d93a264e);

var $oQFSZ = parcelRequire("oQFSZ");
const $b2f4c6c4ebe5a14d$export$6232c8d38dd75a76 = (0, $oQFSZ.OpenRequestsCellView);
const $b2f4c6c4ebe5a14d$export$217e2042d93a264e = (0, $oQFSZ.ClosedRequestsCellView);

});
parcelRegister("oQFSZ", function(module, exports) {

$parcel$export(module.exports, "OpenRequestsCellView", () => $5f0800c02c2230ee$export$769d59d9cebdd255);
$parcel$export(module.exports, "ClosedRequestsCellView", () => $5f0800c02c2230ee$export$9d1a10e8875012df);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $3NBfm = parcelRequire("3NBfm");
const $5f0800c02c2230ee$var$REQUESTS_STATUS = {
    OPEN: 'Open',
    CLOSED: 'Closed'
};
const $5f0800c02c2230ee$var$LinkButton = ({ jqlString: jqlString, label: label, type: type })=>{
    const baseUrl = '';
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onClick = (_x, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, `viewRequests${type}`);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        spacing: "none",
        appearance: "link",
        href: `${baseUrl}/issues/?jql=${jqlString}`,
        target: "_blank",
        onClick: onClick
    }, label);
};
const $5f0800c02c2230ee$export$769d59d9cebdd255 = ({ profile: { openRequestsJql: openRequestsJql, openRequestCount: openRequestCount, showCounts: showCounts } })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (!showCounts) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5f0800c02c2230ee$var$LinkButton, {
        label: formatMessage((0, $3NBfm.default).viewOpen),
        jqlString: openRequestsJql,
        type: $5f0800c02c2230ee$var$REQUESTS_STATUS.OPEN
    });
    if (openRequestCount > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5f0800c02c2230ee$var$LinkButton, {
        label: formatMessage((0, $3NBfm.default).openRequests, {
            requestsCount: openRequestCount
        }),
        jqlString: openRequestsJql,
        type: $5f0800c02c2230ee$var$REQUESTS_STATUS.OPEN
    });
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, formatMessage((0, $3NBfm.default).openRequests, {
        requestsCount: openRequestCount
    }));
};
const $5f0800c02c2230ee$export$9d1a10e8875012df = ({ profile: { closedRequestCount: closedRequestCount, closedRequestsJql: closedRequestsJql, showCounts: showCounts } })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (!showCounts) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5f0800c02c2230ee$var$LinkButton, {
        label: formatMessage((0, $3NBfm.default).viewClosed),
        jqlString: closedRequestsJql,
        type: $5f0800c02c2230ee$var$REQUESTS_STATUS.CLOSED
    });
    if (closedRequestCount > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5f0800c02c2230ee$var$LinkButton, {
        label: formatMessage((0, $3NBfm.default).closedRequests, {
            requestsCount: closedRequestCount
        }),
        jqlString: closedRequestsJql,
        type: $5f0800c02c2230ee$var$REQUESTS_STATUS.CLOSED
    });
    return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, formatMessage((0, $3NBfm.default).closedRequests, {
        requestsCount: closedRequestCount
    })));
};

});
parcelRegister("3NBfm", function(module, exports) {

$parcel$export(module.exports, "default", () => $a49a85a9e9f497d9$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a49a85a9e9f497d9$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    viewOpen: {
        "id": "servicedesk-customers-organization-common.table.requests-cell.view-open",
        "defaultMessage": "View open"
    },
    openRequests: {
        "id": "servicedesk-customers-organization-common.table.requests-cell.open-requests",
        "defaultMessage": "{requestsCount} open"
    },
    viewClosed: {
        "id": "servicedesk-customers-organization-common.table.requests-cell.view-closed",
        "defaultMessage": "View closed"
    },
    closedRequests: {
        "id": "servicedesk-customers-organization-common.table.requests-cell.closed-requests",
        "defaultMessage": "{requestsCount} closed"
    }
});

});




parcelRegister("ak4QW", function(module, exports) {

$parcel$export(module.exports, "EmptyState", () => $6bd683767798f592$export$fddf379e22a74b00);

var $eUqFw = parcelRequire("eUqFw");

var $220ac = parcelRequire("220ac");

var $giAhk = parcelRequire("giAhk");

var $8P97t = parcelRequire("8P97t");
const $6bd683767798f592$var$EmptyStateView = ({ intl: { formatMessage: formatMessage } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "servicedesk-customers-organization-common.ui.table.pagination.wrapper",
        "aria-live": "polite"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        header: formatMessage((0, $8P97t.default).noResults)
    }));
const $6bd683767798f592$export$fddf379e22a74b00 = (0, $giAhk.injectIntlV2)($6bd683767798f592$var$EmptyStateView);

});
parcelRegister("8P97t", function(module, exports) {

$parcel$export(module.exports, "default", () => $9651e0b2c827315f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9651e0b2c827315f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    paginationPrev: {
        "id": "servicedesk-customers-organization-common.table.pagination.pagination-prev",
        "defaultMessage": "Prev"
    },
    paginationNext: {
        "id": "servicedesk-customers-organization-common.table.pagination.pagination-next",
        "defaultMessage": "Next"
    },
    noResults: {
        "id": "servicedesk-customers-organization-common.table.pagination.no-results",
        "defaultMessage": "No matches for your search."
    }
});

});


parcelRegister("4YoJu", function(module, exports) {

$parcel$export(module.exports, "PaginationLabel", () => $d5c6c91d9e73bb14$export$5742121915cb78c6);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $lkPEe = parcelRequire("lkPEe");

var $giAhk = parcelRequire("giAhk");

var $d3MpK = parcelRequire("d3MpK");
const $d5c6c91d9e73bb14$export$a7bb072605d6094c = 'servicedesk-customers-organization-common.ui.table.pagination-count-label';
const $d5c6c91d9e73bb14$export$4a0b103ecd79b58 = ({ label: label, start: start, end: end, size: size, justifyCenter: justifyCenter, intl: { formatMessage: formatMessage } })=>{
    if (label) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "p",
        xcss: [
            $d5c6c91d9e73bb14$var$labelStyles,
            !justifyCenter && $d5c6c91d9e73bb14$var$justifyRightStyles
        ],
        "aria-live": "polite",
        "data-testId": $d5c6c91d9e73bb14$export$a7bb072605d6094c
    }, label);
    if (size > 0 && end >= start) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "p",
        xcss: $d5c6c91d9e73bb14$var$labelStyles,
        "aria-live": "polite",
        "data-testId": $d5c6c91d9e73bb14$export$a7bb072605d6094c
    }, formatMessage((0, $d3MpK.default).paginationMessage, {
        start: start,
        end: end,
        size: size,
        span: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lkPEe.default), null, chunks)
    }));
    return null;
};
$d5c6c91d9e73bb14$export$4a0b103ecd79b58.defaultProps = {
    label: '',
    start: 0,
    end: 0,
    size: 0,
    showPagination: false
};
const $d5c6c91d9e73bb14$export$5742121915cb78c6 = (0, $giAhk.injectIntlV2)($d5c6c91d9e73bb14$export$4a0b103ecd79b58);
const $d5c6c91d9e73bb14$var$labelStyles = (0, $1ZAYh.xcss)({
    float: 'right',
    margin: 'space.0',
    position: 'relative',
    gridColumnStart: 1,
    gridRowStart: 1,
    justifySelf: 'center',
    bottom: 'space.0'
});
const $d5c6c91d9e73bb14$var$justifyRightStyles = (0, $1ZAYh.xcss)({
    justifySelf: 'right'
});

});
parcelRegister("d3MpK", function(module, exports) {

$parcel$export(module.exports, "default", () => $21b8c5f9f4e25d43$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $21b8c5f9f4e25d43$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    paginationMessage: {
        "id": "servicedesk-customers-organization-common.table.pagination-count-label.pagination-message",
        "defaultMessage": "{start}-{end} for {size} <span>{size, plural, =1{result} other{results}} found</span>"
    }
});

});


parcelRegister("kSp6c", function(module, exports) {

$parcel$export(module.exports, "usePaginationHook", () => $56f6855fdd87ca8d$export$107464500942a07f);

var $eUqFw = parcelRequire("eUqFw");

var $lkPEe = parcelRequire("lkPEe");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fuV9u = parcelRequire("fuV9u");

var $9zsta = parcelRequire("9zsta");
const $56f6855fdd87ca8d$var$FALLBACK_VALUE = 5;
const $56f6855fdd87ca8d$var$jsmCustomersDefaultPageRange = ()=>(0, $1ybV0.getFeatureFlagValue)('jsm-customers-default-page-range', $56f6855fdd87ca8d$var$FALLBACK_VALUE);
const $56f6855fdd87ca8d$export$107464500942a07f = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { query: query, totalHasBeenDetermined: totalHasBeenDetermined, total: total, lastDeterminedPaged: lastDeterminedPaged, pageNumber: pageNumber } = props;
    const isSearching = query !== '';
    const rowsPerPage = isSearching ? (0, $fuV9u.SEARCH_PER_PAGE) : (0, $fuV9u.LIST_PER_PAGE);
    const start = (pageNumber - 1) * rowsPerPage + 1;
    const end = Math.min((pageNumber - 1) * rowsPerPage + rowsPerPage, total);
    // 1-100 of 100+
    const listLabel = formatMessage((0, $9zsta.default).pageLabel, {
        start: start,
        end: end,
        total: total,
        hasPlusSign: !totalHasBeenDetermined,
        span: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lkPEe.default), null, chunks)
    });
    // 1-20 of 20, search is always limited to 20 results
    const searchLabel = formatMessage((0, $9zsta.default).searchLabel, {
        start: start,
        end: end,
        total: total,
        span: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lkPEe.default), null, chunks)
    });
    const paginationLabel = isSearching ? searchLabel : listLabel;
    const isMaxLimitReached = lastDeterminedPaged > $56f6855fdd87ca8d$var$jsmCustomersDefaultPageRange();
    const defaultTotalPages = totalHasBeenDetermined || isMaxLimitReached ? pageNumber : lastDeterminedPaged;
    const totalPages = isSearching ? total : defaultTotalPages;
    const showPagination = !isSearching && totalPages > 1;
    const hideRightEllipsis = isMaxLimitReached || totalHasBeenDetermined;
    // < 1, 2, ... >
    const bracketSize = lastDeterminedPaged < 2 ? 2 : 5;
    return {
        isMaxLimitReached: isMaxLimitReached,
        paginationLabel: paginationLabel,
        showPagination: showPagination,
        totalPages: totalPages,
        bracketSize: bracketSize,
        hideRightEllipsis: hideRightEllipsis
    };
};

});
parcelRegister("9zsta", function(module, exports) {

$parcel$export(module.exports, "default", () => $49d2217b1fd73258$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $49d2217b1fd73258$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    pageLabel: {
        "id": "servicedesk-customers-organization-common.table.page-label",
        "defaultMessage": "{start}-{end} for {total}{hasPlusSign, select, true{+} other{}} <span>{total, plural, =1{result} other{results}} found</span>"
    },
    searchLabel: {
        "id": "servicedesk-customers-organization-common.table.search-label",
        "defaultMessage": "{start}-{end} for {total} <span>{total, plural, =1{result} other{results}} found</span>"
    }
});

});



parcelRegister("1t6yB", function(module, exports) {

$parcel$export(module.exports, "useRemoveCustomerService", () => $4f92c577d4eaa2c5$export$fa0c75e7be8471fb);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $7byHA = parcelRequire("7byHA");
var $lRmyA = parcelRequire("lRmyA");

var $fdCL3 = parcelRequire("fdCL3");
const $4f92c577d4eaa2c5$export$fa0c75e7be8471fb = (baseUrl, projectKey)=>{
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const [data, setData] = (0, $eUqFw.useState)(null);
    const [error, setError] = (0, $eUqFw.useState)(null);
    const fetch = (0, $eUqFw.useCallback)(async (customerId)=>{
        setLoading(true);
        setError(null);
        try {
            await (0, $lRmyA.performDeleteRequest)((0, $fdCL3.getUrl)(baseUrl, projectKey, customerId));
            setData(customerId);
            setLoading(false);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setLoading(false);
            setError(err);
            // Only fire analytics for unexpected errors. ValidationErrors are used when
            // the backend returns a 400. Expected 400 errors from the backend include:
            // - user is removed successfully from the customer role but still maintains access to Service Desk
            // This error message is used to let the user know that they may still need to adjust
            // permissions if removal of access is required, but it doesn't indicate a failure
            const shouldFireErrorAnalytics = !(0, $7byHA.isValidationError)(err);
            if (shouldFireErrorAnalytics) (0, $guiFP.default)({
                error: err,
                meta: {
                    id: 'useRemoveCustomerService',
                    packageName: 'jiraServicedeskCustomers',
                    teamName: 'boysenberry'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        baseUrl,
        projectKey
    ]);
    return {
        loading: loading,
        error: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type '((Error | ValidationErrors | { statusCode: number; message?: string | undefined; }) & ValidationErrors) | null'.
        error,
        data: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'ServiceData<Data>'.
        data,
        fetch: // @ts-expect-error - TS2322 - Type '(customerId: string) => Promise<void>' is not assignable to type '(() => Promise<void>) & ((arg1: string) => Promise<void>)'.
        fetch
    };
};

});
parcelRegister("fdCL3", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $f56e05e131137079$export$94df0e59ebebf4a7);
const $f56e05e131137079$export$94df0e59ebebf4a7 = (baseUrl, projectKey, customerId)=>`${baseUrl}/rest/servicedesk/1/servicedesk/${projectKey}/customerrole/${customerId}/remove`;

});


parcelRegister("7utas", function(module, exports) {

$parcel$export(module.exports, "default", () => $86b999a9b0be97ce$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $86b999a9b0be97ce$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    flagTitle: {
        "id": "servicedesk-customers.table.flag-title",
        "defaultMessage": "{customerName} removed from {projectName}"
    },
    removeCustomerError: {
        "id": "servicedesk-customers.table.remove-customer-error",
        "defaultMessage": "Something has gone wrong with your request. If symptoms persist contact your System Administrator."
    },
    resendInviteSuccessFlagTitle: {
        "id": "servicedesk-customers.table.resend-invite-success-flag-title",
        "defaultMessage": "Invite sent successfully"
    },
    resendInviteSuccessFlagDescription: {
        "id": "servicedesk-customers.table.resend-invite-success-flag-description",
        "defaultMessage": "An email has been sent to {email} to set a password for their account."
    },
    resendVerificationEmailTitle: {
        "id": "servicedesk-customers.table.resend-verification-email-title",
        "defaultMessage": "Verification email sent successfully"
    },
    resendVerificationEmailDescription: {
        "id": "servicedesk-customers.table.resend-verification-email-description",
        "defaultMessage": "An email has been sent to {email} to verify the customer\u2019s email address."
    },
    resendInviteFailureFlagTitle: {
        "id": "servicedesk-customers.table.resend-invite-failure-flag-title",
        "defaultMessage": "We couldn\u2019t resend the invite"
    },
    resendInviteFailureFlagDescription: {
        "id": "servicedesk-customers.table.resend-invite-failure-flag-description",
        "defaultMessage": "Check your network connection, refresh the page and try again."
    }
});

});





parcelRegister("aSEj7", function(module, exports) {

$parcel$export(module.exports, "default", () => $d93f023cd162d6f9$export$2e2bcd8739ae039);

var $3HCkE = parcelRequire("3HCkE");

var $k1AKH = parcelRequire("k1AKH");
const $d93f023cd162d6f9$var$useServiceProjectFeatures = ()=>(0, $3HCkE.useResource)((0, $k1AKH.featuresResource));
var $d93f023cd162d6f9$export$2e2bcd8739ae039 = $d93f023cd162d6f9$var$useServiceProjectFeatures;

});

parcelRegister("kKzsy", function(module, exports) {

$parcel$export(module.exports, "JsdGettingStartedPanelShouldRender", () => $993d872dc7228c2f$export$46976e0f90edfcfe);
$parcel$export(module.exports, "JsdGettingStartedPanel", () => $993d872dc7228c2f$export$6f9913539cfb4ab6);
$parcel$export(module.exports, "JsdGettingStartedPanelOpenButton", () => $993d872dc7228c2f$export$4cb23b2c31a1b2ad);
$parcel$export(module.exports, "JsdGettingStartedPanelReopenSpotlight", () => $993d872dc7228c2f$export$c7732c55900cf0b9);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $993d872dc7228c2f$var$AsyncGettingStartedPanelShouldRender = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("hfiyN")).then(({ JsdGettingStartedPanelShouldRender: JsdGettingStartedPanelShouldRender })=>JsdGettingStartedPanelShouldRender), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/should-render/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $993d872dc7228c2f$var$AsyncGettingStartedPanel = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("hTkS8")).then(({ JsdGettingStartedPanel: JsdGettingStartedPanel })=>JsdGettingStartedPanel), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/panel/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $993d872dc7228c2f$var$AsyncGettingStartedPanelOpenButton = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("c3XjM")).then(({ JsdGettingStartedPanelOpenButton: JsdGettingStartedPanelOpenButton })=>JsdGettingStartedPanelOpenButton), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/open-button/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $993d872dc7228c2f$var$AsyncGettingStartedPanelReopenSpotlight = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("eTjqX")).then(({ JsdGettingStartedPanelReopenSpotlight: JsdGettingStartedPanelReopenSpotlight })=>JsdGettingStartedPanelReopenSpotlight), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/reopen-spotlight/async.tsx"
});
const $993d872dc7228c2f$export$46976e0f90edfcfe = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jsm-getting-started-panel-async-should-render",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($993d872dc7228c2f$var$AsyncGettingStartedPanelShouldRender, null));
$993d872dc7228c2f$export$46976e0f90edfcfe.displayName = 'AsyncJsdGettingStartedPanelShouldRender';
const $993d872dc7228c2f$export$6f9913539cfb4ab6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jsm-getting-started-panel-async-panel",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($993d872dc7228c2f$var$AsyncGettingStartedPanel, null));
$993d872dc7228c2f$export$6f9913539cfb4ab6.displayName = 'AsyncJsdGettingStartedPanel';
const $993d872dc7228c2f$export$4cb23b2c31a1b2ad = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jsm-getting-started-panel-async-open-button",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($993d872dc7228c2f$var$AsyncGettingStartedPanelOpenButton, null));
$993d872dc7228c2f$export$4cb23b2c31a1b2ad.displayName = 'AsyncJsdGettingStartedPanelOpenButton';
const $993d872dc7228c2f$export$c7732c55900cf0b9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jsm-getting-started-panel-async-reopen-spotlight",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($993d872dc7228c2f$var$AsyncGettingStartedPanelReopenSpotlight, null));
$993d872dc7228c2f$export$c7732c55900cf0b9.displayName = 'AsyncJsdGettingStartedPanelReopenSpotlight';

});
parcelRegister("hfiyN", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('kd6Ju');
        const value = parcelRequire('appSk');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("kd6Ju").then(()=>parcelRequire('appSk'));
}

});

parcelRegister("hTkS8", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('5eFqM')
        ]);
        const value = parcelRequire('ddfk6');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("5eFqM")
    ]).then(()=>parcelRequire('ddfk6'));
}

});

parcelRegister("c3XjM", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('ahRif')
        ]);
        const value = parcelRequire('1HvEW');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("ahRif")
    ]).then(()=>parcelRequire('1HvEW'));
}

});

parcelRegister("eTjqX", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('cxrYi')
        ]);
        const value = parcelRequire('f9sDQ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("cxrYi")
    ]).then(()=>parcelRequire('f9sDQ'));
}

});


parcelRegister("3o0h6", function(module, exports) {

$parcel$export(module.exports, "PageStyle", () => $d0c61d036d967c5f$export$c59987a647e9a55);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $9c7gV = parcelRequire("9c7gV");
const $d0c61d036d967c5f$export$c59987a647e9a55 = ({ Page: Page, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d0c61d036d967c5f$var$JSDSpaPageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Page, null, children));
$d0c61d036d967c5f$export$c59987a647e9a55.defaultProps = {
    Page: (0, $9c7gV.default)
};
var $d0c61d036d967c5f$export$2e2bcd8739ae039 = $d0c61d036d967c5f$export$c59987a647e9a55;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d0c61d036d967c5f$var$JSDSpaPageWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8zdiv",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9c7gV", function(module, exports) {

$parcel$export(module.exports, "default", () => $4be3daaa307b075d$export$2e2bcd8739ae039);

var $aJWi0 = parcelRequire("aJWi0");

var $j7bQJ = parcelRequire("j7bQJ");

var $6tahE = parcelRequire("6tahE");
var // Page already has a jsdoc where it is defined
// eslint-disable-next-line @repo/internal/react/require-jsdoc
$4be3daaa307b075d$export$2e2bcd8739ae039 = (0, $aJWi0.default);

});
parcelRegister("aJWi0", function(module, exports) {

$parcel$export(module.exports, "default", () => $7341c6e5fd381e79$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $cuCEk = parcelRequire("cuCEk");
function $7341c6e5fd381e79$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7341c6e5fd381e79$var$bannerStyles = {
    name: "4oew4k",
    styles: "width:100%;position:fixed"
};
const $7341c6e5fd381e79$var$bannerContainerStyles = {
    name: "1x3pv69",
    styles: "width:100%;position:relative;z-index:3;flex:1 0 auto;transition:height 0.25s ease-in-out"
};
const $7341c6e5fd381e79$var$pageContentStyles = {
    name: "15n167b",
    styles: "min-width:0;position:relative;z-index:1;flex:1 1 auto"
};
const $7341c6e5fd381e79$var$wrapperStyles = {
    name: "m5v4sl",
    styles: "display:flex;width:100%;min-height:100%;flex-direction:column"
};
const $7341c6e5fd381e79$var$mainContainerStyles = {
    name: "1cete8c",
    styles: "display:flex;flex:1 1 auto"
};
const $7341c6e5fd381e79$var$navigationStyles = {
    name: "wrqbg1",
    styles: "position:relative;z-index:2"
};
/**
 * __Page__
 *
 * Used to build page layouts.
 *
 * Has built in support for positioning [banners](https://atlassian.design/components/banner/examples)
 * and the deprecated `@atlaskit/navigation`.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $7341c6e5fd381e79$var$Page = ({ isBannerOpen: isBannerOpen = false, bannerHeight: bannerHeight = (0, $cuCEk.defaultBannerHeight), banner: banner, navigation: navigation, children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $7341c6e5fd381e79$var$wrapperStyles,
        "data-testid": testId
    }, banner ? /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $7341c6e5fd381e79$var$bannerContainerStyles,
        style: {
            height: isBannerOpen ? `${bannerHeight}px` : '0'
        },
        "aria-hidden": !isBannerOpen,
        "data-testid": testId ? `${testId}--banner-container` : undefined
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $7341c6e5fd381e79$var$bannerStyles
    }, banner)) : null, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $7341c6e5fd381e79$var$mainContainerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $7341c6e5fd381e79$var$navigationStyles
    }, navigation), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $7341c6e5fd381e79$var$pageContentStyles
    }, children)));
};
var $7341c6e5fd381e79$export$2e2bcd8739ae039 = $7341c6e5fd381e79$var$Page;

});



parcelRegister("2d7Sj", function(module, exports) {

$parcel$export(module.exports, "PageTitle", () => $0653f34646647329$export$155581e8dc02007a);
$parcel$export(module.exports, "ServiceDeskDocumentTitle", () => $0653f34646647329$export$c7841d2c1c13065e);

var $eUqFw = parcelRequire("eUqFw");

var $knPb9 = parcelRequire("knPb9");

var $1ybV0 = parcelRequire("1ybV0");

var $heNSb = parcelRequire("heNSb");

var $giAhk = parcelRequire("giAhk");

var $f9Osc = parcelRequire("f9Osc");
const $0653f34646647329$export$155581e8dc02007a = (props)=>{
    const { DocumentTitle: DocumentTitle, section: section, intl: { formatMessage: formatMessage }, projectName: projectName, subsection: subsection } = props;
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ proformaForms: MessageDescriptorV2; chat: MessageDescriptorV2; incidentManagementSettings: MessageDescriptorV2; ... 32 more ...; serviceProject: MessageDescriptorV2; }'.
    const titleOld = `${projectName} - ${formatMessage((0, $f9Osc.default)[section])} - ${formatMessage((0, $f9Osc.default).serviceProject)}`;
    const titleNew = subsection ? // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ proformaForms: MessageDescriptorV2; chat: MessageDescriptorV2; incidentManagementSettings: MessageDescriptorV2; ... 32 more ...; serviceProject: MessageDescriptorV2; }'.
    `${projectName} - ${formatMessage((0, $f9Osc.default)[section])} - ${subsection} - ${formatMessage((0, $f9Osc.default).serviceProject)}` : // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ proformaForms: MessageDescriptorV2; chat: MessageDescriptorV2; incidentManagementSettings: MessageDescriptorV2; ... 32 more ...; serviceProject: MessageDescriptorV2; }'.
    `${projectName} - ${formatMessage((0, $f9Osc.default)[section])} - ${formatMessage((0, $f9Osc.default).serviceProject)}`;
    const title = (0, $1ybV0.ff)('a11y-fission-queues-related-issues_giuuk') ? titleNew : titleOld;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DocumentTitle, {
        title: title
    });
};
const $0653f34646647329$var$InjectedPage = (0, $knPb9.default)($0653f34646647329$export$155581e8dc02007a, {
    DocumentTitle: (0, $heNSb.DocumentTitle)
});
const $0653f34646647329$export$c7841d2c1c13065e = (0, $giAhk.injectIntlV2)($0653f34646647329$var$InjectedPage);
var $0653f34646647329$export$2e2bcd8739ae039 = $0653f34646647329$export$c7841d2c1c13065e;

});
parcelRegister("f9Osc", function(module, exports) {

$parcel$export(module.exports, "default", () => $7be746c19c254767$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7be746c19c254767$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    atlassianAnalytics: {
        "id": "servicedesk-spa-commons.common.utils.document-title.atlassian-analytics",
        "defaultMessage": "Atlassian Analytics"
    },
    serviceProject: {
        "id": "servicedesk-spa-commons.common.utils.document-title.service-project",
        "defaultMessage": "Service project"
    },
    knowledge: {
        "id": "servicedesk-spa-commons.common.utils.document-title.knowledge",
        "defaultMessage": "Knowledge base"
    },
    itsmFeatures: {
        "id": "servicedesk-spa-commons.common.utils.document-title.itsm-features",
        "defaultMessage": "Features"
    },
    queues: {
        "id": "servicedesk-spa-commons.common.utils.document-title.queues",
        "defaultMessage": "Queues"
    },
    customers: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customers",
        "defaultMessage": "Customers"
    },
    organizations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.organizations",
        "defaultMessage": "Organizations"
    },
    customerServiceEscalations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-service-escalations",
        "defaultMessage": "Developer escalations"
    },
    reports: {
        "id": "servicedesk-spa-commons.common.utils.document-title.reports",
        "defaultMessage": "Reports"
    },
    services: {
        "id": "servicedesk-spa-commons.common.utils.document-title.services",
        "defaultMessage": "Services"
    },
    oncall: {
        "id": "servicedesk-spa-commons.common.utils.document-title.oncall",
        "defaultMessage": "On-call"
    },
    email: {
        "id": "servicedesk-spa-commons.common.utils.document-title.email",
        "defaultMessage": "Email"
    },
    sla: {
        "id": "servicedesk-spa-commons.common.utils.document-title.sla",
        "defaultMessage": "Service level agreements"
    },
    csat: {
        "id": "servicedesk-spa-commons.common.utils.document-title.csat",
        "defaultMessage": "Customer satisfaction"
    },
    details: {
        "id": "servicedesk-spa-commons.common.utils.document-title.details",
        "defaultMessage": "Details"
    },
    portal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.portal",
        "defaultMessage": "Customer portal"
    },
    externalLinks: {
        "id": "servicedesk-spa-commons.common.utils.document-title.external-links",
        "defaultMessage": "Links"
    },
    portalSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.portal-settings",
        "defaultMessage": "Portal settings"
    },
    automation: {
        "id": "servicedesk-spa-commons.common.utils.document-title.automation",
        "defaultMessage": "Automation"
    },
    advanced: {
        "id": "servicedesk-spa-commons.common.utils.document-title.advanced",
        "defaultMessage": "Advanced"
    },
    languageSupport: {
        "id": "servicedesk-spa-commons.common.utils.document-title.language-support",
        "defaultMessage": "Language support"
    },
    languageTranslations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.language-translations",
        "defaultMessage": "Language translations"
    },
    notificationEmail: {
        "id": "servicedesk-spa-commons.common.utils.document-title.notification-email",
        "defaultMessage": "Notification email"
    },
    notifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.notifications",
        "defaultMessage": "Notifications"
    },
    internalNotifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.internal-notifications",
        "defaultMessage": "Internal notifications"
    },
    customerNotifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-notifications",
        "defaultMessage": "Customer notifications"
    },
    widget: {
        "id": "servicedesk-spa-commons.common.utils.document-title.widget",
        "defaultMessage": "Widget"
    },
    customerPermissions: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-permissions",
        "defaultMessage": "Customer permissions"
    },
    people: {
        "id": "servicedesk-spa-commons.common.utils.document-title.people",
        "defaultMessage": "Internal access"
    },
    issueType: {
        "id": "servicedesk-spa-commons.common.utils.document-title.issue-type",
        "defaultMessage": "Request types"
    },
    connectAppControls: {
        "id": "servicedesk-spa-commons.common.utils.document-title.connect-app-controls",
        "defaultMessage": "Apps"
    },
    features: {
        "id": "servicedesk-spa-commons.common.utils.document-title.features",
        "defaultMessage": "Features"
    },
    calendar: {
        "id": "servicedesk-spa-commons.common.utils.document-title.calendar",
        "defaultMessage": "Calendar"
    },
    changeCalendar: {
        "id": "servicedesk-spa-commons.common.utils.document-title.change-calendar",
        "defaultMessage": "Change calendar"
    },
    changeManagementSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.change-management-settings",
        "defaultMessage": "Change management"
    },
    incidentManagementSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.incident-management-settings",
        "defaultMessage": "Incident management"
    },
    virtualAgentConversations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-conversations",
        "defaultMessage": "Conversations"
    },
    virtualAgentIntents: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-intents",
        "defaultMessage": "Intents"
    },
    virtualAgentStandardFlows: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-standard-flows",
        "defaultMessage": "Standard flows"
    },
    virtualAgentSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-settings",
        "defaultMessage": "Settings"
    },
    virtualAgentLanding: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-landing",
        "defaultMessage": "Virtual agent"
    },
    chat: {
        "id": "servicedesk-spa-commons.common.utils.document-title.chat",
        "defaultMessage": "Chat"
    },
    proformaForms: {
        "id": "servicedesk-spa-commons.common.utils.document-title.proforma-forms",
        "defaultMessage": "Forms"
    },
    dataClassifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.data-classifications",
        "defaultMessage": "Data classification"
    },
    // EAX-256 - Finalise this string
    fieldsNonFinal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.fields-non-final",
        "defaultMessage": "Fields"
    },
    workflowScheme: {
        "id": "servicedesk-spa-commons.common.utils.document-title.workflow-scheme",
        "defaultMessage": "Workflows"
    }
});

});


parcelRegister("dVAlv", function(module, exports) {

$parcel$export(module.exports, "SpaPageWrapper", () => $33637cae863dc9b4$export$577514961fbf4842);
// eslint-disable-next-line @typescript-eslint/no-unused-vars

var $eUqFw = parcelRequire("eUqFw");

var $ae4LH = parcelRequire("ae4LH");

var $gUUjF = parcelRequire("gUUjF");

var $knPb9 = parcelRequire("knPb9");

var $fO5rB = parcelRequire("fO5rB");

var $bhwgQ = parcelRequire("bhwgQ");

var $1IzB8 = parcelRequire("1IzB8");

var $2Ba2b = parcelRequire("2Ba2b");
const $33637cae863dc9b4$export$91f88695e0d311a5 = (props)=>{
    const { projectContext: projectContext, isLoading: isLoading, error: error, children: children, AccessCheck: AccessCheck, AuthenticationCheck: AuthenticationCheck, ProjectNotFound: ProjectNotFound, GenericError: GenericError, SubProductUpdater: SubProductUpdater } = props;
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ae4LH.default), null);
    if (error) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('jsdspa-page-wrapper', 'rendering-error-page', error);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AuthenticationCheck, null, error.statusCode === 404 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ProjectNotFound, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(GenericError, null));
    }
    if (projectContext) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SubProductUpdater, {
        subProduct: "serviceDesk"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AuthenticationCheck, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AccessCheck, null, children)));
    return null;
};
const $33637cae863dc9b4$export$577514961fbf4842 = (0, $knPb9.default)($33637cae863dc9b4$export$91f88695e0d311a5, {
    AccessCheck: (0, $1IzB8.default),
    GenericError: (0, $2Ba2b.GenericError),
    ProjectNotFound: (0, $2Ba2b.ProjectNotFound),
    AuthenticationCheck: (0, $bhwgQ.AuthenticationCheck),
    SubProductUpdater: (0, $fO5rB.SubProductUpdater)
});
var $33637cae863dc9b4$export$2e2bcd8739ae039 = $33637cae863dc9b4$export$577514961fbf4842;

});
parcelRegister("fO5rB", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $0dcc4693f2e4993e$export$eb40d3df56aa5c53);

var $eUqFw = parcelRequire("eUqFw");

var $3viaK = parcelRequire("3viaK");

var $cOnuN = parcelRequire("cOnuN");

var $6QL9v = parcelRequire("6QL9v");

var $kxBN8 = parcelRequire("kxBN8");

var $2SV7r = parcelRequire("2SV7r");
const $0dcc4693f2e4993e$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $2SV7r.isSubProductProps)(props) ? props.subProduct : (0, $6QL9v.subProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
        op: (0, $kxBN8.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cOnuN.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("cOnuN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3e22c81c3ebeab6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lgxha = parcelRequire("lgxha");

var $j5W2t = parcelRequire("j5W2t");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b3e22c81c3ebeab6$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lgxha.default), {
        op: (0, $j5W2t.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("j5W2t", function(module, exports) {

$parcel$export(module.exports, "default", () => $8613fa53f568085a$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $lRmyA = parcelRequire("lRmyA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8613fa53f568085a$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $lRmyA.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("kxBN8", function(module, exports) {

$parcel$export(module.exports, "default", () => $95a7ec92a66826ce$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");
var $ds5Im = parcelRequire("ds5Im");
var $4DtuZ = parcelRequire("4DtuZ");


var $gUUjF = parcelRequire("gUUjF");

var $3FyZ4 = parcelRequire("3FyZ4");
const $95a7ec92a66826ce$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$95a7ec92a66826ce$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $96da08ab2c7a3243$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $95a7ec92a66826ce$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $4DtuZ.waitForHeritage)() : null, ()=>(0, $2BvS3.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $ds5Im.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $gUUjF.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $96da08ab2c7a3243$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("2SV7r", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $5e5ef73a1d4e492a$export$c3063d6d7a8c075f);
const $5e5ef73a1d4e492a$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
const $5e5ef73a1d4e492a$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';

});


parcelRegister("1IzB8", function(module, exports) {

$parcel$export(module.exports, "default", () => $edeca50de0b85084$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $10fdS = parcelRequire("10fdS");


var $bsgfb = parcelRequire("bsgfb");

var $1fuiA = parcelRequire("1fuiA");
const $edeca50de0b85084$var$AccessCheck = ({ children: children })=>{
    const isSettingsRoute = (0, $10fdS.useCurrentRoute)().path.includes(`${(0, $2df94debed157361$export$967ba7bfb5ce30bd)}/:projectKey/settings/`);
    const Gate = isSettingsRoute ? (0, $1fuiA.default) : (0, $bsgfb.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Gate, null, children);
};
var $edeca50de0b85084$export$2e2bcd8739ae039 = $edeca50de0b85084$var$AccessCheck;

});
const $2df94debed157361$export$967ba7bfb5ce30bd = '/jira/servicedesk/projects';

parcelRegister("bsgfb", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7d02215a42a3332$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kJlBc = parcelRequire("kJlBc");

var $fz8wa = parcelRequire("fz8wa");

var $11C4f = parcelRequire("11C4f");
const $a7d02215a42a3332$var$ProductAccessCheck = ({ children: children })=>{
    const { hasServiceDeskAccess: hasServiceDeskAccess } = (0, $fz8wa.useApplicationPermissions)();
    const [projectKey = ''] = (0, $kJlBc.usePathParam)('projectKey');
    if (projectKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $11C4f.default), null, children);
    return hasServiceDeskAccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
        to: "/jira"
    });
};
var $a7d02215a42a3332$export$2e2bcd8739ae039 = $a7d02215a42a3332$var$ProductAccessCheck;

});
parcelRegister("11C4f", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2544b3bfea70255$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kJlBc = parcelRequire("kJlBc");

var $jyTef = parcelRequire("jyTef");


var $6tW8V = parcelRequire("6tW8V");
const $a2544b3bfea70255$var$AgentCheck = ({ children: children })=>{
    const [projectKey = ''] = (0, $kJlBc.usePathParam)('projectKey');
    const [{ data: data, error: error }] = (0, $jyTef.useServiceDeskContext)();
    if (data || error) {
        // @ts-expect-error - TS2345 - Argument of type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to parameter of type '{ statusCode?: number | undefined; } | null'.
        if (!(0, $6tW8V.isAccessError)(error)) {
            const { userRole: userRole = '' } = data || {};
            if (userRole === 'agent' || userRole === 'agent-project-admin') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
            if (error) throw error;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
            to: `${(0, $2df94debed157361$export$967ba7bfb5ce30bd)}/${projectKey}/issues`
        });
    }
    return null;
};
var $a2544b3bfea70255$export$2e2bcd8739ae039 = $a2544b3bfea70255$var$AgentCheck;

});
parcelRegister("6tW8V", function(module, exports) {

$parcel$export(module.exports, "isAccessError", () => $5107715f0b974007$export$ddaebe4928e793cb);

const $5107715f0b974007$var$RESTRICTED_ACCESS_CODES = [
    (0, $1c3fbb431a173cc6$export$a3269a3914b007e3),
    (0, $1c3fbb431a173cc6$export$8bca792d963eb0ef),
    (0, $1c3fbb431a173cc6$export$67d19e9a991baa07)
];
const $5107715f0b974007$export$ddaebe4928e793cb = (error)=>error?.statusCode != null ? $5107715f0b974007$var$RESTRICTED_ACCESS_CODES.includes(error.statusCode) : false;

});



parcelRegister("1fuiA", function(module, exports) {

$parcel$export(module.exports, "default", () => $0788b3e6146363c4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2Ba2b = parcelRequire("2Ba2b");

var $jyTef = parcelRequire("jyTef");

var $6tW8V = parcelRequire("6tW8V");
const $0788b3e6146363c4$var$SettingsAccessCheck = ({ children: children })=>{
    const [{ data: serviceDeskContext, error: serviceDeskContextError }] = (0, $jyTef.useServiceDeskContext)();
    const userRole = serviceDeskContext?.userRole;
    // @ts-expect-error - TS2345 - Argument of type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to parameter of type '{ statusCode?: number | undefined; } | null'.
    const hasAccessError = (0, $6tW8V.isAccessError)(serviceDeskContextError);
    // Service desk context is updated on every route change
    // If context fails to give us an indicative result (e.g. fetch failed, 500 error)
    // We will continue to use current value to assess permissions
    if (userRole === 'agent-project-admin' && !hasAccessError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    if (userRole !== undefined || hasAccessError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Ba2b.ProjectNotFound), null);
    if (serviceDeskContextError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Ba2b.GenericError), null);
    return null;
};
var $0788b3e6146363c4$export$2e2bcd8739ae039 = $0788b3e6146363c4$var$SettingsAccessCheck;

});



parcelRegister("fCHTf", function(module, exports) {

$parcel$export(module.exports, "AsyncContactsAppLayout", () => $5e311c8a5815fbc3$export$4a505c5c2222d386);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $5e311c8a5815fbc3$export$55118fe902ecc07a = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("2o7qt")), {
    moduleId: "./src/packages/spa-apps/servicedesk/contacts/src/index.tsx"
});
const $5e311c8a5815fbc3$export$4a505c5c2222d386 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "servicedesk-contacts",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5e311c8a5815fbc3$export$55118fe902ecc07a, null));

});
parcelRegister("2o7qt", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('bWzqn')
        ]);
        const value = parcelRequire('7oHdk');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("bWzqn")
    ]).then(()=>parcelRequire('7oHdk'));
}

});





//# sourceMappingURL=async-servicedesk-customers-v2.3f2f39ac.js.map
